
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree19e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree19e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("R1mjg", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gaCXw"));

});
parcelRegister("gaCXw", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $bc5bccfdcac5ebd0$export$ffb0004e005737fa; }, function (v) { return $bc5bccfdcac5ebd0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $bc5bccfdcac5ebd0$export$34b9dba7ce09269b; }, function (v) { return $bc5bccfdcac5ebd0$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $bc5bccfdcac5ebd0$export$25062201e9e25d76; }, function (v) { return $bc5bccfdcac5ebd0$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bc5bccfdcac5ebd0$export$ffb0004e005737fa;
var $bc5bccfdcac5ebd0$export$34b9dba7ce09269b;
var $bc5bccfdcac5ebd0$export$25062201e9e25d76;
"use strict";
var $bc5bccfdcac5ebd0$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $bc5bccfdcac5ebd0$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $bc5bccfdcac5ebd0$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $bc5bccfdcac5ebd0$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$bc5bccfdcac5ebd0$export$ffb0004e005737fa = $bc5bccfdcac5ebd0$var$REACT_FRAGMENT_TYPE;
$bc5bccfdcac5ebd0$export$34b9dba7ce09269b = $bc5bccfdcac5ebd0$var$jsxProd;
$bc5bccfdcac5ebd0$export$25062201e9e25d76 = $bc5bccfdcac5ebd0$var$jsxProd;

});


parcelRegister("9qxVB", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $6dd0dc3063cc2a97$export$dca3b0875bd9a954; }, function (v) { return $6dd0dc3063cc2a97$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $6dd0dc3063cc2a97$export$16fa2f45be04daa8; }, function (v) { return $6dd0dc3063cc2a97$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $6dd0dc3063cc2a97$export$ffb0004e005737fa; }, function (v) { return $6dd0dc3063cc2a97$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $6dd0dc3063cc2a97$export$e2c29f18771995cb; }, function (v) { return $6dd0dc3063cc2a97$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $6dd0dc3063cc2a97$export$221d75b3f55bb0bd; }, function (v) { return $6dd0dc3063cc2a97$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $6dd0dc3063cc2a97$export$5f8d39834fd61797; }, function (v) { return $6dd0dc3063cc2a97$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $6dd0dc3063cc2a97$export$74bf444e3cd11ea5; }, function (v) { return $6dd0dc3063cc2a97$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $6dd0dc3063cc2a97$export$1ced07cd6b1985ce; }, function (v) { return $6dd0dc3063cc2a97$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $6dd0dc3063cc2a97$export$abd8e32b826d7ea7; }, function (v) { return $6dd0dc3063cc2a97$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $6dd0dc3063cc2a97$export$69a3209f1a06c04d; }, function (v) { return $6dd0dc3063cc2a97$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cloneElement", function () { return $6dd0dc3063cc2a97$export$e530037191fcd5d7; }, function (v) { return $6dd0dc3063cc2a97$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $6dd0dc3063cc2a97$export$fd42f52fd3ae1109; }, function (v) { return $6dd0dc3063cc2a97$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $6dd0dc3063cc2a97$export$c8a8987d4410bf2d; }, function (v) { return $6dd0dc3063cc2a97$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $6dd0dc3063cc2a97$export$7d1e3a5e95ceca43; }, function (v) { return $6dd0dc3063cc2a97$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $6dd0dc3063cc2a97$export$257a8862b851cb5b; }, function (v) { return $6dd0dc3063cc2a97$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $6dd0dc3063cc2a97$export$a8257692ac88316c; }, function (v) { return $6dd0dc3063cc2a97$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $6dd0dc3063cc2a97$export$488013bae63b21da; }, function (v) { return $6dd0dc3063cc2a97$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $6dd0dc3063cc2a97$export$7c73462e0d25e514; }, function (v) { return $6dd0dc3063cc2a97$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $6dd0dc3063cc2a97$export$7568632d0d33d16d; }, function (v) { return $6dd0dc3063cc2a97$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $6dd0dc3063cc2a97$export$f93f40ac0ca7e3a8; }, function (v) { return $6dd0dc3063cc2a97$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $6dd0dc3063cc2a97$export$1f96ae73734a86cc; }, function (v) { return $6dd0dc3063cc2a97$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $6dd0dc3063cc2a97$export$9a47ced3238df325; }, function (v) { return $6dd0dc3063cc2a97$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $6dd0dc3063cc2a97$export$35808ee640e87ca7; }, function (v) { return $6dd0dc3063cc2a97$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $6dd0dc3063cc2a97$export$fae74005e78b1a27; }, function (v) { return $6dd0dc3063cc2a97$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $6dd0dc3063cc2a97$export$dc8fbce3eb94dc1e; }, function (v) { return $6dd0dc3063cc2a97$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $6dd0dc3063cc2a97$export$6a7bc4e911dc01cf; }, function (v) { return $6dd0dc3063cc2a97$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $6dd0dc3063cc2a97$export$6d9c69b0de29b591; }, function (v) { return $6dd0dc3063cc2a97$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $6dd0dc3063cc2a97$export$f680877a34711e37; }, function (v) { return $6dd0dc3063cc2a97$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $6dd0dc3063cc2a97$export$d5a552a76deda3c2; }, function (v) { return $6dd0dc3063cc2a97$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $6dd0dc3063cc2a97$export$aaabe4eda9ed9969; }, function (v) { return $6dd0dc3063cc2a97$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $6dd0dc3063cc2a97$export$e5c5a5f917a5871c; }, function (v) { return $6dd0dc3063cc2a97$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $6dd0dc3063cc2a97$export$1538c33de8887b59; }, function (v) { return $6dd0dc3063cc2a97$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $6dd0dc3063cc2a97$export$fca7f784ae7a249a; }, function (v) { return $6dd0dc3063cc2a97$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $6dd0dc3063cc2a97$export$13e3392192263954; }, function (v) { return $6dd0dc3063cc2a97$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $6dd0dc3063cc2a97$export$b8f5890fc79d6aca; }, function (v) { return $6dd0dc3063cc2a97$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $6dd0dc3063cc2a97$export$60241385465d0a34; }, function (v) { return $6dd0dc3063cc2a97$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $6dd0dc3063cc2a97$export$306c0aa65ff9ec16; }, function (v) { return $6dd0dc3063cc2a97$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $6dd0dc3063cc2a97$export$7b286972b8d8ccbf; }, function (v) { return $6dd0dc3063cc2a97$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $6dd0dc3063cc2a97$export$83d89fbfd8236492; }, function (v) { return $6dd0dc3063cc2a97$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6dd0dc3063cc2a97$export$dca3b0875bd9a954;
var $6dd0dc3063cc2a97$export$16fa2f45be04daa8;
var $6dd0dc3063cc2a97$export$ffb0004e005737fa;
var $6dd0dc3063cc2a97$export$e2c29f18771995cb;
var $6dd0dc3063cc2a97$export$221d75b3f55bb0bd;
var $6dd0dc3063cc2a97$export$5f8d39834fd61797;
var $6dd0dc3063cc2a97$export$74bf444e3cd11ea5;
var $6dd0dc3063cc2a97$export$1ced07cd6b1985ce;
var $6dd0dc3063cc2a97$export$abd8e32b826d7ea7;
var $6dd0dc3063cc2a97$export$69a3209f1a06c04d;
var $6dd0dc3063cc2a97$export$e530037191fcd5d7;
var $6dd0dc3063cc2a97$export$fd42f52fd3ae1109;
var $6dd0dc3063cc2a97$export$c8a8987d4410bf2d;
var $6dd0dc3063cc2a97$export$7d1e3a5e95ceca43;
var $6dd0dc3063cc2a97$export$257a8862b851cb5b;
var $6dd0dc3063cc2a97$export$a8257692ac88316c;
var $6dd0dc3063cc2a97$export$488013bae63b21da;
var $6dd0dc3063cc2a97$export$7c73462e0d25e514;
var $6dd0dc3063cc2a97$export$7568632d0d33d16d;
var $6dd0dc3063cc2a97$export$f93f40ac0ca7e3a8;
var $6dd0dc3063cc2a97$export$1f96ae73734a86cc;
var $6dd0dc3063cc2a97$export$9a47ced3238df325;
var $6dd0dc3063cc2a97$export$35808ee640e87ca7;
var $6dd0dc3063cc2a97$export$fae74005e78b1a27;
var $6dd0dc3063cc2a97$export$dc8fbce3eb94dc1e;
var $6dd0dc3063cc2a97$export$6a7bc4e911dc01cf;
var $6dd0dc3063cc2a97$export$6d9c69b0de29b591;
var $6dd0dc3063cc2a97$export$f680877a34711e37;
var $6dd0dc3063cc2a97$export$d5a552a76deda3c2;
var $6dd0dc3063cc2a97$export$aaabe4eda9ed9969;
var $6dd0dc3063cc2a97$export$e5c5a5f917a5871c;
var $6dd0dc3063cc2a97$export$1538c33de8887b59;
var $6dd0dc3063cc2a97$export$fca7f784ae7a249a;
var $6dd0dc3063cc2a97$export$13e3392192263954;
var $6dd0dc3063cc2a97$export$b8f5890fc79d6aca;
var $6dd0dc3063cc2a97$export$60241385465d0a34;
var $6dd0dc3063cc2a97$export$306c0aa65ff9ec16;
var $6dd0dc3063cc2a97$export$7b286972b8d8ccbf;
var $6dd0dc3063cc2a97$export$83d89fbfd8236492;
"use strict";
var $6dd0dc3063cc2a97$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $6dd0dc3063cc2a97$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $6dd0dc3063cc2a97$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $6dd0dc3063cc2a97$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $6dd0dc3063cc2a97$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $6dd0dc3063cc2a97$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $6dd0dc3063cc2a97$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $6dd0dc3063cc2a97$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $6dd0dc3063cc2a97$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $6dd0dc3063cc2a97$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $6dd0dc3063cc2a97$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $6dd0dc3063cc2a97$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $6dd0dc3063cc2a97$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $6dd0dc3063cc2a97$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$6dd0dc3063cc2a97$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $6dd0dc3063cc2a97$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $6dd0dc3063cc2a97$var$assign = Object.assign, $6dd0dc3063cc2a97$var$emptyObject = {};
function $6dd0dc3063cc2a97$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $6dd0dc3063cc2a97$var$emptyObject;
    this.updater = updater || $6dd0dc3063cc2a97$var$ReactNoopUpdateQueue;
}
$6dd0dc3063cc2a97$var$Component.prototype.isReactComponent = {};
$6dd0dc3063cc2a97$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$6dd0dc3063cc2a97$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $6dd0dc3063cc2a97$var$ComponentDummy() {}
$6dd0dc3063cc2a97$var$ComponentDummy.prototype = $6dd0dc3063cc2a97$var$Component.prototype;
function $6dd0dc3063cc2a97$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $6dd0dc3063cc2a97$var$emptyObject;
    this.updater = updater || $6dd0dc3063cc2a97$var$ReactNoopUpdateQueue;
}
var $6dd0dc3063cc2a97$var$pureComponentPrototype = $6dd0dc3063cc2a97$var$PureComponent.prototype = new $6dd0dc3063cc2a97$var$ComponentDummy();
$6dd0dc3063cc2a97$var$pureComponentPrototype.constructor = $6dd0dc3063cc2a97$var$PureComponent;
$6dd0dc3063cc2a97$var$assign($6dd0dc3063cc2a97$var$pureComponentPrototype, $6dd0dc3063cc2a97$var$Component.prototype);
$6dd0dc3063cc2a97$var$pureComponentPrototype.isPureReactComponent = !0;
var $6dd0dc3063cc2a97$var$isArrayImpl = Array.isArray, $6dd0dc3063cc2a97$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $6dd0dc3063cc2a97$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $6dd0dc3063cc2a97$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $6dd0dc3063cc2a97$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $6dd0dc3063cc2a97$var$cloneAndReplaceKey(oldElement, newKey) {
    return $6dd0dc3063cc2a97$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $6dd0dc3063cc2a97$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $6dd0dc3063cc2a97$var$REACT_ELEMENT_TYPE;
}
function $6dd0dc3063cc2a97$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $6dd0dc3063cc2a97$var$userProvidedKeyEscapeRegex = /\/+/g;
function $6dd0dc3063cc2a97$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $6dd0dc3063cc2a97$var$escape("" + element.key) : index.toString(36);
}
function $6dd0dc3063cc2a97$var$noop$1() {}
function $6dd0dc3063cc2a97$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($6dd0dc3063cc2a97$var$noop$1, $6dd0dc3063cc2a97$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $6dd0dc3063cc2a97$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $6dd0dc3063cc2a97$var$REACT_ELEMENT_TYPE:
                case $6dd0dc3063cc2a97$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $6dd0dc3063cc2a97$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $6dd0dc3063cc2a97$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $6dd0dc3063cc2a97$var$getElementKey(children, 0) : nameSoFar, $6dd0dc3063cc2a97$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($6dd0dc3063cc2a97$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $6dd0dc3063cc2a97$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($6dd0dc3063cc2a97$var$isValidElement(callback) && (callback = $6dd0dc3063cc2a97$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($6dd0dc3063cc2a97$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($6dd0dc3063cc2a97$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $6dd0dc3063cc2a97$var$getElementKey(nameSoFar, i), invokeCallback += $6dd0dc3063cc2a97$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $6dd0dc3063cc2a97$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $6dd0dc3063cc2a97$var$getElementKey(nameSoFar, i++), invokeCallback += $6dd0dc3063cc2a97$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $6dd0dc3063cc2a97$var$mapIntoArray($6dd0dc3063cc2a97$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $6dd0dc3063cc2a97$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $6dd0dc3063cc2a97$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $6dd0dc3063cc2a97$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $6dd0dc3063cc2a97$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $6dd0dc3063cc2a97$var$noop() {}
$6dd0dc3063cc2a97$export$dca3b0875bd9a954 = {
    map: $6dd0dc3063cc2a97$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $6dd0dc3063cc2a97$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $6dd0dc3063cc2a97$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $6dd0dc3063cc2a97$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$6dd0dc3063cc2a97$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$6dd0dc3063cc2a97$export$16fa2f45be04daa8 = $6dd0dc3063cc2a97$var$Component;
$6dd0dc3063cc2a97$export$ffb0004e005737fa = $6dd0dc3063cc2a97$var$REACT_FRAGMENT_TYPE;
$6dd0dc3063cc2a97$export$e2c29f18771995cb = $6dd0dc3063cc2a97$var$REACT_PROFILER_TYPE;
$6dd0dc3063cc2a97$export$221d75b3f55bb0bd = $6dd0dc3063cc2a97$var$PureComponent;
$6dd0dc3063cc2a97$export$5f8d39834fd61797 = $6dd0dc3063cc2a97$var$REACT_STRICT_MODE_TYPE;
$6dd0dc3063cc2a97$export$74bf444e3cd11ea5 = $6dd0dc3063cc2a97$var$REACT_SUSPENSE_TYPE;
$6dd0dc3063cc2a97$export$1ced07cd6b1985ce = $6dd0dc3063cc2a97$var$ReactSharedInternals;
$6dd0dc3063cc2a97$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$6dd0dc3063cc2a97$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$6dd0dc3063cc2a97$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $6dd0dc3063cc2a97$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$6dd0dc3063cc2a97$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $6dd0dc3063cc2a97$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$6dd0dc3063cc2a97$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $6dd0dc3063cc2a97$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $6dd0dc3063cc2a97$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$6dd0dc3063cc2a97$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$6dd0dc3063cc2a97$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $6dd0dc3063cc2a97$var$ReactElement(type, key, void 0, void 0, null, props);
};
$6dd0dc3063cc2a97$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$6dd0dc3063cc2a97$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $6dd0dc3063cc2a97$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$6dd0dc3063cc2a97$export$a8257692ac88316c = $6dd0dc3063cc2a97$var$isValidElement;
$6dd0dc3063cc2a97$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $6dd0dc3063cc2a97$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $6dd0dc3063cc2a97$var$lazyInitializer
    };
};
$6dd0dc3063cc2a97$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $6dd0dc3063cc2a97$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$6dd0dc3063cc2a97$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $6dd0dc3063cc2a97$var$ReactSharedInternals.T, currentTransition = {};
    $6dd0dc3063cc2a97$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $6dd0dc3063cc2a97$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($6dd0dc3063cc2a97$var$noop, $6dd0dc3063cc2a97$var$reportGlobalError);
    } catch (error) {
        $6dd0dc3063cc2a97$var$reportGlobalError(error);
    } finally{
        $6dd0dc3063cc2a97$var$ReactSharedInternals.T = prevTransition;
    }
};
$6dd0dc3063cc2a97$export$f93f40ac0ca7e3a8 = function() {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useCacheRefresh();
};
$6dd0dc3063cc2a97$export$1f96ae73734a86cc = function(usable) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.use(usable);
};
$6dd0dc3063cc2a97$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$6dd0dc3063cc2a97$export$35808ee640e87ca7 = function(callback, deps) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$6dd0dc3063cc2a97$export$fae74005e78b1a27 = function(Context) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useContext(Context);
};
$6dd0dc3063cc2a97$export$dc8fbce3eb94dc1e = function() {};
$6dd0dc3063cc2a97$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$6dd0dc3063cc2a97$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $6dd0dc3063cc2a97$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$6dd0dc3063cc2a97$export$f680877a34711e37 = function() {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useId();
};
$6dd0dc3063cc2a97$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$6dd0dc3063cc2a97$export$aaabe4eda9ed9969 = function(create, deps) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$6dd0dc3063cc2a97$export$e5c5a5f917a5871c = function(create, deps) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$6dd0dc3063cc2a97$export$1538c33de8887b59 = function(create, deps) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useMemo(create, deps);
};
$6dd0dc3063cc2a97$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$6dd0dc3063cc2a97$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$6dd0dc3063cc2a97$export$b8f5890fc79d6aca = function(initialValue) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useRef(initialValue);
};
$6dd0dc3063cc2a97$export$60241385465d0a34 = function(initialState) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useState(initialState);
};
$6dd0dc3063cc2a97$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$6dd0dc3063cc2a97$export$7b286972b8d8ccbf = function() {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useTransition();
};
$6dd0dc3063cc2a97$export$83d89fbfd8236492 = "19.1.0";

});

parcelRegister("hErLM", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $cd9bb691314980fc$export$882461b6382ed46c; }, function (v) { return $cd9bb691314980fc$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $cd9bb691314980fc$export$757ceba2d55c277e; }, function (v) { return $cd9bb691314980fc$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $cd9bb691314980fc$export$83d89fbfd8236492; }, function (v) { return $cd9bb691314980fc$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $cd9bb691314980fc$export$882461b6382ed46c;
var $cd9bb691314980fc$export$757ceba2d55c277e;
var $cd9bb691314980fc$export$83d89fbfd8236492;
"use strict";

var $dY8mw = parcelRequire("dY8mw");

var $i7uhG = parcelRequire("i7uhG");

var $f7Clz = parcelRequire("f7Clz");
function $cd9bb691314980fc$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $cd9bb691314980fc$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $cd9bb691314980fc$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $cd9bb691314980fc$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $cd9bb691314980fc$var$assertIsMounted(fiber) {
    if ($cd9bb691314980fc$var$getNearestMountedFiber(fiber) !== fiber) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(188));
}
function $cd9bb691314980fc$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $cd9bb691314980fc$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $cd9bb691314980fc$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $cd9bb691314980fc$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($cd9bb691314980fc$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $cd9bb691314980fc$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $cd9bb691314980fc$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $cd9bb691314980fc$var$assign = Object.assign, $cd9bb691314980fc$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $cd9bb691314980fc$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $cd9bb691314980fc$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $cd9bb691314980fc$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $cd9bb691314980fc$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $cd9bb691314980fc$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $cd9bb691314980fc$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $cd9bb691314980fc$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $cd9bb691314980fc$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $cd9bb691314980fc$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $cd9bb691314980fc$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $cd9bb691314980fc$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $cd9bb691314980fc$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $cd9bb691314980fc$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $cd9bb691314980fc$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $cd9bb691314980fc$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $cd9bb691314980fc$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $cd9bb691314980fc$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $cd9bb691314980fc$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$cd9bb691314980fc$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $cd9bb691314980fc$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $cd9bb691314980fc$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $cd9bb691314980fc$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $cd9bb691314980fc$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $cd9bb691314980fc$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $cd9bb691314980fc$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $cd9bb691314980fc$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $cd9bb691314980fc$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $cd9bb691314980fc$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $cd9bb691314980fc$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $cd9bb691314980fc$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $cd9bb691314980fc$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $cd9bb691314980fc$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $cd9bb691314980fc$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $cd9bb691314980fc$var$getComponentNameFromType(type.type) || "Memo";
        case $cd9bb691314980fc$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $cd9bb691314980fc$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $cd9bb691314980fc$var$isArrayImpl = Array.isArray, $cd9bb691314980fc$var$ReactSharedInternals = $i7uhG.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $cd9bb691314980fc$var$ReactDOMSharedInternals = $f7Clz.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $cd9bb691314980fc$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $cd9bb691314980fc$var$valueStack = [], $cd9bb691314980fc$var$index = -1;
function $cd9bb691314980fc$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $cd9bb691314980fc$var$pop(cursor) {
    0 > $cd9bb691314980fc$var$index || (cursor.current = $cd9bb691314980fc$var$valueStack[$cd9bb691314980fc$var$index], $cd9bb691314980fc$var$valueStack[$cd9bb691314980fc$var$index] = null, $cd9bb691314980fc$var$index--);
}
function $cd9bb691314980fc$var$push(cursor, value) {
    $cd9bb691314980fc$var$index++;
    $cd9bb691314980fc$var$valueStack[$cd9bb691314980fc$var$index] = cursor.current;
    cursor.current = value;
}
var $cd9bb691314980fc$var$contextStackCursor = $cd9bb691314980fc$var$createCursor(null), $cd9bb691314980fc$var$contextFiberStackCursor = $cd9bb691314980fc$var$createCursor(null), $cd9bb691314980fc$var$rootInstanceStackCursor = $cd9bb691314980fc$var$createCursor(null), $cd9bb691314980fc$var$hostTransitionProviderCursor = $cd9bb691314980fc$var$createCursor(null);
function $cd9bb691314980fc$var$pushHostContainer(fiber, nextRootInstance) {
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$rootInstanceStackCursor, nextRootInstance);
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$contextFiberStackCursor, fiber);
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $cd9bb691314980fc$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $cd9bb691314980fc$var$getOwnHostContext(nextRootInstance), fiber = $cd9bb691314980fc$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$contextStackCursor);
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$contextStackCursor, fiber);
}
function $cd9bb691314980fc$var$popHostContainer() {
    $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$contextStackCursor);
    $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$contextFiberStackCursor);
    $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$rootInstanceStackCursor);
}
function $cd9bb691314980fc$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $cd9bb691314980fc$var$push($cd9bb691314980fc$var$hostTransitionProviderCursor, fiber);
    var context = $cd9bb691314980fc$var$contextStackCursor.current;
    var JSCompiler_inline_result = $cd9bb691314980fc$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($cd9bb691314980fc$var$push($cd9bb691314980fc$var$contextFiberStackCursor, fiber), $cd9bb691314980fc$var$push($cd9bb691314980fc$var$contextStackCursor, JSCompiler_inline_result));
}
function $cd9bb691314980fc$var$popHostContext(fiber) {
    $cd9bb691314980fc$var$contextFiberStackCursor.current === fiber && ($cd9bb691314980fc$var$pop($cd9bb691314980fc$var$contextStackCursor), $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$contextFiberStackCursor));
    $cd9bb691314980fc$var$hostTransitionProviderCursor.current === fiber && ($cd9bb691314980fc$var$pop($cd9bb691314980fc$var$hostTransitionProviderCursor), $cd9bb691314980fc$var$HostTransitionContext._currentValue = $cd9bb691314980fc$var$sharedNotPendingObject);
}
var $cd9bb691314980fc$var$hasOwnProperty = Object.prototype.hasOwnProperty, $cd9bb691314980fc$var$scheduleCallback$3 = $dY8mw.unstable_scheduleCallback, $cd9bb691314980fc$var$cancelCallback$1 = $dY8mw.unstable_cancelCallback, $cd9bb691314980fc$var$shouldYield = $dY8mw.unstable_shouldYield, $cd9bb691314980fc$var$requestPaint = $dY8mw.unstable_requestPaint, $cd9bb691314980fc$var$now = $dY8mw.unstable_now, $cd9bb691314980fc$var$getCurrentPriorityLevel = $dY8mw.unstable_getCurrentPriorityLevel, $cd9bb691314980fc$var$ImmediatePriority = $dY8mw.unstable_ImmediatePriority, $cd9bb691314980fc$var$UserBlockingPriority = $dY8mw.unstable_UserBlockingPriority, $cd9bb691314980fc$var$NormalPriority$1 = $dY8mw.unstable_NormalPriority, $cd9bb691314980fc$var$LowPriority = $dY8mw.unstable_LowPriority, $cd9bb691314980fc$var$IdlePriority = $dY8mw.unstable_IdlePriority, $cd9bb691314980fc$var$log$1 = $dY8mw.log, $cd9bb691314980fc$var$unstable_setDisableYieldValue = $dY8mw.unstable_setDisableYieldValue, $cd9bb691314980fc$var$rendererID = null, $cd9bb691314980fc$var$injectedHook = null;
function $cd9bb691314980fc$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $cd9bb691314980fc$var$log$1 && $cd9bb691314980fc$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($cd9bb691314980fc$var$injectedHook && "function" === typeof $cd9bb691314980fc$var$injectedHook.setStrictMode) try {
        $cd9bb691314980fc$var$injectedHook.setStrictMode($cd9bb691314980fc$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $cd9bb691314980fc$var$clz32 = Math.clz32 ? Math.clz32 : $cd9bb691314980fc$var$clz32Fallback, $cd9bb691314980fc$var$log = Math.log, $cd9bb691314980fc$var$LN2 = Math.LN2;
function $cd9bb691314980fc$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($cd9bb691314980fc$var$log(x) / $cd9bb691314980fc$var$LN2 | 0) | 0;
}
var $cd9bb691314980fc$var$nextTransitionLane = 256, $cd9bb691314980fc$var$nextRetryLane = 4194304;
function $cd9bb691314980fc$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $cd9bb691314980fc$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $cd9bb691314980fc$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $cd9bb691314980fc$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $cd9bb691314980fc$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $cd9bb691314980fc$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $cd9bb691314980fc$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $cd9bb691314980fc$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $cd9bb691314980fc$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $cd9bb691314980fc$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $cd9bb691314980fc$var$claimNextTransitionLane() {
    var lane = $cd9bb691314980fc$var$nextTransitionLane;
    $cd9bb691314980fc$var$nextTransitionLane <<= 1;
    0 === ($cd9bb691314980fc$var$nextTransitionLane & 4194048) && ($cd9bb691314980fc$var$nextTransitionLane = 256);
    return lane;
}
function $cd9bb691314980fc$var$claimNextRetryLane() {
    var lane = $cd9bb691314980fc$var$nextRetryLane;
    $cd9bb691314980fc$var$nextRetryLane <<= 1;
    0 === ($cd9bb691314980fc$var$nextRetryLane & 62914560) && ($cd9bb691314980fc$var$nextRetryLane = 4194304);
    return lane;
}
function $cd9bb691314980fc$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $cd9bb691314980fc$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $cd9bb691314980fc$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - $cd9bb691314980fc$var$clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $cd9bb691314980fc$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $cd9bb691314980fc$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $cd9bb691314980fc$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function $cd9bb691314980fc$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - $cd9bb691314980fc$var$clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $cd9bb691314980fc$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $cd9bb691314980fc$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $cd9bb691314980fc$var$resolveUpdatePriority() {
    var updatePriority = $cd9bb691314980fc$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $cd9bb691314980fc$var$getEventPriority(updatePriority.type);
}
function $cd9bb691314980fc$var$runWithPriority(priority, fn) {
    var previousPriority = $cd9bb691314980fc$var$ReactDOMSharedInternals.p;
    try {
        return $cd9bb691314980fc$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $cd9bb691314980fc$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $cd9bb691314980fc$var$randomKey = Math.random().toString(36).slice(2), $cd9bb691314980fc$var$internalInstanceKey = "__reactFiber$" + $cd9bb691314980fc$var$randomKey, $cd9bb691314980fc$var$internalPropsKey = "__reactProps$" + $cd9bb691314980fc$var$randomKey, $cd9bb691314980fc$var$internalContainerInstanceKey = "__reactContainer$" + $cd9bb691314980fc$var$randomKey, $cd9bb691314980fc$var$internalEventHandlersKey = "__reactEvents$" + $cd9bb691314980fc$var$randomKey, $cd9bb691314980fc$var$internalEventHandlerListenersKey = "__reactListeners$" + $cd9bb691314980fc$var$randomKey, $cd9bb691314980fc$var$internalEventHandlesSetKey = "__reactHandles$" + $cd9bb691314980fc$var$randomKey, $cd9bb691314980fc$var$internalRootNodeResourcesKey = "__reactResources$" + $cd9bb691314980fc$var$randomKey, $cd9bb691314980fc$var$internalHoistableMarker = "__reactMarker$" + $cd9bb691314980fc$var$randomKey;
function $cd9bb691314980fc$var$detachDeletedInstance(node) {
    delete node[$cd9bb691314980fc$var$internalInstanceKey];
    delete node[$cd9bb691314980fc$var$internalPropsKey];
    delete node[$cd9bb691314980fc$var$internalEventHandlersKey];
    delete node[$cd9bb691314980fc$var$internalEventHandlerListenersKey];
    delete node[$cd9bb691314980fc$var$internalEventHandlesSetKey];
}
function $cd9bb691314980fc$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$cd9bb691314980fc$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$cd9bb691314980fc$var$internalContainerInstanceKey] || parentNode[$cd9bb691314980fc$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $cd9bb691314980fc$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$cd9bb691314980fc$var$internalInstanceKey]) return parentNode;
                targetNode = $cd9bb691314980fc$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $cd9bb691314980fc$var$getInstanceFromNode(node) {
    if (node = node[$cd9bb691314980fc$var$internalInstanceKey] || node[$cd9bb691314980fc$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $cd9bb691314980fc$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($cd9bb691314980fc$var$formatProdErrorMessage(33));
}
function $cd9bb691314980fc$var$getResourcesFromRoot(root) {
    var resources = root[$cd9bb691314980fc$var$internalRootNodeResourcesKey];
    resources || (resources = root[$cd9bb691314980fc$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $cd9bb691314980fc$var$markNodeAsHoistable(node) {
    node[$cd9bb691314980fc$var$internalHoistableMarker] = !0;
}
var $cd9bb691314980fc$var$allNativeEvents = new Set(), $cd9bb691314980fc$var$registrationNameDependencies = {};
function $cd9bb691314980fc$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $cd9bb691314980fc$var$registerDirectEvent(registrationName, dependencies);
    $cd9bb691314980fc$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $cd9bb691314980fc$var$registerDirectEvent(registrationName, dependencies) {
    $cd9bb691314980fc$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$cd9bb691314980fc$var$allNativeEvents.add(dependencies[registrationName]);
}
var $cd9bb691314980fc$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $cd9bb691314980fc$var$illegalAttributeNameCache = {}, $cd9bb691314980fc$var$validatedAttributeNameCache = {};
function $cd9bb691314980fc$var$isAttributeNameSafe(attributeName) {
    if ($cd9bb691314980fc$var$hasOwnProperty.call($cd9bb691314980fc$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($cd9bb691314980fc$var$hasOwnProperty.call($cd9bb691314980fc$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($cd9bb691314980fc$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $cd9bb691314980fc$var$validatedAttributeNameCache[attributeName] = !0;
    $cd9bb691314980fc$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $cd9bb691314980fc$var$setValueForAttribute(node, name, value) {
    if ($cd9bb691314980fc$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $cd9bb691314980fc$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $cd9bb691314980fc$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var $cd9bb691314980fc$var$prefix, $cd9bb691314980fc$var$suffix;
function $cd9bb691314980fc$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $cd9bb691314980fc$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $cd9bb691314980fc$var$prefix = match && match[1] || "";
        $cd9bb691314980fc$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $cd9bb691314980fc$var$prefix + name + $cd9bb691314980fc$var$suffix;
}
var $cd9bb691314980fc$var$reentry = !1;
function $cd9bb691314980fc$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $cd9bb691314980fc$var$reentry) return "";
    $cd9bb691314980fc$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $cd9bb691314980fc$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $cd9bb691314980fc$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $cd9bb691314980fc$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $cd9bb691314980fc$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $cd9bb691314980fc$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $cd9bb691314980fc$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $cd9bb691314980fc$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $cd9bb691314980fc$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $cd9bb691314980fc$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $cd9bb691314980fc$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $cd9bb691314980fc$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $cd9bb691314980fc$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $cd9bb691314980fc$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $cd9bb691314980fc$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $cd9bb691314980fc$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $cd9bb691314980fc$var$trackValueOnNode(node) {
    var valueField = $cd9bb691314980fc$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $cd9bb691314980fc$var$track(node) {
    node._valueTracker || (node._valueTracker = $cd9bb691314980fc$var$trackValueOnNode(node));
}
function $cd9bb691314980fc$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $cd9bb691314980fc$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $cd9bb691314980fc$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $cd9bb691314980fc$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $cd9bb691314980fc$var$getToStringValue(value);
        } else element.value !== "" + $cd9bb691314980fc$var$getToStringValue(value) && (element.value = "" + $cd9bb691314980fc$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $cd9bb691314980fc$var$setDefaultValue(element, type, $cd9bb691314980fc$var$getToStringValue(value)) : null != defaultValue ? $cd9bb691314980fc$var$setDefaultValue(element, type, $cd9bb691314980fc$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $cd9bb691314980fc$var$getToStringValue(name) : element.removeAttribute("name");
}
function $cd9bb691314980fc$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $cd9bb691314980fc$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $cd9bb691314980fc$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $cd9bb691314980fc$var$setDefaultValue(node, type, value) {
    "number" === type && $cd9bb691314980fc$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $cd9bb691314980fc$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $cd9bb691314980fc$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $cd9bb691314980fc$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $cd9bb691314980fc$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $cd9bb691314980fc$var$getToStringValue(defaultValue) : "";
}
function $cd9bb691314980fc$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(92));
            if ($cd9bb691314980fc$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $cd9bb691314980fc$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $cd9bb691314980fc$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $cd9bb691314980fc$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $cd9bb691314980fc$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $cd9bb691314980fc$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $cd9bb691314980fc$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $cd9bb691314980fc$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $cd9bb691314980fc$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $cd9bb691314980fc$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $cd9bb691314980fc$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $cd9bb691314980fc$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $cd9bb691314980fc$var$sanitizeURL(url) {
    return $cd9bb691314980fc$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $cd9bb691314980fc$var$currentReplayingEvent = null;
function $cd9bb691314980fc$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $cd9bb691314980fc$var$restoreTarget = null, $cd9bb691314980fc$var$restoreQueue = null;
function $cd9bb691314980fc$var$restoreStateOfTarget(target) {
    var internalInstance = $cd9bb691314980fc$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$cd9bb691314980fc$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $cd9bb691314980fc$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$cd9bb691314980fc$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(90));
                            $cd9bb691314980fc$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $cd9bb691314980fc$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $cd9bb691314980fc$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $cd9bb691314980fc$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $cd9bb691314980fc$var$isInsideEventHandler = !1;
function $cd9bb691314980fc$var$batchedUpdates$1(fn, a, b) {
    if ($cd9bb691314980fc$var$isInsideEventHandler) return fn(a, b);
    $cd9bb691314980fc$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($cd9bb691314980fc$var$isInsideEventHandler = !1, null !== $cd9bb691314980fc$var$restoreTarget || null !== $cd9bb691314980fc$var$restoreQueue) {
            if ($cd9bb691314980fc$var$flushSyncWork$1(), $cd9bb691314980fc$var$restoreTarget && (a = $cd9bb691314980fc$var$restoreTarget, fn = $cd9bb691314980fc$var$restoreQueue, $cd9bb691314980fc$var$restoreQueue = $cd9bb691314980fc$var$restoreTarget = null, $cd9bb691314980fc$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$cd9bb691314980fc$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $cd9bb691314980fc$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$cd9bb691314980fc$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $cd9bb691314980fc$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $cd9bb691314980fc$var$passiveBrowserEventsSupported = !1;
if ($cd9bb691314980fc$var$canUseDOM) try {
    var $cd9bb691314980fc$var$options = {};
    Object.defineProperty($cd9bb691314980fc$var$options, "passive", {
        get: function() {
            $cd9bb691314980fc$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $cd9bb691314980fc$var$options, $cd9bb691314980fc$var$options);
    window.removeEventListener("test", $cd9bb691314980fc$var$options, $cd9bb691314980fc$var$options);
} catch (e) {
    $cd9bb691314980fc$var$passiveBrowserEventsSupported = !1;
}
var $cd9bb691314980fc$var$root = null, $cd9bb691314980fc$var$startText = null, $cd9bb691314980fc$var$fallbackText = null;
function $cd9bb691314980fc$var$getData() {
    if ($cd9bb691314980fc$var$fallbackText) return $cd9bb691314980fc$var$fallbackText;
    var start, startValue = $cd9bb691314980fc$var$startText, startLength = startValue.length, end, endValue = "value" in $cd9bb691314980fc$var$root ? $cd9bb691314980fc$var$root.value : $cd9bb691314980fc$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $cd9bb691314980fc$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $cd9bb691314980fc$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $cd9bb691314980fc$var$functionThatReturnsTrue() {
    return !0;
}
function $cd9bb691314980fc$var$functionThatReturnsFalse() {
    return !1;
}
function $cd9bb691314980fc$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $cd9bb691314980fc$var$functionThatReturnsTrue : $cd9bb691314980fc$var$functionThatReturnsFalse;
        this.isPropagationStopped = $cd9bb691314980fc$var$functionThatReturnsFalse;
        return this;
    }
    $cd9bb691314980fc$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $cd9bb691314980fc$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $cd9bb691314980fc$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $cd9bb691314980fc$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $cd9bb691314980fc$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $cd9bb691314980fc$var$SyntheticEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$EventInterface), $cd9bb691314980fc$var$UIEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$EventInterface, {
    view: 0,
    detail: 0
}), $cd9bb691314980fc$var$SyntheticUIEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$UIEventInterface), $cd9bb691314980fc$var$lastMovementX, $cd9bb691314980fc$var$lastMovementY, $cd9bb691314980fc$var$lastMouseEvent, $cd9bb691314980fc$var$MouseEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $cd9bb691314980fc$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $cd9bb691314980fc$var$lastMouseEvent && ($cd9bb691314980fc$var$lastMouseEvent && "mousemove" === event.type ? ($cd9bb691314980fc$var$lastMovementX = event.screenX - $cd9bb691314980fc$var$lastMouseEvent.screenX, $cd9bb691314980fc$var$lastMovementY = event.screenY - $cd9bb691314980fc$var$lastMouseEvent.screenY) : $cd9bb691314980fc$var$lastMovementY = $cd9bb691314980fc$var$lastMovementX = 0, $cd9bb691314980fc$var$lastMouseEvent = event);
        return $cd9bb691314980fc$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $cd9bb691314980fc$var$lastMovementY;
    }
}), $cd9bb691314980fc$var$SyntheticMouseEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$MouseEventInterface), $cd9bb691314980fc$var$DragEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$MouseEventInterface, {
    dataTransfer: 0
}), $cd9bb691314980fc$var$SyntheticDragEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$DragEventInterface), $cd9bb691314980fc$var$FocusEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$UIEventInterface, {
    relatedTarget: 0
}), $cd9bb691314980fc$var$SyntheticFocusEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$FocusEventInterface), $cd9bb691314980fc$var$AnimationEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $cd9bb691314980fc$var$SyntheticAnimationEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$AnimationEventInterface), $cd9bb691314980fc$var$ClipboardEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $cd9bb691314980fc$var$SyntheticClipboardEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$ClipboardEventInterface), $cd9bb691314980fc$var$CompositionEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$EventInterface, {
    data: 0
}), $cd9bb691314980fc$var$SyntheticCompositionEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$CompositionEventInterface), $cd9bb691314980fc$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $cd9bb691314980fc$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $cd9bb691314980fc$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $cd9bb691314980fc$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $cd9bb691314980fc$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $cd9bb691314980fc$var$getEventModifierState() {
    return $cd9bb691314980fc$var$modifierStateGetter;
}
var $cd9bb691314980fc$var$KeyboardEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $cd9bb691314980fc$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $cd9bb691314980fc$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $cd9bb691314980fc$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $cd9bb691314980fc$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $cd9bb691314980fc$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $cd9bb691314980fc$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $cd9bb691314980fc$var$SyntheticKeyboardEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$KeyboardEventInterface), $cd9bb691314980fc$var$PointerEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $cd9bb691314980fc$var$SyntheticPointerEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$PointerEventInterface), $cd9bb691314980fc$var$TouchEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $cd9bb691314980fc$var$getEventModifierState
}), $cd9bb691314980fc$var$SyntheticTouchEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$TouchEventInterface), $cd9bb691314980fc$var$TransitionEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $cd9bb691314980fc$var$SyntheticTransitionEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$TransitionEventInterface), $cd9bb691314980fc$var$WheelEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $cd9bb691314980fc$var$SyntheticWheelEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$WheelEventInterface), $cd9bb691314980fc$var$ToggleEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $cd9bb691314980fc$var$SyntheticToggleEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$ToggleEventInterface), $cd9bb691314980fc$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $cd9bb691314980fc$var$canUseCompositionEvent = $cd9bb691314980fc$var$canUseDOM && "CompositionEvent" in window, $cd9bb691314980fc$var$documentMode = null;
$cd9bb691314980fc$var$canUseDOM && "documentMode" in document && ($cd9bb691314980fc$var$documentMode = document.documentMode);
var $cd9bb691314980fc$var$canUseTextInputEvent = $cd9bb691314980fc$var$canUseDOM && "TextEvent" in window && !$cd9bb691314980fc$var$documentMode, $cd9bb691314980fc$var$useFallbackCompositionData = $cd9bb691314980fc$var$canUseDOM && (!$cd9bb691314980fc$var$canUseCompositionEvent || $cd9bb691314980fc$var$documentMode && 8 < $cd9bb691314980fc$var$documentMode && 11 >= $cd9bb691314980fc$var$documentMode), $cd9bb691314980fc$var$SPACEBAR_CHAR = String.fromCharCode(32), $cd9bb691314980fc$var$hasSpaceKeypress = !1;
function $cd9bb691314980fc$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $cd9bb691314980fc$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $cd9bb691314980fc$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $cd9bb691314980fc$var$isComposing = !1;
function $cd9bb691314980fc$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $cd9bb691314980fc$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $cd9bb691314980fc$var$hasSpaceKeypress = !0;
            return $cd9bb691314980fc$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $cd9bb691314980fc$var$SPACEBAR_CHAR && $cd9bb691314980fc$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $cd9bb691314980fc$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($cd9bb691314980fc$var$isComposing) return "compositionend" === domEventName || !$cd9bb691314980fc$var$canUseCompositionEvent && $cd9bb691314980fc$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $cd9bb691314980fc$var$getData(), $cd9bb691314980fc$var$fallbackText = $cd9bb691314980fc$var$startText = $cd9bb691314980fc$var$root = null, $cd9bb691314980fc$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $cd9bb691314980fc$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $cd9bb691314980fc$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $cd9bb691314980fc$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$cd9bb691314980fc$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $cd9bb691314980fc$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $cd9bb691314980fc$var$restoreTarget ? $cd9bb691314980fc$var$restoreQueue ? $cd9bb691314980fc$var$restoreQueue.push(target) : $cd9bb691314980fc$var$restoreQueue = [
        target
    ] : $cd9bb691314980fc$var$restoreTarget = target;
    inst = $cd9bb691314980fc$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $cd9bb691314980fc$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $cd9bb691314980fc$var$activeElement$1 = null, $cd9bb691314980fc$var$activeElementInst$1 = null;
function $cd9bb691314980fc$var$runEventInBatch(dispatchQueue) {
    $cd9bb691314980fc$var$processDispatchQueue(dispatchQueue, 0);
}
function $cd9bb691314980fc$var$getInstIfValueChanged(targetInst) {
    var targetNode = $cd9bb691314980fc$var$getNodeFromInstance(targetInst);
    if ($cd9bb691314980fc$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $cd9bb691314980fc$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $cd9bb691314980fc$var$isInputEventSupported = !1;
if ($cd9bb691314980fc$var$canUseDOM) {
    var $cd9bb691314980fc$var$JSCompiler_inline_result$jscomp$282;
    if ($cd9bb691314980fc$var$canUseDOM) {
        var $cd9bb691314980fc$var$isSupported$jscomp$inline_417 = "oninput" in document;
        if (!$cd9bb691314980fc$var$isSupported$jscomp$inline_417) {
            var $cd9bb691314980fc$var$element$jscomp$inline_418 = document.createElement("div");
            $cd9bb691314980fc$var$element$jscomp$inline_418.setAttribute("oninput", "return;");
            $cd9bb691314980fc$var$isSupported$jscomp$inline_417 = "function" === typeof $cd9bb691314980fc$var$element$jscomp$inline_418.oninput;
        }
        $cd9bb691314980fc$var$JSCompiler_inline_result$jscomp$282 = $cd9bb691314980fc$var$isSupported$jscomp$inline_417;
    } else $cd9bb691314980fc$var$JSCompiler_inline_result$jscomp$282 = !1;
    $cd9bb691314980fc$var$isInputEventSupported = $cd9bb691314980fc$var$JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function $cd9bb691314980fc$var$stopWatchingForValueChange() {
    $cd9bb691314980fc$var$activeElement$1 && ($cd9bb691314980fc$var$activeElement$1.detachEvent("onpropertychange", $cd9bb691314980fc$var$handlePropertyChange), $cd9bb691314980fc$var$activeElementInst$1 = $cd9bb691314980fc$var$activeElement$1 = null);
}
function $cd9bb691314980fc$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $cd9bb691314980fc$var$getInstIfValueChanged($cd9bb691314980fc$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $cd9bb691314980fc$var$createAndAccumulateChangeEvent(dispatchQueue, $cd9bb691314980fc$var$activeElementInst$1, nativeEvent, $cd9bb691314980fc$var$getEventTarget(nativeEvent));
        $cd9bb691314980fc$var$batchedUpdates$1($cd9bb691314980fc$var$runEventInBatch, dispatchQueue);
    }
}
function $cd9bb691314980fc$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($cd9bb691314980fc$var$stopWatchingForValueChange(), $cd9bb691314980fc$var$activeElement$1 = target, $cd9bb691314980fc$var$activeElementInst$1 = targetInst, $cd9bb691314980fc$var$activeElement$1.attachEvent("onpropertychange", $cd9bb691314980fc$var$handlePropertyChange)) : "focusout" === domEventName && $cd9bb691314980fc$var$stopWatchingForValueChange();
}
function $cd9bb691314980fc$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $cd9bb691314980fc$var$getInstIfValueChanged($cd9bb691314980fc$var$activeElementInst$1);
}
function $cd9bb691314980fc$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $cd9bb691314980fc$var$getInstIfValueChanged(targetInst);
}
function $cd9bb691314980fc$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $cd9bb691314980fc$var$getInstIfValueChanged(targetInst);
}
function $cd9bb691314980fc$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $cd9bb691314980fc$var$objectIs = "function" === typeof Object.is ? Object.is : $cd9bb691314980fc$var$is;
function $cd9bb691314980fc$var$shallowEqual(objA, objB) {
    if ($cd9bb691314980fc$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$cd9bb691314980fc$var$hasOwnProperty.call(objB, currentKey) || !$cd9bb691314980fc$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $cd9bb691314980fc$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $cd9bb691314980fc$var$getNodeForCharacterOffset(root, offset) {
    var node = $cd9bb691314980fc$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $cd9bb691314980fc$var$getLeafNode(node);
    }
}
function $cd9bb691314980fc$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $cd9bb691314980fc$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $cd9bb691314980fc$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $cd9bb691314980fc$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $cd9bb691314980fc$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $cd9bb691314980fc$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $cd9bb691314980fc$var$skipSelectionChangeEvent = $cd9bb691314980fc$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $cd9bb691314980fc$var$activeElement = null, $cd9bb691314980fc$var$activeElementInst = null, $cd9bb691314980fc$var$lastSelection = null, $cd9bb691314980fc$var$mouseDown = !1;
function $cd9bb691314980fc$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $cd9bb691314980fc$var$mouseDown || null == $cd9bb691314980fc$var$activeElement || $cd9bb691314980fc$var$activeElement !== $cd9bb691314980fc$var$getActiveElement(doc) || (doc = $cd9bb691314980fc$var$activeElement, "selectionStart" in doc && $cd9bb691314980fc$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $cd9bb691314980fc$var$lastSelection && $cd9bb691314980fc$var$shallowEqual($cd9bb691314980fc$var$lastSelection, doc) || ($cd9bb691314980fc$var$lastSelection = doc, doc = $cd9bb691314980fc$var$accumulateTwoPhaseListeners($cd9bb691314980fc$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $cd9bb691314980fc$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $cd9bb691314980fc$var$activeElement)));
}
function $cd9bb691314980fc$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $cd9bb691314980fc$var$vendorPrefixes = {
    animationend: $cd9bb691314980fc$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $cd9bb691314980fc$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $cd9bb691314980fc$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $cd9bb691314980fc$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $cd9bb691314980fc$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $cd9bb691314980fc$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $cd9bb691314980fc$var$makePrefixMap("Transition", "TransitionEnd")
}, $cd9bb691314980fc$var$prefixedEventNames = {}, $cd9bb691314980fc$var$style = {};
$cd9bb691314980fc$var$canUseDOM && ($cd9bb691314980fc$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $cd9bb691314980fc$var$vendorPrefixes.animationend.animation, delete $cd9bb691314980fc$var$vendorPrefixes.animationiteration.animation, delete $cd9bb691314980fc$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $cd9bb691314980fc$var$vendorPrefixes.transitionend.transition);
function $cd9bb691314980fc$var$getVendorPrefixedEventName(eventName) {
    if ($cd9bb691314980fc$var$prefixedEventNames[eventName]) return $cd9bb691314980fc$var$prefixedEventNames[eventName];
    if (!$cd9bb691314980fc$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $cd9bb691314980fc$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $cd9bb691314980fc$var$style) return $cd9bb691314980fc$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $cd9bb691314980fc$var$ANIMATION_END = $cd9bb691314980fc$var$getVendorPrefixedEventName("animationend"), $cd9bb691314980fc$var$ANIMATION_ITERATION = $cd9bb691314980fc$var$getVendorPrefixedEventName("animationiteration"), $cd9bb691314980fc$var$ANIMATION_START = $cd9bb691314980fc$var$getVendorPrefixedEventName("animationstart"), $cd9bb691314980fc$var$TRANSITION_RUN = $cd9bb691314980fc$var$getVendorPrefixedEventName("transitionrun"), $cd9bb691314980fc$var$TRANSITION_START = $cd9bb691314980fc$var$getVendorPrefixedEventName("transitionstart"), $cd9bb691314980fc$var$TRANSITION_CANCEL = $cd9bb691314980fc$var$getVendorPrefixedEventName("transitioncancel"), $cd9bb691314980fc$var$TRANSITION_END = $cd9bb691314980fc$var$getVendorPrefixedEventName("transitionend"), $cd9bb691314980fc$var$topLevelEventsToReactNames = new Map(), $cd9bb691314980fc$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$cd9bb691314980fc$var$simpleEventPluginEvents.push("scrollEnd");
function $cd9bb691314980fc$var$registerSimpleEvent(domEventName, reactName) {
    $cd9bb691314980fc$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $cd9bb691314980fc$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $cd9bb691314980fc$var$CapturedStacks = new WeakMap();
function $cd9bb691314980fc$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $cd9bb691314980fc$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $cd9bb691314980fc$var$getStackByFiberInDevAndProd(source)
        };
        $cd9bb691314980fc$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $cd9bb691314980fc$var$getStackByFiberInDevAndProd(source)
    };
}
var $cd9bb691314980fc$var$concurrentQueues = [], $cd9bb691314980fc$var$concurrentQueuesIndex = 0, $cd9bb691314980fc$var$concurrentlyUpdatedLanes = 0;
function $cd9bb691314980fc$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $cd9bb691314980fc$var$concurrentQueuesIndex, i = $cd9bb691314980fc$var$concurrentlyUpdatedLanes = $cd9bb691314980fc$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $cd9bb691314980fc$var$concurrentQueues[i];
        $cd9bb691314980fc$var$concurrentQueues[i++] = null;
        var queue = $cd9bb691314980fc$var$concurrentQueues[i];
        $cd9bb691314980fc$var$concurrentQueues[i++] = null;
        var update = $cd9bb691314980fc$var$concurrentQueues[i];
        $cd9bb691314980fc$var$concurrentQueues[i++] = null;
        var lane = $cd9bb691314980fc$var$concurrentQueues[i];
        $cd9bb691314980fc$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $cd9bb691314980fc$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $cd9bb691314980fc$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $cd9bb691314980fc$var$concurrentQueues[$cd9bb691314980fc$var$concurrentQueuesIndex++] = fiber;
    $cd9bb691314980fc$var$concurrentQueues[$cd9bb691314980fc$var$concurrentQueuesIndex++] = queue;
    $cd9bb691314980fc$var$concurrentQueues[$cd9bb691314980fc$var$concurrentQueuesIndex++] = update;
    $cd9bb691314980fc$var$concurrentQueues[$cd9bb691314980fc$var$concurrentQueuesIndex++] = lane;
    $cd9bb691314980fc$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $cd9bb691314980fc$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $cd9bb691314980fc$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $cd9bb691314980fc$var$getRootForUpdatedFiber(fiber);
}
function $cd9bb691314980fc$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $cd9bb691314980fc$var$enqueueUpdate$1(fiber, null, null, lane);
    return $cd9bb691314980fc$var$getRootForUpdatedFiber(fiber);
}
function $cd9bb691314980fc$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $cd9bb691314980fc$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $cd9bb691314980fc$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $cd9bb691314980fc$var$nestedUpdateCount) throw $cd9bb691314980fc$var$nestedUpdateCount = 0, $cd9bb691314980fc$var$rootWithNestedUpdates = null, Error($cd9bb691314980fc$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $cd9bb691314980fc$var$emptyContextObject = {};
function $cd9bb691314980fc$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $cd9bb691314980fc$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $cd9bb691314980fc$var$FiberNode(tag, pendingProps, key, mode);
}
function $cd9bb691314980fc$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $cd9bb691314980fc$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $cd9bb691314980fc$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $cd9bb691314980fc$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $cd9bb691314980fc$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $cd9bb691314980fc$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $cd9bb691314980fc$var$isHostHoistableType(type, pendingProps, $cd9bb691314980fc$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $cd9bb691314980fc$var$REACT_ACTIVITY_TYPE:
            return type = $cd9bb691314980fc$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $cd9bb691314980fc$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $cd9bb691314980fc$var$REACT_FRAGMENT_TYPE:
            return $cd9bb691314980fc$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $cd9bb691314980fc$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $cd9bb691314980fc$var$REACT_PROFILER_TYPE:
            return type = $cd9bb691314980fc$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $cd9bb691314980fc$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $cd9bb691314980fc$var$REACT_SUSPENSE_TYPE:
            return type = $cd9bb691314980fc$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $cd9bb691314980fc$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $cd9bb691314980fc$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $cd9bb691314980fc$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $cd9bb691314980fc$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $cd9bb691314980fc$var$REACT_PROVIDER_TYPE:
                case $cd9bb691314980fc$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $cd9bb691314980fc$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $cd9bb691314980fc$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $cd9bb691314980fc$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $cd9bb691314980fc$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($cd9bb691314980fc$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $cd9bb691314980fc$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $cd9bb691314980fc$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $cd9bb691314980fc$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $cd9bb691314980fc$var$createFiberFromText(content, mode, lanes) {
    content = $cd9bb691314980fc$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $cd9bb691314980fc$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $cd9bb691314980fc$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $cd9bb691314980fc$var$forkStack = [], $cd9bb691314980fc$var$forkStackIndex = 0, $cd9bb691314980fc$var$treeForkProvider = null, $cd9bb691314980fc$var$treeForkCount = 0, $cd9bb691314980fc$var$idStack = [], $cd9bb691314980fc$var$idStackIndex = 0, $cd9bb691314980fc$var$treeContextProvider = null, $cd9bb691314980fc$var$treeContextId = 1, $cd9bb691314980fc$var$treeContextOverflow = "";
function $cd9bb691314980fc$var$pushTreeFork(workInProgress, totalChildren) {
    $cd9bb691314980fc$var$forkStack[$cd9bb691314980fc$var$forkStackIndex++] = $cd9bb691314980fc$var$treeForkCount;
    $cd9bb691314980fc$var$forkStack[$cd9bb691314980fc$var$forkStackIndex++] = $cd9bb691314980fc$var$treeForkProvider;
    $cd9bb691314980fc$var$treeForkProvider = workInProgress;
    $cd9bb691314980fc$var$treeForkCount = totalChildren;
}
function $cd9bb691314980fc$var$pushTreeId(workInProgress, totalChildren, index) {
    $cd9bb691314980fc$var$idStack[$cd9bb691314980fc$var$idStackIndex++] = $cd9bb691314980fc$var$treeContextId;
    $cd9bb691314980fc$var$idStack[$cd9bb691314980fc$var$idStackIndex++] = $cd9bb691314980fc$var$treeContextOverflow;
    $cd9bb691314980fc$var$idStack[$cd9bb691314980fc$var$idStackIndex++] = $cd9bb691314980fc$var$treeContextProvider;
    $cd9bb691314980fc$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $cd9bb691314980fc$var$treeContextId;
    workInProgress = $cd9bb691314980fc$var$treeContextOverflow;
    var baseLength = 32 - $cd9bb691314980fc$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $cd9bb691314980fc$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $cd9bb691314980fc$var$treeContextId = 1 << 32 - $cd9bb691314980fc$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $cd9bb691314980fc$var$treeContextOverflow = length + workInProgress;
    } else $cd9bb691314980fc$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $cd9bb691314980fc$var$treeContextOverflow = workInProgress;
}
function $cd9bb691314980fc$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($cd9bb691314980fc$var$pushTreeFork(workInProgress, 1), $cd9bb691314980fc$var$pushTreeId(workInProgress, 1, 0));
}
function $cd9bb691314980fc$var$popTreeContext(workInProgress) {
    for(; workInProgress === $cd9bb691314980fc$var$treeForkProvider;)$cd9bb691314980fc$var$treeForkProvider = $cd9bb691314980fc$var$forkStack[--$cd9bb691314980fc$var$forkStackIndex], $cd9bb691314980fc$var$forkStack[$cd9bb691314980fc$var$forkStackIndex] = null, $cd9bb691314980fc$var$treeForkCount = $cd9bb691314980fc$var$forkStack[--$cd9bb691314980fc$var$forkStackIndex], $cd9bb691314980fc$var$forkStack[$cd9bb691314980fc$var$forkStackIndex] = null;
    for(; workInProgress === $cd9bb691314980fc$var$treeContextProvider;)$cd9bb691314980fc$var$treeContextProvider = $cd9bb691314980fc$var$idStack[--$cd9bb691314980fc$var$idStackIndex], $cd9bb691314980fc$var$idStack[$cd9bb691314980fc$var$idStackIndex] = null, $cd9bb691314980fc$var$treeContextOverflow = $cd9bb691314980fc$var$idStack[--$cd9bb691314980fc$var$idStackIndex], $cd9bb691314980fc$var$idStack[$cd9bb691314980fc$var$idStackIndex] = null, $cd9bb691314980fc$var$treeContextId = $cd9bb691314980fc$var$idStack[--$cd9bb691314980fc$var$idStackIndex], $cd9bb691314980fc$var$idStack[$cd9bb691314980fc$var$idStackIndex] = null;
}
var $cd9bb691314980fc$var$hydrationParentFiber = null, $cd9bb691314980fc$var$nextHydratableInstance = null, $cd9bb691314980fc$var$isHydrating = !1, $cd9bb691314980fc$var$hydrationErrors = null, $cd9bb691314980fc$var$rootOrSingletonContext = !1, $cd9bb691314980fc$var$HydrationMismatchException = Error($cd9bb691314980fc$var$formatProdErrorMessage(519));
function $cd9bb691314980fc$var$throwOnHydrationMismatch(fiber) {
    var error = Error($cd9bb691314980fc$var$formatProdErrorMessage(418, ""));
    $cd9bb691314980fc$var$queueHydrationError($cd9bb691314980fc$var$createCapturedValueAtFiber(error, fiber));
    throw $cd9bb691314980fc$var$HydrationMismatchException;
}
function $cd9bb691314980fc$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$cd9bb691314980fc$var$internalInstanceKey] = fiber;
    instance[$cd9bb691314980fc$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("cancel", instance);
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $cd9bb691314980fc$var$mediaEventTypes.length; type++)$cd9bb691314980fc$var$listenToNonDelegatedEvent($cd9bb691314980fc$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("error", instance);
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("invalid", instance);
            $cd9bb691314980fc$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $cd9bb691314980fc$var$track(instance);
            break;
        case "select":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("invalid", instance), $cd9bb691314980fc$var$initTextarea(instance, props.value, props.defaultValue, props.children), $cd9bb691314980fc$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $cd9bb691314980fc$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($cd9bb691314980fc$var$listenToNonDelegatedEvent("beforetoggle", instance), $cd9bb691314980fc$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $cd9bb691314980fc$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $cd9bb691314980fc$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $cd9bb691314980fc$var$noop$1), instance = !0) : instance = !1;
    instance || $cd9bb691314980fc$var$throwOnHydrationMismatch(fiber);
}
function $cd9bb691314980fc$var$popToNextHostParent(fiber) {
    for($cd9bb691314980fc$var$hydrationParentFiber = fiber.return; $cd9bb691314980fc$var$hydrationParentFiber;)switch($cd9bb691314980fc$var$hydrationParentFiber.tag){
        case 5:
        case 13:
            $cd9bb691314980fc$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $cd9bb691314980fc$var$rootOrSingletonContext = !0;
            return;
        default:
            $cd9bb691314980fc$var$hydrationParentFiber = $cd9bb691314980fc$var$hydrationParentFiber.return;
    }
}
function $cd9bb691314980fc$var$popHydrationState(fiber) {
    if (fiber !== $cd9bb691314980fc$var$hydrationParentFiber) return !1;
    if (!$cd9bb691314980fc$var$isHydrating) return $cd9bb691314980fc$var$popToNextHostParent(fiber), $cd9bb691314980fc$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $cd9bb691314980fc$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $cd9bb691314980fc$var$nextHydratableInstance && $cd9bb691314980fc$var$throwOnHydrationMismatch(fiber);
    $cd9bb691314980fc$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            $cd9bb691314980fc$var$nextHydratableInstance = $cd9bb691314980fc$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            $cd9bb691314980fc$var$nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = $cd9bb691314980fc$var$nextHydratableInstance, $cd9bb691314980fc$var$isSingletonScope(fiber.type) ? (fiber = $cd9bb691314980fc$var$previousHydratableOnEnteringScopedSingleton, $cd9bb691314980fc$var$previousHydratableOnEnteringScopedSingleton = null, $cd9bb691314980fc$var$nextHydratableInstance = fiber) : $cd9bb691314980fc$var$nextHydratableInstance = tag) : $cd9bb691314980fc$var$nextHydratableInstance = $cd9bb691314980fc$var$hydrationParentFiber ? $cd9bb691314980fc$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $cd9bb691314980fc$var$resetHydrationState() {
    $cd9bb691314980fc$var$nextHydratableInstance = $cd9bb691314980fc$var$hydrationParentFiber = null;
    $cd9bb691314980fc$var$isHydrating = !1;
}
function $cd9bb691314980fc$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $cd9bb691314980fc$var$hydrationErrors;
    null !== queuedErrors && (null === $cd9bb691314980fc$var$workInProgressRootRecoverableErrors ? $cd9bb691314980fc$var$workInProgressRootRecoverableErrors = queuedErrors : $cd9bb691314980fc$var$workInProgressRootRecoverableErrors.push.apply($cd9bb691314980fc$var$workInProgressRootRecoverableErrors, queuedErrors), $cd9bb691314980fc$var$hydrationErrors = null);
    return queuedErrors;
}
function $cd9bb691314980fc$var$queueHydrationError(error) {
    null === $cd9bb691314980fc$var$hydrationErrors ? $cd9bb691314980fc$var$hydrationErrors = [
        error
    ] : $cd9bb691314980fc$var$hydrationErrors.push(error);
}
var $cd9bb691314980fc$var$valueCursor = $cd9bb691314980fc$var$createCursor(null), $cd9bb691314980fc$var$currentlyRenderingFiber$1 = null, $cd9bb691314980fc$var$lastContextDependency = null;
function $cd9bb691314980fc$var$pushProvider(providerFiber, context, nextValue) {
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $cd9bb691314980fc$var$popProvider(context) {
    context._currentValue = $cd9bb691314980fc$var$valueCursor.current;
    $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$valueCursor);
}
function $cd9bb691314980fc$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $cd9bb691314980fc$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $cd9bb691314980fc$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $cd9bb691314980fc$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $cd9bb691314980fc$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $cd9bb691314980fc$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $cd9bb691314980fc$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($cd9bb691314980fc$var$HostTransitionContext) : current = [
                $cd9bb691314980fc$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $cd9bb691314980fc$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $cd9bb691314980fc$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$cd9bb691314980fc$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $cd9bb691314980fc$var$prepareToReadContext(workInProgress) {
    $cd9bb691314980fc$var$currentlyRenderingFiber$1 = workInProgress;
    $cd9bb691314980fc$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $cd9bb691314980fc$var$readContext(context) {
    return $cd9bb691314980fc$var$readContextForConsumer($cd9bb691314980fc$var$currentlyRenderingFiber$1, context);
}
function $cd9bb691314980fc$var$readContextDuringReconciliation(consumer, context) {
    null === $cd9bb691314980fc$var$currentlyRenderingFiber$1 && $cd9bb691314980fc$var$prepareToReadContext(consumer);
    return $cd9bb691314980fc$var$readContextForConsumer(consumer, context);
}
function $cd9bb691314980fc$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $cd9bb691314980fc$var$lastContextDependency) {
        if (null === consumer) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(308));
        $cd9bb691314980fc$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $cd9bb691314980fc$var$lastContextDependency = $cd9bb691314980fc$var$lastContextDependency.next = context;
    return value;
}
var $cd9bb691314980fc$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $cd9bb691314980fc$var$scheduleCallback$2 = $dY8mw.unstable_scheduleCallback, $cd9bb691314980fc$var$NormalPriority = $dY8mw.unstable_NormalPriority, $cd9bb691314980fc$var$CacheContext = {
    $$typeof: $cd9bb691314980fc$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $cd9bb691314980fc$var$createCache() {
    return {
        controller: new $cd9bb691314980fc$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $cd9bb691314980fc$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $cd9bb691314980fc$var$scheduleCallback$2($cd9bb691314980fc$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $cd9bb691314980fc$var$currentEntangledListeners = null, $cd9bb691314980fc$var$currentEntangledPendingCount = 0, $cd9bb691314980fc$var$currentEntangledLane = 0, $cd9bb691314980fc$var$currentEntangledActionThenable = null;
function $cd9bb691314980fc$var$entangleAsyncAction(transition, thenable) {
    if (null === $cd9bb691314980fc$var$currentEntangledListeners) {
        var entangledListeners = $cd9bb691314980fc$var$currentEntangledListeners = [];
        $cd9bb691314980fc$var$currentEntangledPendingCount = 0;
        $cd9bb691314980fc$var$currentEntangledLane = $cd9bb691314980fc$var$requestTransitionLane();
        $cd9bb691314980fc$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $cd9bb691314980fc$var$currentEntangledPendingCount++;
    thenable.then($cd9bb691314980fc$var$pingEngtangledActionScope, $cd9bb691314980fc$var$pingEngtangledActionScope);
    return thenable;
}
function $cd9bb691314980fc$var$pingEngtangledActionScope() {
    if (0 === --$cd9bb691314980fc$var$currentEntangledPendingCount && null !== $cd9bb691314980fc$var$currentEntangledListeners) {
        null !== $cd9bb691314980fc$var$currentEntangledActionThenable && ($cd9bb691314980fc$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $cd9bb691314980fc$var$currentEntangledListeners;
        $cd9bb691314980fc$var$currentEntangledListeners = null;
        $cd9bb691314980fc$var$currentEntangledLane = 0;
        $cd9bb691314980fc$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $cd9bb691314980fc$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $cd9bb691314980fc$var$prevOnStartTransitionFinish = $cd9bb691314980fc$var$ReactSharedInternals.S;
$cd9bb691314980fc$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $cd9bb691314980fc$var$entangleAsyncAction(transition, returnValue);
    null !== $cd9bb691314980fc$var$prevOnStartTransitionFinish && $cd9bb691314980fc$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $cd9bb691314980fc$var$resumedCache = $cd9bb691314980fc$var$createCursor(null);
function $cd9bb691314980fc$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $cd9bb691314980fc$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $cd9bb691314980fc$var$workInProgressRoot.pooledCache;
}
function $cd9bb691314980fc$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $cd9bb691314980fc$var$push($cd9bb691314980fc$var$resumedCache, $cd9bb691314980fc$var$resumedCache.current) : $cd9bb691314980fc$var$push($cd9bb691314980fc$var$resumedCache, prevCachePool.pool);
}
function $cd9bb691314980fc$var$getSuspendedCache() {
    var cacheFromPool = $cd9bb691314980fc$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $cd9bb691314980fc$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $cd9bb691314980fc$var$SuspenseException = Error($cd9bb691314980fc$var$formatProdErrorMessage(460)), $cd9bb691314980fc$var$SuspenseyCommitException = Error($cd9bb691314980fc$var$formatProdErrorMessage(474)), $cd9bb691314980fc$var$SuspenseActionException = Error($cd9bb691314980fc$var$formatProdErrorMessage(542)), $cd9bb691314980fc$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $cd9bb691314980fc$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $cd9bb691314980fc$var$noop$3() {}
function $cd9bb691314980fc$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($cd9bb691314980fc$var$noop$3, $cd9bb691314980fc$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $cd9bb691314980fc$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($cd9bb691314980fc$var$noop$3, $cd9bb691314980fc$var$noop$3);
            else {
                thenableState = $cd9bb691314980fc$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $cd9bb691314980fc$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $cd9bb691314980fc$var$suspendedThenable = thenable;
            throw $cd9bb691314980fc$var$SuspenseException;
    }
}
var $cd9bb691314980fc$var$suspendedThenable = null;
function $cd9bb691314980fc$var$getSuspendedThenable() {
    if (null === $cd9bb691314980fc$var$suspendedThenable) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(459));
    var thenable = $cd9bb691314980fc$var$suspendedThenable;
    $cd9bb691314980fc$var$suspendedThenable = null;
    return thenable;
}
function $cd9bb691314980fc$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $cd9bb691314980fc$var$SuspenseException || rejectedReason === $cd9bb691314980fc$var$SuspenseActionException) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(483));
}
var $cd9bb691314980fc$var$hasForceUpdate = !1;
function $cd9bb691314980fc$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $cd9bb691314980fc$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $cd9bb691314980fc$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $cd9bb691314980fc$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($cd9bb691314980fc$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $cd9bb691314980fc$var$getRootForUpdatedFiber(fiber);
        $cd9bb691314980fc$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $cd9bb691314980fc$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $cd9bb691314980fc$var$getRootForUpdatedFiber(fiber);
}
function $cd9bb691314980fc$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $cd9bb691314980fc$var$markRootEntangled(root, lane);
    }
}
function $cd9bb691314980fc$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $cd9bb691314980fc$var$didReadFromEntangledAsyncAction = !1;
function $cd9bb691314980fc$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($cd9bb691314980fc$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $cd9bb691314980fc$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $cd9bb691314980fc$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $cd9bb691314980fc$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $cd9bb691314980fc$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($cd9bb691314980fc$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $cd9bb691314980fc$var$currentEntangledLane && ($cd9bb691314980fc$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $cd9bb691314980fc$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $cd9bb691314980fc$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $cd9bb691314980fc$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $cd9bb691314980fc$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $cd9bb691314980fc$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$cd9bb691314980fc$var$callCallback(callbacks[updateQueue], context);
}
var $cd9bb691314980fc$var$currentTreeHiddenStackCursor = $cd9bb691314980fc$var$createCursor(null), $cd9bb691314980fc$var$prevEntangledRenderLanesCursor = $cd9bb691314980fc$var$createCursor(0);
function $cd9bb691314980fc$var$pushHiddenContext(fiber, context) {
    fiber = $cd9bb691314980fc$var$entangledRenderLanes;
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$prevEntangledRenderLanesCursor, fiber);
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$currentTreeHiddenStackCursor, context);
    $cd9bb691314980fc$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $cd9bb691314980fc$var$reuseHiddenContextOnStack() {
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$prevEntangledRenderLanesCursor, $cd9bb691314980fc$var$entangledRenderLanes);
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$currentTreeHiddenStackCursor, $cd9bb691314980fc$var$currentTreeHiddenStackCursor.current);
}
function $cd9bb691314980fc$var$popHiddenContext() {
    $cd9bb691314980fc$var$entangledRenderLanes = $cd9bb691314980fc$var$prevEntangledRenderLanesCursor.current;
    $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$currentTreeHiddenStackCursor);
    $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$prevEntangledRenderLanesCursor);
}
var $cd9bb691314980fc$var$renderLanes = 0, $cd9bb691314980fc$var$currentlyRenderingFiber = null, $cd9bb691314980fc$var$currentHook = null, $cd9bb691314980fc$var$workInProgressHook = null, $cd9bb691314980fc$var$didScheduleRenderPhaseUpdate = !1, $cd9bb691314980fc$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $cd9bb691314980fc$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $cd9bb691314980fc$var$localIdCounter = 0, $cd9bb691314980fc$var$thenableIndexCounter$1 = 0, $cd9bb691314980fc$var$thenableState$1 = null, $cd9bb691314980fc$var$globalClientIdCounter = 0;
function $cd9bb691314980fc$var$throwInvalidHookError() {
    throw Error($cd9bb691314980fc$var$formatProdErrorMessage(321));
}
function $cd9bb691314980fc$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$cd9bb691314980fc$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $cd9bb691314980fc$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $cd9bb691314980fc$var$renderLanes = nextRenderLanes;
    $cd9bb691314980fc$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $cd9bb691314980fc$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $cd9bb691314980fc$var$HooksDispatcherOnMount : $cd9bb691314980fc$var$HooksDispatcherOnUpdate;
    $cd9bb691314980fc$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $cd9bb691314980fc$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $cd9bb691314980fc$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $cd9bb691314980fc$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $cd9bb691314980fc$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $cd9bb691314980fc$var$finishRenderingHooks(current) {
    $cd9bb691314980fc$var$ReactSharedInternals.H = $cd9bb691314980fc$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $cd9bb691314980fc$var$currentHook && null !== $cd9bb691314980fc$var$currentHook.next;
    $cd9bb691314980fc$var$renderLanes = 0;
    $cd9bb691314980fc$var$workInProgressHook = $cd9bb691314980fc$var$currentHook = $cd9bb691314980fc$var$currentlyRenderingFiber = null;
    $cd9bb691314980fc$var$didScheduleRenderPhaseUpdate = !1;
    $cd9bb691314980fc$var$thenableIndexCounter$1 = 0;
    $cd9bb691314980fc$var$thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(300));
    null === current || $cd9bb691314980fc$var$didReceiveUpdate || (current = current.dependencies, null !== current && $cd9bb691314980fc$var$checkIfContextChanged(current) && ($cd9bb691314980fc$var$didReceiveUpdate = !0));
}
function $cd9bb691314980fc$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $cd9bb691314980fc$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $cd9bb691314980fc$var$didScheduleRenderPhaseUpdateDuringThisPass && ($cd9bb691314980fc$var$thenableState$1 = null);
        $cd9bb691314980fc$var$thenableIndexCounter$1 = 0;
        $cd9bb691314980fc$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $cd9bb691314980fc$var$workInProgressHook = $cd9bb691314980fc$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $cd9bb691314980fc$var$ReactSharedInternals.H = $cd9bb691314980fc$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($cd9bb691314980fc$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $cd9bb691314980fc$var$TransitionAwareHostComponent() {
    var dispatcher = $cd9bb691314980fc$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $cd9bb691314980fc$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $cd9bb691314980fc$var$currentHook ? $cd9bb691314980fc$var$currentHook.memoizedState : null) !== dispatcher && ($cd9bb691314980fc$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $cd9bb691314980fc$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $cd9bb691314980fc$var$localIdCounter;
    $cd9bb691314980fc$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $cd9bb691314980fc$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $cd9bb691314980fc$var$resetHooksOnUnwind(workInProgress) {
    if ($cd9bb691314980fc$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $cd9bb691314980fc$var$didScheduleRenderPhaseUpdate = !1;
    }
    $cd9bb691314980fc$var$renderLanes = 0;
    $cd9bb691314980fc$var$workInProgressHook = $cd9bb691314980fc$var$currentHook = $cd9bb691314980fc$var$currentlyRenderingFiber = null;
    $cd9bb691314980fc$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $cd9bb691314980fc$var$thenableIndexCounter$1 = $cd9bb691314980fc$var$localIdCounter = 0;
    $cd9bb691314980fc$var$thenableState$1 = null;
}
function $cd9bb691314980fc$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $cd9bb691314980fc$var$workInProgressHook ? $cd9bb691314980fc$var$currentlyRenderingFiber.memoizedState = $cd9bb691314980fc$var$workInProgressHook = hook : $cd9bb691314980fc$var$workInProgressHook = $cd9bb691314980fc$var$workInProgressHook.next = hook;
    return $cd9bb691314980fc$var$workInProgressHook;
}
function $cd9bb691314980fc$var$updateWorkInProgressHook() {
    if (null === $cd9bb691314980fc$var$currentHook) {
        var nextCurrentHook = $cd9bb691314980fc$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $cd9bb691314980fc$var$currentHook.next;
    var nextWorkInProgressHook = null === $cd9bb691314980fc$var$workInProgressHook ? $cd9bb691314980fc$var$currentlyRenderingFiber.memoizedState : $cd9bb691314980fc$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $cd9bb691314980fc$var$workInProgressHook = nextWorkInProgressHook, $cd9bb691314980fc$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $cd9bb691314980fc$var$currentlyRenderingFiber.alternate) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(467));
            throw Error($cd9bb691314980fc$var$formatProdErrorMessage(310));
        }
        $cd9bb691314980fc$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $cd9bb691314980fc$var$currentHook.memoizedState,
            baseState: $cd9bb691314980fc$var$currentHook.baseState,
            baseQueue: $cd9bb691314980fc$var$currentHook.baseQueue,
            queue: $cd9bb691314980fc$var$currentHook.queue,
            next: null
        };
        null === $cd9bb691314980fc$var$workInProgressHook ? $cd9bb691314980fc$var$currentlyRenderingFiber.memoizedState = $cd9bb691314980fc$var$workInProgressHook = nextCurrentHook : $cd9bb691314980fc$var$workInProgressHook = $cd9bb691314980fc$var$workInProgressHook.next = nextCurrentHook;
    }
    return $cd9bb691314980fc$var$workInProgressHook;
}
function $cd9bb691314980fc$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $cd9bb691314980fc$var$useThenable(thenable) {
    var index = $cd9bb691314980fc$var$thenableIndexCounter$1;
    $cd9bb691314980fc$var$thenableIndexCounter$1 += 1;
    null === $cd9bb691314980fc$var$thenableState$1 && ($cd9bb691314980fc$var$thenableState$1 = []);
    thenable = $cd9bb691314980fc$var$trackUsedThenable($cd9bb691314980fc$var$thenableState$1, thenable, index);
    index = $cd9bb691314980fc$var$currentlyRenderingFiber;
    null === (null === $cd9bb691314980fc$var$workInProgressHook ? index.memoizedState : $cd9bb691314980fc$var$workInProgressHook.next) && (index = index.alternate, $cd9bb691314980fc$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $cd9bb691314980fc$var$HooksDispatcherOnMount : $cd9bb691314980fc$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $cd9bb691314980fc$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $cd9bb691314980fc$var$useThenable(usable);
        if (usable.$$typeof === $cd9bb691314980fc$var$REACT_CONTEXT_TYPE) return $cd9bb691314980fc$var$readContext(usable);
    }
    throw Error($cd9bb691314980fc$var$formatProdErrorMessage(438, String(usable)));
}
function $cd9bb691314980fc$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $cd9bb691314980fc$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $cd9bb691314980fc$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $cd9bb691314980fc$var$createFunctionComponentUpdateQueue(), $cd9bb691314980fc$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $cd9bb691314980fc$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $cd9bb691314980fc$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $cd9bb691314980fc$var$updateReducer(reducer) {
    var hook = $cd9bb691314980fc$var$updateWorkInProgressHook();
    return $cd9bb691314980fc$var$updateReducerImpl(hook, $cd9bb691314980fc$var$currentHook, reducer);
}
function $cd9bb691314980fc$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($cd9bb691314980fc$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($cd9bb691314980fc$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $cd9bb691314980fc$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if (($cd9bb691314980fc$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $cd9bb691314980fc$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $cd9bb691314980fc$var$currentlyRenderingFiber.lanes |= revertLane, $cd9bb691314980fc$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $cd9bb691314980fc$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $cd9bb691314980fc$var$currentlyRenderingFiber.lanes |= updateLane, $cd9bb691314980fc$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$cd9bb691314980fc$var$objectIs(pendingQueue, hook.memoizedState) && ($cd9bb691314980fc$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = $cd9bb691314980fc$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $cd9bb691314980fc$var$rerenderReducer(reducer) {
    var hook = $cd9bb691314980fc$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $cd9bb691314980fc$var$objectIs(newState, hook.memoizedState) || ($cd9bb691314980fc$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $cd9bb691314980fc$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $cd9bb691314980fc$var$currentlyRenderingFiber, hook = $cd9bb691314980fc$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $cd9bb691314980fc$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$cd9bb691314980fc$var$objectIs(($cd9bb691314980fc$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $cd9bb691314980fc$var$didReceiveUpdate = !0);
    hook = hook.queue;
    var create = $cd9bb691314980fc$var$subscribeToStore.bind(null, fiber, hook, subscribe);
    $cd9bb691314980fc$var$updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $cd9bb691314980fc$var$workInProgressHook && $cd9bb691314980fc$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $cd9bb691314980fc$var$pushSimpleEffect(9, $cd9bb691314980fc$var$createEffectInstance(), $cd9bb691314980fc$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $cd9bb691314980fc$var$workInProgressRoot) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($cd9bb691314980fc$var$renderLanes & 124) || $cd9bb691314980fc$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $cd9bb691314980fc$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $cd9bb691314980fc$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $cd9bb691314980fc$var$createFunctionComponentUpdateQueue(), $cd9bb691314980fc$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $cd9bb691314980fc$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $cd9bb691314980fc$var$checkIfSnapshotChanged(inst) && $cd9bb691314980fc$var$forceStoreRerender(fiber);
}
function $cd9bb691314980fc$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $cd9bb691314980fc$var$checkIfSnapshotChanged(inst) && $cd9bb691314980fc$var$forceStoreRerender(fiber);
    });
}
function $cd9bb691314980fc$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$cd9bb691314980fc$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $cd9bb691314980fc$var$forceStoreRerender(fiber) {
    var root = $cd9bb691314980fc$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $cd9bb691314980fc$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $cd9bb691314980fc$var$mountStateImpl(initialState) {
    var hook = $cd9bb691314980fc$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($cd9bb691314980fc$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $cd9bb691314980fc$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $cd9bb691314980fc$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $cd9bb691314980fc$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $cd9bb691314980fc$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $cd9bb691314980fc$var$updateReducerImpl(hook, $cd9bb691314980fc$var$currentHook, "function" === typeof reducer ? reducer : $cd9bb691314980fc$var$basicStateReducer);
}
function $cd9bb691314980fc$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($cd9bb691314980fc$var$isRenderPhaseUpdate(fiber)) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $cd9bb691314980fc$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $cd9bb691314980fc$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $cd9bb691314980fc$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $cd9bb691314980fc$var$ReactSharedInternals.T, currentTransition = {};
        $cd9bb691314980fc$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $cd9bb691314980fc$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $cd9bb691314980fc$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $cd9bb691314980fc$var$onActionError(actionQueue, node, error);
        } finally{
            $cd9bb691314980fc$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $cd9bb691314980fc$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        $cd9bb691314980fc$var$onActionError(actionQueue, node, error$38);
    }
}
function $cd9bb691314980fc$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $cd9bb691314980fc$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $cd9bb691314980fc$var$onActionError(actionQueue, node, error);
    }) : $cd9bb691314980fc$var$onActionSuccess(actionQueue, node, returnValue);
}
function $cd9bb691314980fc$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $cd9bb691314980fc$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $cd9bb691314980fc$var$runActionStateAction(actionQueue, nextState)));
}
function $cd9bb691314980fc$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $cd9bb691314980fc$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $cd9bb691314980fc$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $cd9bb691314980fc$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $cd9bb691314980fc$var$mountActionState(action, initialStateProp) {
    if ($cd9bb691314980fc$var$isHydrating) {
        var ssrFormState = $cd9bb691314980fc$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $cd9bb691314980fc$var$currentlyRenderingFiber;
                if ($cd9bb691314980fc$var$isHydrating) {
                    if ($cd9bb691314980fc$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $cd9bb691314980fc$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $cd9bb691314980fc$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $cd9bb691314980fc$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $cd9bb691314980fc$var$nextHydratableInstance = $cd9bb691314980fc$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $cd9bb691314980fc$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $cd9bb691314980fc$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $cd9bb691314980fc$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $cd9bb691314980fc$var$dispatchSetState.bind(null, $cd9bb691314980fc$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $cd9bb691314980fc$var$mountStateImpl(!1);
    inRootOrSingleton = $cd9bb691314980fc$var$dispatchOptimisticSetState.bind(null, $cd9bb691314980fc$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $cd9bb691314980fc$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $cd9bb691314980fc$var$dispatchActionState.bind(null, $cd9bb691314980fc$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $cd9bb691314980fc$var$updateActionState(action) {
    var stateHook = $cd9bb691314980fc$var$updateWorkInProgressHook();
    return $cd9bb691314980fc$var$updateActionStateImpl(stateHook, $cd9bb691314980fc$var$currentHook, action);
}
function $cd9bb691314980fc$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $cd9bb691314980fc$var$updateReducerImpl(stateHook, currentStateHook, $cd9bb691314980fc$var$actionStateReducer)[0];
    stateHook = $cd9bb691314980fc$var$updateReducer($cd9bb691314980fc$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $cd9bb691314980fc$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $cd9bb691314980fc$var$SuspenseException) throw $cd9bb691314980fc$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $cd9bb691314980fc$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($cd9bb691314980fc$var$currentlyRenderingFiber.flags |= 2048, $cd9bb691314980fc$var$pushSimpleEffect(9, $cd9bb691314980fc$var$createEffectInstance(), $cd9bb691314980fc$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $cd9bb691314980fc$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $cd9bb691314980fc$var$rerenderActionState(action) {
    var stateHook = $cd9bb691314980fc$var$updateWorkInProgressHook(), currentStateHook = $cd9bb691314980fc$var$currentHook;
    if (null !== currentStateHook) return $cd9bb691314980fc$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $cd9bb691314980fc$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $cd9bb691314980fc$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $cd9bb691314980fc$var$pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = $cd9bb691314980fc$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $cd9bb691314980fc$var$createFunctionComponentUpdateQueue(), $cd9bb691314980fc$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function $cd9bb691314980fc$var$createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function $cd9bb691314980fc$var$updateRef() {
    return $cd9bb691314980fc$var$updateWorkInProgressHook().memoizedState;
}
function $cd9bb691314980fc$var$mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = $cd9bb691314980fc$var$mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    $cd9bb691314980fc$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $cd9bb691314980fc$var$pushSimpleEffect(1 | hookFlags, $cd9bb691314980fc$var$createEffectInstance(), create, createDeps);
}
function $cd9bb691314980fc$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $cd9bb691314980fc$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $cd9bb691314980fc$var$currentHook && null !== deps && $cd9bb691314980fc$var$areHookInputsEqual(deps, $cd9bb691314980fc$var$currentHook.memoizedState.deps) ? hook.memoizedState = $cd9bb691314980fc$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($cd9bb691314980fc$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $cd9bb691314980fc$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $cd9bb691314980fc$var$mountEffect(create, createDeps) {
    $cd9bb691314980fc$var$mountEffectImpl(8390656, 8, create, createDeps);
}
function $cd9bb691314980fc$var$updateEffect(create, createDeps) {
    $cd9bb691314980fc$var$updateEffectImpl(2048, 8, create, createDeps);
}
function $cd9bb691314980fc$var$updateInsertionEffect(create, deps) {
    return $cd9bb691314980fc$var$updateEffectImpl(4, 2, create, deps);
}
function $cd9bb691314980fc$var$updateLayoutEffect(create, deps) {
    return $cd9bb691314980fc$var$updateEffectImpl(4, 4, create, deps);
}
function $cd9bb691314980fc$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $cd9bb691314980fc$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $cd9bb691314980fc$var$updateEffectImpl(4, 4, $cd9bb691314980fc$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $cd9bb691314980fc$var$mountDebugValue() {}
function $cd9bb691314980fc$var$updateCallback(callback, deps) {
    var hook = $cd9bb691314980fc$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $cd9bb691314980fc$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $cd9bb691314980fc$var$updateMemo(nextCreate, deps) {
    var hook = $cd9bb691314980fc$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $cd9bb691314980fc$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($cd9bb691314980fc$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $cd9bb691314980fc$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $cd9bb691314980fc$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $cd9bb691314980fc$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($cd9bb691314980fc$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $cd9bb691314980fc$var$requestDeferredLane();
    $cd9bb691314980fc$var$currentlyRenderingFiber.lanes |= hook;
    $cd9bb691314980fc$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $cd9bb691314980fc$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($cd9bb691314980fc$var$objectIs(value, prevValue)) return value;
    if (null !== $cd9bb691314980fc$var$currentTreeHiddenStackCursor.current) return hook = $cd9bb691314980fc$var$mountDeferredValueImpl(hook, value, initialValue), $cd9bb691314980fc$var$objectIs(hook, prevValue) || ($cd9bb691314980fc$var$didReceiveUpdate = !0), hook;
    if (0 === ($cd9bb691314980fc$var$renderLanes & 42)) return $cd9bb691314980fc$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $cd9bb691314980fc$var$requestDeferredLane();
    $cd9bb691314980fc$var$currentlyRenderingFiber.lanes |= hook;
    $cd9bb691314980fc$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $cd9bb691314980fc$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $cd9bb691314980fc$var$ReactDOMSharedInternals.p;
    $cd9bb691314980fc$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $cd9bb691314980fc$var$ReactSharedInternals.T, currentTransition = {};
    $cd9bb691314980fc$var$ReactSharedInternals.T = currentTransition;
    $cd9bb691314980fc$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $cd9bb691314980fc$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $cd9bb691314980fc$var$chainThenableValue(returnValue, finishedState);
            $cd9bb691314980fc$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $cd9bb691314980fc$var$requestUpdateLane(fiber));
        } else $cd9bb691314980fc$var$dispatchSetStateInternal(fiber, queue, finishedState, $cd9bb691314980fc$var$requestUpdateLane(fiber));
    } catch (error) {
        $cd9bb691314980fc$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $cd9bb691314980fc$var$requestUpdateLane());
    } finally{
        $cd9bb691314980fc$var$ReactDOMSharedInternals.p = previousPriority, $cd9bb691314980fc$var$ReactSharedInternals.T = prevTransition;
    }
}
function $cd9bb691314980fc$var$noop$2() {}
function $cd9bb691314980fc$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(476));
    var queue = $cd9bb691314980fc$var$ensureFormComponentIsStateful(formFiber).queue;
    $cd9bb691314980fc$var$startTransition(formFiber, queue, pendingState, $cd9bb691314980fc$var$sharedNotPendingObject, null === action ? $cd9bb691314980fc$var$noop$2 : function() {
        $cd9bb691314980fc$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $cd9bb691314980fc$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $cd9bb691314980fc$var$sharedNotPendingObject,
        baseState: $cd9bb691314980fc$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $cd9bb691314980fc$var$basicStateReducer,
            lastRenderedState: $cd9bb691314980fc$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $cd9bb691314980fc$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $cd9bb691314980fc$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $cd9bb691314980fc$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $cd9bb691314980fc$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $cd9bb691314980fc$var$requestUpdateLane());
}
function $cd9bb691314980fc$var$useHostTransitionStatus() {
    return $cd9bb691314980fc$var$readContext($cd9bb691314980fc$var$HostTransitionContext);
}
function $cd9bb691314980fc$var$updateId() {
    return $cd9bb691314980fc$var$updateWorkInProgressHook().memoizedState;
}
function $cd9bb691314980fc$var$updateRefresh() {
    return $cd9bb691314980fc$var$updateWorkInProgressHook().memoizedState;
}
function $cd9bb691314980fc$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $cd9bb691314980fc$var$requestUpdateLane();
                fiber = $cd9bb691314980fc$var$createUpdate(lane);
                var root$41 = $cd9bb691314980fc$var$enqueueUpdate(provider, fiber, lane);
                null !== root$41 && ($cd9bb691314980fc$var$scheduleUpdateOnFiber(root$41, provider, lane), $cd9bb691314980fc$var$entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: $cd9bb691314980fc$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $cd9bb691314980fc$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $cd9bb691314980fc$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $cd9bb691314980fc$var$isRenderPhaseUpdate(fiber) ? $cd9bb691314980fc$var$enqueueRenderPhaseUpdate(queue, action) : (action = $cd9bb691314980fc$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($cd9bb691314980fc$var$scheduleUpdateOnFiber(action, fiber, lane), $cd9bb691314980fc$var$entangleTransitionUpdate(action, queue, lane)));
}
function $cd9bb691314980fc$var$dispatchSetState(fiber, queue, action) {
    var lane = $cd9bb691314980fc$var$requestUpdateLane();
    $cd9bb691314980fc$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $cd9bb691314980fc$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($cd9bb691314980fc$var$isRenderPhaseUpdate(fiber)) $cd9bb691314980fc$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($cd9bb691314980fc$var$objectIs(eagerState, currentState)) return $cd9bb691314980fc$var$enqueueUpdate$1(fiber, queue, update, 0), null === $cd9bb691314980fc$var$workInProgressRoot && $cd9bb691314980fc$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $cd9bb691314980fc$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $cd9bb691314980fc$var$scheduleUpdateOnFiber(action, fiber, lane), $cd9bb691314980fc$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $cd9bb691314980fc$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $cd9bb691314980fc$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($cd9bb691314980fc$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $cd9bb691314980fc$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $cd9bb691314980fc$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $cd9bb691314980fc$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $cd9bb691314980fc$var$currentlyRenderingFiber || null !== alternate && alternate === $cd9bb691314980fc$var$currentlyRenderingFiber;
}
function $cd9bb691314980fc$var$enqueueRenderPhaseUpdate(queue, update) {
    $cd9bb691314980fc$var$didScheduleRenderPhaseUpdateDuringThisPass = $cd9bb691314980fc$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $cd9bb691314980fc$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $cd9bb691314980fc$var$markRootEntangled(root, lane);
    }
}
var $cd9bb691314980fc$var$ContextOnlyDispatcher = {
    readContext: $cd9bb691314980fc$var$readContext,
    use: $cd9bb691314980fc$var$use,
    useCallback: $cd9bb691314980fc$var$throwInvalidHookError,
    useContext: $cd9bb691314980fc$var$throwInvalidHookError,
    useEffect: $cd9bb691314980fc$var$throwInvalidHookError,
    useImperativeHandle: $cd9bb691314980fc$var$throwInvalidHookError,
    useLayoutEffect: $cd9bb691314980fc$var$throwInvalidHookError,
    useInsertionEffect: $cd9bb691314980fc$var$throwInvalidHookError,
    useMemo: $cd9bb691314980fc$var$throwInvalidHookError,
    useReducer: $cd9bb691314980fc$var$throwInvalidHookError,
    useRef: $cd9bb691314980fc$var$throwInvalidHookError,
    useState: $cd9bb691314980fc$var$throwInvalidHookError,
    useDebugValue: $cd9bb691314980fc$var$throwInvalidHookError,
    useDeferredValue: $cd9bb691314980fc$var$throwInvalidHookError,
    useTransition: $cd9bb691314980fc$var$throwInvalidHookError,
    useSyncExternalStore: $cd9bb691314980fc$var$throwInvalidHookError,
    useId: $cd9bb691314980fc$var$throwInvalidHookError,
    useHostTransitionStatus: $cd9bb691314980fc$var$throwInvalidHookError,
    useFormState: $cd9bb691314980fc$var$throwInvalidHookError,
    useActionState: $cd9bb691314980fc$var$throwInvalidHookError,
    useOptimistic: $cd9bb691314980fc$var$throwInvalidHookError,
    useMemoCache: $cd9bb691314980fc$var$throwInvalidHookError,
    useCacheRefresh: $cd9bb691314980fc$var$throwInvalidHookError
}, $cd9bb691314980fc$var$HooksDispatcherOnMount = {
    readContext: $cd9bb691314980fc$var$readContext,
    use: $cd9bb691314980fc$var$use,
    useCallback: function(callback, deps) {
        $cd9bb691314980fc$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $cd9bb691314980fc$var$readContext,
    useEffect: $cd9bb691314980fc$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $cd9bb691314980fc$var$mountEffectImpl(4194308, 4, $cd9bb691314980fc$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $cd9bb691314980fc$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $cd9bb691314980fc$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $cd9bb691314980fc$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($cd9bb691314980fc$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $cd9bb691314980fc$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $cd9bb691314980fc$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $cd9bb691314980fc$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($cd9bb691314980fc$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $cd9bb691314980fc$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $cd9bb691314980fc$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $cd9bb691314980fc$var$dispatchReducerAction.bind(null, $cd9bb691314980fc$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $cd9bb691314980fc$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $cd9bb691314980fc$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $cd9bb691314980fc$var$dispatchSetState.bind(null, $cd9bb691314980fc$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $cd9bb691314980fc$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $cd9bb691314980fc$var$mountWorkInProgressHook();
        return $cd9bb691314980fc$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $cd9bb691314980fc$var$mountStateImpl(!1);
        stateHook = $cd9bb691314980fc$var$startTransition.bind(null, $cd9bb691314980fc$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $cd9bb691314980fc$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $cd9bb691314980fc$var$currentlyRenderingFiber, hook = $cd9bb691314980fc$var$mountWorkInProgressHook();
        if ($cd9bb691314980fc$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $cd9bb691314980fc$var$workInProgressRoot) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(349));
            0 !== ($cd9bb691314980fc$var$workInProgressRootRenderLanes & 124) || $cd9bb691314980fc$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $cd9bb691314980fc$var$mountEffect($cd9bb691314980fc$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $cd9bb691314980fc$var$pushSimpleEffect(9, $cd9bb691314980fc$var$createEffectInstance(), $cd9bb691314980fc$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $cd9bb691314980fc$var$mountWorkInProgressHook(), identifierPrefix = $cd9bb691314980fc$var$workInProgressRoot.identifierPrefix;
        if ($cd9bb691314980fc$var$isHydrating) {
            var JSCompiler_inline_result = $cd9bb691314980fc$var$treeContextOverflow;
            var idWithLeadingBit = $cd9bb691314980fc$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $cd9bb691314980fc$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $cd9bb691314980fc$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = $cd9bb691314980fc$var$globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $cd9bb691314980fc$var$useHostTransitionStatus,
    useFormState: $cd9bb691314980fc$var$mountActionState,
    useActionState: $cd9bb691314980fc$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $cd9bb691314980fc$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $cd9bb691314980fc$var$dispatchOptimisticSetState.bind(null, $cd9bb691314980fc$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $cd9bb691314980fc$var$useMemoCache,
    useCacheRefresh: function() {
        return $cd9bb691314980fc$var$mountWorkInProgressHook().memoizedState = $cd9bb691314980fc$var$refreshCache.bind(null, $cd9bb691314980fc$var$currentlyRenderingFiber);
    }
}, $cd9bb691314980fc$var$HooksDispatcherOnUpdate = {
    readContext: $cd9bb691314980fc$var$readContext,
    use: $cd9bb691314980fc$var$use,
    useCallback: $cd9bb691314980fc$var$updateCallback,
    useContext: $cd9bb691314980fc$var$readContext,
    useEffect: $cd9bb691314980fc$var$updateEffect,
    useImperativeHandle: $cd9bb691314980fc$var$updateImperativeHandle,
    useInsertionEffect: $cd9bb691314980fc$var$updateInsertionEffect,
    useLayoutEffect: $cd9bb691314980fc$var$updateLayoutEffect,
    useMemo: $cd9bb691314980fc$var$updateMemo,
    useReducer: $cd9bb691314980fc$var$updateReducer,
    useRef: $cd9bb691314980fc$var$updateRef,
    useState: function() {
        return $cd9bb691314980fc$var$updateReducer($cd9bb691314980fc$var$basicStateReducer);
    },
    useDebugValue: $cd9bb691314980fc$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $cd9bb691314980fc$var$updateWorkInProgressHook();
        return $cd9bb691314980fc$var$updateDeferredValueImpl(hook, $cd9bb691314980fc$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $cd9bb691314980fc$var$updateReducer($cd9bb691314980fc$var$basicStateReducer)[0], start = $cd9bb691314980fc$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $cd9bb691314980fc$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $cd9bb691314980fc$var$updateSyncExternalStore,
    useId: $cd9bb691314980fc$var$updateId,
    useHostTransitionStatus: $cd9bb691314980fc$var$useHostTransitionStatus,
    useFormState: $cd9bb691314980fc$var$updateActionState,
    useActionState: $cd9bb691314980fc$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $cd9bb691314980fc$var$updateWorkInProgressHook();
        return $cd9bb691314980fc$var$updateOptimisticImpl(hook, $cd9bb691314980fc$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $cd9bb691314980fc$var$useMemoCache,
    useCacheRefresh: $cd9bb691314980fc$var$updateRefresh
}, $cd9bb691314980fc$var$HooksDispatcherOnRerender = {
    readContext: $cd9bb691314980fc$var$readContext,
    use: $cd9bb691314980fc$var$use,
    useCallback: $cd9bb691314980fc$var$updateCallback,
    useContext: $cd9bb691314980fc$var$readContext,
    useEffect: $cd9bb691314980fc$var$updateEffect,
    useImperativeHandle: $cd9bb691314980fc$var$updateImperativeHandle,
    useInsertionEffect: $cd9bb691314980fc$var$updateInsertionEffect,
    useLayoutEffect: $cd9bb691314980fc$var$updateLayoutEffect,
    useMemo: $cd9bb691314980fc$var$updateMemo,
    useReducer: $cd9bb691314980fc$var$rerenderReducer,
    useRef: $cd9bb691314980fc$var$updateRef,
    useState: function() {
        return $cd9bb691314980fc$var$rerenderReducer($cd9bb691314980fc$var$basicStateReducer);
    },
    useDebugValue: $cd9bb691314980fc$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $cd9bb691314980fc$var$updateWorkInProgressHook();
        return null === $cd9bb691314980fc$var$currentHook ? $cd9bb691314980fc$var$mountDeferredValueImpl(hook, value, initialValue) : $cd9bb691314980fc$var$updateDeferredValueImpl(hook, $cd9bb691314980fc$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $cd9bb691314980fc$var$rerenderReducer($cd9bb691314980fc$var$basicStateReducer)[0], start = $cd9bb691314980fc$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $cd9bb691314980fc$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $cd9bb691314980fc$var$updateSyncExternalStore,
    useId: $cd9bb691314980fc$var$updateId,
    useHostTransitionStatus: $cd9bb691314980fc$var$useHostTransitionStatus,
    useFormState: $cd9bb691314980fc$var$rerenderActionState,
    useActionState: $cd9bb691314980fc$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $cd9bb691314980fc$var$updateWorkInProgressHook();
        if (null !== $cd9bb691314980fc$var$currentHook) return $cd9bb691314980fc$var$updateOptimisticImpl(hook, $cd9bb691314980fc$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $cd9bb691314980fc$var$useMemoCache,
    useCacheRefresh: $cd9bb691314980fc$var$updateRefresh
}, $cd9bb691314980fc$var$thenableState = null, $cd9bb691314980fc$var$thenableIndexCounter = 0;
function $cd9bb691314980fc$var$unwrapThenable(thenable) {
    var index = $cd9bb691314980fc$var$thenableIndexCounter;
    $cd9bb691314980fc$var$thenableIndexCounter += 1;
    null === $cd9bb691314980fc$var$thenableState && ($cd9bb691314980fc$var$thenableState = []);
    return $cd9bb691314980fc$var$trackUsedThenable($cd9bb691314980fc$var$thenableState, thenable, index);
}
function $cd9bb691314980fc$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $cd9bb691314980fc$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $cd9bb691314980fc$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($cd9bb691314980fc$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $cd9bb691314980fc$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $cd9bb691314980fc$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $cd9bb691314980fc$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $cd9bb691314980fc$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $cd9bb691314980fc$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $cd9bb691314980fc$var$REACT_LAZY_TYPE && $cd9bb691314980fc$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $cd9bb691314980fc$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $cd9bb691314980fc$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $cd9bb691314980fc$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $cd9bb691314980fc$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $cd9bb691314980fc$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $cd9bb691314980fc$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $cd9bb691314980fc$var$REACT_ELEMENT_TYPE:
                    return lanes = $cd9bb691314980fc$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $cd9bb691314980fc$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $cd9bb691314980fc$var$REACT_PORTAL_TYPE:
                    return newChild = $cd9bb691314980fc$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $cd9bb691314980fc$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($cd9bb691314980fc$var$isArrayImpl(newChild) || $cd9bb691314980fc$var$getIteratorFn(newChild)) return newChild = $cd9bb691314980fc$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $cd9bb691314980fc$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $cd9bb691314980fc$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $cd9bb691314980fc$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $cd9bb691314980fc$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $cd9bb691314980fc$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $cd9bb691314980fc$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $cd9bb691314980fc$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($cd9bb691314980fc$var$isArrayImpl(newChild) || $cd9bb691314980fc$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $cd9bb691314980fc$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $cd9bb691314980fc$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $cd9bb691314980fc$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $cd9bb691314980fc$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $cd9bb691314980fc$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $cd9bb691314980fc$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $cd9bb691314980fc$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($cd9bb691314980fc$var$isArrayImpl(newChild) || $cd9bb691314980fc$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $cd9bb691314980fc$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $cd9bb691314980fc$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $cd9bb691314980fc$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $cd9bb691314980fc$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $cd9bb691314980fc$var$isHydrating && $cd9bb691314980fc$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $cd9bb691314980fc$var$isHydrating && $cd9bb691314980fc$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $cd9bb691314980fc$var$isHydrating && $cd9bb691314980fc$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $cd9bb691314980fc$var$isHydrating && $cd9bb691314980fc$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $cd9bb691314980fc$var$isHydrating && $cd9bb691314980fc$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $cd9bb691314980fc$var$isHydrating && $cd9bb691314980fc$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $cd9bb691314980fc$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $cd9bb691314980fc$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $cd9bb691314980fc$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $cd9bb691314980fc$var$REACT_LAZY_TYPE && $cd9bb691314980fc$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $cd9bb691314980fc$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $cd9bb691314980fc$var$REACT_FRAGMENT_TYPE ? (lanes = $cd9bb691314980fc$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $cd9bb691314980fc$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $cd9bb691314980fc$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $cd9bb691314980fc$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $cd9bb691314980fc$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $cd9bb691314980fc$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($cd9bb691314980fc$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($cd9bb691314980fc$var$getIteratorFn(newChild)) {
                key = $cd9bb691314980fc$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $cd9bb691314980fc$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $cd9bb691314980fc$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $cd9bb691314980fc$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $cd9bb691314980fc$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $cd9bb691314980fc$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $cd9bb691314980fc$var$thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $cd9bb691314980fc$var$thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $cd9bb691314980fc$var$SuspenseException || x === $cd9bb691314980fc$var$SuspenseActionException) throw x;
            var fiber = $cd9bb691314980fc$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $cd9bb691314980fc$var$reconcileChildFibers = $cd9bb691314980fc$var$createChildReconciler(!0), $cd9bb691314980fc$var$mountChildFibers = $cd9bb691314980fc$var$createChildReconciler(!1), $cd9bb691314980fc$var$suspenseHandlerStackCursor = $cd9bb691314980fc$var$createCursor(null), $cd9bb691314980fc$var$shellBoundary = null;
function $cd9bb691314980fc$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$suspenseStackCursor, $cd9bb691314980fc$var$suspenseStackCursor.current & 1);
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$suspenseHandlerStackCursor, handler);
    null === $cd9bb691314980fc$var$shellBoundary && (null === current || null !== $cd9bb691314980fc$var$currentTreeHiddenStackCursor.current ? $cd9bb691314980fc$var$shellBoundary = handler : null !== current.memoizedState && ($cd9bb691314980fc$var$shellBoundary = handler));
}
function $cd9bb691314980fc$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($cd9bb691314980fc$var$push($cd9bb691314980fc$var$suspenseStackCursor, $cd9bb691314980fc$var$suspenseStackCursor.current), $cd9bb691314980fc$var$push($cd9bb691314980fc$var$suspenseHandlerStackCursor, fiber), null === $cd9bb691314980fc$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($cd9bb691314980fc$var$shellBoundary = fiber);
        }
    } else $cd9bb691314980fc$var$reuseSuspenseHandlerOnStack(fiber);
}
function $cd9bb691314980fc$var$reuseSuspenseHandlerOnStack() {
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$suspenseStackCursor, $cd9bb691314980fc$var$suspenseStackCursor.current);
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$suspenseHandlerStackCursor, $cd9bb691314980fc$var$suspenseHandlerStackCursor.current);
}
function $cd9bb691314980fc$var$popSuspenseHandler(fiber) {
    $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$suspenseHandlerStackCursor);
    $cd9bb691314980fc$var$shellBoundary === fiber && ($cd9bb691314980fc$var$shellBoundary = null);
    $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$suspenseStackCursor);
}
var $cd9bb691314980fc$var$suspenseStackCursor = $cd9bb691314980fc$var$createCursor(0);
function $cd9bb691314980fc$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || $cd9bb691314980fc$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function $cd9bb691314980fc$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $cd9bb691314980fc$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $cd9bb691314980fc$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $cd9bb691314980fc$var$requestUpdateLane(), update = $cd9bb691314980fc$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $cd9bb691314980fc$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($cd9bb691314980fc$var$scheduleUpdateOnFiber(payload, inst, lane), $cd9bb691314980fc$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $cd9bb691314980fc$var$requestUpdateLane(), update = $cd9bb691314980fc$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $cd9bb691314980fc$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($cd9bb691314980fc$var$scheduleUpdateOnFiber(payload, inst, lane), $cd9bb691314980fc$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $cd9bb691314980fc$var$requestUpdateLane(), update = $cd9bb691314980fc$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $cd9bb691314980fc$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($cd9bb691314980fc$var$scheduleUpdateOnFiber(callback, inst, lane), $cd9bb691314980fc$var$entangleTransitions(callback, inst, lane));
    }
};
function $cd9bb691314980fc$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$cd9bb691314980fc$var$shallowEqual(oldProps, newProps) || !$cd9bb691314980fc$var$shallowEqual(oldState, newState) : !0;
}
function $cd9bb691314980fc$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $cd9bb691314980fc$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $cd9bb691314980fc$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $cd9bb691314980fc$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var $cd9bb691314980fc$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $cd9bb691314980fc$var$defaultOnUncaughtError(error) {
    $cd9bb691314980fc$var$reportGlobalError(error);
}
function $cd9bb691314980fc$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $cd9bb691314980fc$var$defaultOnRecoverableError(error) {
    $cd9bb691314980fc$var$reportGlobalError(error);
}
function $cd9bb691314980fc$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $cd9bb691314980fc$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $cd9bb691314980fc$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $cd9bb691314980fc$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $cd9bb691314980fc$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $cd9bb691314980fc$var$createClassErrorUpdate(lane) {
    lane = $cd9bb691314980fc$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $cd9bb691314980fc$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $cd9bb691314980fc$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $cd9bb691314980fc$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $cd9bb691314980fc$var$legacyErrorBoundariesThatAlreadyFailed ? $cd9bb691314980fc$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $cd9bb691314980fc$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $cd9bb691314980fc$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $cd9bb691314980fc$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $cd9bb691314980fc$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $cd9bb691314980fc$var$shellBoundary ? $cd9bb691314980fc$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $cd9bb691314980fc$var$workInProgressRootExitStatus && ($cd9bb691314980fc$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $cd9bb691314980fc$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $cd9bb691314980fc$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $cd9bb691314980fc$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $cd9bb691314980fc$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($cd9bb691314980fc$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $cd9bb691314980fc$var$attachPingListener(root, value, rootRenderLanes);
        $cd9bb691314980fc$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($cd9bb691314980fc$var$isHydrating) return returnFiber = $cd9bb691314980fc$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $cd9bb691314980fc$var$HydrationMismatchException && (root = Error($cd9bb691314980fc$var$formatProdErrorMessage(422), {
        cause: value
    }), $cd9bb691314980fc$var$queueHydrationError($cd9bb691314980fc$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $cd9bb691314980fc$var$HydrationMismatchException && (returnFiber = Error($cd9bb691314980fc$var$formatProdErrorMessage(423), {
        cause: value
    }), $cd9bb691314980fc$var$queueHydrationError($cd9bb691314980fc$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $cd9bb691314980fc$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $cd9bb691314980fc$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $cd9bb691314980fc$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $cd9bb691314980fc$var$workInProgressRootExitStatus && ($cd9bb691314980fc$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($cd9bb691314980fc$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $cd9bb691314980fc$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $cd9bb691314980fc$var$workInProgressRootConcurrentErrors ? $cd9bb691314980fc$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $cd9bb691314980fc$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $cd9bb691314980fc$var$workInProgressRootExitStatus && ($cd9bb691314980fc$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $cd9bb691314980fc$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $cd9bb691314980fc$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $cd9bb691314980fc$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $cd9bb691314980fc$var$legacyErrorBoundariesThatAlreadyFailed || !$cd9bb691314980fc$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $cd9bb691314980fc$var$createClassErrorUpdate(rootRenderLanes), $cd9bb691314980fc$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $cd9bb691314980fc$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $cd9bb691314980fc$var$SelectiveHydrationException = Error($cd9bb691314980fc$var$formatProdErrorMessage(461)), $cd9bb691314980fc$var$didReceiveUpdate = !1;
function $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $cd9bb691314980fc$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $cd9bb691314980fc$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $cd9bb691314980fc$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $cd9bb691314980fc$var$prepareToReadContext(workInProgress);
    nextProps = $cd9bb691314980fc$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $cd9bb691314980fc$var$checkDidRenderIdHook();
    if (null !== current && !$cd9bb691314980fc$var$didReceiveUpdate) return $cd9bb691314980fc$var$bailoutHooks(current, workInProgress, renderLanes), $cd9bb691314980fc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $cd9bb691314980fc$var$isHydrating && key && $cd9bb691314980fc$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $cd9bb691314980fc$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$cd9bb691314980fc$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $cd9bb691314980fc$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $cd9bb691314980fc$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$cd9bb691314980fc$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $cd9bb691314980fc$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $cd9bb691314980fc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $cd9bb691314980fc$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $cd9bb691314980fc$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($cd9bb691314980fc$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($cd9bb691314980fc$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $cd9bb691314980fc$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($cd9bb691314980fc$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $cd9bb691314980fc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $cd9bb691314980fc$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $cd9bb691314980fc$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $cd9bb691314980fc$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $cd9bb691314980fc$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $cd9bb691314980fc$var$pushHiddenContext(workInProgress, prevState) : $cd9bb691314980fc$var$reuseHiddenContextOnStack(), $cd9bb691314980fc$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $cd9bb691314980fc$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($cd9bb691314980fc$var$pushTransition(workInProgress, prevState.cachePool), $cd9bb691314980fc$var$pushHiddenContext(workInProgress, prevState), $cd9bb691314980fc$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $cd9bb691314980fc$var$pushTransition(workInProgress, null), $cd9bb691314980fc$var$reuseHiddenContextOnStack(), $cd9bb691314980fc$var$reuseSuspenseHandlerOnStack(workInProgress));
    $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $cd9bb691314980fc$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $cd9bb691314980fc$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $cd9bb691314980fc$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $cd9bb691314980fc$var$pushTransition(workInProgress, null);
    $cd9bb691314980fc$var$reuseHiddenContextOnStack();
    $cd9bb691314980fc$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $cd9bb691314980fc$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $cd9bb691314980fc$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $cd9bb691314980fc$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $cd9bb691314980fc$var$prepareToReadContext(workInProgress);
    Component = $cd9bb691314980fc$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $cd9bb691314980fc$var$checkDidRenderIdHook();
    if (null !== current && !$cd9bb691314980fc$var$didReceiveUpdate) return $cd9bb691314980fc$var$bailoutHooks(current, workInProgress, renderLanes), $cd9bb691314980fc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $cd9bb691314980fc$var$isHydrating && nextProps && $cd9bb691314980fc$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $cd9bb691314980fc$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $cd9bb691314980fc$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $cd9bb691314980fc$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $cd9bb691314980fc$var$finishRenderingHooks(current);
    Component = $cd9bb691314980fc$var$checkDidRenderIdHook();
    if (null !== current && !$cd9bb691314980fc$var$didReceiveUpdate) return $cd9bb691314980fc$var$bailoutHooks(current, workInProgress, renderLanes), $cd9bb691314980fc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $cd9bb691314980fc$var$isHydrating && Component && $cd9bb691314980fc$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $cd9bb691314980fc$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $cd9bb691314980fc$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $cd9bb691314980fc$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $cd9bb691314980fc$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $cd9bb691314980fc$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $cd9bb691314980fc$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $cd9bb691314980fc$var$readContext(contextType) : $cd9bb691314980fc$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($cd9bb691314980fc$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $cd9bb691314980fc$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $cd9bb691314980fc$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $cd9bb691314980fc$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $cd9bb691314980fc$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $cd9bb691314980fc$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $cd9bb691314980fc$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $cd9bb691314980fc$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $cd9bb691314980fc$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $cd9bb691314980fc$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $cd9bb691314980fc$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $cd9bb691314980fc$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($cd9bb691314980fc$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $cd9bb691314980fc$var$hasForceUpdate || $cd9bb691314980fc$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $cd9bb691314980fc$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $cd9bb691314980fc$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $cd9bb691314980fc$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $cd9bb691314980fc$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $cd9bb691314980fc$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $cd9bb691314980fc$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $cd9bb691314980fc$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $cd9bb691314980fc$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $cd9bb691314980fc$var$hasForceUpdate || null !== current && null !== current.dependencies && $cd9bb691314980fc$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($cd9bb691314980fc$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $cd9bb691314980fc$var$hasForceUpdate || $cd9bb691314980fc$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $cd9bb691314980fc$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $cd9bb691314980fc$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $cd9bb691314980fc$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $cd9bb691314980fc$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $cd9bb691314980fc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $cd9bb691314980fc$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $cd9bb691314980fc$var$resetHydrationState();
    workInProgress.flags |= 256;
    $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $cd9bb691314980fc$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $cd9bb691314980fc$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $cd9bb691314980fc$var$getSuspendedCache()
    };
}
function $cd9bb691314980fc$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $cd9bb691314980fc$var$workInProgressDeferredLane);
    return current;
}
function $cd9bb691314980fc$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($cd9bb691314980fc$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($cd9bb691314980fc$var$isHydrating) {
            showFallback ? $cd9bb691314980fc$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $cd9bb691314980fc$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($cd9bb691314980fc$var$isHydrating) {
                var nextInstance = $cd9bb691314980fc$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $cd9bb691314980fc$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $cd9bb691314980fc$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $cd9bb691314980fc$var$treeContextProvider ? {
                            id: $cd9bb691314980fc$var$treeContextId,
                            overflow: $cd9bb691314980fc$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = $cd9bb691314980fc$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $cd9bb691314980fc$var$hydrationParentFiber = workInProgress, $cd9bb691314980fc$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $cd9bb691314980fc$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return $cd9bb691314980fc$var$isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            $cd9bb691314980fc$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $cd9bb691314980fc$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $cd9bb691314980fc$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $cd9bb691314980fc$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $cd9bb691314980fc$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $cd9bb691314980fc$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $cd9bb691314980fc$var$SUSPENDED_MARKER, nextProps;
        $cd9bb691314980fc$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $cd9bb691314980fc$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($cd9bb691314980fc$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $cd9bb691314980fc$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($cd9bb691314980fc$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($cd9bb691314980fc$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $cd9bb691314980fc$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $cd9bb691314980fc$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $cd9bb691314980fc$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $cd9bb691314980fc$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $cd9bb691314980fc$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $cd9bb691314980fc$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($cd9bb691314980fc$var$pushPrimaryTreeSuspenseHandler(workInProgress), $cd9bb691314980fc$var$isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($cd9bb691314980fc$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $cd9bb691314980fc$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $cd9bb691314980fc$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($cd9bb691314980fc$var$didReceiveUpdate || $cd9bb691314980fc$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $cd9bb691314980fc$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $cd9bb691314980fc$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : $cd9bb691314980fc$var$getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $cd9bb691314980fc$var$enqueueConcurrentRenderForLane(current, nextProps), $cd9bb691314980fc$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $cd9bb691314980fc$var$SelectiveHydrationException;
            "$?" === nextInstance.data || $cd9bb691314980fc$var$renderDidSuspendDelayIfPossible();
            workInProgress = $cd9bb691314980fc$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $cd9bb691314980fc$var$nextHydratableInstance = $cd9bb691314980fc$var$getNextHydratable(nextInstance.nextSibling), $cd9bb691314980fc$var$hydrationParentFiber = workInProgress, $cd9bb691314980fc$var$isHydrating = !0, $cd9bb691314980fc$var$hydrationErrors = null, $cd9bb691314980fc$var$rootOrSingletonContext = !1, null !== current && ($cd9bb691314980fc$var$idStack[$cd9bb691314980fc$var$idStackIndex++] = $cd9bb691314980fc$var$treeContextId, $cd9bb691314980fc$var$idStack[$cd9bb691314980fc$var$idStackIndex++] = $cd9bb691314980fc$var$treeContextOverflow, $cd9bb691314980fc$var$idStack[$cd9bb691314980fc$var$idStackIndex++] = $cd9bb691314980fc$var$treeContextProvider, $cd9bb691314980fc$var$treeContextId = current.id, $cd9bb691314980fc$var$treeContextOverflow = current.overflow, $cd9bb691314980fc$var$treeContextProvider = workInProgress), workInProgress = $cd9bb691314980fc$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $cd9bb691314980fc$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $cd9bb691314980fc$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = $cd9bb691314980fc$var$createWorkInProgress(digest, showFallback) : (showFallback = $cd9bb691314980fc$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $cd9bb691314980fc$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $cd9bb691314980fc$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $cd9bb691314980fc$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $cd9bb691314980fc$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $cd9bb691314980fc$var$SUSPENDED_MARKER, nextProps;
    $cd9bb691314980fc$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $cd9bb691314980fc$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $cd9bb691314980fc$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $cd9bb691314980fc$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $cd9bb691314980fc$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $cd9bb691314980fc$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function $cd9bb691314980fc$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $cd9bb691314980fc$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $cd9bb691314980fc$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $cd9bb691314980fc$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $cd9bb691314980fc$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $cd9bb691314980fc$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $cd9bb691314980fc$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $cd9bb691314980fc$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $cd9bb691314980fc$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $cd9bb691314980fc$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $cd9bb691314980fc$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $cd9bb691314980fc$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $cd9bb691314980fc$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $cd9bb691314980fc$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $cd9bb691314980fc$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $cd9bb691314980fc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $cd9bb691314980fc$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($cd9bb691314980fc$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $cd9bb691314980fc$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $cd9bb691314980fc$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $cd9bb691314980fc$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $cd9bb691314980fc$var$checkIfContextChanged(current) ? !0 : !1;
}
function $cd9bb691314980fc$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $cd9bb691314980fc$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $cd9bb691314980fc$var$pushProvider(workInProgress, $cd9bb691314980fc$var$CacheContext, current.memoizedState.cache);
            $cd9bb691314980fc$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $cd9bb691314980fc$var$pushHostContext(workInProgress);
            break;
        case 4:
            $cd9bb691314980fc$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $cd9bb691314980fc$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $cd9bb691314980fc$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $cd9bb691314980fc$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $cd9bb691314980fc$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $cd9bb691314980fc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $cd9bb691314980fc$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($cd9bb691314980fc$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $cd9bb691314980fc$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $cd9bb691314980fc$var$push($cd9bb691314980fc$var$suspenseStackCursor, $cd9bb691314980fc$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $cd9bb691314980fc$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $cd9bb691314980fc$var$pushProvider(workInProgress, $cd9bb691314980fc$var$CacheContext, current.memoizedState.cache);
    }
    return $cd9bb691314980fc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $cd9bb691314980fc$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $cd9bb691314980fc$var$didReceiveUpdate = !0;
        else {
            if (!$cd9bb691314980fc$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $cd9bb691314980fc$var$didReceiveUpdate = !1, $cd9bb691314980fc$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $cd9bb691314980fc$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $cd9bb691314980fc$var$didReceiveUpdate = !1, $cd9bb691314980fc$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $cd9bb691314980fc$var$pushTreeId(workInProgress, $cd9bb691314980fc$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $cd9bb691314980fc$var$shouldConstruct(lazyComponent) ? (current = $cd9bb691314980fc$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $cd9bb691314980fc$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $cd9bb691314980fc$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $cd9bb691314980fc$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $cd9bb691314980fc$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $cd9bb691314980fc$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $cd9bb691314980fc$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $cd9bb691314980fc$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($cd9bb691314980fc$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $cd9bb691314980fc$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $cd9bb691314980fc$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $cd9bb691314980fc$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $cd9bb691314980fc$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                $cd9bb691314980fc$var$cloneUpdateQueue(current, workInProgress);
                $cd9bb691314980fc$var$processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                $cd9bb691314980fc$var$pushProvider(workInProgress, $cd9bb691314980fc$var$CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && $cd9bb691314980fc$var$propagateContextChanges(workInProgress, [
                    $cd9bb691314980fc$var$CacheContext
                ], renderLanes, !0);
                $cd9bb691314980fc$var$suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $cd9bb691314980fc$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = $cd9bb691314980fc$var$createCapturedValueAtFiber(Error($cd9bb691314980fc$var$formatProdErrorMessage(424)), workInProgress);
                        $cd9bb691314980fc$var$queueHydrationError(init);
                        workInProgress = $cd9bb691314980fc$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $cd9bb691314980fc$var$nextHydratableInstance = $cd9bb691314980fc$var$getNextHydratable(current.firstChild);
                        $cd9bb691314980fc$var$hydrationParentFiber = workInProgress;
                        $cd9bb691314980fc$var$isHydrating = !0;
                        $cd9bb691314980fc$var$hydrationErrors = null;
                        $cd9bb691314980fc$var$rootOrSingletonContext = !0;
                        renderLanes = $cd9bb691314980fc$var$mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $cd9bb691314980fc$var$resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = $cd9bb691314980fc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $cd9bb691314980fc$var$markRef(current, workInProgress), null === current ? (renderLanes = $cd9bb691314980fc$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $cd9bb691314980fc$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $cd9bb691314980fc$var$getOwnerDocumentFromRootContainer($cd9bb691314980fc$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$cd9bb691314980fc$var$internalInstanceKey] = workInProgress, lazyComponent[$cd9bb691314980fc$var$internalPropsKey] = current, $cd9bb691314980fc$var$setInitialProperties(lazyComponent, renderLanes, current), $cd9bb691314980fc$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $cd9bb691314980fc$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $cd9bb691314980fc$var$pushHostContext(workInProgress), null === current && $cd9bb691314980fc$var$isHydrating && (lazyComponent = workInProgress.stateNode = $cd9bb691314980fc$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $cd9bb691314980fc$var$rootInstanceStackCursor.current), $cd9bb691314980fc$var$hydrationParentFiber = workInProgress, $cd9bb691314980fc$var$rootOrSingletonContext = !0, init = $cd9bb691314980fc$var$nextHydratableInstance, $cd9bb691314980fc$var$isSingletonScope(workInProgress.type) ? ($cd9bb691314980fc$var$previousHydratableOnEnteringScopedSingleton = init, $cd9bb691314980fc$var$nextHydratableInstance = $cd9bb691314980fc$var$getNextHydratable(lazyComponent.firstChild)) : $cd9bb691314980fc$var$nextHydratableInstance = init), $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $cd9bb691314980fc$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $cd9bb691314980fc$var$isHydrating) {
                if (init = lazyComponent = $cd9bb691314980fc$var$nextHydratableInstance) lazyComponent = $cd9bb691314980fc$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $cd9bb691314980fc$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $cd9bb691314980fc$var$hydrationParentFiber = workInProgress, $cd9bb691314980fc$var$nextHydratableInstance = $cd9bb691314980fc$var$getNextHydratable(lazyComponent.firstChild), $cd9bb691314980fc$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $cd9bb691314980fc$var$throwOnHydrationMismatch(workInProgress);
            }
            $cd9bb691314980fc$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            $cd9bb691314980fc$var$shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && $cd9bb691314980fc$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $cd9bb691314980fc$var$renderWithHooks(current, workInProgress, $cd9bb691314980fc$var$TransitionAwareHostComponent, null, null, renderLanes), $cd9bb691314980fc$var$HostTransitionContext._currentValue = init);
            $cd9bb691314980fc$var$markRef(current, workInProgress);
            $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $cd9bb691314980fc$var$isHydrating) {
                if (current = renderLanes = $cd9bb691314980fc$var$nextHydratableInstance) renderLanes = $cd9bb691314980fc$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $cd9bb691314980fc$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $cd9bb691314980fc$var$hydrationParentFiber = workInProgress, $cd9bb691314980fc$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $cd9bb691314980fc$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $cd9bb691314980fc$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $cd9bb691314980fc$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $cd9bb691314980fc$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $cd9bb691314980fc$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $cd9bb691314980fc$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $cd9bb691314980fc$var$prepareToReadContext(workInProgress), init = $cd9bb691314980fc$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $cd9bb691314980fc$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $cd9bb691314980fc$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $cd9bb691314980fc$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = $cd9bb691314980fc$var$mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = $cd9bb691314980fc$var$createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return $cd9bb691314980fc$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $cd9bb691314980fc$var$prepareToReadContext(workInProgress), lazyComponent = $cd9bb691314980fc$var$readContext($cd9bb691314980fc$var$CacheContext), null === current ? (init = $cd9bb691314980fc$var$peekCacheFromPool(), null === init && (init = $cd9bb691314980fc$var$workInProgressRoot, prevState = $cd9bb691314980fc$var$createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $cd9bb691314980fc$var$initializeUpdateQueue(workInProgress), $cd9bb691314980fc$var$pushProvider(workInProgress, $cd9bb691314980fc$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($cd9bb691314980fc$var$cloneUpdateQueue(current, workInProgress), $cd9bb691314980fc$var$processUpdateQueue(workInProgress, null, null, renderLanes), $cd9bb691314980fc$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $cd9bb691314980fc$var$pushProvider(workInProgress, $cd9bb691314980fc$var$CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, $cd9bb691314980fc$var$pushProvider(workInProgress, $cd9bb691314980fc$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $cd9bb691314980fc$var$propagateContextChanges(workInProgress, [
                $cd9bb691314980fc$var$CacheContext
            ], renderLanes, !0))), $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($cd9bb691314980fc$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $cd9bb691314980fc$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $cd9bb691314980fc$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$cd9bb691314980fc$var$preloadResource(resource)) {
        resource = $cd9bb691314980fc$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($cd9bb691314980fc$var$workInProgressRootRenderLanes & 4194048) === $cd9bb691314980fc$var$workInProgressRootRenderLanes ? null !== $cd9bb691314980fc$var$shellBoundary : ($cd9bb691314980fc$var$workInProgressRootRenderLanes & 62914560) !== $cd9bb691314980fc$var$workInProgressRootRenderLanes && 0 === ($cd9bb691314980fc$var$workInProgressRootRenderLanes & 536870912) || resource !== $cd9bb691314980fc$var$shellBoundary)) throw $cd9bb691314980fc$var$suspendedThenable = $cd9bb691314980fc$var$noopSuspenseyCommitThenable, $cd9bb691314980fc$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $cd9bb691314980fc$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $cd9bb691314980fc$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $cd9bb691314980fc$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $cd9bb691314980fc$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$cd9bb691314980fc$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function $cd9bb691314980fc$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $cd9bb691314980fc$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $cd9bb691314980fc$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $cd9bb691314980fc$var$bubbleProperties(workInProgress), null;
        case 1:
            return $cd9bb691314980fc$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $cd9bb691314980fc$var$popProvider($cd9bb691314980fc$var$CacheContext);
            $cd9bb691314980fc$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $cd9bb691314980fc$var$popHydrationState(workInProgress) ? $cd9bb691314980fc$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $cd9bb691314980fc$var$upgradeHydrationErrorsToRecoverable());
            $cd9bb691314980fc$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($cd9bb691314980fc$var$markUpdate(workInProgress), null !== renderLanes ? ($cd9bb691314980fc$var$bubbleProperties(workInProgress), $cd9bb691314980fc$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($cd9bb691314980fc$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($cd9bb691314980fc$var$markUpdate(workInProgress), $cd9bb691314980fc$var$bubbleProperties(workInProgress), $cd9bb691314980fc$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($cd9bb691314980fc$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $cd9bb691314980fc$var$markUpdate(workInProgress), $cd9bb691314980fc$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $cd9bb691314980fc$var$popHostContext(workInProgress);
            renderLanes = $cd9bb691314980fc$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $cd9bb691314980fc$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(166));
                    $cd9bb691314980fc$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $cd9bb691314980fc$var$contextStackCursor.current;
                $cd9bb691314980fc$var$popHydrationState(workInProgress) ? $cd9bb691314980fc$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $cd9bb691314980fc$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $cd9bb691314980fc$var$markUpdate(workInProgress));
            }
            $cd9bb691314980fc$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $cd9bb691314980fc$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $cd9bb691314980fc$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(166));
                    $cd9bb691314980fc$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $cd9bb691314980fc$var$contextStackCursor.current;
                if ($cd9bb691314980fc$var$popHydrationState(workInProgress)) $cd9bb691314980fc$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $cd9bb691314980fc$var$getOwnerDocumentFromRootContainer($cd9bb691314980fc$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$cd9bb691314980fc$var$internalInstanceKey] = workInProgress;
                    current[$cd9bb691314980fc$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($cd9bb691314980fc$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $cd9bb691314980fc$var$markUpdate(workInProgress);
                }
            }
            $cd9bb691314980fc$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $cd9bb691314980fc$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(166));
                current = $cd9bb691314980fc$var$rootInstanceStackCursor.current;
                if ($cd9bb691314980fc$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $cd9bb691314980fc$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$cd9bb691314980fc$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $cd9bb691314980fc$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $cd9bb691314980fc$var$throwOnHydrationMismatch(workInProgress);
                } else current = $cd9bb691314980fc$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$cd9bb691314980fc$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $cd9bb691314980fc$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $cd9bb691314980fc$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(317));
                        type[$cd9bb691314980fc$var$internalInstanceKey] = workInProgress;
                    } else $cd9bb691314980fc$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $cd9bb691314980fc$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $cd9bb691314980fc$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $cd9bb691314980fc$var$popSuspenseHandler(workInProgress), workInProgress;
                    $cd9bb691314980fc$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $cd9bb691314980fc$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $cd9bb691314980fc$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $cd9bb691314980fc$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $cd9bb691314980fc$var$popHostContainer(), null === current && $cd9bb691314980fc$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $cd9bb691314980fc$var$bubbleProperties(workInProgress), null;
        case 10:
            return $cd9bb691314980fc$var$popProvider(workInProgress.type), $cd9bb691314980fc$var$bubbleProperties(workInProgress), null;
        case 19:
            $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $cd9bb691314980fc$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) $cd9bb691314980fc$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $cd9bb691314980fc$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = $cd9bb691314980fc$var$findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            $cd9bb691314980fc$var$cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            $cd9bb691314980fc$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$cd9bb691314980fc$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $cd9bb691314980fc$var$push($cd9bb691314980fc$var$suspenseStackCursor, $cd9bb691314980fc$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $cd9bb691314980fc$var$now() > $cd9bb691314980fc$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $cd9bb691314980fc$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $cd9bb691314980fc$var$findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $cd9bb691314980fc$var$scheduleRetryEffect(workInProgress, current), $cd9bb691314980fc$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !$cd9bb691314980fc$var$isHydrating) return $cd9bb691314980fc$var$bubbleProperties(workInProgress), null;
                    } else 2 * $cd9bb691314980fc$var$now() - type.renderingStartTime > $cd9bb691314980fc$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $cd9bb691314980fc$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $cd9bb691314980fc$var$now(), workInProgress.sibling = null, current = $cd9bb691314980fc$var$suspenseStackCursor.current, $cd9bb691314980fc$var$push($cd9bb691314980fc$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $cd9bb691314980fc$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $cd9bb691314980fc$var$popSuspenseHandler(workInProgress), $cd9bb691314980fc$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($cd9bb691314980fc$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $cd9bb691314980fc$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $cd9bb691314980fc$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $cd9bb691314980fc$var$popProvider($cd9bb691314980fc$var$CacheContext), $cd9bb691314980fc$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($cd9bb691314980fc$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $cd9bb691314980fc$var$unwindWork(current, workInProgress) {
    $cd9bb691314980fc$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $cd9bb691314980fc$var$popProvider($cd9bb691314980fc$var$CacheContext), $cd9bb691314980fc$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $cd9bb691314980fc$var$popHostContext(workInProgress), null;
        case 13:
            $cd9bb691314980fc$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(340));
                $cd9bb691314980fc$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$suspenseStackCursor), null;
        case 4:
            return $cd9bb691314980fc$var$popHostContainer(), null;
        case 10:
            return $cd9bb691314980fc$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $cd9bb691314980fc$var$popSuspenseHandler(workInProgress), $cd9bb691314980fc$var$popHiddenContext(), null !== current && $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $cd9bb691314980fc$var$popProvider($cd9bb691314980fc$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $cd9bb691314980fc$var$unwindInterruptedWork(current, interruptedWork) {
    $cd9bb691314980fc$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $cd9bb691314980fc$var$popProvider($cd9bb691314980fc$var$CacheContext);
            $cd9bb691314980fc$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $cd9bb691314980fc$var$popHostContext(interruptedWork);
            break;
        case 4:
            $cd9bb691314980fc$var$popHostContainer();
            break;
        case 13:
            $cd9bb691314980fc$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$suspenseStackCursor);
            break;
        case 10:
            $cd9bb691314980fc$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $cd9bb691314980fc$var$popSuspenseHandler(interruptedWork);
            $cd9bb691314980fc$var$popHiddenContext();
            null !== current && $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$resumedCache);
            break;
        case 24:
            $cd9bb691314980fc$var$popProvider($cd9bb691314980fc$var$CacheContext);
    }
}
function $cd9bb691314980fc$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $cd9bb691314980fc$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $cd9bb691314980fc$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $cd9bb691314980fc$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $cd9bb691314980fc$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $cd9bb691314980fc$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $cd9bb691314980fc$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $cd9bb691314980fc$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $cd9bb691314980fc$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $cd9bb691314980fc$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $cd9bb691314980fc$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $cd9bb691314980fc$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            $cd9bb691314980fc$var$captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function $cd9bb691314980fc$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $cd9bb691314980fc$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $cd9bb691314980fc$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$cd9bb691314980fc$var$internalPropsKey] = newProps;
    } catch (error) {
        $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $cd9bb691314980fc$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $cd9bb691314980fc$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $cd9bb691314980fc$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $cd9bb691314980fc$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $cd9bb691314980fc$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $cd9bb691314980fc$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $cd9bb691314980fc$var$noop$1));
    else if (4 !== tag && (27 === tag && $cd9bb691314980fc$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($cd9bb691314980fc$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$cd9bb691314980fc$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $cd9bb691314980fc$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $cd9bb691314980fc$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($cd9bb691314980fc$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$cd9bb691314980fc$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $cd9bb691314980fc$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $cd9bb691314980fc$var$setInitialProperties(singleton, type, props);
        singleton[$cd9bb691314980fc$var$internalInstanceKey] = finishedWork;
        singleton[$cd9bb691314980fc$var$internalPropsKey] = props;
    } catch (error) {
        $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $cd9bb691314980fc$var$offscreenSubtreeIsHidden = !1, $cd9bb691314980fc$var$offscreenSubtreeWasHidden = !1, $cd9bb691314980fc$var$needsFormReset = !1, $cd9bb691314980fc$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $cd9bb691314980fc$var$nextEffect = null;
function $cd9bb691314980fc$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $cd9bb691314980fc$var$eventsEnabled = $cd9bb691314980fc$var$_enabled;
    root = $cd9bb691314980fc$var$getActiveElementDeep(root);
    if ($cd9bb691314980fc$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $cd9bb691314980fc$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $cd9bb691314980fc$var$_enabled = !1;
    for($cd9bb691314980fc$var$nextEffect = firstChild; null !== $cd9bb691314980fc$var$nextEffect;)if (firstChild = $cd9bb691314980fc$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, $cd9bb691314980fc$var$nextEffect = root;
    else for(; null !== $cd9bb691314980fc$var$nextEffect;){
        firstChild = $cd9bb691314980fc$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $cd9bb691314980fc$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $cd9bb691314980fc$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $cd9bb691314980fc$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $cd9bb691314980fc$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $cd9bb691314980fc$var$nextEffect = root;
            break;
        }
        $cd9bb691314980fc$var$nextEffect = firstChild.return;
    }
}
function $cd9bb691314980fc$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $cd9bb691314980fc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $cd9bb691314980fc$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $cd9bb691314980fc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $cd9bb691314980fc$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && $cd9bb691314980fc$var$commitClassCallbacks(finishedWork);
            flags & 512 && $cd9bb691314980fc$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $cd9bb691314980fc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $cd9bb691314980fc$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $cd9bb691314980fc$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $cd9bb691314980fc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $cd9bb691314980fc$var$commitHostMount(finishedWork);
            flags & 512 && $cd9bb691314980fc$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $cd9bb691314980fc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $cd9bb691314980fc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $cd9bb691314980fc$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $cd9bb691314980fc$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $cd9bb691314980fc$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $cd9bb691314980fc$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $cd9bb691314980fc$var$offscreenSubtreeWasHidden;
                prevProps = $cd9bb691314980fc$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $cd9bb691314980fc$var$offscreenSubtreeWasHidden;
                $cd9bb691314980fc$var$offscreenSubtreeIsHidden = flags;
                ($cd9bb691314980fc$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $cd9bb691314980fc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $cd9bb691314980fc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $cd9bb691314980fc$var$offscreenSubtreeIsHidden = prevProps;
                $cd9bb691314980fc$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $cd9bb691314980fc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $cd9bb691314980fc$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $cd9bb691314980fc$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $cd9bb691314980fc$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $cd9bb691314980fc$var$hostParent = null, $cd9bb691314980fc$var$hostParentIsContainer = !1;
function $cd9bb691314980fc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$cd9bb691314980fc$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $cd9bb691314980fc$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($cd9bb691314980fc$var$injectedHook && "function" === typeof $cd9bb691314980fc$var$injectedHook.onCommitFiberUnmount) try {
        $cd9bb691314980fc$var$injectedHook.onCommitFiberUnmount($cd9bb691314980fc$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $cd9bb691314980fc$var$offscreenSubtreeWasHidden || $cd9bb691314980fc$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $cd9bb691314980fc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $cd9bb691314980fc$var$offscreenSubtreeWasHidden || $cd9bb691314980fc$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $cd9bb691314980fc$var$hostParent, prevHostParentIsContainer = $cd9bb691314980fc$var$hostParentIsContainer;
            $cd9bb691314980fc$var$isSingletonScope(deletedFiber.type) && ($cd9bb691314980fc$var$hostParent = deletedFiber.stateNode, $cd9bb691314980fc$var$hostParentIsContainer = !1);
            $cd9bb691314980fc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $cd9bb691314980fc$var$releaseSingletonInstance(deletedFiber.stateNode);
            $cd9bb691314980fc$var$hostParent = prevHostParent;
            $cd9bb691314980fc$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $cd9bb691314980fc$var$offscreenSubtreeWasHidden || $cd9bb691314980fc$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $cd9bb691314980fc$var$hostParent;
            prevHostParentIsContainer = $cd9bb691314980fc$var$hostParentIsContainer;
            $cd9bb691314980fc$var$hostParent = null;
            $cd9bb691314980fc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $cd9bb691314980fc$var$hostParent = prevHostParent;
            $cd9bb691314980fc$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $cd9bb691314980fc$var$hostParent) {
                if ($cd9bb691314980fc$var$hostParentIsContainer) try {
                    (9 === $cd9bb691314980fc$var$hostParent.nodeType ? $cd9bb691314980fc$var$hostParent.body : "HTML" === $cd9bb691314980fc$var$hostParent.nodeName ? $cd9bb691314980fc$var$hostParent.ownerDocument.body : $cd9bb691314980fc$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $cd9bb691314980fc$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $cd9bb691314980fc$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $cd9bb691314980fc$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $cd9bb691314980fc$var$hostParent && ($cd9bb691314980fc$var$hostParentIsContainer ? (finishedRoot = $cd9bb691314980fc$var$hostParent, $cd9bb691314980fc$var$clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $cd9bb691314980fc$var$retryIfBlockedOn(finishedRoot)) : $cd9bb691314980fc$var$clearSuspenseBoundary($cd9bb691314980fc$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $cd9bb691314980fc$var$hostParent;
            prevHostParentIsContainer = $cd9bb691314980fc$var$hostParentIsContainer;
            $cd9bb691314980fc$var$hostParent = deletedFiber.stateNode.containerInfo;
            $cd9bb691314980fc$var$hostParentIsContainer = !0;
            $cd9bb691314980fc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $cd9bb691314980fc$var$hostParent = prevHostParent;
            $cd9bb691314980fc$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $cd9bb691314980fc$var$offscreenSubtreeWasHidden || $cd9bb691314980fc$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $cd9bb691314980fc$var$offscreenSubtreeWasHidden || $cd9bb691314980fc$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $cd9bb691314980fc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $cd9bb691314980fc$var$offscreenSubtreeWasHidden || ($cd9bb691314980fc$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $cd9bb691314980fc$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $cd9bb691314980fc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $cd9bb691314980fc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $cd9bb691314980fc$var$offscreenSubtreeWasHidden = (prevHostParent = $cd9bb691314980fc$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $cd9bb691314980fc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $cd9bb691314980fc$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $cd9bb691314980fc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $cd9bb691314980fc$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $cd9bb691314980fc$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $cd9bb691314980fc$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $cd9bb691314980fc$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $cd9bb691314980fc$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($cd9bb691314980fc$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $cd9bb691314980fc$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $cd9bb691314980fc$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $cd9bb691314980fc$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($cd9bb691314980fc$var$isSingletonScope(parent.type)) {
                        $cd9bb691314980fc$var$hostParent = parent.stateNode;
                        $cd9bb691314980fc$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $cd9bb691314980fc$var$hostParent = parent.stateNode;
                    $cd9bb691314980fc$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $cd9bb691314980fc$var$hostParent = parent.stateNode.containerInfo;
                    $cd9bb691314980fc$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $cd9bb691314980fc$var$hostParent) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(160));
        $cd9bb691314980fc$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $cd9bb691314980fc$var$hostParent = null;
        $cd9bb691314980fc$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$cd9bb691314980fc$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $cd9bb691314980fc$var$currentHoistableRoot = null;
function $cd9bb691314980fc$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($cd9bb691314980fc$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $cd9bb691314980fc$var$commitHookEffectListMount(3, finishedWork), $cd9bb691314980fc$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($cd9bb691314980fc$var$offscreenSubtreeWasHidden || null === current || $cd9bb691314980fc$var$safelyDetachRef(current, current.return));
            flags & 64 && $cd9bb691314980fc$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $cd9bb691314980fc$var$currentHoistableRoot;
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($cd9bb691314980fc$var$offscreenSubtreeWasHidden || null === current || $cd9bb691314980fc$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$cd9bb691314980fc$var$internalHoistableMarker] || currentResource[$cd9bb691314980fc$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $cd9bb691314980fc$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$cd9bb691314980fc$var$internalInstanceKey] = finishedWork;
                                        $cd9bb691314980fc$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $cd9bb691314980fc$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $cd9bb691314980fc$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $cd9bb691314980fc$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $cd9bb691314980fc$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($cd9bb691314980fc$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$cd9bb691314980fc$var$internalInstanceKey] = finishedWork;
                                $cd9bb691314980fc$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $cd9bb691314980fc$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $cd9bb691314980fc$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $cd9bb691314980fc$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $cd9bb691314980fc$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $cd9bb691314980fc$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($cd9bb691314980fc$var$offscreenSubtreeWasHidden || null === current || $cd9bb691314980fc$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $cd9bb691314980fc$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($cd9bb691314980fc$var$offscreenSubtreeWasHidden || null === current || $cd9bb691314980fc$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $cd9bb691314980fc$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $cd9bb691314980fc$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($cd9bb691314980fc$var$needsFormReset = !0);
            break;
        case 6:
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $cd9bb691314980fc$var$tagCaches = null;
            hoistableRoot = $cd9bb691314980fc$var$currentHoistableRoot;
            $cd9bb691314980fc$var$currentHoistableRoot = $cd9bb691314980fc$var$getHoistableRoot(root.containerInfo);
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $cd9bb691314980fc$var$currentHoistableRoot = hoistableRoot;
            $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $cd9bb691314980fc$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $cd9bb691314980fc$var$needsFormReset && ($cd9bb691314980fc$var$needsFormReset = !1, $cd9bb691314980fc$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $cd9bb691314980fc$var$currentHoistableRoot;
            $cd9bb691314980fc$var$currentHoistableRoot = $cd9bb691314980fc$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
            $cd9bb691314980fc$var$currentHoistableRoot = flags;
            break;
        case 12:
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($cd9bb691314980fc$var$globalMostRecentFallbackTime = $cd9bb691314980fc$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $cd9bb691314980fc$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $cd9bb691314980fc$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $cd9bb691314980fc$var$offscreenSubtreeWasHidden;
            $cd9bb691314980fc$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $cd9bb691314980fc$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $cd9bb691314980fc$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $cd9bb691314980fc$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $cd9bb691314980fc$var$offscreenSubtreeIsHidden || $cd9bb691314980fc$var$offscreenSubtreeWasHidden || $cd9bb691314980fc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $cd9bb691314980fc$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $cd9bb691314980fc$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $cd9bb691314980fc$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $cd9bb691314980fc$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork), $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
    }
}
function $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($cd9bb691314980fc$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $cd9bb691314980fc$var$getHostSibling(finishedWork);
                    $cd9bb691314980fc$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($cd9bb691314980fc$var$setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = $cd9bb691314980fc$var$getHostSibling(finishedWork);
                    $cd9bb691314980fc$var$insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = $cd9bb691314980fc$var$getHostSibling(finishedWork);
                    $cd9bb691314980fc$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error($cd9bb691314980fc$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $cd9bb691314980fc$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $cd9bb691314980fc$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $cd9bb691314980fc$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$cd9bb691314980fc$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $cd9bb691314980fc$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $cd9bb691314980fc$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $cd9bb691314980fc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $cd9bb691314980fc$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $cd9bb691314980fc$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $cd9bb691314980fc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $cd9bb691314980fc$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $cd9bb691314980fc$var$safelyDetachRef(finishedWork, finishedWork.return);
                $cd9bb691314980fc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $cd9bb691314980fc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $cd9bb691314980fc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $cd9bb691314980fc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $cd9bb691314980fc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $cd9bb691314980fc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $cd9bb691314980fc$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $cd9bb691314980fc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $cd9bb691314980fc$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$cd9bb691314980fc$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $cd9bb691314980fc$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $cd9bb691314980fc$var$commitClassCallbacks(finishedWork);
                $cd9bb691314980fc$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $cd9bb691314980fc$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $cd9bb691314980fc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $cd9bb691314980fc$var$commitHostMount(finishedWork);
                $cd9bb691314980fc$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $cd9bb691314980fc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $cd9bb691314980fc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $cd9bb691314980fc$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $cd9bb691314980fc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $cd9bb691314980fc$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $cd9bb691314980fc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $cd9bb691314980fc$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $cd9bb691314980fc$var$releaseCache(previousCache));
}
function $cd9bb691314980fc$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $cd9bb691314980fc$var$releaseCache(current));
}
function $cd9bb691314980fc$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$cd9bb691314980fc$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $cd9bb691314980fc$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $cd9bb691314980fc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $cd9bb691314980fc$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $cd9bb691314980fc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $cd9bb691314980fc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $cd9bb691314980fc$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $cd9bb691314980fc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $cd9bb691314980fc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $cd9bb691314980fc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $cd9bb691314980fc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $cd9bb691314980fc$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $cd9bb691314980fc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $cd9bb691314980fc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $cd9bb691314980fc$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $cd9bb691314980fc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $cd9bb691314980fc$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $cd9bb691314980fc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $cd9bb691314980fc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $cd9bb691314980fc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $cd9bb691314980fc$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $cd9bb691314980fc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $cd9bb691314980fc$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $cd9bb691314980fc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $cd9bb691314980fc$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $cd9bb691314980fc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $cd9bb691314980fc$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $cd9bb691314980fc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $cd9bb691314980fc$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $cd9bb691314980fc$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $cd9bb691314980fc$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $cd9bb691314980fc$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $cd9bb691314980fc$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $cd9bb691314980fc$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $cd9bb691314980fc$var$suspenseyCommitFlag = 8192;
function $cd9bb691314980fc$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $cd9bb691314980fc$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$cd9bb691314980fc$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $cd9bb691314980fc$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $cd9bb691314980fc$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $cd9bb691314980fc$var$suspenseyCommitFlag && null !== fiber.memoizedState && $cd9bb691314980fc$var$suspendResource($cd9bb691314980fc$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $cd9bb691314980fc$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $cd9bb691314980fc$var$currentHoistableRoot;
            $cd9bb691314980fc$var$currentHoistableRoot = $cd9bb691314980fc$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $cd9bb691314980fc$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $cd9bb691314980fc$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $cd9bb691314980fc$var$suspenseyCommitFlag, $cd9bb691314980fc$var$suspenseyCommitFlag = 16777216, $cd9bb691314980fc$var$recursivelyAccumulateSuspenseyCommit(fiber), $cd9bb691314980fc$var$suspenseyCommitFlag = previousHoistableRoot) : $cd9bb691314980fc$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $cd9bb691314980fc$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $cd9bb691314980fc$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $cd9bb691314980fc$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $cd9bb691314980fc$var$nextEffect = childToDelete;
            $cd9bb691314980fc$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $cd9bb691314980fc$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$cd9bb691314980fc$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $cd9bb691314980fc$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $cd9bb691314980fc$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $cd9bb691314980fc$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $cd9bb691314980fc$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $cd9bb691314980fc$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $cd9bb691314980fc$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $cd9bb691314980fc$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $cd9bb691314980fc$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $cd9bb691314980fc$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $cd9bb691314980fc$var$nextEffect = childToDelete;
            $cd9bb691314980fc$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $cd9bb691314980fc$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $cd9bb691314980fc$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $cd9bb691314980fc$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $cd9bb691314980fc$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $cd9bb691314980fc$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $cd9bb691314980fc$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $cd9bb691314980fc$var$nextEffect;){
        var fiber = $cd9bb691314980fc$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $cd9bb691314980fc$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $cd9bb691314980fc$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $cd9bb691314980fc$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $cd9bb691314980fc$var$nextEffect;){
            cache = $cd9bb691314980fc$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $cd9bb691314980fc$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $cd9bb691314980fc$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $cd9bb691314980fc$var$nextEffect = sibling;
                break a;
            }
            $cd9bb691314980fc$var$nextEffect = returnFiber;
        }
    }
}
var $cd9bb691314980fc$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $cd9bb691314980fc$var$readContext($cd9bb691314980fc$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $cd9bb691314980fc$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $cd9bb691314980fc$var$executionContext = 0, $cd9bb691314980fc$var$workInProgressRoot = null, $cd9bb691314980fc$var$workInProgress = null, $cd9bb691314980fc$var$workInProgressRootRenderLanes = 0, $cd9bb691314980fc$var$workInProgressSuspendedReason = 0, $cd9bb691314980fc$var$workInProgressThrownValue = null, $cd9bb691314980fc$var$workInProgressRootDidSkipSuspendedSiblings = !1, $cd9bb691314980fc$var$workInProgressRootIsPrerendering = !1, $cd9bb691314980fc$var$workInProgressRootDidAttachPingListener = !1, $cd9bb691314980fc$var$entangledRenderLanes = 0, $cd9bb691314980fc$var$workInProgressRootExitStatus = 0, $cd9bb691314980fc$var$workInProgressRootSkippedLanes = 0, $cd9bb691314980fc$var$workInProgressRootInterleavedUpdatedLanes = 0, $cd9bb691314980fc$var$workInProgressRootPingedLanes = 0, $cd9bb691314980fc$var$workInProgressDeferredLane = 0, $cd9bb691314980fc$var$workInProgressSuspendedRetryLanes = 0, $cd9bb691314980fc$var$workInProgressRootConcurrentErrors = null, $cd9bb691314980fc$var$workInProgressRootRecoverableErrors = null, $cd9bb691314980fc$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $cd9bb691314980fc$var$globalMostRecentFallbackTime = 0, $cd9bb691314980fc$var$workInProgressRootRenderTargetTime = Infinity, $cd9bb691314980fc$var$workInProgressTransitions = null, $cd9bb691314980fc$var$legacyErrorBoundariesThatAlreadyFailed = null, $cd9bb691314980fc$var$pendingEffectsStatus = 0, $cd9bb691314980fc$var$pendingEffectsRoot = null, $cd9bb691314980fc$var$pendingFinishedWork = null, $cd9bb691314980fc$var$pendingEffectsLanes = 0, $cd9bb691314980fc$var$pendingEffectsRemainingLanes = 0, $cd9bb691314980fc$var$pendingPassiveTransitions = null, $cd9bb691314980fc$var$pendingRecoverableErrors = null, $cd9bb691314980fc$var$nestedUpdateCount = 0, $cd9bb691314980fc$var$rootWithNestedUpdates = null;
function $cd9bb691314980fc$var$requestUpdateLane() {
    if (0 !== ($cd9bb691314980fc$var$executionContext & 2) && 0 !== $cd9bb691314980fc$var$workInProgressRootRenderLanes) return $cd9bb691314980fc$var$workInProgressRootRenderLanes & -$cd9bb691314980fc$var$workInProgressRootRenderLanes;
    if (null !== $cd9bb691314980fc$var$ReactSharedInternals.T) {
        var actionScopeLane = $cd9bb691314980fc$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $cd9bb691314980fc$var$requestTransitionLane();
    }
    return $cd9bb691314980fc$var$resolveUpdatePriority();
}
function $cd9bb691314980fc$var$requestDeferredLane() {
    0 === $cd9bb691314980fc$var$workInProgressDeferredLane && ($cd9bb691314980fc$var$workInProgressDeferredLane = 0 === ($cd9bb691314980fc$var$workInProgressRootRenderLanes & 536870912) || $cd9bb691314980fc$var$isHydrating ? $cd9bb691314980fc$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $cd9bb691314980fc$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $cd9bb691314980fc$var$workInProgressDeferredLane;
}
function $cd9bb691314980fc$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $cd9bb691314980fc$var$workInProgressRoot && (2 === $cd9bb691314980fc$var$workInProgressSuspendedReason || 9 === $cd9bb691314980fc$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $cd9bb691314980fc$var$prepareFreshStack(root, 0), $cd9bb691314980fc$var$markRootSuspended(root, $cd9bb691314980fc$var$workInProgressRootRenderLanes, $cd9bb691314980fc$var$workInProgressDeferredLane, !1);
    $cd9bb691314980fc$var$markRootUpdated$1(root, lane);
    if (0 === ($cd9bb691314980fc$var$executionContext & 2) || root !== $cd9bb691314980fc$var$workInProgressRoot) root === $cd9bb691314980fc$var$workInProgressRoot && (0 === ($cd9bb691314980fc$var$executionContext & 2) && ($cd9bb691314980fc$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $cd9bb691314980fc$var$workInProgressRootExitStatus && $cd9bb691314980fc$var$markRootSuspended(root, $cd9bb691314980fc$var$workInProgressRootRenderLanes, $cd9bb691314980fc$var$workInProgressDeferredLane, !1)), $cd9bb691314980fc$var$ensureRootIsScheduled(root);
}
function $cd9bb691314980fc$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($cd9bb691314980fc$var$executionContext & 6)) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || $cd9bb691314980fc$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $cd9bb691314980fc$var$renderRootConcurrent(root$jscomp$0, lanes) : $cd9bb691314980fc$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $cd9bb691314980fc$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $cd9bb691314980fc$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$cd9bb691314980fc$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $cd9bb691314980fc$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $cd9bb691314980fc$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($cd9bb691314980fc$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $cd9bb691314980fc$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($cd9bb691314980fc$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $cd9bb691314980fc$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $cd9bb691314980fc$var$workInProgressRootRecoverableErrors;
                            $cd9bb691314980fc$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $cd9bb691314980fc$var$workInProgressRootRecoverableErrors ? $cd9bb691314980fc$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $cd9bb691314980fc$var$workInProgressRootRecoverableErrors.push.apply($cd9bb691314980fc$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $cd9bb691314980fc$var$prepareFreshStack(root$jscomp$0, 0);
                $cd9bb691314980fc$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($cd9bb691314980fc$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $cd9bb691314980fc$var$markRootSuspended(shouldTimeSlice, lanes, $cd9bb691314980fc$var$workInProgressDeferredLane, !$cd9bb691314980fc$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $cd9bb691314980fc$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($cd9bb691314980fc$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $cd9bb691314980fc$var$globalMostRecentFallbackTime + 300 - $cd9bb691314980fc$var$now(), 10 < exitStatus)) {
                    $cd9bb691314980fc$var$markRootSuspended(shouldTimeSlice, lanes, $cd9bb691314980fc$var$workInProgressDeferredLane, !$cd9bb691314980fc$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $cd9bb691314980fc$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = $cd9bb691314980fc$var$scheduleTimeout($cd9bb691314980fc$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $cd9bb691314980fc$var$workInProgressRootRecoverableErrors, $cd9bb691314980fc$var$workInProgressTransitions, $cd9bb691314980fc$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $cd9bb691314980fc$var$workInProgressDeferredLane, $cd9bb691314980fc$var$workInProgressRootInterleavedUpdatedLanes, $cd9bb691314980fc$var$workInProgressSuspendedRetryLanes, $cd9bb691314980fc$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                $cd9bb691314980fc$var$commitRootWhenReady(shouldTimeSlice, forceSync, $cd9bb691314980fc$var$workInProgressRootRecoverableErrors, $cd9bb691314980fc$var$workInProgressTransitions, $cd9bb691314980fc$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $cd9bb691314980fc$var$workInProgressDeferredLane, $cd9bb691314980fc$var$workInProgressRootInterleavedUpdatedLanes, $cd9bb691314980fc$var$workInProgressSuspendedRetryLanes, $cd9bb691314980fc$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $cd9bb691314980fc$var$ensureRootIsScheduled(root$jscomp$0);
}
function $cd9bb691314980fc$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if ($cd9bb691314980fc$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $cd9bb691314980fc$var$noop
        }, $cd9bb691314980fc$var$accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = $cd9bb691314980fc$var$waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason($cd9bb691314980fc$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            $cd9bb691314980fc$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $cd9bb691314980fc$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $cd9bb691314980fc$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$cd9bb691314980fc$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $cd9bb691314980fc$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$cd9bb691314980fc$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$cd9bb691314980fc$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - $cd9bb691314980fc$var$clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $cd9bb691314980fc$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $cd9bb691314980fc$var$flushSyncWork$1() {
    return 0 === ($cd9bb691314980fc$var$executionContext & 6) ? ($cd9bb691314980fc$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $cd9bb691314980fc$var$resetWorkInProgressStack() {
    if (null !== $cd9bb691314980fc$var$workInProgress) {
        if (0 === $cd9bb691314980fc$var$workInProgressSuspendedReason) var interruptedWork = $cd9bb691314980fc$var$workInProgress.return;
        else interruptedWork = $cd9bb691314980fc$var$workInProgress, $cd9bb691314980fc$var$lastContextDependency = $cd9bb691314980fc$var$currentlyRenderingFiber$1 = null, $cd9bb691314980fc$var$resetHooksOnUnwind(interruptedWork), $cd9bb691314980fc$var$thenableState = null, $cd9bb691314980fc$var$thenableIndexCounter = 0, interruptedWork = $cd9bb691314980fc$var$workInProgress;
        for(; null !== interruptedWork;)$cd9bb691314980fc$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $cd9bb691314980fc$var$workInProgress = null;
    }
}
function $cd9bb691314980fc$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $cd9bb691314980fc$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $cd9bb691314980fc$var$resetWorkInProgressStack();
    $cd9bb691314980fc$var$workInProgressRoot = root;
    $cd9bb691314980fc$var$workInProgress = timeoutHandle = $cd9bb691314980fc$var$createWorkInProgress(root.current, null);
    $cd9bb691314980fc$var$workInProgressRootRenderLanes = lanes;
    $cd9bb691314980fc$var$workInProgressSuspendedReason = 0;
    $cd9bb691314980fc$var$workInProgressThrownValue = null;
    $cd9bb691314980fc$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $cd9bb691314980fc$var$workInProgressRootIsPrerendering = $cd9bb691314980fc$var$checkIfRootIsPrerendering(root, lanes);
    $cd9bb691314980fc$var$workInProgressRootDidAttachPingListener = !1;
    $cd9bb691314980fc$var$workInProgressSuspendedRetryLanes = $cd9bb691314980fc$var$workInProgressDeferredLane = $cd9bb691314980fc$var$workInProgressRootPingedLanes = $cd9bb691314980fc$var$workInProgressRootInterleavedUpdatedLanes = $cd9bb691314980fc$var$workInProgressRootSkippedLanes = $cd9bb691314980fc$var$workInProgressRootExitStatus = 0;
    $cd9bb691314980fc$var$workInProgressRootRecoverableErrors = $cd9bb691314980fc$var$workInProgressRootConcurrentErrors = null;
    $cd9bb691314980fc$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - $cd9bb691314980fc$var$clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    $cd9bb691314980fc$var$entangledRenderLanes = lanes;
    $cd9bb691314980fc$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $cd9bb691314980fc$var$handleThrow(root, thrownValue) {
    $cd9bb691314980fc$var$currentlyRenderingFiber = null;
    $cd9bb691314980fc$var$ReactSharedInternals.H = $cd9bb691314980fc$var$ContextOnlyDispatcher;
    thrownValue === $cd9bb691314980fc$var$SuspenseException || thrownValue === $cd9bb691314980fc$var$SuspenseActionException ? (thrownValue = $cd9bb691314980fc$var$getSuspendedThenable(), $cd9bb691314980fc$var$workInProgressSuspendedReason = 3) : thrownValue === $cd9bb691314980fc$var$SuspenseyCommitException ? (thrownValue = $cd9bb691314980fc$var$getSuspendedThenable(), $cd9bb691314980fc$var$workInProgressSuspendedReason = 4) : $cd9bb691314980fc$var$workInProgressSuspendedReason = thrownValue === $cd9bb691314980fc$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $cd9bb691314980fc$var$workInProgressThrownValue = thrownValue;
    null === $cd9bb691314980fc$var$workInProgress && ($cd9bb691314980fc$var$workInProgressRootExitStatus = 1, $cd9bb691314980fc$var$logUncaughtError(root, $cd9bb691314980fc$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $cd9bb691314980fc$var$pushDispatcher() {
    var prevDispatcher = $cd9bb691314980fc$var$ReactSharedInternals.H;
    $cd9bb691314980fc$var$ReactSharedInternals.H = $cd9bb691314980fc$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $cd9bb691314980fc$var$ContextOnlyDispatcher : prevDispatcher;
}
function $cd9bb691314980fc$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $cd9bb691314980fc$var$ReactSharedInternals.A;
    $cd9bb691314980fc$var$ReactSharedInternals.A = $cd9bb691314980fc$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $cd9bb691314980fc$var$renderDidSuspendDelayIfPossible() {
    $cd9bb691314980fc$var$workInProgressRootExitStatus = 4;
    $cd9bb691314980fc$var$workInProgressRootDidSkipSuspendedSiblings || ($cd9bb691314980fc$var$workInProgressRootRenderLanes & 4194048) !== $cd9bb691314980fc$var$workInProgressRootRenderLanes && null !== $cd9bb691314980fc$var$suspenseHandlerStackCursor.current || ($cd9bb691314980fc$var$workInProgressRootIsPrerendering = !0);
    0 === ($cd9bb691314980fc$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($cd9bb691314980fc$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $cd9bb691314980fc$var$workInProgressRoot || $cd9bb691314980fc$var$markRootSuspended($cd9bb691314980fc$var$workInProgressRoot, $cd9bb691314980fc$var$workInProgressRootRenderLanes, $cd9bb691314980fc$var$workInProgressDeferredLane, !1);
}
function $cd9bb691314980fc$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $cd9bb691314980fc$var$executionContext;
    $cd9bb691314980fc$var$executionContext |= 2;
    var prevDispatcher = $cd9bb691314980fc$var$pushDispatcher(), prevAsyncDispatcher = $cd9bb691314980fc$var$pushAsyncDispatcher();
    if ($cd9bb691314980fc$var$workInProgressRoot !== root || $cd9bb691314980fc$var$workInProgressRootRenderLanes !== lanes) $cd9bb691314980fc$var$workInProgressTransitions = null, $cd9bb691314980fc$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $cd9bb691314980fc$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $cd9bb691314980fc$var$workInProgressSuspendedReason && null !== $cd9bb691314980fc$var$workInProgress) {
            var unitOfWork = $cd9bb691314980fc$var$workInProgress, thrownValue = $cd9bb691314980fc$var$workInProgressThrownValue;
            switch($cd9bb691314980fc$var$workInProgressSuspendedReason){
                case 8:
                    $cd9bb691314980fc$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $cd9bb691314980fc$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $cd9bb691314980fc$var$workInProgressSuspendedReason;
                    $cd9bb691314980fc$var$workInProgressSuspendedReason = 0;
                    $cd9bb691314980fc$var$workInProgressThrownValue = null;
                    $cd9bb691314980fc$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $cd9bb691314980fc$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $cd9bb691314980fc$var$workInProgressSuspendedReason, $cd9bb691314980fc$var$workInProgressSuspendedReason = 0, $cd9bb691314980fc$var$workInProgressThrownValue = null, $cd9bb691314980fc$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $cd9bb691314980fc$var$workLoopSync();
        exitStatus = $cd9bb691314980fc$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        $cd9bb691314980fc$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $cd9bb691314980fc$var$lastContextDependency = $cd9bb691314980fc$var$currentlyRenderingFiber$1 = null;
    $cd9bb691314980fc$var$executionContext = prevExecutionContext;
    $cd9bb691314980fc$var$ReactSharedInternals.H = prevDispatcher;
    $cd9bb691314980fc$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $cd9bb691314980fc$var$workInProgress && ($cd9bb691314980fc$var$workInProgressRoot = null, $cd9bb691314980fc$var$workInProgressRootRenderLanes = 0, $cd9bb691314980fc$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $cd9bb691314980fc$var$workLoopSync() {
    for(; null !== $cd9bb691314980fc$var$workInProgress;)$cd9bb691314980fc$var$performUnitOfWork($cd9bb691314980fc$var$workInProgress);
}
function $cd9bb691314980fc$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $cd9bb691314980fc$var$executionContext;
    $cd9bb691314980fc$var$executionContext |= 2;
    var prevDispatcher = $cd9bb691314980fc$var$pushDispatcher(), prevAsyncDispatcher = $cd9bb691314980fc$var$pushAsyncDispatcher();
    $cd9bb691314980fc$var$workInProgressRoot !== root || $cd9bb691314980fc$var$workInProgressRootRenderLanes !== lanes ? ($cd9bb691314980fc$var$workInProgressTransitions = null, $cd9bb691314980fc$var$workInProgressRootRenderTargetTime = $cd9bb691314980fc$var$now() + 500, $cd9bb691314980fc$var$prepareFreshStack(root, lanes)) : $cd9bb691314980fc$var$workInProgressRootIsPrerendering = $cd9bb691314980fc$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $cd9bb691314980fc$var$workInProgressSuspendedReason && null !== $cd9bb691314980fc$var$workInProgress) {
            lanes = $cd9bb691314980fc$var$workInProgress;
            var thrownValue = $cd9bb691314980fc$var$workInProgressThrownValue;
            b: switch($cd9bb691314980fc$var$workInProgressSuspendedReason){
                case 1:
                    $cd9bb691314980fc$var$workInProgressSuspendedReason = 0;
                    $cd9bb691314980fc$var$workInProgressThrownValue = null;
                    $cd9bb691314980fc$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($cd9bb691314980fc$var$isThenableResolved(thrownValue)) {
                        $cd9bb691314980fc$var$workInProgressSuspendedReason = 0;
                        $cd9bb691314980fc$var$workInProgressThrownValue = null;
                        $cd9bb691314980fc$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $cd9bb691314980fc$var$workInProgressSuspendedReason && 9 !== $cd9bb691314980fc$var$workInProgressSuspendedReason || $cd9bb691314980fc$var$workInProgressRoot !== root || ($cd9bb691314980fc$var$workInProgressSuspendedReason = 7);
                        $cd9bb691314980fc$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $cd9bb691314980fc$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $cd9bb691314980fc$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $cd9bb691314980fc$var$isThenableResolved(thrownValue) ? ($cd9bb691314980fc$var$workInProgressSuspendedReason = 0, $cd9bb691314980fc$var$workInProgressThrownValue = null, $cd9bb691314980fc$var$replaySuspendedUnitOfWork(lanes)) : ($cd9bb691314980fc$var$workInProgressSuspendedReason = 0, $cd9bb691314980fc$var$workInProgressThrownValue = null, $cd9bb691314980fc$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($cd9bb691314980fc$var$workInProgress.tag){
                        case 26:
                            resource = $cd9bb691314980fc$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $cd9bb691314980fc$var$workInProgress;
                            if (resource ? $cd9bb691314980fc$var$preloadResource(resource) : 1) {
                                $cd9bb691314980fc$var$workInProgressSuspendedReason = 0;
                                $cd9bb691314980fc$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $cd9bb691314980fc$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($cd9bb691314980fc$var$workInProgress = returnFiber, $cd9bb691314980fc$var$completeUnitOfWork(returnFiber)) : $cd9bb691314980fc$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $cd9bb691314980fc$var$workInProgressSuspendedReason = 0;
                    $cd9bb691314980fc$var$workInProgressThrownValue = null;
                    $cd9bb691314980fc$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $cd9bb691314980fc$var$workInProgressSuspendedReason = 0;
                    $cd9bb691314980fc$var$workInProgressThrownValue = null;
                    $cd9bb691314980fc$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $cd9bb691314980fc$var$resetWorkInProgressStack();
                    $cd9bb691314980fc$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($cd9bb691314980fc$var$formatProdErrorMessage(462));
            }
        }
        $cd9bb691314980fc$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        $cd9bb691314980fc$var$handleThrow(root, thrownValue$169);
    }
    while (1);
    $cd9bb691314980fc$var$lastContextDependency = $cd9bb691314980fc$var$currentlyRenderingFiber$1 = null;
    $cd9bb691314980fc$var$ReactSharedInternals.H = prevDispatcher;
    $cd9bb691314980fc$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $cd9bb691314980fc$var$executionContext = prevExecutionContext;
    if (null !== $cd9bb691314980fc$var$workInProgress) return 0;
    $cd9bb691314980fc$var$workInProgressRoot = null;
    $cd9bb691314980fc$var$workInProgressRootRenderLanes = 0;
    $cd9bb691314980fc$var$finishQueueingConcurrentUpdates();
    return $cd9bb691314980fc$var$workInProgressRootExitStatus;
}
function $cd9bb691314980fc$var$workLoopConcurrentByScheduler() {
    for(; null !== $cd9bb691314980fc$var$workInProgress && !$cd9bb691314980fc$var$shouldYield();)$cd9bb691314980fc$var$performUnitOfWork($cd9bb691314980fc$var$workInProgress);
}
function $cd9bb691314980fc$var$performUnitOfWork(unitOfWork) {
    var next = $cd9bb691314980fc$var$beginWork(unitOfWork.alternate, unitOfWork, $cd9bb691314980fc$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $cd9bb691314980fc$var$completeUnitOfWork(unitOfWork) : $cd9bb691314980fc$var$workInProgress = next;
}
function $cd9bb691314980fc$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $cd9bb691314980fc$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $cd9bb691314980fc$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $cd9bb691314980fc$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $cd9bb691314980fc$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $cd9bb691314980fc$var$resetHooksOnUnwind(next);
        default:
            $cd9bb691314980fc$var$unwindInterruptedWork(current, next), next = $cd9bb691314980fc$var$workInProgress = $cd9bb691314980fc$var$resetWorkInProgress(next, $cd9bb691314980fc$var$entangledRenderLanes), next = $cd9bb691314980fc$var$beginWork(current, next, $cd9bb691314980fc$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $cd9bb691314980fc$var$completeUnitOfWork(unitOfWork) : $cd9bb691314980fc$var$workInProgress = next;
}
function $cd9bb691314980fc$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $cd9bb691314980fc$var$lastContextDependency = $cd9bb691314980fc$var$currentlyRenderingFiber$1 = null;
    $cd9bb691314980fc$var$resetHooksOnUnwind(unitOfWork);
    $cd9bb691314980fc$var$thenableState = null;
    $cd9bb691314980fc$var$thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($cd9bb691314980fc$var$throwException(root, returnFiber, unitOfWork, thrownValue, $cd9bb691314980fc$var$workInProgressRootRenderLanes)) {
            $cd9bb691314980fc$var$workInProgressRootExitStatus = 1;
            $cd9bb691314980fc$var$logUncaughtError(root, $cd9bb691314980fc$var$createCapturedValueAtFiber(thrownValue, root.current));
            $cd9bb691314980fc$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $cd9bb691314980fc$var$workInProgress = returnFiber, error;
        $cd9bb691314980fc$var$workInProgressRootExitStatus = 1;
        $cd9bb691314980fc$var$logUncaughtError(root, $cd9bb691314980fc$var$createCapturedValueAtFiber(thrownValue, root.current));
        $cd9bb691314980fc$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($cd9bb691314980fc$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($cd9bb691314980fc$var$workInProgressRootIsPrerendering || 0 !== ($cd9bb691314980fc$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($cd9bb691314980fc$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $cd9bb691314980fc$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $cd9bb691314980fc$var$unwindUnitOfWork(unitOfWork, root);
    } else $cd9bb691314980fc$var$completeUnitOfWork(unitOfWork);
}
function $cd9bb691314980fc$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $cd9bb691314980fc$var$unwindUnitOfWork(completedWork, $cd9bb691314980fc$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $cd9bb691314980fc$var$completeWork(completedWork.alternate, completedWork, $cd9bb691314980fc$var$entangledRenderLanes);
        if (null !== next) {
            $cd9bb691314980fc$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $cd9bb691314980fc$var$workInProgress = completedWork;
            return;
        }
        $cd9bb691314980fc$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $cd9bb691314980fc$var$workInProgressRootExitStatus && ($cd9bb691314980fc$var$workInProgressRootExitStatus = 5);
}
function $cd9bb691314980fc$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $cd9bb691314980fc$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $cd9bb691314980fc$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $cd9bb691314980fc$var$workInProgress = unitOfWork;
            return;
        }
        $cd9bb691314980fc$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $cd9bb691314980fc$var$workInProgressRootExitStatus = 6;
    $cd9bb691314980fc$var$workInProgress = null;
}
function $cd9bb691314980fc$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $cd9bb691314980fc$var$flushPendingEffects();
    while (0 !== $cd9bb691314980fc$var$pendingEffectsStatus);
    if (0 !== ($cd9bb691314980fc$var$executionContext & 6)) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $cd9bb691314980fc$var$concurrentlyUpdatedLanes;
        $cd9bb691314980fc$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $cd9bb691314980fc$var$workInProgressRoot && ($cd9bb691314980fc$var$workInProgress = $cd9bb691314980fc$var$workInProgressRoot = null, $cd9bb691314980fc$var$workInProgressRootRenderLanes = 0);
        $cd9bb691314980fc$var$pendingFinishedWork = finishedWork;
        $cd9bb691314980fc$var$pendingEffectsRoot = root;
        $cd9bb691314980fc$var$pendingEffectsLanes = lanes;
        $cd9bb691314980fc$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $cd9bb691314980fc$var$pendingPassiveTransitions = transitions;
        $cd9bb691314980fc$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $cd9bb691314980fc$var$scheduleCallback$1($cd9bb691314980fc$var$NormalPriority$1, function() {
            $cd9bb691314980fc$var$flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $cd9bb691314980fc$var$ReactSharedInternals.T;
            $cd9bb691314980fc$var$ReactSharedInternals.T = null;
            transitions = $cd9bb691314980fc$var$ReactDOMSharedInternals.p;
            $cd9bb691314980fc$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $cd9bb691314980fc$var$executionContext;
            $cd9bb691314980fc$var$executionContext |= 4;
            try {
                $cd9bb691314980fc$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $cd9bb691314980fc$var$executionContext = spawnedLane, $cd9bb691314980fc$var$ReactDOMSharedInternals.p = transitions, $cd9bb691314980fc$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $cd9bb691314980fc$var$pendingEffectsStatus = 1;
        $cd9bb691314980fc$var$flushMutationEffects();
        $cd9bb691314980fc$var$flushLayoutEffects();
        $cd9bb691314980fc$var$flushSpawnedWork();
    }
}
function $cd9bb691314980fc$var$flushMutationEffects() {
    if (1 === $cd9bb691314980fc$var$pendingEffectsStatus) {
        $cd9bb691314980fc$var$pendingEffectsStatus = 0;
        var root = $cd9bb691314980fc$var$pendingEffectsRoot, finishedWork = $cd9bb691314980fc$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $cd9bb691314980fc$var$ReactSharedInternals.T;
            $cd9bb691314980fc$var$ReactSharedInternals.T = null;
            var previousPriority = $cd9bb691314980fc$var$ReactDOMSharedInternals.p;
            $cd9bb691314980fc$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $cd9bb691314980fc$var$executionContext;
            $cd9bb691314980fc$var$executionContext |= 4;
            try {
                $cd9bb691314980fc$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $cd9bb691314980fc$var$selectionInformation, curFocusedElem = $cd9bb691314980fc$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $cd9bb691314980fc$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $cd9bb691314980fc$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $cd9bb691314980fc$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $cd9bb691314980fc$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $cd9bb691314980fc$var$_enabled = !!$cd9bb691314980fc$var$eventsEnabled;
                $cd9bb691314980fc$var$selectionInformation = $cd9bb691314980fc$var$eventsEnabled = null;
            } finally{
                $cd9bb691314980fc$var$executionContext = prevExecutionContext, $cd9bb691314980fc$var$ReactDOMSharedInternals.p = previousPriority, $cd9bb691314980fc$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $cd9bb691314980fc$var$pendingEffectsStatus = 2;
    }
}
function $cd9bb691314980fc$var$flushLayoutEffects() {
    if (2 === $cd9bb691314980fc$var$pendingEffectsStatus) {
        $cd9bb691314980fc$var$pendingEffectsStatus = 0;
        var root = $cd9bb691314980fc$var$pendingEffectsRoot, finishedWork = $cd9bb691314980fc$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $cd9bb691314980fc$var$ReactSharedInternals.T;
            $cd9bb691314980fc$var$ReactSharedInternals.T = null;
            var previousPriority = $cd9bb691314980fc$var$ReactDOMSharedInternals.p;
            $cd9bb691314980fc$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $cd9bb691314980fc$var$executionContext;
            $cd9bb691314980fc$var$executionContext |= 4;
            try {
                $cd9bb691314980fc$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $cd9bb691314980fc$var$executionContext = prevExecutionContext, $cd9bb691314980fc$var$ReactDOMSharedInternals.p = previousPriority, $cd9bb691314980fc$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $cd9bb691314980fc$var$pendingEffectsStatus = 3;
    }
}
function $cd9bb691314980fc$var$flushSpawnedWork() {
    if (4 === $cd9bb691314980fc$var$pendingEffectsStatus || 3 === $cd9bb691314980fc$var$pendingEffectsStatus) {
        $cd9bb691314980fc$var$pendingEffectsStatus = 0;
        $cd9bb691314980fc$var$requestPaint();
        var root = $cd9bb691314980fc$var$pendingEffectsRoot, finishedWork = $cd9bb691314980fc$var$pendingFinishedWork, lanes = $cd9bb691314980fc$var$pendingEffectsLanes, recoverableErrors = $cd9bb691314980fc$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $cd9bb691314980fc$var$pendingEffectsStatus = 5 : ($cd9bb691314980fc$var$pendingEffectsStatus = 0, $cd9bb691314980fc$var$pendingFinishedWork = $cd9bb691314980fc$var$pendingEffectsRoot = null, $cd9bb691314980fc$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($cd9bb691314980fc$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $cd9bb691314980fc$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($cd9bb691314980fc$var$injectedHook && "function" === typeof $cd9bb691314980fc$var$injectedHook.onCommitFiberRoot) try {
            $cd9bb691314980fc$var$injectedHook.onCommitFiberRoot($cd9bb691314980fc$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $cd9bb691314980fc$var$ReactSharedInternals.T;
            remainingLanes = $cd9bb691314980fc$var$ReactDOMSharedInternals.p;
            $cd9bb691314980fc$var$ReactDOMSharedInternals.p = 2;
            $cd9bb691314980fc$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $cd9bb691314980fc$var$ReactSharedInternals.T = finishedWork, $cd9bb691314980fc$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($cd9bb691314980fc$var$pendingEffectsLanes & 3) && $cd9bb691314980fc$var$flushPendingEffects();
        $cd9bb691314980fc$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === $cd9bb691314980fc$var$rootWithNestedUpdates ? $cd9bb691314980fc$var$nestedUpdateCount++ : ($cd9bb691314980fc$var$nestedUpdateCount = 0, $cd9bb691314980fc$var$rootWithNestedUpdates = root) : $cd9bb691314980fc$var$nestedUpdateCount = 0;
        $cd9bb691314980fc$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $cd9bb691314980fc$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $cd9bb691314980fc$var$releaseCache(remainingLanes)));
}
function $cd9bb691314980fc$var$flushPendingEffects(wasDelayedCommit) {
    $cd9bb691314980fc$var$flushMutationEffects();
    $cd9bb691314980fc$var$flushLayoutEffects();
    $cd9bb691314980fc$var$flushSpawnedWork();
    return $cd9bb691314980fc$var$flushPassiveEffects(wasDelayedCommit);
}
function $cd9bb691314980fc$var$flushPassiveEffects() {
    if (5 !== $cd9bb691314980fc$var$pendingEffectsStatus) return !1;
    var root = $cd9bb691314980fc$var$pendingEffectsRoot, remainingLanes = $cd9bb691314980fc$var$pendingEffectsRemainingLanes;
    $cd9bb691314980fc$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $cd9bb691314980fc$var$lanesToEventPriority($cd9bb691314980fc$var$pendingEffectsLanes), prevTransition = $cd9bb691314980fc$var$ReactSharedInternals.T, previousPriority = $cd9bb691314980fc$var$ReactDOMSharedInternals.p;
    try {
        $cd9bb691314980fc$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $cd9bb691314980fc$var$ReactSharedInternals.T = null;
        renderPriority = $cd9bb691314980fc$var$pendingPassiveTransitions;
        $cd9bb691314980fc$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $cd9bb691314980fc$var$pendingEffectsRoot, lanes = $cd9bb691314980fc$var$pendingEffectsLanes;
        $cd9bb691314980fc$var$pendingEffectsStatus = 0;
        $cd9bb691314980fc$var$pendingFinishedWork = $cd9bb691314980fc$var$pendingEffectsRoot = null;
        $cd9bb691314980fc$var$pendingEffectsLanes = 0;
        if (0 !== ($cd9bb691314980fc$var$executionContext & 6)) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(331));
        var prevExecutionContext = $cd9bb691314980fc$var$executionContext;
        $cd9bb691314980fc$var$executionContext |= 4;
        $cd9bb691314980fc$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $cd9bb691314980fc$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $cd9bb691314980fc$var$executionContext = prevExecutionContext;
        $cd9bb691314980fc$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($cd9bb691314980fc$var$injectedHook && "function" === typeof $cd9bb691314980fc$var$injectedHook.onPostCommitFiberRoot) try {
            $cd9bb691314980fc$var$injectedHook.onPostCommitFiberRoot($cd9bb691314980fc$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $cd9bb691314980fc$var$ReactDOMSharedInternals.p = previousPriority, $cd9bb691314980fc$var$ReactSharedInternals.T = prevTransition, $cd9bb691314980fc$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $cd9bb691314980fc$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $cd9bb691314980fc$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $cd9bb691314980fc$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $cd9bb691314980fc$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($cd9bb691314980fc$var$markRootUpdated$1(rootFiber, 2), $cd9bb691314980fc$var$ensureRootIsScheduled(rootFiber));
}
function $cd9bb691314980fc$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $cd9bb691314980fc$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $cd9bb691314980fc$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $cd9bb691314980fc$var$legacyErrorBoundariesThatAlreadyFailed || !$cd9bb691314980fc$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $cd9bb691314980fc$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $cd9bb691314980fc$var$createClassErrorUpdate(2);
                instance = $cd9bb691314980fc$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($cd9bb691314980fc$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $cd9bb691314980fc$var$markRootUpdated$1(instance, 2), $cd9bb691314980fc$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $cd9bb691314980fc$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $cd9bb691314980fc$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($cd9bb691314980fc$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $cd9bb691314980fc$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $cd9bb691314980fc$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $cd9bb691314980fc$var$workInProgressRoot === root && ($cd9bb691314980fc$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $cd9bb691314980fc$var$workInProgressRootExitStatus || 3 === $cd9bb691314980fc$var$workInProgressRootExitStatus && ($cd9bb691314980fc$var$workInProgressRootRenderLanes & 62914560) === $cd9bb691314980fc$var$workInProgressRootRenderLanes && 300 > $cd9bb691314980fc$var$now() - $cd9bb691314980fc$var$globalMostRecentFallbackTime ? 0 === ($cd9bb691314980fc$var$executionContext & 2) && $cd9bb691314980fc$var$prepareFreshStack(root, 0) : $cd9bb691314980fc$var$workInProgressRootPingedLanes |= pingedLanes, $cd9bb691314980fc$var$workInProgressSuspendedRetryLanes === $cd9bb691314980fc$var$workInProgressRootRenderLanes && ($cd9bb691314980fc$var$workInProgressSuspendedRetryLanes = 0));
    $cd9bb691314980fc$var$ensureRootIsScheduled(root);
}
function $cd9bb691314980fc$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $cd9bb691314980fc$var$claimNextRetryLane());
    boundaryFiber = $cd9bb691314980fc$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($cd9bb691314980fc$var$markRootUpdated$1(boundaryFiber, retryLane), $cd9bb691314980fc$var$ensureRootIsScheduled(boundaryFiber));
}
function $cd9bb691314980fc$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $cd9bb691314980fc$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $cd9bb691314980fc$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($cd9bb691314980fc$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $cd9bb691314980fc$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $cd9bb691314980fc$var$scheduleCallback$1(priorityLevel, callback) {
    return $cd9bb691314980fc$var$scheduleCallback$3(priorityLevel, callback);
}
var $cd9bb691314980fc$var$firstScheduledRoot = null, $cd9bb691314980fc$var$lastScheduledRoot = null, $cd9bb691314980fc$var$didScheduleMicrotask = !1, $cd9bb691314980fc$var$mightHavePendingSyncWork = !1, $cd9bb691314980fc$var$isFlushingWork = !1, $cd9bb691314980fc$var$currentEventTransitionLane = 0;
function $cd9bb691314980fc$var$ensureRootIsScheduled(root) {
    root !== $cd9bb691314980fc$var$lastScheduledRoot && null === root.next && (null === $cd9bb691314980fc$var$lastScheduledRoot ? $cd9bb691314980fc$var$firstScheduledRoot = $cd9bb691314980fc$var$lastScheduledRoot = root : $cd9bb691314980fc$var$lastScheduledRoot = $cd9bb691314980fc$var$lastScheduledRoot.next = root);
    $cd9bb691314980fc$var$mightHavePendingSyncWork = !0;
    $cd9bb691314980fc$var$didScheduleMicrotask || ($cd9bb691314980fc$var$didScheduleMicrotask = !0, $cd9bb691314980fc$var$scheduleImmediateRootScheduleTask());
}
function $cd9bb691314980fc$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$cd9bb691314980fc$var$isFlushingWork && $cd9bb691314980fc$var$mightHavePendingSyncWork) {
        $cd9bb691314980fc$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = $cd9bb691314980fc$var$firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $cd9bb691314980fc$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $cd9bb691314980fc$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $cd9bb691314980fc$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $cd9bb691314980fc$var$getNextLanes(root$174, root$174 === $cd9bb691314980fc$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $cd9bb691314980fc$var$checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, $cd9bb691314980fc$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        $cd9bb691314980fc$var$isFlushingWork = !1;
    }
}
function $cd9bb691314980fc$var$processRootScheduleInImmediateTask() {
    $cd9bb691314980fc$var$processRootScheduleInMicrotask();
}
function $cd9bb691314980fc$var$processRootScheduleInMicrotask() {
    $cd9bb691314980fc$var$mightHavePendingSyncWork = $cd9bb691314980fc$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $cd9bb691314980fc$var$currentEventTransitionLane && ($cd9bb691314980fc$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $cd9bb691314980fc$var$currentEventTransitionLane), $cd9bb691314980fc$var$currentEventTransitionLane = 0);
    for(var currentTime = $cd9bb691314980fc$var$now(), prev = null, root = $cd9bb691314980fc$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $cd9bb691314980fc$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $cd9bb691314980fc$var$firstScheduledRoot = next : prev.next = next, null === next && ($cd9bb691314980fc$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $cd9bb691314980fc$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $cd9bb691314980fc$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $cd9bb691314980fc$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - $cd9bb691314980fc$var$clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = $cd9bb691314980fc$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $cd9bb691314980fc$var$workInProgressRoot;
    suspendedLanes = $cd9bb691314980fc$var$workInProgressRootRenderLanes;
    suspendedLanes = $cd9bb691314980fc$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $cd9bb691314980fc$var$workInProgressSuspendedReason || 9 === $cd9bb691314980fc$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $cd9bb691314980fc$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $cd9bb691314980fc$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $cd9bb691314980fc$var$cancelCallback$1(pingedLanes);
        switch($cd9bb691314980fc$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $cd9bb691314980fc$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $cd9bb691314980fc$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $cd9bb691314980fc$var$IdlePriority;
                break;
            default:
                suspendedLanes = $cd9bb691314980fc$var$NormalPriority$1;
        }
        pingedLanes = $cd9bb691314980fc$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $cd9bb691314980fc$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $cd9bb691314980fc$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $cd9bb691314980fc$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $cd9bb691314980fc$var$pendingEffectsStatus && 5 !== $cd9bb691314980fc$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($cd9bb691314980fc$var$flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $cd9bb691314980fc$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $cd9bb691314980fc$var$getNextLanes(root, root === $cd9bb691314980fc$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $cd9bb691314980fc$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $cd9bb691314980fc$var$scheduleTaskForRootDuringMicrotask(root, $cd9bb691314980fc$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $cd9bb691314980fc$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $cd9bb691314980fc$var$performSyncWorkOnRoot(root, lanes) {
    if ($cd9bb691314980fc$var$flushPendingEffects()) return null;
    $cd9bb691314980fc$var$performWorkOnRoot(root, lanes, !0);
}
function $cd9bb691314980fc$var$scheduleImmediateRootScheduleTask() {
    $cd9bb691314980fc$var$scheduleMicrotask(function() {
        0 !== ($cd9bb691314980fc$var$executionContext & 6) ? $cd9bb691314980fc$var$scheduleCallback$3($cd9bb691314980fc$var$ImmediatePriority, $cd9bb691314980fc$var$processRootScheduleInImmediateTask) : $cd9bb691314980fc$var$processRootScheduleInMicrotask();
    });
}
function $cd9bb691314980fc$var$requestTransitionLane() {
    0 === $cd9bb691314980fc$var$currentEventTransitionLane && ($cd9bb691314980fc$var$currentEventTransitionLane = $cd9bb691314980fc$var$claimNextTransitionLane());
    return $cd9bb691314980fc$var$currentEventTransitionLane;
}
function $cd9bb691314980fc$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $cd9bb691314980fc$var$sanitizeURL("" + actionProp);
}
function $cd9bb691314980fc$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $cd9bb691314980fc$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $cd9bb691314980fc$var$coerceFormActionProp((nativeEventTarget[$cd9bb691314980fc$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$cd9bb691314980fc$var$internalPropsKey] || null) ? $cd9bb691314980fc$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $cd9bb691314980fc$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $cd9bb691314980fc$var$currentEventTransitionLane) {
                                var formData = submitter ? $cd9bb691314980fc$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $cd9bb691314980fc$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $cd9bb691314980fc$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $cd9bb691314980fc$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $cd9bb691314980fc$var$i$jscomp$inline_1528 = 0; $cd9bb691314980fc$var$i$jscomp$inline_1528 < $cd9bb691314980fc$var$simpleEventPluginEvents.length; $cd9bb691314980fc$var$i$jscomp$inline_1528++){
    var $cd9bb691314980fc$var$eventName$jscomp$inline_1529 = $cd9bb691314980fc$var$simpleEventPluginEvents[$cd9bb691314980fc$var$i$jscomp$inline_1528], $cd9bb691314980fc$var$domEventName$jscomp$inline_1530 = $cd9bb691314980fc$var$eventName$jscomp$inline_1529.toLowerCase(), $cd9bb691314980fc$var$capitalizedEvent$jscomp$inline_1531 = $cd9bb691314980fc$var$eventName$jscomp$inline_1529[0].toUpperCase() + $cd9bb691314980fc$var$eventName$jscomp$inline_1529.slice(1);
    $cd9bb691314980fc$var$registerSimpleEvent($cd9bb691314980fc$var$domEventName$jscomp$inline_1530, "on" + $cd9bb691314980fc$var$capitalizedEvent$jscomp$inline_1531);
}
$cd9bb691314980fc$var$registerSimpleEvent($cd9bb691314980fc$var$ANIMATION_END, "onAnimationEnd");
$cd9bb691314980fc$var$registerSimpleEvent($cd9bb691314980fc$var$ANIMATION_ITERATION, "onAnimationIteration");
$cd9bb691314980fc$var$registerSimpleEvent($cd9bb691314980fc$var$ANIMATION_START, "onAnimationStart");
$cd9bb691314980fc$var$registerSimpleEvent("dblclick", "onDoubleClick");
$cd9bb691314980fc$var$registerSimpleEvent("focusin", "onFocus");
$cd9bb691314980fc$var$registerSimpleEvent("focusout", "onBlur");
$cd9bb691314980fc$var$registerSimpleEvent($cd9bb691314980fc$var$TRANSITION_RUN, "onTransitionRun");
$cd9bb691314980fc$var$registerSimpleEvent($cd9bb691314980fc$var$TRANSITION_START, "onTransitionStart");
$cd9bb691314980fc$var$registerSimpleEvent($cd9bb691314980fc$var$TRANSITION_CANCEL, "onTransitionCancel");
$cd9bb691314980fc$var$registerSimpleEvent($cd9bb691314980fc$var$TRANSITION_END, "onTransitionEnd");
$cd9bb691314980fc$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$cd9bb691314980fc$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$cd9bb691314980fc$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$cd9bb691314980fc$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$cd9bb691314980fc$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$cd9bb691314980fc$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$cd9bb691314980fc$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$cd9bb691314980fc$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$cd9bb691314980fc$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$cd9bb691314980fc$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $cd9bb691314980fc$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $cd9bb691314980fc$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($cd9bb691314980fc$var$mediaEventTypes));
function $cd9bb691314980fc$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $cd9bb691314980fc$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $cd9bb691314980fc$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $cd9bb691314980fc$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$cd9bb691314980fc$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$cd9bb691314980fc$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($cd9bb691314980fc$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $cd9bb691314980fc$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $cd9bb691314980fc$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $cd9bb691314980fc$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $cd9bb691314980fc$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$cd9bb691314980fc$var$listeningMarker]) {
        rootContainerElement[$cd9bb691314980fc$var$listeningMarker] = !0;
        $cd9bb691314980fc$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($cd9bb691314980fc$var$nonDelegatedEvents.has(domEventName) || $cd9bb691314980fc$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $cd9bb691314980fc$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$cd9bb691314980fc$var$listeningMarker] || (ownerDocument[$cd9bb691314980fc$var$listeningMarker] = !0, $cd9bb691314980fc$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $cd9bb691314980fc$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($cd9bb691314980fc$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $cd9bb691314980fc$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $cd9bb691314980fc$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $cd9bb691314980fc$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$cd9bb691314980fc$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $cd9bb691314980fc$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $cd9bb691314980fc$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $cd9bb691314980fc$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $cd9bb691314980fc$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $cd9bb691314980fc$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $cd9bb691314980fc$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticTouchEvent;
                        break;
                    case $cd9bb691314980fc$var$ANIMATION_END:
                    case $cd9bb691314980fc$var$ANIMATION_ITERATION:
                    case $cd9bb691314980fc$var$ANIMATION_START:
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticAnimationEvent;
                        break;
                    case $cd9bb691314980fc$var$TRANSITION_END:
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $cd9bb691314980fc$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($cd9bb691314980fc$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $cd9bb691314980fc$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($cd9bb691314980fc$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$cd9bb691314980fc$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $cd9bb691314980fc$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $cd9bb691314980fc$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $cd9bb691314980fc$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $cd9bb691314980fc$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $cd9bb691314980fc$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $cd9bb691314980fc$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $cd9bb691314980fc$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $cd9bb691314980fc$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $cd9bb691314980fc$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $cd9bb691314980fc$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $cd9bb691314980fc$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $cd9bb691314980fc$var$getParent(inCapturePhase);
                                reactEventName = $cd9bb691314980fc$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $cd9bb691314980fc$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $cd9bb691314980fc$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $cd9bb691314980fc$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $cd9bb691314980fc$var$getTargetInstForChangeEvent;
                else if ($cd9bb691314980fc$var$isTextInputElement(reactName)) {
                    if ($cd9bb691314980fc$var$isInputEventSupported) getTargetInstFunc = $cd9bb691314980fc$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $cd9bb691314980fc$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $cd9bb691314980fc$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $cd9bb691314980fc$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $cd9bb691314980fc$var$getTargetInstForChangeEvent) : getTargetInstFunc = $cd9bb691314980fc$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $cd9bb691314980fc$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $cd9bb691314980fc$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $cd9bb691314980fc$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($cd9bb691314980fc$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $cd9bb691314980fc$var$activeElement = handleEventFunc, $cd9bb691314980fc$var$activeElementInst = targetInst, $cd9bb691314980fc$var$lastSelection = null;
                    break;
                case "focusout":
                    $cd9bb691314980fc$var$lastSelection = $cd9bb691314980fc$var$activeElementInst = $cd9bb691314980fc$var$activeElement = null;
                    break;
                case "mousedown":
                    $cd9bb691314980fc$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $cd9bb691314980fc$var$mouseDown = !1;
                    $cd9bb691314980fc$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($cd9bb691314980fc$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $cd9bb691314980fc$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($cd9bb691314980fc$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $cd9bb691314980fc$var$isComposing ? $cd9bb691314980fc$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($cd9bb691314980fc$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($cd9bb691314980fc$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $cd9bb691314980fc$var$isComposing && (fallbackData = $cd9bb691314980fc$var$getData()) : ($cd9bb691314980fc$var$root = nativeEventTarget, $cd9bb691314980fc$var$startText = "value" in $cd9bb691314980fc$var$root ? $cd9bb691314980fc$var$root.value : $cd9bb691314980fc$var$root.textContent, $cd9bb691314980fc$var$isComposing = !0)), handleEventFunc = $cd9bb691314980fc$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $cd9bb691314980fc$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $cd9bb691314980fc$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $cd9bb691314980fc$var$canUseTextInputEvent ? $cd9bb691314980fc$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $cd9bb691314980fc$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $cd9bb691314980fc$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $cd9bb691314980fc$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $cd9bb691314980fc$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $cd9bb691314980fc$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $cd9bb691314980fc$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $cd9bb691314980fc$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $cd9bb691314980fc$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($cd9bb691314980fc$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $cd9bb691314980fc$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($cd9bb691314980fc$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $cd9bb691314980fc$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $cd9bb691314980fc$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $cd9bb691314980fc$var$getListener(target, registrationName), null != stateNode && listeners.unshift($cd9bb691314980fc$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $cd9bb691314980fc$var$getListener(target, registrationName), null != stateNode && listeners.push($cd9bb691314980fc$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $cd9bb691314980fc$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $cd9bb691314980fc$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $cd9bb691314980fc$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($cd9bb691314980fc$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($cd9bb691314980fc$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $cd9bb691314980fc$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $cd9bb691314980fc$var$normalizeMarkupForTextOrAttribute(clientText);
    return $cd9bb691314980fc$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $cd9bb691314980fc$var$noop$1() {}
function $cd9bb691314980fc$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $cd9bb691314980fc$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $cd9bb691314980fc$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $cd9bb691314980fc$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $cd9bb691314980fc$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $cd9bb691314980fc$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $cd9bb691314980fc$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $cd9bb691314980fc$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $cd9bb691314980fc$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $cd9bb691314980fc$var$setProp(domElement, tag, "name", props.name, props, null), $cd9bb691314980fc$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $cd9bb691314980fc$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $cd9bb691314980fc$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($cd9bb691314980fc$var$setProp(domElement, tag, "encType", props.encType, props, null), $cd9bb691314980fc$var$setProp(domElement, tag, "method", props.method, props, null), $cd9bb691314980fc$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $cd9bb691314980fc$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $cd9bb691314980fc$var$noop$1);
            break;
        case "onScroll":
            null != value && $cd9bb691314980fc$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $cd9bb691314980fc$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $cd9bb691314980fc$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("toggle", domElement);
            $cd9bb691314980fc$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $cd9bb691314980fc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $cd9bb691314980fc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $cd9bb691314980fc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $cd9bb691314980fc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $cd9bb691314980fc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $cd9bb691314980fc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $cd9bb691314980fc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $cd9bb691314980fc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $cd9bb691314980fc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $cd9bb691314980fc$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $cd9bb691314980fc$var$aliases.get(key) || key, $cd9bb691314980fc$var$setValueForAttribute(domElement, key, value);
    }
}
function $cd9bb691314980fc$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $cd9bb691314980fc$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $cd9bb691314980fc$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $cd9bb691314980fc$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $cd9bb691314980fc$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $cd9bb691314980fc$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $cd9bb691314980fc$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$cd9bb691314980fc$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$cd9bb691314980fc$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $cd9bb691314980fc$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $cd9bb691314980fc$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("error", domElement);
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($cd9bb691314980fc$var$formatProdErrorMessage(137, tag));
                    default:
                        $cd9bb691314980fc$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $cd9bb691314980fc$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $cd9bb691314980fc$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $cd9bb691314980fc$var$setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            $cd9bb691314980fc$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $cd9bb691314980fc$var$track(domElement);
            return;
        case "select":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $cd9bb691314980fc$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $cd9bb691314980fc$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $cd9bb691314980fc$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(91));
                    break;
                default:
                    $cd9bb691314980fc$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $cd9bb691314980fc$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $cd9bb691314980fc$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $cd9bb691314980fc$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("toggle", domElement);
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("cancel", domElement);
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $cd9bb691314980fc$var$mediaEventTypes.length; hasSrc++)$cd9bb691314980fc$var$listenToNonDelegatedEvent($cd9bb691314980fc$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("error", domElement);
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("error", domElement), $cd9bb691314980fc$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($cd9bb691314980fc$var$formatProdErrorMessage(137, tag));
                default:
                    $cd9bb691314980fc$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($cd9bb691314980fc$var$isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && $cd9bb691314980fc$var$setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $cd9bb691314980fc$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $cd9bb691314980fc$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $cd9bb691314980fc$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $cd9bb691314980fc$var$setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            $cd9bb691314980fc$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $cd9bb691314980fc$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $cd9bb691314980fc$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? $cd9bb691314980fc$var$updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? $cd9bb691314980fc$var$updateOptions(domElement, !!lastProps, tag, !0) : $cd9bb691314980fc$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $cd9bb691314980fc$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $cd9bb691314980fc$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $cd9bb691314980fc$var$updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $cd9bb691314980fc$var$setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    $cd9bb691314980fc$var$setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && $cd9bb691314980fc$var$setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $cd9bb691314980fc$var$setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if ($cd9bb691314980fc$var$isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && $cd9bb691314980fc$var$setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || $cd9bb691314980fc$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && $cd9bb691314980fc$var$setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || $cd9bb691314980fc$var$setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var $cd9bb691314980fc$var$eventsEnabled = null, $cd9bb691314980fc$var$selectionInformation = null;
function $cd9bb691314980fc$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $cd9bb691314980fc$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $cd9bb691314980fc$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $cd9bb691314980fc$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $cd9bb691314980fc$var$currentPopstateTransitionEvent = null;
function $cd9bb691314980fc$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $cd9bb691314980fc$var$currentPopstateTransitionEvent) return !1;
        $cd9bb691314980fc$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $cd9bb691314980fc$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $cd9bb691314980fc$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $cd9bb691314980fc$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $cd9bb691314980fc$var$localPromise = "function" === typeof Promise ? Promise : void 0, $cd9bb691314980fc$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $cd9bb691314980fc$var$localPromise ? function(callback) {
    return $cd9bb691314980fc$var$localPromise.resolve(null).then(callback).catch($cd9bb691314980fc$var$handleErrorInNextTick);
} : $cd9bb691314980fc$var$scheduleTimeout;
function $cd9bb691314980fc$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $cd9bb691314980fc$var$isSingletonScope(type) {
    return "head" === type;
}
function $cd9bb691314980fc$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && $cd9bb691314980fc$var$releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && $cd9bb691314980fc$var$releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, $cd9bb691314980fc$var$releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[$cd9bb691314980fc$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $cd9bb691314980fc$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    $cd9bb691314980fc$var$retryIfBlockedOn(suspenseInstance);
}
function $cd9bb691314980fc$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $cd9bb691314980fc$var$clearContainerSparingly(node);
                $cd9bb691314980fc$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $cd9bb691314980fc$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$cd9bb691314980fc$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $cd9bb691314980fc$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $cd9bb691314980fc$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $cd9bb691314980fc$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $cd9bb691314980fc$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function $cd9bb691314980fc$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $cd9bb691314980fc$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var $cd9bb691314980fc$var$previousHydratableOnEnteringScopedSingleton = null;
function $cd9bb691314980fc$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $cd9bb691314980fc$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $cd9bb691314980fc$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($cd9bb691314980fc$var$formatProdErrorMessage(451));
    }
}
function $cd9bb691314980fc$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $cd9bb691314980fc$var$detachDeletedInstance(instance);
}
var $cd9bb691314980fc$var$preloadPropsMap = new Map(), $cd9bb691314980fc$var$preconnectsSet = new Set();
function $cd9bb691314980fc$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $cd9bb691314980fc$var$previousDispatcher = $cd9bb691314980fc$var$ReactDOMSharedInternals.d;
$cd9bb691314980fc$var$ReactDOMSharedInternals.d = {
    f: $cd9bb691314980fc$var$flushSyncWork,
    r: $cd9bb691314980fc$var$requestFormReset,
    D: $cd9bb691314980fc$var$prefetchDNS,
    C: $cd9bb691314980fc$var$preconnect,
    L: $cd9bb691314980fc$var$preload,
    m: $cd9bb691314980fc$var$preloadModule,
    X: $cd9bb691314980fc$var$preinitScript,
    S: $cd9bb691314980fc$var$preinitStyle,
    M: $cd9bb691314980fc$var$preinitModuleScript
};
function $cd9bb691314980fc$var$flushSyncWork() {
    var previousWasRendering = $cd9bb691314980fc$var$previousDispatcher.f(), wasRendering = $cd9bb691314980fc$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $cd9bb691314980fc$var$requestFormReset(form) {
    var formInst = $cd9bb691314980fc$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $cd9bb691314980fc$var$requestFormReset$1(formInst) : $cd9bb691314980fc$var$previousDispatcher.r(form);
}
var $cd9bb691314980fc$var$globalDocument = "undefined" === typeof document ? null : document;
function $cd9bb691314980fc$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $cd9bb691314980fc$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $cd9bb691314980fc$var$preconnectsSet.has(limitedEscapedHref) || ($cd9bb691314980fc$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $cd9bb691314980fc$var$setInitialProperties(href, "link", rel), $cd9bb691314980fc$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $cd9bb691314980fc$var$prefetchDNS(href) {
    $cd9bb691314980fc$var$previousDispatcher.D(href);
    $cd9bb691314980fc$var$preconnectAs("dns-prefetch", href, null);
}
function $cd9bb691314980fc$var$preconnect(href, crossOrigin) {
    $cd9bb691314980fc$var$previousDispatcher.C(href, crossOrigin);
    $cd9bb691314980fc$var$preconnectAs("preconnect", href, crossOrigin);
}
function $cd9bb691314980fc$var$preload(href, as, options) {
    $cd9bb691314980fc$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $cd9bb691314980fc$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $cd9bb691314980fc$var$getStyleKey(href);
                break;
            case "script":
                key = $cd9bb691314980fc$var$getScriptKey(href);
        }
        $cd9bb691314980fc$var$preloadPropsMap.has(key) || (href = $cd9bb691314980fc$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $cd9bb691314980fc$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($cd9bb691314980fc$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($cd9bb691314980fc$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $cd9bb691314980fc$var$setInitialProperties(as, "link", href), $cd9bb691314980fc$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $cd9bb691314980fc$var$preloadModule(href, options) {
    $cd9bb691314980fc$var$previousDispatcher.m(href, options);
    var ownerDocument = $cd9bb691314980fc$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $cd9bb691314980fc$var$getScriptKey(href);
        }
        if (!$cd9bb691314980fc$var$preloadPropsMap.has(key) && (href = $cd9bb691314980fc$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $cd9bb691314980fc$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($cd9bb691314980fc$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $cd9bb691314980fc$var$setInitialProperties(as, "link", href);
            $cd9bb691314980fc$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $cd9bb691314980fc$var$preinitStyle(href, precedence, options) {
    $cd9bb691314980fc$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $cd9bb691314980fc$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $cd9bb691314980fc$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $cd9bb691314980fc$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($cd9bb691314980fc$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $cd9bb691314980fc$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $cd9bb691314980fc$var$preloadPropsMap.get(key)) && $cd9bb691314980fc$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $cd9bb691314980fc$var$markNodeAsHoistable(link);
                $cd9bb691314980fc$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $cd9bb691314980fc$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $cd9bb691314980fc$var$preinitScript(src, options) {
    $cd9bb691314980fc$var$previousDispatcher.X(src, options);
    var ownerDocument = $cd9bb691314980fc$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $cd9bb691314980fc$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $cd9bb691314980fc$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($cd9bb691314980fc$var$getScriptSelectorFromKey(key)), resource || (src = $cd9bb691314980fc$var$assign({
            src: src,
            async: !0
        }, options), (options = $cd9bb691314980fc$var$preloadPropsMap.get(key)) && $cd9bb691314980fc$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $cd9bb691314980fc$var$markNodeAsHoistable(resource), $cd9bb691314980fc$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $cd9bb691314980fc$var$preinitModuleScript(src, options) {
    $cd9bb691314980fc$var$previousDispatcher.M(src, options);
    var ownerDocument = $cd9bb691314980fc$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $cd9bb691314980fc$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $cd9bb691314980fc$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($cd9bb691314980fc$var$getScriptSelectorFromKey(key)), resource || (src = $cd9bb691314980fc$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $cd9bb691314980fc$var$preloadPropsMap.get(key)) && $cd9bb691314980fc$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $cd9bb691314980fc$var$markNodeAsHoistable(resource), $cd9bb691314980fc$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $cd9bb691314980fc$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $cd9bb691314980fc$var$rootInstanceStackCursor.current) ? $cd9bb691314980fc$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $cd9bb691314980fc$var$getStyleKey(pendingProps.href), pendingProps = $cd9bb691314980fc$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $cd9bb691314980fc$var$getStyleKey(pendingProps.href);
                var styles$244 = $cd9bb691314980fc$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector($cd9bb691314980fc$var$getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), $cd9bb691314980fc$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $cd9bb691314980fc$var$preloadPropsMap.set(type, pendingProps), styles$244 || $cd9bb691314980fc$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $cd9bb691314980fc$var$getScriptKey(pendingProps), pendingProps = $cd9bb691314980fc$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($cd9bb691314980fc$var$formatProdErrorMessage(444, type));
    }
}
function $cd9bb691314980fc$var$getStyleKey(href) {
    return 'href="' + $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $cd9bb691314980fc$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $cd9bb691314980fc$var$stylesheetPropsFromRawProps(rawProps) {
    return $cd9bb691314980fc$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $cd9bb691314980fc$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $cd9bb691314980fc$var$setInitialProperties(key, "link", preloadProps), $cd9bb691314980fc$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $cd9bb691314980fc$var$getScriptKey(src) {
    return '[src="' + $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $cd9bb691314980fc$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $cd9bb691314980fc$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $cd9bb691314980fc$var$markNodeAsHoistable(instance), instance;
            var styleProps = $cd9bb691314980fc$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $cd9bb691314980fc$var$markNodeAsHoistable(instance);
            $cd9bb691314980fc$var$setInitialProperties(instance, "style", styleProps);
            $cd9bb691314980fc$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $cd9bb691314980fc$var$getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector($cd9bb691314980fc$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, $cd9bb691314980fc$var$markNodeAsHoistable(instance$250), instance$250;
            instance = $cd9bb691314980fc$var$stylesheetPropsFromRawProps(props);
            (styleProps = $cd9bb691314980fc$var$preloadPropsMap.get(styleProps)) && $cd9bb691314980fc$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $cd9bb691314980fc$var$markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $cd9bb691314980fc$var$setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            $cd9bb691314980fc$var$insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = $cd9bb691314980fc$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($cd9bb691314980fc$var$getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, $cd9bb691314980fc$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $cd9bb691314980fc$var$preloadPropsMap.get(instance$250)) instance = $cd9bb691314980fc$var$assign({}, props), $cd9bb691314980fc$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $cd9bb691314980fc$var$markNodeAsHoistable(styleProps);
            $cd9bb691314980fc$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($cd9bb691314980fc$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $cd9bb691314980fc$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $cd9bb691314980fc$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $cd9bb691314980fc$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $cd9bb691314980fc$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $cd9bb691314980fc$var$tagCaches = null;
function $cd9bb691314980fc$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $cd9bb691314980fc$var$tagCaches) {
        var cache = new Map();
        var caches = $cd9bb691314980fc$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $cd9bb691314980fc$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$cd9bb691314980fc$var$internalHoistableMarker] || node[$cd9bb691314980fc$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $cd9bb691314980fc$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $cd9bb691314980fc$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $cd9bb691314980fc$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $cd9bb691314980fc$var$suspendedState = null;
function $cd9bb691314980fc$var$noop() {}
function $cd9bb691314980fc$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $cd9bb691314980fc$var$suspendedState) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(475));
    var state = $cd9bb691314980fc$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $cd9bb691314980fc$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($cd9bb691314980fc$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $cd9bb691314980fc$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $cd9bb691314980fc$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $cd9bb691314980fc$var$stylesheetPropsFromRawProps(props);
            (key = $cd9bb691314980fc$var$preloadPropsMap.get(key)) && $cd9bb691314980fc$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $cd9bb691314980fc$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $cd9bb691314980fc$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $cd9bb691314980fc$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $cd9bb691314980fc$var$waitForCommitToBeReady() {
    if (null === $cd9bb691314980fc$var$suspendedState) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(475));
    var state = $cd9bb691314980fc$var$suspendedState;
    state.stylesheets && 0 === state.count && $cd9bb691314980fc$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $cd9bb691314980fc$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $cd9bb691314980fc$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $cd9bb691314980fc$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $cd9bb691314980fc$var$precedencesByRoot = null;
function $cd9bb691314980fc$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $cd9bb691314980fc$var$precedencesByRoot = new Map(), resources.forEach($cd9bb691314980fc$var$insertStylesheetIntoRoot, state), $cd9bb691314980fc$var$precedencesByRoot = null, $cd9bb691314980fc$var$onUnsuspend.call(state));
}
function $cd9bb691314980fc$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $cd9bb691314980fc$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $cd9bb691314980fc$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $cd9bb691314980fc$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $cd9bb691314980fc$var$HostTransitionContext = {
    $$typeof: $cd9bb691314980fc$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $cd9bb691314980fc$var$sharedNotPendingObject,
    _currentValue2: $cd9bb691314980fc$var$sharedNotPendingObject,
    _threadCount: 0
};
function $cd9bb691314980fc$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $cd9bb691314980fc$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $cd9bb691314980fc$var$createLaneMap(0);
    this.hiddenUpdates = $cd9bb691314980fc$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $cd9bb691314980fc$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $cd9bb691314980fc$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $cd9bb691314980fc$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $cd9bb691314980fc$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $cd9bb691314980fc$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $cd9bb691314980fc$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $cd9bb691314980fc$var$emptyContextObject;
    parentComponent = $cd9bb691314980fc$var$emptyContextObject;
    return parentComponent;
}
function $cd9bb691314980fc$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $cd9bb691314980fc$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $cd9bb691314980fc$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $cd9bb691314980fc$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($cd9bb691314980fc$var$scheduleUpdateOnFiber(element, rootFiber, lane), $cd9bb691314980fc$var$entangleTransitions(element, rootFiber, lane));
}
function $cd9bb691314980fc$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $cd9bb691314980fc$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $cd9bb691314980fc$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $cd9bb691314980fc$var$markRetryLaneImpl(fiber, retryLane);
}
function $cd9bb691314980fc$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $cd9bb691314980fc$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $cd9bb691314980fc$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $cd9bb691314980fc$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $cd9bb691314980fc$var$_enabled = !0;
function $cd9bb691314980fc$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $cd9bb691314980fc$var$ReactSharedInternals.T;
    $cd9bb691314980fc$var$ReactSharedInternals.T = null;
    var previousPriority = $cd9bb691314980fc$var$ReactDOMSharedInternals.p;
    try {
        $cd9bb691314980fc$var$ReactDOMSharedInternals.p = 2, $cd9bb691314980fc$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $cd9bb691314980fc$var$ReactDOMSharedInternals.p = previousPriority, $cd9bb691314980fc$var$ReactSharedInternals.T = prevTransition;
    }
}
function $cd9bb691314980fc$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $cd9bb691314980fc$var$ReactSharedInternals.T;
    $cd9bb691314980fc$var$ReactSharedInternals.T = null;
    var previousPriority = $cd9bb691314980fc$var$ReactDOMSharedInternals.p;
    try {
        $cd9bb691314980fc$var$ReactDOMSharedInternals.p = 8, $cd9bb691314980fc$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $cd9bb691314980fc$var$ReactDOMSharedInternals.p = previousPriority, $cd9bb691314980fc$var$ReactSharedInternals.T = prevTransition;
    }
}
function $cd9bb691314980fc$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($cd9bb691314980fc$var$_enabled) {
        var blockedOn = $cd9bb691314980fc$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $cd9bb691314980fc$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $cd9bb691314980fc$var$return_targetInst, targetContainer), $cd9bb691314980fc$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($cd9bb691314980fc$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($cd9bb691314980fc$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $cd9bb691314980fc$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $cd9bb691314980fc$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $cd9bb691314980fc$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $cd9bb691314980fc$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $cd9bb691314980fc$var$ensureRootIsScheduled(fiber);
                                0 === ($cd9bb691314980fc$var$executionContext & 6) && ($cd9bb691314980fc$var$workInProgressRootRenderTargetTime = $cd9bb691314980fc$var$now() + 500, $cd9bb691314980fc$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $cd9bb691314980fc$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $cd9bb691314980fc$var$scheduleUpdateOnFiber(root, fiber, 2), $cd9bb691314980fc$var$flushSyncWork$1(), $cd9bb691314980fc$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $cd9bb691314980fc$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $cd9bb691314980fc$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $cd9bb691314980fc$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $cd9bb691314980fc$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $cd9bb691314980fc$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $cd9bb691314980fc$var$getEventTarget(nativeEvent);
    return $cd9bb691314980fc$var$findInstanceBlockingTarget(nativeEvent);
}
var $cd9bb691314980fc$var$return_targetInst = null;
function $cd9bb691314980fc$var$findInstanceBlockingTarget(targetNode) {
    $cd9bb691314980fc$var$return_targetInst = null;
    targetNode = $cd9bb691314980fc$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $cd9bb691314980fc$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $cd9bb691314980fc$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $cd9bb691314980fc$var$return_targetInst = targetNode;
    return null;
}
function $cd9bb691314980fc$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($cd9bb691314980fc$var$getCurrentPriorityLevel()){
                case $cd9bb691314980fc$var$ImmediatePriority:
                    return 2;
                case $cd9bb691314980fc$var$UserBlockingPriority:
                    return 8;
                case $cd9bb691314980fc$var$NormalPriority$1:
                case $cd9bb691314980fc$var$LowPriority:
                    return 32;
                case $cd9bb691314980fc$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $cd9bb691314980fc$var$hasScheduledReplayAttempt = !1, $cd9bb691314980fc$var$queuedFocus = null, $cd9bb691314980fc$var$queuedDrag = null, $cd9bb691314980fc$var$queuedMouse = null, $cd9bb691314980fc$var$queuedPointers = new Map(), $cd9bb691314980fc$var$queuedPointerCaptures = new Map(), $cd9bb691314980fc$var$queuedExplicitHydrationTargets = [], $cd9bb691314980fc$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $cd9bb691314980fc$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $cd9bb691314980fc$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $cd9bb691314980fc$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $cd9bb691314980fc$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $cd9bb691314980fc$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $cd9bb691314980fc$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $cd9bb691314980fc$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $cd9bb691314980fc$var$getInstanceFromNode(blockedOn), null !== blockedOn && $cd9bb691314980fc$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $cd9bb691314980fc$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $cd9bb691314980fc$var$queuedFocus = $cd9bb691314980fc$var$accumulateOrCreateContinuousQueuedReplayableEvent($cd9bb691314980fc$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $cd9bb691314980fc$var$queuedDrag = $cd9bb691314980fc$var$accumulateOrCreateContinuousQueuedReplayableEvent($cd9bb691314980fc$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $cd9bb691314980fc$var$queuedMouse = $cd9bb691314980fc$var$accumulateOrCreateContinuousQueuedReplayableEvent($cd9bb691314980fc$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $cd9bb691314980fc$var$queuedPointers.set(pointerId, $cd9bb691314980fc$var$accumulateOrCreateContinuousQueuedReplayableEvent($cd9bb691314980fc$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $cd9bb691314980fc$var$queuedPointerCaptures.set(pointerId, $cd9bb691314980fc$var$accumulateOrCreateContinuousQueuedReplayableEvent($cd9bb691314980fc$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $cd9bb691314980fc$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $cd9bb691314980fc$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $cd9bb691314980fc$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $cd9bb691314980fc$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $cd9bb691314980fc$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $cd9bb691314980fc$var$requestUpdateLane();
                            lane = $cd9bb691314980fc$var$getBumpedLaneForHydrationByLane(lane);
                            var root = $cd9bb691314980fc$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $cd9bb691314980fc$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $cd9bb691314980fc$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $cd9bb691314980fc$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $cd9bb691314980fc$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $cd9bb691314980fc$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $cd9bb691314980fc$var$currentReplayingEvent = null;
        } else return targetContainers = $cd9bb691314980fc$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $cd9bb691314980fc$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $cd9bb691314980fc$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $cd9bb691314980fc$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $cd9bb691314980fc$var$replayUnblockedEvents() {
    $cd9bb691314980fc$var$hasScheduledReplayAttempt = !1;
    null !== $cd9bb691314980fc$var$queuedFocus && $cd9bb691314980fc$var$attemptReplayContinuousQueuedEvent($cd9bb691314980fc$var$queuedFocus) && ($cd9bb691314980fc$var$queuedFocus = null);
    null !== $cd9bb691314980fc$var$queuedDrag && $cd9bb691314980fc$var$attemptReplayContinuousQueuedEvent($cd9bb691314980fc$var$queuedDrag) && ($cd9bb691314980fc$var$queuedDrag = null);
    null !== $cd9bb691314980fc$var$queuedMouse && $cd9bb691314980fc$var$attemptReplayContinuousQueuedEvent($cd9bb691314980fc$var$queuedMouse) && ($cd9bb691314980fc$var$queuedMouse = null);
    $cd9bb691314980fc$var$queuedPointers.forEach($cd9bb691314980fc$var$attemptReplayContinuousQueuedEventInMap);
    $cd9bb691314980fc$var$queuedPointerCaptures.forEach($cd9bb691314980fc$var$attemptReplayContinuousQueuedEventInMap);
}
function $cd9bb691314980fc$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $cd9bb691314980fc$var$hasScheduledReplayAttempt || ($cd9bb691314980fc$var$hasScheduledReplayAttempt = !0, $dY8mw.unstable_scheduleCallback($dY8mw.unstable_NormalPriority, $cd9bb691314980fc$var$replayUnblockedEvents)));
}
var $cd9bb691314980fc$var$lastScheduledReplayQueue = null;
function $cd9bb691314980fc$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $cd9bb691314980fc$var$lastScheduledReplayQueue !== formReplayingQueue && ($cd9bb691314980fc$var$lastScheduledReplayQueue = formReplayingQueue, $dY8mw.unstable_scheduleCallback($dY8mw.unstable_NormalPriority, function() {
        $cd9bb691314980fc$var$lastScheduledReplayQueue === formReplayingQueue && ($cd9bb691314980fc$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $cd9bb691314980fc$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $cd9bb691314980fc$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $cd9bb691314980fc$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $cd9bb691314980fc$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $cd9bb691314980fc$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $cd9bb691314980fc$var$queuedFocus && $cd9bb691314980fc$var$scheduleCallbackIfUnblocked($cd9bb691314980fc$var$queuedFocus, unblocked);
    null !== $cd9bb691314980fc$var$queuedDrag && $cd9bb691314980fc$var$scheduleCallbackIfUnblocked($cd9bb691314980fc$var$queuedDrag, unblocked);
    null !== $cd9bb691314980fc$var$queuedMouse && $cd9bb691314980fc$var$scheduleCallbackIfUnblocked($cd9bb691314980fc$var$queuedMouse, unblocked);
    $cd9bb691314980fc$var$queuedPointers.forEach(unblock);
    $cd9bb691314980fc$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $cd9bb691314980fc$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $cd9bb691314980fc$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $cd9bb691314980fc$var$queuedExplicitHydrationTargets.length && (i = $cd9bb691314980fc$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$cd9bb691314980fc$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $cd9bb691314980fc$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$cd9bb691314980fc$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $cd9bb691314980fc$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$cd9bb691314980fc$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $cd9bb691314980fc$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $cd9bb691314980fc$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $cd9bb691314980fc$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$cd9bb691314980fc$var$ReactDOMHydrationRoot.prototype.render = $cd9bb691314980fc$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(409));
    var current = root.current, lane = $cd9bb691314980fc$var$requestUpdateLane();
    $cd9bb691314980fc$var$updateContainerImpl(current, lane, children, root, null, null);
};
$cd9bb691314980fc$var$ReactDOMHydrationRoot.prototype.unmount = $cd9bb691314980fc$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $cd9bb691314980fc$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $cd9bb691314980fc$var$flushSyncWork$1();
        container[$cd9bb691314980fc$var$internalContainerInstanceKey] = null;
    }
};
function $cd9bb691314980fc$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$cd9bb691314980fc$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $cd9bb691314980fc$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $cd9bb691314980fc$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $cd9bb691314980fc$var$queuedExplicitHydrationTargets[i].priority; i++);
        $cd9bb691314980fc$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $cd9bb691314980fc$var$attemptExplicitHydrationTarget(target);
    }
};
var $cd9bb691314980fc$var$isomorphicReactPackageVersion$jscomp$inline_1785 = $i7uhG.version;
if ("19.1.0" !== $cd9bb691314980fc$var$isomorphicReactPackageVersion$jscomp$inline_1785) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(527, $cd9bb691314980fc$var$isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.0"));
$cd9bb691314980fc$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($cd9bb691314980fc$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $cd9bb691314980fc$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $cd9bb691314980fc$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $cd9bb691314980fc$var$internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $cd9bb691314980fc$var$ReactSharedInternals,
    reconcilerVersion: "19.1.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $cd9bb691314980fc$var$hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$cd9bb691314980fc$var$hook$jscomp$inline_2257.isDisabled && $cd9bb691314980fc$var$hook$jscomp$inline_2257.supportsFiber) try {
        $cd9bb691314980fc$var$rendererID = $cd9bb691314980fc$var$hook$jscomp$inline_2257.inject($cd9bb691314980fc$var$internals$jscomp$inline_2256), $cd9bb691314980fc$var$injectedHook = $cd9bb691314980fc$var$hook$jscomp$inline_2257;
    } catch (err) {}
}
$cd9bb691314980fc$export$882461b6382ed46c = function(container, options) {
    if (!$cd9bb691314980fc$var$isValidContainer(container)) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $cd9bb691314980fc$var$defaultOnUncaughtError, onCaughtError = $cd9bb691314980fc$var$defaultOnCaughtError, onRecoverableError = $cd9bb691314980fc$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $cd9bb691314980fc$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$cd9bb691314980fc$var$internalContainerInstanceKey] = options.current;
    $cd9bb691314980fc$var$listenToAllSupportedEvents(container);
    return new $cd9bb691314980fc$var$ReactDOMRoot(options);
};
$cd9bb691314980fc$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$cd9bb691314980fc$var$isValidContainer(container)) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $cd9bb691314980fc$var$defaultOnUncaughtError, onCaughtError = $cd9bb691314980fc$var$defaultOnCaughtError, onRecoverableError = $cd9bb691314980fc$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $cd9bb691314980fc$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $cd9bb691314980fc$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $cd9bb691314980fc$var$requestUpdateLane();
    isStrictMode = $cd9bb691314980fc$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $cd9bb691314980fc$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $cd9bb691314980fc$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $cd9bb691314980fc$var$markRootUpdated$1(initialChildren, options);
    $cd9bb691314980fc$var$ensureRootIsScheduled(initialChildren);
    container[$cd9bb691314980fc$var$internalContainerInstanceKey] = initialChildren.current;
    $cd9bb691314980fc$var$listenToAllSupportedEvents(container);
    return new $cd9bb691314980fc$var$ReactDOMHydrationRoot(initialChildren);
};
$cd9bb691314980fc$export$83d89fbfd8236492 = "19.1.0";

});
parcelRegister("dY8mw", function(module, exports) {
'use strict';

module.exports = (parcelRequire("aNaky"));

});
parcelRegister("aNaky", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $7db67e68002e6b6c$export$c4744153514ff05d; }, function (v) { return $7db67e68002e6b6c$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $7db67e68002e6b6c$export$3e506c1ccc9cc1a7; }, function (v) { return $7db67e68002e6b6c$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $7db67e68002e6b6c$export$e26fe2ed2fa76875; }, function (v) { return $7db67e68002e6b6c$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $7db67e68002e6b6c$export$502329bbf4b505b1; }, function (v) { return $7db67e68002e6b6c$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $7db67e68002e6b6c$export$6e3807111c4874c4; }, function (v) { return $7db67e68002e6b6c$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $7db67e68002e6b6c$export$c27134553091fb3a; }, function (v) { return $7db67e68002e6b6c$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $7db67e68002e6b6c$export$33ee1acdc04fd2a2; }, function (v) { return $7db67e68002e6b6c$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $7db67e68002e6b6c$export$b00a404bbd5edef2; }, function (v) { return $7db67e68002e6b6c$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $7db67e68002e6b6c$export$d66a1c1c77bd778b; }, function (v) { return $7db67e68002e6b6c$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $7db67e68002e6b6c$export$d3dfb8e4810cb555; }, function (v) { return $7db67e68002e6b6c$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $7db67e68002e6b6c$export$72fdf0e06517287b; }, function (v) { return $7db67e68002e6b6c$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $7db67e68002e6b6c$export$816d2913ae6b83b1; }, function (v) { return $7db67e68002e6b6c$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $7db67e68002e6b6c$export$61bcfe829111a1d0; }, function (v) { return $7db67e68002e6b6c$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $7db67e68002e6b6c$export$7ee8c9beb337bc3f; }, function (v) { return $7db67e68002e6b6c$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $7db67e68002e6b6c$export$b5836b71941fa3ed; }, function (v) { return $7db67e68002e6b6c$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $7db67e68002e6b6c$export$cf845f2c119da08a; }, function (v) { return $7db67e68002e6b6c$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7db67e68002e6b6c$export$c4744153514ff05d;
var $7db67e68002e6b6c$export$3e506c1ccc9cc1a7;
var $7db67e68002e6b6c$export$e26fe2ed2fa76875;
var $7db67e68002e6b6c$export$502329bbf4b505b1;
var $7db67e68002e6b6c$export$6e3807111c4874c4;
var $7db67e68002e6b6c$export$c27134553091fb3a;
var $7db67e68002e6b6c$export$33ee1acdc04fd2a2;
var $7db67e68002e6b6c$export$b00a404bbd5edef2;
var $7db67e68002e6b6c$export$d66a1c1c77bd778b;
var $7db67e68002e6b6c$export$d3dfb8e4810cb555;
var $7db67e68002e6b6c$export$72fdf0e06517287b;
var $7db67e68002e6b6c$export$816d2913ae6b83b1;
var $7db67e68002e6b6c$export$61bcfe829111a1d0;
var $7db67e68002e6b6c$export$7ee8c9beb337bc3f;
var $7db67e68002e6b6c$export$b5836b71941fa3ed;
var $7db67e68002e6b6c$export$cf845f2c119da08a;
"use strict";
function $7db67e68002e6b6c$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $7db67e68002e6b6c$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $7db67e68002e6b6c$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $7db67e68002e6b6c$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $7db67e68002e6b6c$var$compare(left, last)) rightIndex < length && 0 > $7db67e68002e6b6c$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $7db67e68002e6b6c$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $7db67e68002e6b6c$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$7db67e68002e6b6c$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $7db67e68002e6b6c$var$localPerformance = performance;
    $7db67e68002e6b6c$export$c4744153514ff05d = function() {
        return $7db67e68002e6b6c$var$localPerformance.now();
    };
} else {
    var $7db67e68002e6b6c$var$localDate = Date, $7db67e68002e6b6c$var$initialTime = $7db67e68002e6b6c$var$localDate.now();
    $7db67e68002e6b6c$export$c4744153514ff05d = function() {
        return $7db67e68002e6b6c$var$localDate.now() - $7db67e68002e6b6c$var$initialTime;
    };
}
var $7db67e68002e6b6c$var$taskQueue = [], $7db67e68002e6b6c$var$timerQueue = [], $7db67e68002e6b6c$var$taskIdCounter = 1, $7db67e68002e6b6c$var$currentTask = null, $7db67e68002e6b6c$var$currentPriorityLevel = 3, $7db67e68002e6b6c$var$isPerformingWork = !1, $7db67e68002e6b6c$var$isHostCallbackScheduled = !1, $7db67e68002e6b6c$var$isHostTimeoutScheduled = !1, $7db67e68002e6b6c$var$needsPaint = !1, $7db67e68002e6b6c$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $7db67e68002e6b6c$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $7db67e68002e6b6c$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $7db67e68002e6b6c$var$advanceTimers(currentTime) {
    for(var timer = $7db67e68002e6b6c$var$peek($7db67e68002e6b6c$var$timerQueue); null !== timer;){
        if (null === timer.callback) $7db67e68002e6b6c$var$pop($7db67e68002e6b6c$var$timerQueue);
        else if (timer.startTime <= currentTime) $7db67e68002e6b6c$var$pop($7db67e68002e6b6c$var$timerQueue), timer.sortIndex = timer.expirationTime, $7db67e68002e6b6c$var$push($7db67e68002e6b6c$var$taskQueue, timer);
        else break;
        timer = $7db67e68002e6b6c$var$peek($7db67e68002e6b6c$var$timerQueue);
    }
}
function $7db67e68002e6b6c$var$handleTimeout(currentTime) {
    $7db67e68002e6b6c$var$isHostTimeoutScheduled = !1;
    $7db67e68002e6b6c$var$advanceTimers(currentTime);
    if (!$7db67e68002e6b6c$var$isHostCallbackScheduled) {
        if (null !== $7db67e68002e6b6c$var$peek($7db67e68002e6b6c$var$taskQueue)) $7db67e68002e6b6c$var$isHostCallbackScheduled = !0, $7db67e68002e6b6c$var$isMessageLoopRunning || ($7db67e68002e6b6c$var$isMessageLoopRunning = !0, $7db67e68002e6b6c$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $7db67e68002e6b6c$var$peek($7db67e68002e6b6c$var$timerQueue);
            null !== firstTimer && $7db67e68002e6b6c$var$requestHostTimeout($7db67e68002e6b6c$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $7db67e68002e6b6c$var$isMessageLoopRunning = !1, $7db67e68002e6b6c$var$taskTimeoutID = -1, $7db67e68002e6b6c$var$frameInterval = 5, $7db67e68002e6b6c$var$startTime = -1;
function $7db67e68002e6b6c$var$shouldYieldToHost() {
    return $7db67e68002e6b6c$var$needsPaint ? !0 : $7db67e68002e6b6c$export$c4744153514ff05d() - $7db67e68002e6b6c$var$startTime < $7db67e68002e6b6c$var$frameInterval ? !1 : !0;
}
function $7db67e68002e6b6c$var$performWorkUntilDeadline() {
    $7db67e68002e6b6c$var$needsPaint = !1;
    if ($7db67e68002e6b6c$var$isMessageLoopRunning) {
        var currentTime = $7db67e68002e6b6c$export$c4744153514ff05d();
        $7db67e68002e6b6c$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $7db67e68002e6b6c$var$isHostCallbackScheduled = !1;
                $7db67e68002e6b6c$var$isHostTimeoutScheduled && ($7db67e68002e6b6c$var$isHostTimeoutScheduled = !1, $7db67e68002e6b6c$var$localClearTimeout($7db67e68002e6b6c$var$taskTimeoutID), $7db67e68002e6b6c$var$taskTimeoutID = -1);
                $7db67e68002e6b6c$var$isPerformingWork = !0;
                var previousPriorityLevel = $7db67e68002e6b6c$var$currentPriorityLevel;
                try {
                    b: {
                        $7db67e68002e6b6c$var$advanceTimers(currentTime);
                        for($7db67e68002e6b6c$var$currentTask = $7db67e68002e6b6c$var$peek($7db67e68002e6b6c$var$taskQueue); null !== $7db67e68002e6b6c$var$currentTask && !($7db67e68002e6b6c$var$currentTask.expirationTime > currentTime && $7db67e68002e6b6c$var$shouldYieldToHost());){
                            var callback = $7db67e68002e6b6c$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $7db67e68002e6b6c$var$currentTask.callback = null;
                                $7db67e68002e6b6c$var$currentPriorityLevel = $7db67e68002e6b6c$var$currentTask.priorityLevel;
                                var continuationCallback = callback($7db67e68002e6b6c$var$currentTask.expirationTime <= currentTime);
                                currentTime = $7db67e68002e6b6c$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $7db67e68002e6b6c$var$currentTask.callback = continuationCallback;
                                    $7db67e68002e6b6c$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $7db67e68002e6b6c$var$currentTask === $7db67e68002e6b6c$var$peek($7db67e68002e6b6c$var$taskQueue) && $7db67e68002e6b6c$var$pop($7db67e68002e6b6c$var$taskQueue);
                                $7db67e68002e6b6c$var$advanceTimers(currentTime);
                            } else $7db67e68002e6b6c$var$pop($7db67e68002e6b6c$var$taskQueue);
                            $7db67e68002e6b6c$var$currentTask = $7db67e68002e6b6c$var$peek($7db67e68002e6b6c$var$taskQueue);
                        }
                        if (null !== $7db67e68002e6b6c$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $7db67e68002e6b6c$var$peek($7db67e68002e6b6c$var$timerQueue);
                            null !== firstTimer && $7db67e68002e6b6c$var$requestHostTimeout($7db67e68002e6b6c$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $7db67e68002e6b6c$var$currentTask = null, $7db67e68002e6b6c$var$currentPriorityLevel = previousPriorityLevel, $7db67e68002e6b6c$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $7db67e68002e6b6c$var$schedulePerformWorkUntilDeadline() : $7db67e68002e6b6c$var$isMessageLoopRunning = !1;
        }
    }
}
var $7db67e68002e6b6c$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $7db67e68002e6b6c$var$localSetImmediate) $7db67e68002e6b6c$var$schedulePerformWorkUntilDeadline = function() {
    $7db67e68002e6b6c$var$localSetImmediate($7db67e68002e6b6c$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $7db67e68002e6b6c$var$channel = new MessageChannel(), $7db67e68002e6b6c$var$port = $7db67e68002e6b6c$var$channel.port2;
    $7db67e68002e6b6c$var$channel.port1.onmessage = $7db67e68002e6b6c$var$performWorkUntilDeadline;
    $7db67e68002e6b6c$var$schedulePerformWorkUntilDeadline = function() {
        $7db67e68002e6b6c$var$port.postMessage(null);
    };
} else $7db67e68002e6b6c$var$schedulePerformWorkUntilDeadline = function() {
    $7db67e68002e6b6c$var$localSetTimeout($7db67e68002e6b6c$var$performWorkUntilDeadline, 0);
};
function $7db67e68002e6b6c$var$requestHostTimeout(callback, ms) {
    $7db67e68002e6b6c$var$taskTimeoutID = $7db67e68002e6b6c$var$localSetTimeout(function() {
        callback($7db67e68002e6b6c$export$c4744153514ff05d());
    }, ms);
}
$7db67e68002e6b6c$export$3e506c1ccc9cc1a7 = 5;
$7db67e68002e6b6c$export$e26fe2ed2fa76875 = 1;
$7db67e68002e6b6c$export$502329bbf4b505b1 = 4;
$7db67e68002e6b6c$export$6e3807111c4874c4 = 3;
$7db67e68002e6b6c$export$c27134553091fb3a = null;
$7db67e68002e6b6c$export$33ee1acdc04fd2a2 = 2;
$7db67e68002e6b6c$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$7db67e68002e6b6c$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $7db67e68002e6b6c$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$7db67e68002e6b6c$export$d3dfb8e4810cb555 = function() {
    return $7db67e68002e6b6c$var$currentPriorityLevel;
};
$7db67e68002e6b6c$export$72fdf0e06517287b = function(eventHandler) {
    switch($7db67e68002e6b6c$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $7db67e68002e6b6c$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $7db67e68002e6b6c$var$currentPriorityLevel;
    $7db67e68002e6b6c$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $7db67e68002e6b6c$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$7db67e68002e6b6c$export$816d2913ae6b83b1 = function() {
    $7db67e68002e6b6c$var$needsPaint = !0;
};
$7db67e68002e6b6c$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $7db67e68002e6b6c$var$currentPriorityLevel;
    $7db67e68002e6b6c$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $7db67e68002e6b6c$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$7db67e68002e6b6c$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $7db67e68002e6b6c$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $7db67e68002e6b6c$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $7db67e68002e6b6c$var$push($7db67e68002e6b6c$var$timerQueue, priorityLevel), null === $7db67e68002e6b6c$var$peek($7db67e68002e6b6c$var$taskQueue) && priorityLevel === $7db67e68002e6b6c$var$peek($7db67e68002e6b6c$var$timerQueue) && ($7db67e68002e6b6c$var$isHostTimeoutScheduled ? ($7db67e68002e6b6c$var$localClearTimeout($7db67e68002e6b6c$var$taskTimeoutID), $7db67e68002e6b6c$var$taskTimeoutID = -1) : $7db67e68002e6b6c$var$isHostTimeoutScheduled = !0, $7db67e68002e6b6c$var$requestHostTimeout($7db67e68002e6b6c$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $7db67e68002e6b6c$var$push($7db67e68002e6b6c$var$taskQueue, priorityLevel), $7db67e68002e6b6c$var$isHostCallbackScheduled || $7db67e68002e6b6c$var$isPerformingWork || ($7db67e68002e6b6c$var$isHostCallbackScheduled = !0, $7db67e68002e6b6c$var$isMessageLoopRunning || ($7db67e68002e6b6c$var$isMessageLoopRunning = !0, $7db67e68002e6b6c$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$7db67e68002e6b6c$export$b5836b71941fa3ed = $7db67e68002e6b6c$var$shouldYieldToHost;
$7db67e68002e6b6c$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $7db67e68002e6b6c$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $7db67e68002e6b6c$var$currentPriorityLevel;
        $7db67e68002e6b6c$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $7db67e68002e6b6c$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("i7uhG", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9qxVB"));

});

parcelRegister("f7Clz", function(module, exports) {
'use strict';
function $b025415768d63d80$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b025415768d63d80$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b025415768d63d80$var$checkDCE();

module.exports = (parcelRequire("9ebfe"));

});
parcelRegister("9ebfe", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $6b7e24cf892d781c$export$69ce8ef3fe5cead0; }, function (v) { return $6b7e24cf892d781c$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $6b7e24cf892d781c$export$d39a5bbd09211389; }, function (v) { return $6b7e24cf892d781c$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $6b7e24cf892d781c$export$cd75ccfd720a3cd4; }, function (v) { return $6b7e24cf892d781c$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $6b7e24cf892d781c$export$a0816fa17a9e79be; }, function (v) { return $6b7e24cf892d781c$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $6b7e24cf892d781c$export$7292efcadded39f3; }, function (v) { return $6b7e24cf892d781c$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $6b7e24cf892d781c$export$da407abadb9b8f86; }, function (v) { return $6b7e24cf892d781c$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $6b7e24cf892d781c$export$314cfea32580671c; }, function (v) { return $6b7e24cf892d781c$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $6b7e24cf892d781c$export$513ccb98c53b8039; }, function (v) { return $6b7e24cf892d781c$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $6b7e24cf892d781c$export$dbca993bc2d264a; }, function (v) { return $6b7e24cf892d781c$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $6b7e24cf892d781c$export$4797a8006f0655d0; }, function (v) { return $6b7e24cf892d781c$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $6b7e24cf892d781c$export$c78a37762a8d58e1; }, function (v) { return $6b7e24cf892d781c$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $6b7e24cf892d781c$export$606f11b2eb45ecc6; }, function (v) { return $6b7e24cf892d781c$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $6b7e24cf892d781c$export$f7e8a0bf92324b1e; }, function (v) { return $6b7e24cf892d781c$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $6b7e24cf892d781c$export$83d89fbfd8236492; }, function (v) { return $6b7e24cf892d781c$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b7e24cf892d781c$export$69ce8ef3fe5cead0;
var $6b7e24cf892d781c$export$d39a5bbd09211389;
var $6b7e24cf892d781c$export$cd75ccfd720a3cd4;
var $6b7e24cf892d781c$export$a0816fa17a9e79be;
var $6b7e24cf892d781c$export$7292efcadded39f3;
var $6b7e24cf892d781c$export$da407abadb9b8f86;
var $6b7e24cf892d781c$export$314cfea32580671c;
var $6b7e24cf892d781c$export$513ccb98c53b8039;
var $6b7e24cf892d781c$export$dbca993bc2d264a;
var $6b7e24cf892d781c$export$4797a8006f0655d0;
var $6b7e24cf892d781c$export$c78a37762a8d58e1;
var $6b7e24cf892d781c$export$606f11b2eb45ecc6;
var $6b7e24cf892d781c$export$f7e8a0bf92324b1e;
var $6b7e24cf892d781c$export$83d89fbfd8236492;
"use strict";

var $i7uhG = parcelRequire("i7uhG");
function $6b7e24cf892d781c$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $6b7e24cf892d781c$var$noop() {}
var $6b7e24cf892d781c$var$Internals = {
    d: {
        f: $6b7e24cf892d781c$var$noop,
        r: function() {
            throw Error($6b7e24cf892d781c$var$formatProdErrorMessage(522));
        },
        D: $6b7e24cf892d781c$var$noop,
        C: $6b7e24cf892d781c$var$noop,
        L: $6b7e24cf892d781c$var$noop,
        m: $6b7e24cf892d781c$var$noop,
        X: $6b7e24cf892d781c$var$noop,
        S: $6b7e24cf892d781c$var$noop,
        M: $6b7e24cf892d781c$var$noop
    },
    p: 0,
    findDOMNode: null
}, $6b7e24cf892d781c$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $6b7e24cf892d781c$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $6b7e24cf892d781c$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $6b7e24cf892d781c$var$ReactSharedInternals = $i7uhG.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $6b7e24cf892d781c$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$6b7e24cf892d781c$export$69ce8ef3fe5cead0 = $6b7e24cf892d781c$var$Internals;
$6b7e24cf892d781c$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($6b7e24cf892d781c$var$formatProdErrorMessage(299));
    return $6b7e24cf892d781c$var$createPortal$1(children, container, null, key);
};
$6b7e24cf892d781c$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $6b7e24cf892d781c$var$ReactSharedInternals.T, previousUpdatePriority = $6b7e24cf892d781c$var$Internals.p;
    try {
        if ($6b7e24cf892d781c$var$ReactSharedInternals.T = null, $6b7e24cf892d781c$var$Internals.p = 2, fn) return fn();
    } finally{
        $6b7e24cf892d781c$var$ReactSharedInternals.T = previousTransition, $6b7e24cf892d781c$var$Internals.p = previousUpdatePriority, $6b7e24cf892d781c$var$Internals.d.f();
    }
};
$6b7e24cf892d781c$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $6b7e24cf892d781c$var$Internals.d.C(href, options));
};
$6b7e24cf892d781c$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $6b7e24cf892d781c$var$Internals.d.D(href);
};
$6b7e24cf892d781c$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $6b7e24cf892d781c$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $6b7e24cf892d781c$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $6b7e24cf892d781c$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$6b7e24cf892d781c$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $6b7e24cf892d781c$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $6b7e24cf892d781c$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $6b7e24cf892d781c$var$Internals.d.M(href);
    }
};
$6b7e24cf892d781c$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $6b7e24cf892d781c$var$getCrossOriginStringAs(as, options.crossOrigin);
        $6b7e24cf892d781c$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$6b7e24cf892d781c$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $6b7e24cf892d781c$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $6b7e24cf892d781c$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $6b7e24cf892d781c$var$Internals.d.m(href);
    }
};
$6b7e24cf892d781c$export$4797a8006f0655d0 = function(form) {
    $6b7e24cf892d781c$var$Internals.d.r(form);
};
$6b7e24cf892d781c$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$6b7e24cf892d781c$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $6b7e24cf892d781c$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$6b7e24cf892d781c$export$f7e8a0bf92324b1e = function() {
    return $6b7e24cf892d781c$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$6b7e24cf892d781c$export$83d89fbfd8236492 = "19.1.0";

});



parcelRegister("4hMQQ", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $31eea4d348f5a935$export$bf730a2d8bf68b42; }, function (v) { return $31eea4d348f5a935$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $31eea4d348f5a935$export$bf730a2d8bf68b42;
"use strict";

var $i7uhG = parcelRequire("i7uhG");
function $31eea4d348f5a935$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $31eea4d348f5a935$var$objectIs = "function" === typeof Object.is ? Object.is : $31eea4d348f5a935$var$is, $31eea4d348f5a935$var$useSyncExternalStore = $i7uhG.useSyncExternalStore, $31eea4d348f5a935$var$useRef = $i7uhG.useRef, $31eea4d348f5a935$var$useEffect = $i7uhG.useEffect, $31eea4d348f5a935$var$useMemo = $i7uhG.useMemo, $31eea4d348f5a935$var$useDebugValue = $i7uhG.useDebugValue;
$31eea4d348f5a935$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $31eea4d348f5a935$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $31eea4d348f5a935$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($31eea4d348f5a935$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $31eea4d348f5a935$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $31eea4d348f5a935$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $31eea4d348f5a935$var$useDebugValue(value);
    return value;
};

});

parcelRegister("ftNHP", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $9MM5H = parcelRequire("9MM5H");
function $b4501efe731b2d44$var$emptyFunction() {}
function $b4501efe731b2d44$var$emptyFunctionWithReset() {}
$b4501efe731b2d44$var$emptyFunctionWithReset.resetWarningCache = $b4501efe731b2d44$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $9MM5H) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $b4501efe731b2d44$var$emptyFunctionWithReset,
        resetWarningCache: $b4501efe731b2d44$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("9MM5H", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $71fde6a1896de2c2$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $71fde6a1896de2c2$var$ReactPropTypesSecret;

});


parcelRegister("7JPzv", function(module, exports) {
module.exports = $parcel$import("8zgBN").then(()=>parcelRequire('O41Q9'));

});

var $aad8959f03d998c8$exports = {};
$parcel$extendImportMap({
    "8zgBN": "grocery.bcbba9ea.js"
});


var $R1mjg = parcelRequire("R1mjg");

var $i7uhG = parcelRequire("i7uhG");
var $4088519dc6b9941f$exports = {};
'use strict';
function $4088519dc6b9941f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($4088519dc6b9941f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$4088519dc6b9941f$var$checkDCE();

$4088519dc6b9941f$exports = (parcelRequire("hErLM"));



var $R1mjg = parcelRequire("R1mjg");
// for hard coded datas
const $71f2a50233d21256$export$8b0f2287631b26b6 = "https://png.pngtree.com/template/20191014/ourmid/pngtree-pin-food-delivery-map-location-delivery-logo-concept-image_318151.jpg";
const $71f2a50233d21256$export$ee7e7ea446877ea7 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
const $71f2a50233d21256$export$5efc1bdaf069455a = "https://corsproxy.io/https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=20.2959847&lng=85.8246101&restaurantId=";



var $i7uhG = parcelRequire("i7uhG");
/**
 * React Router DOM v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $i7uhG = parcelRequire("i7uhG");

var $f7Clz = parcelRequire("f7Clz");
/**
 * @remix-run/router v1.15.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $a8236ed938146300$var$_extends() {
    $a8236ed938146300$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a8236ed938146300$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $a8236ed938146300$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($a8236ed938146300$export$e19cd5f9376f8cee || ($a8236ed938146300$export$e19cd5f9376f8cee = {}));
const $a8236ed938146300$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $a8236ed938146300$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $a8236ed938146300$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $a8236ed938146300$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $a8236ed938146300$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $a8236ed938146300$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $a8236ed938146300$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $a8236ed938146300$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $a8236ed938146300$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $a8236ed938146300$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $a8236ed938146300$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $a8236ed938146300$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $a8236ed938146300$export$fe53371bee54353d(to);
    }
    return $a8236ed938146300$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $a8236ed938146300$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $a8236ed938146300$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $a8236ed938146300$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $a8236ed938146300$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $a8236ed938146300$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $a8236ed938146300$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $a8236ed938146300$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $a8236ed938146300$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $a8236ed938146300$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $a8236ed938146300$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $a8236ed938146300$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $a8236ed938146300$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $a8236ed938146300$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $a8236ed938146300$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $a8236ed938146300$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $a8236ed938146300$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $a8236ed938146300$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $a8236ed938146300$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($a8236ed938146300$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $a8236ed938146300$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $a8236ed938146300$export$e19cd5f9376f8cee.Push;
        let location = $a8236ed938146300$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $a8236ed938146300$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $a8236ed938146300$export$e19cd5f9376f8cee.Replace;
        let location = $a8236ed938146300$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $a8236ed938146300$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $a8236ed938146300$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $a8236ed938146300$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($a8236ed938146300$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($a8236ed938146300$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $a8236ed938146300$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($a8236ed938146300$var$ResultType || ($a8236ed938146300$var$ResultType = {}));
const $a8236ed938146300$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $a8236ed938146300$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $a8236ed938146300$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $a8236ed938146300$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $a8236ed938146300$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($a8236ed938146300$var$isIndexRoute(route)) {
            let indexRoute = $a8236ed938146300$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $a8236ed938146300$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $a8236ed938146300$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $a8236ed938146300$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $a8236ed938146300$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $a8236ed938146300$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $a8236ed938146300$var$flattenRoutes(routes);
    $a8236ed938146300$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $a8236ed938146300$var$decodePath(pathname);
        matches = $a8236ed938146300$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $a8236ed938146300$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $a8236ed938146300$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $a8236ed938146300$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $a8236ed938146300$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $a8236ed938146300$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $a8236ed938146300$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $a8236ed938146300$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $a8236ed938146300$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $a8236ed938146300$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $a8236ed938146300$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $a8236ed938146300$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $a8236ed938146300$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $a8236ed938146300$var$paramRe = /^:[\w-]+$/;
const $a8236ed938146300$var$dynamicSegmentValue = 3;
const $a8236ed938146300$var$indexRouteValue = 2;
const $a8236ed938146300$var$emptySegmentValue = 1;
const $a8236ed938146300$var$staticSegmentValue = 10;
const $a8236ed938146300$var$splatPenalty = -2;
const $a8236ed938146300$var$isSplat = (s)=>s === "*";
function $a8236ed938146300$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($a8236ed938146300$var$isSplat)) initialScore += $a8236ed938146300$var$splatPenalty;
    if (index) initialScore += $a8236ed938146300$var$indexRouteValue;
    return segments.filter((s)=>!$a8236ed938146300$var$isSplat(s)).reduce((score, segment)=>score + ($a8236ed938146300$var$paramRe.test(segment) ? $a8236ed938146300$var$dynamicSegmentValue : segment === "" ? $a8236ed938146300$var$emptySegmentValue : $a8236ed938146300$var$staticSegmentValue), initialScore);
}
function $a8236ed938146300$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $a8236ed938146300$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $a8236ed938146300$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $a8236ed938146300$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $a8236ed938146300$export$a5c6d149b50c1d86($a8236ed938146300$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $a8236ed938146300$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $a8236ed938146300$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $a8236ed938146300$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $a8236ed938146300$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $a8236ed938146300$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $a8236ed938146300$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $a8236ed938146300$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $a8236ed938146300$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $a8236ed938146300$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $a8236ed938146300$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $a8236ed938146300$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $a8236ed938146300$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $a8236ed938146300$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $a8236ed938146300$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $a8236ed938146300$var$normalizeSearch(search),
        hash: $a8236ed938146300$var$normalizeHash(hash)
    };
}
function $a8236ed938146300$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $a8236ed938146300$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $a8236ed938146300$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $a8236ed938146300$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $a8236ed938146300$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $a8236ed938146300$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $a8236ed938146300$export$8ccf933b0513f8d0(toArg);
    else {
        to = $a8236ed938146300$var$_extends({}, toArg);
        $a8236ed938146300$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $a8236ed938146300$var$getInvalidPathError("?", "pathname", "search", to));
        $a8236ed938146300$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $a8236ed938146300$var$getInvalidPathError("#", "pathname", "hash", to));
        $a8236ed938146300$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $a8236ed938146300$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $a8236ed938146300$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $a8236ed938146300$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $a8236ed938146300$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $a8236ed938146300$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $a8236ed938146300$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $a8236ed938146300$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $a8236ed938146300$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $a8236ed938146300$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $a8236ed938146300$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $a8236ed938146300$export$42a99a7a4bc0e76a extends Error {
}
class $a8236ed938146300$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $a8236ed938146300$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $a8236ed938146300$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $a8236ed938146300$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $a8236ed938146300$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $a8236ed938146300$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $a8236ed938146300$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $a8236ed938146300$var$unwrapTrackedPromise(value) {
    if (!$a8236ed938146300$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $a8236ed938146300$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $a8236ed938146300$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $a8236ed938146300$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $a8236ed938146300$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $a8236ed938146300$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $a8236ed938146300$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $a8236ed938146300$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $a8236ed938146300$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $a8236ed938146300$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $a8236ed938146300$var$validMutationMethods = new Set($a8236ed938146300$var$validMutationMethodsArr);
const $a8236ed938146300$var$validRequestMethodsArr = [
    "get",
    ...$a8236ed938146300$var$validMutationMethodsArr
];
const $a8236ed938146300$var$validRequestMethods = new Set($a8236ed938146300$var$validRequestMethodsArr);
const $a8236ed938146300$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $a8236ed938146300$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $a8236ed938146300$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $a8236ed938146300$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $a8236ed938146300$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $a8236ed938146300$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $a8236ed938146300$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $a8236ed938146300$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $a8236ed938146300$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $a8236ed938146300$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $a8236ed938146300$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $a8236ed938146300$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $a8236ed938146300$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $a8236ed938146300$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $a8236ed938146300$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $a8236ed938146300$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $a8236ed938146300$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $a8236ed938146300$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $a8236ed938146300$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $a8236ed938146300$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $a8236ed938146300$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$a8236ed938146300$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($a8236ed938146300$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $a8236ed938146300$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $a8236ed938146300$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $a8236ed938146300$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $a8236ed938146300$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $a8236ed938146300$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $a8236ed938146300$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $a8236ed938146300$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $a8236ed938146300$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $a8236ed938146300$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($a8236ed938146300$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $a8236ed938146300$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $a8236ed938146300$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $a8236ed938146300$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $a8236ed938146300$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $a8236ed938146300$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $a8236ed938146300$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $a8236ed938146300$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $a8236ed938146300$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $a8236ed938146300$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $a8236ed938146300$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $a8236ed938146300$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $a8236ed938146300$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $a8236ed938146300$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $a8236ed938146300$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $a8236ed938146300$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $a8236ed938146300$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $a8236ed938146300$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$a8236ed938146300$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $a8236ed938146300$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $a8236ed938146300$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $a8236ed938146300$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $a8236ed938146300$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $a8236ed938146300$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $a8236ed938146300$var$ResultType.error,
            error: $a8236ed938146300$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $a8236ed938146300$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($a8236ed938146300$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($a8236ed938146300$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $a8236ed938146300$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $a8236ed938146300$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($a8236ed938146300$var$isDeferredResult(result)) throw $a8236ed938146300$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $a8236ed938146300$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $a8236ed938146300$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $a8236ed938146300$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $a8236ed938146300$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $a8236ed938146300$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($a8236ed938146300$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $a8236ed938146300$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $a8236ed938146300$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $a8236ed938146300$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $a8236ed938146300$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $a8236ed938146300$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $a8236ed938146300$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $a8236ed938146300$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $a8236ed938146300$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $a8236ed938146300$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $a8236ed938146300$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $a8236ed938146300$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $a8236ed938146300$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $a8236ed938146300$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($a8236ed938146300$var$isRedirectResult(actionResult) || $a8236ed938146300$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $a8236ed938146300$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($a8236ed938146300$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $a8236ed938146300$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $a8236ed938146300$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($a8236ed938146300$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($a8236ed938146300$var$isDeferredResult(actionResult)) throw $a8236ed938146300$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $a8236ed938146300$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $a8236ed938146300$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $a8236ed938146300$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $a8236ed938146300$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $a8236ed938146300$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $a8236ed938146300$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $a8236ed938146300$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $a8236ed938146300$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $a8236ed938146300$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $a8236ed938146300$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $a8236ed938146300$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $a8236ed938146300$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $a8236ed938146300$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $a8236ed938146300$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($a8236ed938146300$var$isDeferredResult(result)) result = await $a8236ed938146300$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $a8236ed938146300$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($a8236ed938146300$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $a8236ed938146300$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($a8236ed938146300$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $a8236ed938146300$export$3e9cee6b33872309(!$a8236ed938146300$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $a8236ed938146300$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $a8236ed938146300$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $a8236ed938146300$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($a8236ed938146300$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $a8236ed938146300$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $a8236ed938146300$export$e19cd5f9376f8cee.Replace : $a8236ed938146300$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $a8236ed938146300$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($a8236ed938146300$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $a8236ed938146300$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $a8236ed938146300$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $a8236ed938146300$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$a8236ed938146300$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $a8236ed938146300$var$callLoaderOrAction("loader", $a8236ed938146300$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $a8236ed938146300$var$ResultType.error,
                        error: $a8236ed938146300$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $a8236ed938146300$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $a8236ed938146300$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $a8236ed938146300$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $a8236ed938146300$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $a8236ed938146300$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $a8236ed938146300$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $a8236ed938146300$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $a8236ed938146300$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $a8236ed938146300$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $a8236ed938146300$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $a8236ed938146300$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $a8236ed938146300$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $a8236ed938146300$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$a8236ed938146300$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $a8236ed938146300$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $a8236ed938146300$export$4d0306f8f6a4585b = Symbol("deferred");
function $a8236ed938146300$export$3336b097a6fbc59a(routes, opts) {
    $a8236ed938146300$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $a8236ed938146300$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $a8236ed938146300$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $a8236ed938146300$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $a8236ed938146300$var$createLocation("", $a8236ed938146300$export$fe53371bee54353d(url), null, "default");
        let matches = $a8236ed938146300$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$a8236ed938146300$var$isValidMethod(method) && method !== "HEAD") {
            let error = $a8236ed938146300$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $a8236ed938146300$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $a8236ed938146300$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $a8236ed938146300$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($a8236ed938146300$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $a8236ed938146300$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $a8236ed938146300$var$createLocation("", $a8236ed938146300$export$fe53371bee54353d(url), null, "default");
        let matches = $a8236ed938146300$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$a8236ed938146300$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $a8236ed938146300$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $a8236ed938146300$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $a8236ed938146300$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $a8236ed938146300$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $a8236ed938146300$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($a8236ed938146300$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$a8236ed938146300$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $a8236ed938146300$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($a8236ed938146300$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $a8236ed938146300$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $a8236ed938146300$var$isResponse(result) ? result : $a8236ed938146300$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($a8236ed938146300$var$isQueryRouteResponse(e)) {
                if (e.type === $a8236ed938146300$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($a8236ed938146300$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $a8236ed938146300$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $a8236ed938146300$var$ResultType.error,
                error: error
            };
        } else {
            result = await $a8236ed938146300$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $a8236ed938146300$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($a8236ed938146300$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($a8236ed938146300$var$isDeferredResult(result)) {
            let error = $a8236ed938146300$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $a8236ed938146300$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($a8236ed938146300$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($a8236ed938146300$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $a8236ed938146300$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $a8236ed938146300$var$_extends({}, context, {
                statusCode: $a8236ed938146300$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $a8236ed938146300$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $a8236ed938146300$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $a8236ed938146300$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $a8236ed938146300$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $a8236ed938146300$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$a8236ed938146300$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $a8236ed938146300$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $a8236ed938146300$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $a8236ed938146300$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $a8236ed938146300$export$fec11da027c70692(routes, context, error) {
    let newContext = $a8236ed938146300$var$_extends({}, context, {
        statusCode: $a8236ed938146300$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $a8236ed938146300$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $a8236ed938146300$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $a8236ed938146300$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $a8236ed938146300$export$cae722b0cc860f13(to ? to : ".", $a8236ed938146300$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $a8236ed938146300$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$a8236ed938146300$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $a8236ed938146300$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $a8236ed938146300$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $a8236ed938146300$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$a8236ed938146300$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$a8236ed938146300$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $a8236ed938146300$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $a8236ed938146300$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $a8236ed938146300$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$a8236ed938146300$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$a8236ed938146300$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $a8236ed938146300$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $a8236ed938146300$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $a8236ed938146300$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $a8236ed938146300$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $a8236ed938146300$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($a8236ed938146300$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $a8236ed938146300$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $a8236ed938146300$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $a8236ed938146300$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $a8236ed938146300$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $a8236ed938146300$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $a8236ed938146300$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($a8236ed938146300$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $a8236ed938146300$var$shouldRevalidateLoader(match, $a8236ed938146300$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $a8236ed938146300$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $a8236ed938146300$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $a8236ed938146300$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $a8236ed938146300$var$shouldRevalidateLoader(fetcherMatch, $a8236ed938146300$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $a8236ed938146300$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $a8236ed938146300$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $a8236ed938146300$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $a8236ed938146300$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $a8236ed938146300$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $a8236ed938146300$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$a8236ed938146300$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $a8236ed938146300$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $a8236ed938146300$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $a8236ed938146300$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $a8236ed938146300$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $a8236ed938146300$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $a8236ed938146300$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $a8236ed938146300$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $a8236ed938146300$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $a8236ed938146300$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($a8236ed938146300$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($a8236ed938146300$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $a8236ed938146300$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$a8236ed938146300$var$ABSOLUTE_URL_REGEX.test(location)) location = $a8236ed938146300$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $a8236ed938146300$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $a8236ed938146300$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $a8236ed938146300$var$ResultType.error ? $a8236ed938146300$var$ResultType.error : $a8236ed938146300$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $a8236ed938146300$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $a8236ed938146300$var$ResultType.error) return {
            type: resultType,
            error: new $a8236ed938146300$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $a8236ed938146300$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $a8236ed938146300$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($a8236ed938146300$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $a8236ed938146300$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $a8236ed938146300$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $a8236ed938146300$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($a8236ed938146300$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $a8236ed938146300$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $a8236ed938146300$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $a8236ed938146300$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $a8236ed938146300$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $a8236ed938146300$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $a8236ed938146300$export$3e9cee6b33872309(!$a8236ed938146300$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($a8236ed938146300$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $a8236ed938146300$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $a8236ed938146300$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($a8236ed938146300$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $a8236ed938146300$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $a8236ed938146300$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $a8236ed938146300$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($a8236ed938146300$var$isErrorResult(result)) {
            let boundaryMatch = $a8236ed938146300$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $a8236ed938146300$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($a8236ed938146300$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $a8236ed938146300$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($a8236ed938146300$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $a8236ed938146300$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $a8236ed938146300$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $a8236ed938146300$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $a8236ed938146300$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $a8236ed938146300$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $a8236ed938146300$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $a8236ed938146300$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $a8236ed938146300$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $a8236ed938146300$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($a8236ed938146300$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $a8236ed938146300$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $a8236ed938146300$export$8ccf933b0513f8d0(path) : path;
    return $a8236ed938146300$export$fe53371bee54353d($a8236ed938146300$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $a8236ed938146300$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $a8236ed938146300$var$isDeferredResult(result) {
    return result.type === $a8236ed938146300$var$ResultType.deferred;
}
function $a8236ed938146300$var$isErrorResult(result) {
    return result.type === $a8236ed938146300$var$ResultType.error;
}
function $a8236ed938146300$var$isRedirectResult(result) {
    return (result && result.type) === $a8236ed938146300$var$ResultType.redirect;
}
function $a8236ed938146300$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $a8236ed938146300$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $a8236ed938146300$var$isRedirectResponse(result) {
    if (!$a8236ed938146300$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $a8236ed938146300$var$isQueryRouteResponse(obj) {
    return obj && $a8236ed938146300$var$isResponse(obj.response) && (obj.type === $a8236ed938146300$var$ResultType.data || obj.type === $a8236ed938146300$var$ResultType.error);
}
function $a8236ed938146300$var$isValidMethod(method) {
    return $a8236ed938146300$var$validRequestMethods.has(method.toLowerCase());
}
function $a8236ed938146300$var$isMutationMethod(method) {
    return $a8236ed938146300$var$validMutationMethods.has(method.toLowerCase());
}
async function $a8236ed938146300$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$a8236ed938146300$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($a8236ed938146300$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $a8236ed938146300$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $a8236ed938146300$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $a8236ed938146300$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $a8236ed938146300$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $a8236ed938146300$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $a8236ed938146300$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $a8236ed938146300$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $a8236ed938146300$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $a8236ed938146300$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $a8236ed938146300$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $a8236ed938146300$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $a8236ed938146300$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $a8236ed938146300$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $a8236ed938146300$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $a8236ed938146300$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $a8236ed938146300$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $a8236ed938146300$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $a8236ed938146300$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($a8236ed938146300$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $a8236ed938146300$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($a8236ed938146300$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $a8236ed938146300$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $i7uhG = parcelRequire("i7uhG");

function $03719940145a991f$var$_extends() {
    $03719940145a991f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $03719940145a991f$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $03719940145a991f$export$3add0d5dce533e2e = /*#__PURE__*/ $i7uhG.createContext(null);
const $03719940145a991f$export$145dfa71566a64dc = /*#__PURE__*/ $i7uhG.createContext(null);
const $03719940145a991f$var$AwaitContext = /*#__PURE__*/ $i7uhG.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $03719940145a991f$export$26749e8557646306 = /*#__PURE__*/ $i7uhG.createContext(null);
const $03719940145a991f$export$c7914228fb69b0f5 = /*#__PURE__*/ $i7uhG.createContext(null);
const $03719940145a991f$export$9072aa6dd1f93057 = /*#__PURE__*/ $i7uhG.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $03719940145a991f$var$RouteErrorContext = /*#__PURE__*/ $i7uhG.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $03719940145a991f$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$03719940145a991f$export$9c954a9d03d32f4a() && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $i7uhG.useContext($03719940145a991f$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $03719940145a991f$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $a8236ed938146300$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $03719940145a991f$export$9c954a9d03d32f4a() {
    return $i7uhG.useContext($03719940145a991f$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $03719940145a991f$export$45d76561a5302f2b() {
    !$03719940145a991f$export$9c954a9d03d32f4a() && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    return $i7uhG.useContext($03719940145a991f$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $03719940145a991f$export$1b3f31771c5d07c() {
    return $i7uhG.useContext($03719940145a991f$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $03719940145a991f$export$6c330e8992e8a295(pattern) {
    !$03719940145a991f$export$9c954a9d03d32f4a() && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $03719940145a991f$export$45d76561a5302f2b();
    return $i7uhG.useMemo(()=>(0, $a8236ed938146300$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $03719940145a991f$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $03719940145a991f$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $i7uhG.useContext($03719940145a991f$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $i7uhG.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $03719940145a991f$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $i7uhG.useContext($03719940145a991f$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $03719940145a991f$var$useNavigateStable() : $03719940145a991f$var$useNavigateUnstable();
}
function $03719940145a991f$var$useNavigateUnstable() {
    !$03719940145a991f$export$9c954a9d03d32f4a() && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    let dataRouterContext = $i7uhG.useContext($03719940145a991f$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $i7uhG.useContext($03719940145a991f$export$26749e8557646306);
    let { matches: matches } = $i7uhG.useContext($03719940145a991f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $03719940145a991f$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $a8236ed938146300$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $i7uhG.useRef(false);
    $03719940145a991f$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $i7uhG.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $a8236ed938146300$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $a8236ed938146300$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $03719940145a991f$var$OutletContext = /*#__PURE__*/ $i7uhG.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $03719940145a991f$export$4138103a3ae699cc() {
    return $i7uhG.useContext($03719940145a991f$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $03719940145a991f$export$a3be3530d8e40d0b(context) {
    let outlet = $i7uhG.useContext($03719940145a991f$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $03719940145a991f$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $i7uhG.useContext($03719940145a991f$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $03719940145a991f$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $i7uhG.useContext($03719940145a991f$export$26749e8557646306);
    let { matches: matches } = $i7uhG.useContext($03719940145a991f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $03719940145a991f$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $a8236ed938146300$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $i7uhG.useMemo(()=>(0, $a8236ed938146300$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $03719940145a991f$export$5d3fca4a98652595(routes, locationArg) {
    return $03719940145a991f$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $03719940145a991f$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$03719940145a991f$export$9c954a9d03d32f4a() && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $i7uhG.useContext($03719940145a991f$export$26749e8557646306);
    let { matches: parentMatches } = $i7uhG.useContext($03719940145a991f$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $03719940145a991f$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $a8236ed938146300$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $a8236ed938146300$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $03719940145a991f$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $a8236ed938146300$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $a8236ed938146300$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $03719940145a991f$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $a8236ed938146300$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $03719940145a991f$var$DefaultErrorComponent() {
    let error = $03719940145a991f$export$ed527bf60f6e05f2();
    let message = (0, $a8236ed938146300$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $i7uhG.createElement($i7uhG.Fragment, null, /*#__PURE__*/ $i7uhG.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $i7uhG.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $i7uhG.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $03719940145a991f$var$defaultErrorElement = /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$var$DefaultErrorComponent, null);
class $03719940145a991f$var$RenderErrorBoundary extends $i7uhG.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $03719940145a991f$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $i7uhG.useContext($03719940145a991f$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $03719940145a991f$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $03719940145a991f$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $03719940145a991f$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $i7uhG.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $03719940145a991f$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($03719940145a991f$var$DataRouterHook || {});
var $03719940145a991f$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($03719940145a991f$var$DataRouterStateHook || {});
function $03719940145a991f$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $03719940145a991f$var$useDataRouterContext(hookName) {
    let ctx = $i7uhG.useContext($03719940145a991f$export$3add0d5dce533e2e);
    !ctx && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    return ctx;
}
function $03719940145a991f$var$useDataRouterState(hookName) {
    let state = $i7uhG.useContext($03719940145a991f$export$145dfa71566a64dc);
    !state && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    return state;
}
function $03719940145a991f$var$useRouteContext(hookName) {
    let route = $i7uhG.useContext($03719940145a991f$export$9072aa6dd1f93057);
    !route && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $03719940145a991f$var$useCurrentRouteId(hookName) {
    let route = $03719940145a991f$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $03719940145a991f$export$5fc8298006ad9e58() {
    return $03719940145a991f$var$useCurrentRouteId($03719940145a991f$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $03719940145a991f$export$d0fd4b7106de2769() {
    let state = $03719940145a991f$var$useDataRouterState($03719940145a991f$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $03719940145a991f$export$600dc272ed516c15() {
    let dataRouterContext = $03719940145a991f$var$useDataRouterContext($03719940145a991f$var$DataRouterHook.UseRevalidator);
    let state = $03719940145a991f$var$useDataRouterState($03719940145a991f$var$DataRouterStateHook.UseRevalidator);
    return $i7uhG.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $03719940145a991f$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $03719940145a991f$var$useDataRouterState($03719940145a991f$var$DataRouterStateHook.UseMatches);
    return $i7uhG.useMemo(()=>matches.map((m)=>(0, $a8236ed938146300$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $03719940145a991f$export$1448a5050d252c4d() {
    let state = $03719940145a991f$var$useDataRouterState($03719940145a991f$var$DataRouterStateHook.UseLoaderData);
    let routeId = $03719940145a991f$var$useCurrentRouteId($03719940145a991f$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $03719940145a991f$export$fd5d37484eab868d(routeId) {
    let state = $03719940145a991f$var$useDataRouterState($03719940145a991f$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $03719940145a991f$export$fdc00f3f26066d5e() {
    let state = $03719940145a991f$var$useDataRouterState($03719940145a991f$var$DataRouterStateHook.UseActionData);
    let routeId = $03719940145a991f$var$useCurrentRouteId($03719940145a991f$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $03719940145a991f$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $i7uhG.useContext($03719940145a991f$var$RouteErrorContext);
    let state = $03719940145a991f$var$useDataRouterState($03719940145a991f$var$DataRouterStateHook.UseRouteError);
    let routeId = $03719940145a991f$var$useCurrentRouteId($03719940145a991f$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $03719940145a991f$export$78a72ddb39bdd145() {
    let value = $i7uhG.useContext($03719940145a991f$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $03719940145a991f$export$17f53340677d5831() {
    let value = $i7uhG.useContext($03719940145a991f$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $03719940145a991f$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $03719940145a991f$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $03719940145a991f$var$useDataRouterContext($03719940145a991f$var$DataRouterHook.UseBlocker);
    let state = $03719940145a991f$var$useDataRouterState($03719940145a991f$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $i7uhG.useState("");
    let blockerFunction = $i7uhG.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $03719940145a991f$var$_extends({}, currentLocation, {
                pathname: (0, $a8236ed938146300$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $03719940145a991f$var$_extends({}, nextLocation, {
                pathname: (0, $a8236ed938146300$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $i7uhG.useEffect(()=>{
        let key = String(++$03719940145a991f$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $i7uhG.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $a8236ed938146300$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $03719940145a991f$var$useNavigateStable() {
    let { router: router } = $03719940145a991f$var$useDataRouterContext($03719940145a991f$var$DataRouterHook.UseNavigateStable);
    let id = $03719940145a991f$var$useCurrentRouteId($03719940145a991f$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $i7uhG.useRef(false);
    $03719940145a991f$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $i7uhG.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $03719940145a991f$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $03719940145a991f$var$alreadyWarned = {};
function $03719940145a991f$var$warningOnce(key, cond, message) {
    if (!cond && !$03719940145a991f$var$alreadyWarned[key]) $03719940145a991f$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $03719940145a991f$var$START_TRANSITION = "startTransition";
const $03719940145a991f$var$startTransitionImpl = $i7uhG[$03719940145a991f$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $03719940145a991f$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $i7uhG.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $i7uhG.useCallback((newState)=>{
        if (v7_startTransition && $03719940145a991f$var$startTransitionImpl) $03719940145a991f$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $i7uhG.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $i7uhG.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $i7uhG.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $i7uhG.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $i7uhG.createElement($i7uhG.Fragment, null, /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $03719940145a991f$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $03719940145a991f$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $03719940145a991f$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $i7uhG.useRef();
    if (historyRef.current == null) historyRef.current = (0, $a8236ed938146300$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $i7uhG.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $i7uhG.useCallback((newState)=>{
        v7_startTransition && $03719940145a991f$var$startTransitionImpl ? $03719940145a991f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $i7uhG.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $03719940145a991f$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$03719940145a991f$export$9c954a9d03d32f4a() && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $i7uhG.useContext($03719940145a991f$export$26749e8557646306);
    let { matches: matches } = $i7uhG.useContext($03719940145a991f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $03719940145a991f$export$45d76561a5302f2b();
    let navigate = $03719940145a991f$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $a8236ed938146300$export$cae722b0cc860f13)(to, (0, $a8236ed938146300$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $i7uhG.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $03719940145a991f$export$910ae8079b2c2852(props) {
    return $03719940145a991f$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $03719940145a991f$export$e7b0ac011bb776c6(_props) {
    (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $03719940145a991f$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $a8236ed938146300$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$03719940145a991f$export$9c954a9d03d32f4a() && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $i7uhG.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $03719940145a991f$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $a8236ed938146300$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $i7uhG.useMemo(()=>{
        let trailingPathname = (0, $a8236ed938146300$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $03719940145a991f$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $03719940145a991f$export$5d3fca4a98652595($03719940145a991f$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $03719940145a991f$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$var$ResolveAwait, null, children));
}
var $03719940145a991f$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($03719940145a991f$var$AwaitRenderStatus || {});
const $03719940145a991f$var$neverSettledPromise = new Promise(()=>{});
class $03719940145a991f$var$AwaitErrorBoundary extends $i7uhG.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $03719940145a991f$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $03719940145a991f$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $03719940145a991f$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $03719940145a991f$var$AwaitRenderStatus.error : promise._data !== undefined ? $03719940145a991f$var$AwaitRenderStatus.success : $03719940145a991f$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $03719940145a991f$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $03719940145a991f$var$AwaitRenderStatus.error && promise._error instanceof (0, $a8236ed938146300$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $03719940145a991f$var$neverSettledPromise;
        if (status === $03719940145a991f$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $03719940145a991f$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $03719940145a991f$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $03719940145a991f$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $03719940145a991f$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $i7uhG.createElement($i7uhG.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $03719940145a991f$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $i7uhG.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $i7uhG.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $i7uhG.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $03719940145a991f$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $03719940145a991f$export$e7b0ac011bb776c6) && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $03719940145a991f$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $03719940145a991f$export$daf73786167a7f72(matches) {
    return $03719940145a991f$var$_renderMatches(matches);
}
function $03719940145a991f$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $i7uhG.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $i7uhG.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $i7uhG.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $03719940145a991f$export$f30f7e456d254e83(routes, opts) {
    return (0, $a8236ed938146300$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $03719940145a991f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $a8236ed938146300$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $03719940145a991f$export$52b333d321859367
    }).initialize();
}



function $b9ce296f3422b46b$var$_extends() {
    $b9ce296f3422b46b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b9ce296f3422b46b$var$_extends.apply(this, arguments);
}
function $b9ce296f3422b46b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $b9ce296f3422b46b$var$defaultMethod = "get";
const $b9ce296f3422b46b$var$defaultEncType = "application/x-www-form-urlencoded";
function $b9ce296f3422b46b$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $b9ce296f3422b46b$var$isButtonElement(object) {
    return $b9ce296f3422b46b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $b9ce296f3422b46b$var$isFormElement(object) {
    return $b9ce296f3422b46b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $b9ce296f3422b46b$var$isInputElement(object) {
    return $b9ce296f3422b46b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $b9ce296f3422b46b$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $b9ce296f3422b46b$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$b9ce296f3422b46b$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $b9ce296f3422b46b$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $b9ce296f3422b46b$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $b9ce296f3422b46b$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $b9ce296f3422b46b$var$_formDataSupportsSubmitter = null;
function $b9ce296f3422b46b$var$isFormDataSubmitterSupported() {
    if ($b9ce296f3422b46b$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $b9ce296f3422b46b$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $b9ce296f3422b46b$var$_formDataSupportsSubmitter = true;
    }
    return $b9ce296f3422b46b$var$_formDataSupportsSubmitter;
}
const $b9ce296f3422b46b$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $b9ce296f3422b46b$var$getFormEncType(encType) {
    if (encType != null && !$b9ce296f3422b46b$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $b9ce296f3422b46b$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($b9ce296f3422b46b$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $a8236ed938146300$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $b9ce296f3422b46b$var$defaultMethod;
        encType = $b9ce296f3422b46b$var$getFormEncType(target.getAttribute("enctype")) || $b9ce296f3422b46b$var$defaultEncType;
        formData = new FormData(target);
    } else if ($b9ce296f3422b46b$var$isButtonElement(target) || $b9ce296f3422b46b$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $a8236ed938146300$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $b9ce296f3422b46b$var$defaultMethod;
        encType = $b9ce296f3422b46b$var$getFormEncType(target.getAttribute("formenctype")) || $b9ce296f3422b46b$var$getFormEncType(form.getAttribute("enctype")) || $b9ce296f3422b46b$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$b9ce296f3422b46b$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($b9ce296f3422b46b$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $b9ce296f3422b46b$var$defaultMethod;
        action = null;
        encType = $b9ce296f3422b46b$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $b9ce296f3422b46b$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $b9ce296f3422b46b$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $b9ce296f3422b46b$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $b9ce296f3422b46b$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $b9ce296f3422b46b$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $b9ce296f3422b46b$export$1f3f55432a00e06d(routes, opts) {
    return (0, $a8236ed938146300$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b9ce296f3422b46b$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $a8236ed938146300$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $b9ce296f3422b46b$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $03719940145a991f$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $b9ce296f3422b46b$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $a8236ed938146300$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b9ce296f3422b46b$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $a8236ed938146300$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $b9ce296f3422b46b$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $03719940145a991f$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $b9ce296f3422b46b$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $b9ce296f3422b46b$var$_extends({}, state, {
        errors: $b9ce296f3422b46b$var$deserializeErrors(state.errors)
    });
    return state;
}
function $b9ce296f3422b46b$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $a8236ed938146300$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $b9ce296f3422b46b$export$7ad602f0e94e62d1 = /*#__PURE__*/ $i7uhG.createContext({
    isTransitioning: false
});
const $b9ce296f3422b46b$export$148fd98d095596d4 = /*#__PURE__*/ $i7uhG.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $b9ce296f3422b46b$var$START_TRANSITION = "startTransition";
const $b9ce296f3422b46b$var$startTransitionImpl = $i7uhG[$b9ce296f3422b46b$var$START_TRANSITION];
const $b9ce296f3422b46b$var$FLUSH_SYNC = "flushSync";
const $b9ce296f3422b46b$var$flushSyncImpl = $f7Clz[$b9ce296f3422b46b$var$FLUSH_SYNC];
const $b9ce296f3422b46b$var$USE_ID = "useId";
const $b9ce296f3422b46b$var$useIdImpl = $i7uhG[$b9ce296f3422b46b$var$USE_ID];
function $b9ce296f3422b46b$var$startTransitionSafe(cb) {
    if ($b9ce296f3422b46b$var$startTransitionImpl) $b9ce296f3422b46b$var$startTransitionImpl(cb);
    else cb();
}
function $b9ce296f3422b46b$var$flushSyncSafe(cb) {
    if ($b9ce296f3422b46b$var$flushSyncImpl) $b9ce296f3422b46b$var$flushSyncImpl(cb);
    else cb();
}
class $b9ce296f3422b46b$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $b9ce296f3422b46b$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $i7uhG.useState(router.state);
    let [pendingState, setPendingState] = $i7uhG.useState();
    let [vtContext, setVtContext] = $i7uhG.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $i7uhG.useState();
    let [transition, setTransition] = $i7uhG.useState();
    let [interruption, setInterruption] = $i7uhG.useState();
    let fetcherData = $i7uhG.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $i7uhG.useCallback((cb)=>{
        if (v7_startTransition) $b9ce296f3422b46b$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $i7uhG.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $b9ce296f3422b46b$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $b9ce296f3422b46b$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $b9ce296f3422b46b$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $b9ce296f3422b46b$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $b9ce296f3422b46b$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $i7uhG.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $i7uhG.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $b9ce296f3422b46b$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $i7uhG.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $i7uhG.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $i7uhG.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $i7uhG.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $i7uhG.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $i7uhG.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $i7uhG.createElement($i7uhG.Fragment, null, /*#__PURE__*/ $i7uhG.createElement((0, $03719940145a991f$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $i7uhG.createElement((0, $03719940145a991f$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $i7uhG.createElement($b9ce296f3422b46b$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $i7uhG.createElement($b9ce296f3422b46b$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $i7uhG.createElement((0, $03719940145a991f$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $i7uhG.createElement($b9ce296f3422b46b$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $b9ce296f3422b46b$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $03719940145a991f$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $b9ce296f3422b46b$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $i7uhG.useRef();
    if (historyRef.current == null) historyRef.current = (0, $a8236ed938146300$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $i7uhG.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $i7uhG.useCallback((newState)=>{
        v7_startTransition && $b9ce296f3422b46b$var$startTransitionImpl ? $b9ce296f3422b46b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $i7uhG.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $i7uhG.createElement((0, $03719940145a991f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $b9ce296f3422b46b$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $i7uhG.useRef();
    if (historyRef.current == null) historyRef.current = (0, $a8236ed938146300$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $i7uhG.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $i7uhG.useCallback((newState)=>{
        v7_startTransition && $b9ce296f3422b46b$var$startTransitionImpl ? $b9ce296f3422b46b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $i7uhG.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $i7uhG.createElement((0, $03719940145a991f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $b9ce296f3422b46b$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $i7uhG.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $i7uhG.useCallback((newState)=>{
        v7_startTransition && $b9ce296f3422b46b$var$startTransitionImpl ? $b9ce296f3422b46b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $i7uhG.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $i7uhG.createElement((0, $03719940145a991f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $b9ce296f3422b46b$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $b9ce296f3422b46b$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $b9ce296f3422b46b$export$a6c7ac8248d6e38a = /*#__PURE__*/ $i7uhG.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $b9ce296f3422b46b$var$_objectWithoutPropertiesLoose(_ref7, $b9ce296f3422b46b$var$_excluded);
    let { basename: basename } = $i7uhG.useContext((0, $03719940145a991f$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $b9ce296f3422b46b$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($b9ce296f3422b46b$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $a8236ed938146300$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $03719940145a991f$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $b9ce296f3422b46b$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $i7uhG.createElement("a", $b9ce296f3422b46b$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $b9ce296f3422b46b$export$b0d92dbee9b5b60d = /*#__PURE__*/ $i7uhG.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $b9ce296f3422b46b$var$_objectWithoutPropertiesLoose(_ref8, $b9ce296f3422b46b$var$_excluded2);
    let path = (0, $03719940145a991f$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $03719940145a991f$export$45d76561a5302f2b)();
    let routerState = $i7uhG.useContext((0, $03719940145a991f$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $i7uhG.useContext((0, $03719940145a991f$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $b9ce296f3422b46b$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $a8236ed938146300$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $i7uhG.createElement($b9ce296f3422b46b$export$a6c7ac8248d6e38a, $b9ce296f3422b46b$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $b9ce296f3422b46b$export$a7fed597f4b8afd8 = /*#__PURE__*/ $i7uhG.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $b9ce296f3422b46b$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $b9ce296f3422b46b$var$_objectWithoutPropertiesLoose(_ref9, $b9ce296f3422b46b$var$_excluded3);
    let submit = $b9ce296f3422b46b$export$47c85c6e3a081d3();
    let formAction = $b9ce296f3422b46b$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $i7uhG.createElement("form", $b9ce296f3422b46b$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $b9ce296f3422b46b$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $b9ce296f3422b46b$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $b9ce296f3422b46b$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($b9ce296f3422b46b$var$DataRouterHook || ($b9ce296f3422b46b$var$DataRouterHook = {}));
var $b9ce296f3422b46b$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($b9ce296f3422b46b$var$DataRouterStateHook || ($b9ce296f3422b46b$var$DataRouterStateHook = {}));
// Internal hooks
function $b9ce296f3422b46b$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $b9ce296f3422b46b$var$useDataRouterContext(hookName) {
    let ctx = $i7uhG.useContext((0, $03719940145a991f$export$3add0d5dce533e2e));
    !ctx && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    return ctx;
}
function $b9ce296f3422b46b$var$useDataRouterState(hookName) {
    let state = $i7uhG.useContext((0, $03719940145a991f$export$145dfa71566a64dc));
    !state && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $b9ce296f3422b46b$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $03719940145a991f$export$9770f232ac06a008)();
    let location = (0, $03719940145a991f$export$45d76561a5302f2b)();
    let path = (0, $03719940145a991f$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $i7uhG.useCallback((event)=>{
        if ($b9ce296f3422b46b$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $a8236ed938146300$export$fe53371bee54353d)(location) === (0, $a8236ed938146300$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $b9ce296f3422b46b$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $i7uhG.useRef($b9ce296f3422b46b$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $i7uhG.useRef(false);
    let location = (0, $03719940145a991f$export$45d76561a5302f2b)();
    let searchParams = $i7uhG.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $b9ce296f3422b46b$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $03719940145a991f$export$9770f232ac06a008)();
    let setSearchParams = $i7uhG.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $b9ce296f3422b46b$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $b9ce296f3422b46b$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $b9ce296f3422b46b$var$fetcherId = 0;
let $b9ce296f3422b46b$var$getUniqueFetcherId = ()=>"__" + String(++$b9ce296f3422b46b$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $b9ce296f3422b46b$export$47c85c6e3a081d3() {
    let { router: router } = $b9ce296f3422b46b$var$useDataRouterContext($b9ce296f3422b46b$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $i7uhG.useContext((0, $03719940145a991f$export$26749e8557646306));
    let currentRouteId = (0, $03719940145a991f$export$5fc8298006ad9e58)();
    return $i7uhG.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $b9ce296f3422b46b$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $b9ce296f3422b46b$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $b9ce296f3422b46b$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $b9ce296f3422b46b$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $i7uhG.useContext((0, $03719940145a991f$export$26749e8557646306));
    let routeContext = $i7uhG.useContext((0, $03719940145a991f$export$9072aa6dd1f93057));
    !routeContext && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $b9ce296f3422b46b$var$_extends({}, (0, $03719940145a991f$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $03719940145a991f$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $a8236ed938146300$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $a8236ed938146300$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $b9ce296f3422b46b$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $b9ce296f3422b46b$var$useDataRouterContext($b9ce296f3422b46b$var$DataRouterHook.UseFetcher);
    let state = $b9ce296f3422b46b$var$useDataRouterState($b9ce296f3422b46b$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $i7uhG.useContext($b9ce296f3422b46b$export$148fd98d095596d4);
    let route = $i7uhG.useContext((0, $03719940145a991f$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    !route && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $b9ce296f3422b46b$var$useIdImpl ? $b9ce296f3422b46b$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $i7uhG.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($b9ce296f3422b46b$var$getUniqueFetcherId());
    // Registration/cleanup
    $i7uhG.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $i7uhG.useCallback((href, opts)=>{
        !routeId && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $b9ce296f3422b46b$export$47c85c6e3a081d3();
    let submit = $i7uhG.useCallback((target, opts)=>{
        submitImpl(target, $b9ce296f3422b46b$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $i7uhG.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $i7uhG.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $i7uhG.createElement($b9ce296f3422b46b$export$a7fed597f4b8afd8, $b9ce296f3422b46b$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $a8236ed938146300$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $i7uhG.useMemo(()=>$b9ce296f3422b46b$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $b9ce296f3422b46b$export$fa996778a3a31087() {
    let state = $b9ce296f3422b46b$var$useDataRouterState($b9ce296f3422b46b$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $b9ce296f3422b46b$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $b9ce296f3422b46b$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $b9ce296f3422b46b$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $b9ce296f3422b46b$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $b9ce296f3422b46b$var$useDataRouterContext($b9ce296f3422b46b$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $b9ce296f3422b46b$var$useDataRouterState($b9ce296f3422b46b$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $i7uhG.useContext((0, $03719940145a991f$export$26749e8557646306));
    let location = (0, $03719940145a991f$export$45d76561a5302f2b)();
    let matches = (0, $03719940145a991f$export$2378eb7f5ff86053)();
    let navigation = (0, $03719940145a991f$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $i7uhG.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $b9ce296f3422b46b$var$usePageHide($i7uhG.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $b9ce296f3422b46b$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $b9ce296f3422b46b$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($b9ce296f3422b46b$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $i7uhG.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $b9ce296f3422b46b$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $b9ce296f3422b46b$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $i7uhG.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($b9ce296f3422b46b$var$_extends({}, location, {
                    pathname: (0, $a8236ed938146300$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($b9ce296f3422b46b$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $i7uhG.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $b9ce296f3422b46b$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $i7uhG.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $b9ce296f3422b46b$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $i7uhG.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $b9ce296f3422b46b$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $03719940145a991f$export$b273b3273281a049)(when);
    $i7uhG.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $i7uhG.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $b9ce296f3422b46b$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $i7uhG.useContext($b9ce296f3422b46b$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    let { basename: basename } = $b9ce296f3422b46b$var$useDataRouterContext($b9ce296f3422b46b$var$DataRouterHook.useViewTransitionState);
    let path = (0, $03719940145a991f$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $a8236ed938146300$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $a8236ed938146300$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $a8236ed938146300$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $a8236ed938146300$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $i7uhG = parcelRequire("i7uhG");
const $c9030a919f491fd7$var$useOnlineStatus = ()=>{
    const [onlineStatus, setOnlineStatus] = (0, $i7uhG.useState)(true);
    (0, $i7uhG.useEffect)(()=>{
        window.addEventListener("offline", ()=>{
            setOnlineStatus(false);
        });
        window.addEventListener("online", ()=>{
            setOnlineStatus(true);
        });
    }, []);
    return onlineStatus;
};
var $c9030a919f491fd7$export$2e2bcd8739ae039 = $c9030a919f491fd7$var$useOnlineStatus;



var $i7uhG = parcelRequire("i7uhG");
var $5267a1cd56fb756c$exports = {};
'use strict';

$5267a1cd56fb756c$exports = (parcelRequire("4hMQQ"));


var $8a2e0dcbd07620ad$var$__defProp = Object.defineProperty;
var $8a2e0dcbd07620ad$var$__defProps = Object.defineProperties;
var $8a2e0dcbd07620ad$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $8a2e0dcbd07620ad$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8a2e0dcbd07620ad$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8a2e0dcbd07620ad$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8a2e0dcbd07620ad$var$__defNormalProp = (obj, key, value)=>key in obj ? $8a2e0dcbd07620ad$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8a2e0dcbd07620ad$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($8a2e0dcbd07620ad$var$__hasOwnProp.call(b, prop)) $8a2e0dcbd07620ad$var$__defNormalProp(a, prop, b[prop]);
    if ($8a2e0dcbd07620ad$var$__getOwnPropSymbols) {
        for (var prop of $8a2e0dcbd07620ad$var$__getOwnPropSymbols(b))if ($8a2e0dcbd07620ad$var$__propIsEnum.call(b, prop)) $8a2e0dcbd07620ad$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $8a2e0dcbd07620ad$var$__spreadProps = (a, b)=>$8a2e0dcbd07620ad$var$__defProps(a, $8a2e0dcbd07620ad$var$__getOwnPropDescs(b));
var $8a2e0dcbd07620ad$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($8a2e0dcbd07620ad$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $8a2e0dcbd07620ad$var$__getOwnPropSymbols) {
        for (var prop of $8a2e0dcbd07620ad$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $8a2e0dcbd07620ad$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $8a2e0dcbd07620ad$var$IS_REACT_19 = /* @__PURE__ */ $i7uhG.version.startsWith("19");
var $8a2e0dcbd07620ad$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($8a2e0dcbd07620ad$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $8a2e0dcbd07620ad$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $8a2e0dcbd07620ad$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $8a2e0dcbd07620ad$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $8a2e0dcbd07620ad$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $8a2e0dcbd07620ad$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $8a2e0dcbd07620ad$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $8a2e0dcbd07620ad$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $8a2e0dcbd07620ad$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $8a2e0dcbd07620ad$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $8a2e0dcbd07620ad$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $8a2e0dcbd07620ad$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $8a2e0dcbd07620ad$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $8a2e0dcbd07620ad$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $8a2e0dcbd07620ad$var$ForwardRef = $8a2e0dcbd07620ad$var$REACT_FORWARD_REF_TYPE;
var $8a2e0dcbd07620ad$var$Memo = $8a2e0dcbd07620ad$var$REACT_MEMO_TYPE;
function $8a2e0dcbd07620ad$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $8a2e0dcbd07620ad$var$REACT_FRAGMENT_TYPE || type === $8a2e0dcbd07620ad$var$REACT_PROFILER_TYPE || type === $8a2e0dcbd07620ad$var$REACT_STRICT_MODE_TYPE || type === $8a2e0dcbd07620ad$var$REACT_SUSPENSE_TYPE || type === $8a2e0dcbd07620ad$var$REACT_SUSPENSE_LIST_TYPE || type === $8a2e0dcbd07620ad$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $8a2e0dcbd07620ad$var$REACT_LAZY_TYPE || type.$$typeof === $8a2e0dcbd07620ad$var$REACT_MEMO_TYPE || type.$$typeof === $8a2e0dcbd07620ad$var$REACT_CONTEXT_TYPE || type.$$typeof === $8a2e0dcbd07620ad$var$REACT_CONSUMER_TYPE || type.$$typeof === $8a2e0dcbd07620ad$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $8a2e0dcbd07620ad$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $8a2e0dcbd07620ad$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $8a2e0dcbd07620ad$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $8a2e0dcbd07620ad$var$REACT_FRAGMENT_TYPE:
                    case $8a2e0dcbd07620ad$var$REACT_PROFILER_TYPE:
                    case $8a2e0dcbd07620ad$var$REACT_STRICT_MODE_TYPE:
                    case $8a2e0dcbd07620ad$var$REACT_SUSPENSE_TYPE:
                    case $8a2e0dcbd07620ad$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $8a2e0dcbd07620ad$var$REACT_CONTEXT_TYPE:
                            case $8a2e0dcbd07620ad$var$REACT_FORWARD_REF_TYPE:
                            case $8a2e0dcbd07620ad$var$REACT_LAZY_TYPE:
                            case $8a2e0dcbd07620ad$var$REACT_MEMO_TYPE:
                                return object;
                            case $8a2e0dcbd07620ad$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $8a2e0dcbd07620ad$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $8a2e0dcbd07620ad$var$isContextConsumer(object) {
    return $8a2e0dcbd07620ad$var$IS_REACT_19 ? $8a2e0dcbd07620ad$var$typeOf(object) === $8a2e0dcbd07620ad$var$REACT_CONSUMER_TYPE : $8a2e0dcbd07620ad$var$typeOf(object) === $8a2e0dcbd07620ad$var$REACT_CONTEXT_TYPE;
}
function $8a2e0dcbd07620ad$var$isMemo(object) {
    return $8a2e0dcbd07620ad$var$typeOf(object) === $8a2e0dcbd07620ad$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $8a2e0dcbd07620ad$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $8a2e0dcbd07620ad$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $8a2e0dcbd07620ad$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $8a2e0dcbd07620ad$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $8a2e0dcbd07620ad$var$verify(mapStateToProps, "mapStateToProps");
    $8a2e0dcbd07620ad$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $8a2e0dcbd07620ad$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $8a2e0dcbd07620ad$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $8a2e0dcbd07620ad$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $8a2e0dcbd07620ad$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $8a2e0dcbd07620ad$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $8a2e0dcbd07620ad$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $8a2e0dcbd07620ad$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $8a2e0dcbd07620ad$var$verifyPlainObject(value, displayName, methodName) {
    if (!$8a2e0dcbd07620ad$var$isPlainObject(value)) $8a2e0dcbd07620ad$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $8a2e0dcbd07620ad$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $8a2e0dcbd07620ad$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $8a2e0dcbd07620ad$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $8a2e0dcbd07620ad$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $8a2e0dcbd07620ad$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $8a2e0dcbd07620ad$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $8a2e0dcbd07620ad$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $8a2e0dcbd07620ad$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $8a2e0dcbd07620ad$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $8a2e0dcbd07620ad$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $8a2e0dcbd07620ad$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $8a2e0dcbd07620ad$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $8a2e0dcbd07620ad$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $8a2e0dcbd07620ad$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $8a2e0dcbd07620ad$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $8a2e0dcbd07620ad$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $8a2e0dcbd07620ad$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $8a2e0dcbd07620ad$var$__spreadValues($8a2e0dcbd07620ad$var$__spreadValues($8a2e0dcbd07620ad$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $8a2e0dcbd07620ad$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $8a2e0dcbd07620ad$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$8a2e0dcbd07620ad$var$defaultMergeProps : typeof mergeProps === "function" ? $8a2e0dcbd07620ad$var$wrapMergePropsFunc(mergeProps) : $8a2e0dcbd07620ad$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $8a2e0dcbd07620ad$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $8a2e0dcbd07620ad$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $8a2e0dcbd07620ad$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $8a2e0dcbd07620ad$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $8a2e0dcbd07620ad$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $8a2e0dcbd07620ad$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $8a2e0dcbd07620ad$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $8a2e0dcbd07620ad$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $8a2e0dcbd07620ad$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $8a2e0dcbd07620ad$var$isDOM = /* @__PURE__ */ $8a2e0dcbd07620ad$var$canUseDOM();
var $8a2e0dcbd07620ad$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $8a2e0dcbd07620ad$var$isReactNative = /* @__PURE__ */ $8a2e0dcbd07620ad$var$isRunningInReactNative();
var $8a2e0dcbd07620ad$var$getUseIsomorphicLayoutEffect = ()=>$8a2e0dcbd07620ad$var$isDOM || $8a2e0dcbd07620ad$var$isReactNative ? $i7uhG.useLayoutEffect : $i7uhG.useEffect;
var $8a2e0dcbd07620ad$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $8a2e0dcbd07620ad$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $8a2e0dcbd07620ad$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $8a2e0dcbd07620ad$export$d36bdfa510afb180(objA, objB) {
    if ($8a2e0dcbd07620ad$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$8a2e0dcbd07620ad$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $8a2e0dcbd07620ad$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $8a2e0dcbd07620ad$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $8a2e0dcbd07620ad$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $8a2e0dcbd07620ad$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $8a2e0dcbd07620ad$var$TYPE_STATICS = {
    [$8a2e0dcbd07620ad$var$ForwardRef]: $8a2e0dcbd07620ad$var$FORWARD_REF_STATICS,
    [$8a2e0dcbd07620ad$var$Memo]: $8a2e0dcbd07620ad$var$MEMO_STATICS
};
function $8a2e0dcbd07620ad$var$getStatics(component) {
    if ($8a2e0dcbd07620ad$var$isMemo(component)) return $8a2e0dcbd07620ad$var$MEMO_STATICS;
    return $8a2e0dcbd07620ad$var$TYPE_STATICS[component["$$typeof"]] || $8a2e0dcbd07620ad$var$REACT_STATICS;
}
var $8a2e0dcbd07620ad$var$defineProperty = Object.defineProperty;
var $8a2e0dcbd07620ad$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $8a2e0dcbd07620ad$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $8a2e0dcbd07620ad$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $8a2e0dcbd07620ad$var$getPrototypeOf = Object.getPrototypeOf;
var $8a2e0dcbd07620ad$var$objectPrototype = Object.prototype;
function $8a2e0dcbd07620ad$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($8a2e0dcbd07620ad$var$objectPrototype) {
            const inheritedComponent = $8a2e0dcbd07620ad$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $8a2e0dcbd07620ad$var$objectPrototype) $8a2e0dcbd07620ad$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $8a2e0dcbd07620ad$var$getOwnPropertyNames(sourceComponent);
        if ($8a2e0dcbd07620ad$var$getOwnPropertySymbols) keys = keys.concat($8a2e0dcbd07620ad$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $8a2e0dcbd07620ad$var$getStatics(targetComponent);
        const sourceStatics = $8a2e0dcbd07620ad$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$8a2e0dcbd07620ad$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $8a2e0dcbd07620ad$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $8a2e0dcbd07620ad$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $8a2e0dcbd07620ad$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $8a2e0dcbd07620ad$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $8a2e0dcbd07620ad$var$getContext() {
    var _a;
    if (!$i7uhG.createContext) return {};
    const contextMap = (_a = $8a2e0dcbd07620ad$var$gT[$8a2e0dcbd07620ad$var$ContextKey]) != null ? _a : $8a2e0dcbd07620ad$var$gT[$8a2e0dcbd07620ad$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($i7uhG.createContext);
    if (!realContext) {
        realContext = $i7uhG.createContext(null);
        contextMap.set($i7uhG.createContext, realContext);
    }
    return realContext;
}
var $8a2e0dcbd07620ad$export$cc80c08dc91f1c00 = /* @__PURE__ */ $8a2e0dcbd07620ad$var$getContext();
// src/components/connect.tsx
var $8a2e0dcbd07620ad$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $8a2e0dcbd07620ad$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $8a2e0dcbd07620ad$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $8a2e0dcbd07620ad$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $8a2e0dcbd07620ad$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $8a2e0dcbd07620ad$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $8a2e0dcbd07620ad$var$strictEqual(a, b) {
    return a === b;
}
var $8a2e0dcbd07620ad$var$hasWarnedAboutDeprecatedPureOption = false;
function $8a2e0dcbd07620ad$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $8a2e0dcbd07620ad$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $8a2e0dcbd07620ad$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $8a2e0dcbd07620ad$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $8a2e0dcbd07620ad$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $8a2e0dcbd07620ad$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $8a2e0dcbd07620ad$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $8a2e0dcbd07620ad$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $8a2e0dcbd07620ad$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $i7uhG.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $8a2e0dcbd07620ad$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $i7uhG.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $i7uhG.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $i7uhG.useMemo(()=>{
                return $8a2e0dcbd07620ad$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $i7uhG.useMemo(()=>{
                if (!shouldHandleStateChanges) return $8a2e0dcbd07620ad$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $8a2e0dcbd07620ad$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $i7uhG.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $8a2e0dcbd07620ad$var$__spreadProps($8a2e0dcbd07620ad$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $i7uhG.useRef(void 0);
            const lastWrapperProps = $i7uhG.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $i7uhG.useRef(void 0);
            const renderIsScheduled = $i7uhG.useRef(false);
            const isMounted = $i7uhG.useRef(false);
            const latestSubscriptionCallbackError = $i7uhG.useRef(void 0);
            $8a2e0dcbd07620ad$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $i7uhG.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $i7uhG.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $8a2e0dcbd07620ad$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $8a2e0dcbd07620ad$var$useIsomorphicLayoutEffectWithArgs($8a2e0dcbd07620ad$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $i7uhG.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $8a2e0dcbd07620ad$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $i7uhG.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $i7uhG.createElement(WrappedComponent, $8a2e0dcbd07620ad$var$__spreadProps($8a2e0dcbd07620ad$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $i7uhG.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $i7uhG.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $i7uhG.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $i7uhG.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $i7uhG.createElement(Connect, $8a2e0dcbd07620ad$var$__spreadProps($8a2e0dcbd07620ad$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $8a2e0dcbd07620ad$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $8a2e0dcbd07620ad$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $8a2e0dcbd07620ad$export$64605811ab45167f = $8a2e0dcbd07620ad$var$connect;
// src/components/Provider.tsx
function $8a2e0dcbd07620ad$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $i7uhG.useMemo(()=>{
        const subscription = $8a2e0dcbd07620ad$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $i7uhG.useMemo(()=>store.getState(), [
        store
    ]);
    $8a2e0dcbd07620ad$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $8a2e0dcbd07620ad$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $i7uhG.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $8a2e0dcbd07620ad$export$2881499e37b75b9a = $8a2e0dcbd07620ad$var$Provider;
// src/hooks/useReduxContext.ts
function $8a2e0dcbd07620ad$var$createReduxContextHook(context = $8a2e0dcbd07620ad$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $i7uhG.useContext(context);
        return contextValue;
    };
}
var $8a2e0dcbd07620ad$var$useReduxContext = /* @__PURE__ */ $8a2e0dcbd07620ad$var$createReduxContextHook();
// src/hooks/useStore.ts
function $8a2e0dcbd07620ad$export$671dba69185d0304(context = $8a2e0dcbd07620ad$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $8a2e0dcbd07620ad$export$cc80c08dc91f1c00 ? $8a2e0dcbd07620ad$var$useReduxContext : // @ts-ignore
    $8a2e0dcbd07620ad$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $8a2e0dcbd07620ad$export$6ccbb43953eebf8 = /* @__PURE__ */ $8a2e0dcbd07620ad$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $8a2e0dcbd07620ad$export$bc9b55530897c558(context = $8a2e0dcbd07620ad$export$cc80c08dc91f1c00) {
    const useStore2 = context === $8a2e0dcbd07620ad$export$cc80c08dc91f1c00 ? $8a2e0dcbd07620ad$export$6ccbb43953eebf8 : $8a2e0dcbd07620ad$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $8a2e0dcbd07620ad$export$8ad76b76a4c905f8 = /* @__PURE__ */ $8a2e0dcbd07620ad$export$bc9b55530897c558();
var $8a2e0dcbd07620ad$var$refEquality = (a, b)=>a === b;
function $8a2e0dcbd07620ad$export$2b53f90d2bd1cbfb(context = $8a2e0dcbd07620ad$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $8a2e0dcbd07620ad$export$cc80c08dc91f1c00 ? $8a2e0dcbd07620ad$var$useReduxContext : $8a2e0dcbd07620ad$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $8a2e0dcbd07620ad$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $i7uhG.useRef(true);
        const wrappedSelector = $i7uhG.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $5267a1cd56fb756c$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $i7uhG.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $8a2e0dcbd07620ad$export$2105062e25df4afe = /* @__PURE__ */ $8a2e0dcbd07620ad$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $8a2e0dcbd07620ad$export$712ea50be43a7858 = $8a2e0dcbd07620ad$var$defaultNoopBatch;


const $ec8fedabc841ae67$var$Header = ()=>{
    const [btnName, setbtnName] = (0, $i7uhG.useState)("login");
    const onlineStatus = (0, $c9030a919f491fd7$export$2e2bcd8739ae039)();
    //to use in cart side as value of store need to subscribr the store
    const cartcount = (0, $8a2e0dcbd07620ad$export$2105062e25df4afe)((store)=>store.cart.items);
    return /*#__PURE__*/ (0, $R1mjg.jsx)("header", {
        className: "section-navbar",
        children: /*#__PURE__*/ (0, $R1mjg.jsxs)("div", {
            className: "flex justify-between items-center px-6 py-7 bg-green-100",
            children: [
                /*#__PURE__*/ (0, $R1mjg.jsx)("div", {
                    className: "navbar-brand",
                    children: /*#__PURE__*/ (0, $R1mjg.jsx)("a", {
                        href: "./",
                        children: /*#__PURE__*/ (0, $R1mjg.jsx)("img", {
                            src: (0, $71f2a50233d21256$export$8b0f2287631b26b6),
                            alt: "LOGO",
                            width: "200px",
                            height: "300px"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $R1mjg.jsx)("nav", {
                    className: "navbar",
                    children: /*#__PURE__*/ (0, $R1mjg.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $R1mjg.jsxs)("li", {
                                className: "status",
                                children: [
                                    "online status :",
                                    onlineStatus ? "\uD83D\uDC9A" : "\u2764\uFE0F"
                                ]
                            }),
                            /*#__PURE__*/ (0, $R1mjg.jsx)("li", {
                                className: "nav-item",
                                children: /*#__PURE__*/ (0, $R1mjg.jsx)((0, $b9ce296f3422b46b$export$a6c7ac8248d6e38a), {
                                    className: "nav-link",
                                    to: "",
                                    children: "home"
                                })
                            }),
                            /*#__PURE__*/ (0, $R1mjg.jsx)("li", {
                                className: "nav-item",
                                children: /*#__PURE__*/ (0, $R1mjg.jsx)((0, $b9ce296f3422b46b$export$a6c7ac8248d6e38a), {
                                    className: "nav-link",
                                    to: "/contact",
                                    children: "contact"
                                })
                            }),
                            /*#__PURE__*/ (0, $R1mjg.jsx)("li", {
                                className: "nav-item",
                                children: /*#__PURE__*/ (0, $R1mjg.jsx)((0, $b9ce296f3422b46b$export$a6c7ac8248d6e38a), {
                                    className: "nav-link",
                                    to: "/services",
                                    children: "services"
                                })
                            }),
                            /*#__PURE__*/ (0, $R1mjg.jsx)("li", {
                                className: "nav-item",
                                children: /*#__PURE__*/ (0, $R1mjg.jsx)((0, $b9ce296f3422b46b$export$a6c7ac8248d6e38a), {
                                    className: "nav-link",
                                    to: "/about",
                                    children: "about"
                                })
                            }),
                            /*#__PURE__*/ (0, $R1mjg.jsx)("li", {
                                className: "nav-item",
                                children: /*#__PURE__*/ (0, $R1mjg.jsxs)((0, $b9ce296f3422b46b$export$a6c7ac8248d6e38a), {
                                    className: "nav-link",
                                    to: "/cart",
                                    children: [
                                        "cart(",
                                        cartcount.length,
                                        ")"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $R1mjg.jsx)("li", {
                                className: "nav-item",
                                children: /*#__PURE__*/ (0, $R1mjg.jsx)((0, $b9ce296f3422b46b$export$a6c7ac8248d6e38a), {
                                    className: "nav-link",
                                    to: "/grocery",
                                    children: "Grocery"
                                })
                            }),
                            /*#__PURE__*/ (0, $R1mjg.jsx)("button", {
                                className: "bg-blue-800 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-lg shadow-md hover:shadow-lg transition duration-300 ease-in-out",
                                onClick: ()=>{
                                    btnName === "login" ? setbtnName("logout") : setbtnName("login");
                                },
                                children: btnName
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $ec8fedabc841ae67$export$2e2bcd8739ae039 = $ec8fedabc841ae67$var$Header;



var $R1mjg = parcelRequire("R1mjg");

var $R1mjg = parcelRequire("R1mjg");

const $6110d401c0c7fa44$var$Restuarantcart = (props)=>{
    const { resdata: resdata } = props;
    const { name: name, cuisines: cuisines, avgRating: avgRating, areaName: areaName, costForTwo: costForTwo, cloudinaryImageId: cloudinaryImageId } = resdata?.info;
    //if not destructure then we would have used peops.resdata.info.name as props receive the data from render by
    //<Restauurantcart resdata={restaurant} /> but if by threee dot <Restauurantcart {...restaurant} /> them every key-value sent separetly not
    //as a single object so can use props.info.name
    return /*#__PURE__*/ (0, $R1mjg.jsxs)("div", {
        className: "rounded-lg w-[220px] h-[320px] ml-[10px] mb-2 mr-2 bg-blue-100 p-[6px] hover:shadow-[0_4px_8px_rgba(0,0,0,0.1),0_6px_20px_rgba(0,0,0,0.19)] hover:cursor-pointer ",
        children: [
            /*#__PURE__*/ (0, $R1mjg.jsx)("img", {
                className: "res-logo",
                src: (0, $71f2a50233d21256$export$ee7e7ea446877ea7) + cloudinaryImageId
            }),
            /*#__PURE__*/ (0, $R1mjg.jsx)("h2", {
                className: "text-base font-mono text-gray-900",
                children: name
            }),
            /*#__PURE__*/ (0, $R1mjg.jsx)("h3", {
                className: "text-base font-medium text-gray-800",
                children: cuisines.join("  ,   ")
            }),
            /*#__PURE__*/ (0, $R1mjg.jsx)("h3", {
                className: "text-base font-medium text-gray-800",
                children: avgRating
            }),
            /*#__PURE__*/ (0, $R1mjg.jsx)("h3", {
                className: "text-base font-medium text-gray-800",
                children: areaName
            }),
            /*#__PURE__*/ (0, $R1mjg.jsx)("h3", {
                className: "text-base font-medium text-gray-800",
                children: costForTwo
            })
        ]
    });
};
const $6110d401c0c7fa44$export$cbace1feb04360aa = (Restuarantcart)=>{
    return (props)=>{
        return /*#__PURE__*/ (0, $R1mjg.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $R1mjg.jsx)("label", {
                    className: "label",
                    children: "Recommended"
                }),
                /*#__PURE__*/ (0, $R1mjg.jsx)(Restuarantcart, {
                    ...props
                })
            ]
        });
    };
};
var $6110d401c0c7fa44$export$2e2bcd8739ae039 = $6110d401c0c7fa44$var$Restuarantcart;



var $i7uhG = parcelRequire("i7uhG");

var $R1mjg = parcelRequire("R1mjg");
parcelRequire("i7uhG");

var $i7uhG = parcelRequire("i7uhG");
var $ea26611a4ff88c75$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ea26611a4ff88c75$var$ReactIs, $ea26611a4ff88c75$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$ea26611a4ff88c75$exports = (parcelRequire("ftNHP"))();


function $cf65bf8d4d365af4$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
var $cf65bf8d4d365af4$var$classnames = $cf65bf8d4d365af4$var$createCommonjsModule(function(module) {
    /*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
        var hasOwn = {}.hasOwnProperty;
        function classNames() {
            var classes = [];
            for(var i = 0; i < arguments.length; i++){
                var arg = arguments[i];
                if (!arg) continue;
                var argType = typeof arg;
                if (argType === 'string' || argType === 'number') classes.push(arg);
                else if (Array.isArray(arg)) {
                    if (arg.length) {
                        var inner = classNames.apply(null, arg);
                        if (inner) classes.push(inner);
                    }
                } else if (argType === 'object') {
                    if (arg.toString === Object.prototype.toString) {
                        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                    } else classes.push(arg.toString());
                }
            }
            return classes.join(' ');
        }
        if (module.exports) {
            classNames.default = classNames;
            module.exports = classNames;
        } else window.classNames = classNames;
    })();
});
function $cf65bf8d4d365af4$var$styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === 'undefined') return;
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    if (insertAt === 'top') {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var $cf65bf8d4d365af4$var$css = ".shimmer-button {\n  border-radius: 4px;\n  height: 38px;\n  width: 120px;\n  margin-bottom: 20px; }\n  .shimmer-button--sm {\n    border-radius: 3px;\n    height: 31px;\n    width: 100px; }\n  .shimmer-button--lg {\n    height: 48px;\n    width: 140px;\n    border-radius: 5px; }\n";
$cf65bf8d4d365af4$var$styleInject($cf65bf8d4d365af4$var$css);
var $cf65bf8d4d365af4$var$defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $cf65bf8d4d365af4$export$399c7d54452eb442 = function ShimmerButton(_ref) {
    var size = _ref.size;
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        className: $cf65bf8d4d365af4$var$classnames($cf65bf8d4d365af4$var$defineProperty({
            "shimmer shimmer-button": true
        }, "shimmer-button--" + size, true))
    });
};
$cf65bf8d4d365af4$export$399c7d54452eb442.propTypes = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).oneOf([
        "lg",
        "md",
        "sm"
    ])
};
$cf65bf8d4d365af4$export$399c7d54452eb442.defaultProps = {
    size: "md"
};
var $cf65bf8d4d365af4$export$697f501f4c22166d = function ShimmerCircularImage(_ref) {
    var size = _ref.size, center = _ref.center, className = _ref.className;
    var style = {};
    if (size) {
        style.width = size + "px";
        style.height = size + "px";
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        className: $cf65bf8d4d365af4$var$classnames({
            "text-center": center
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        style: style,
        className: $cf65bf8d4d365af4$var$classnames($cf65bf8d4d365af4$var$defineProperty({
            "shimmer shimmer-avatar": true
        }, className, className))
    }));
};
$cf65bf8d4d365af4$export$697f501f4c22166d.propTypes = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).number,
    center: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).string
};
$cf65bf8d4d365af4$export$697f501f4c22166d.defaultProps = {
    center: false,
    size: 80
};
var $cf65bf8d4d365af4$export$973ab931129fa7e9 = function ShimmerThumbnail(_ref) {
    var height = _ref.height, width = _ref.width, center = _ref.center, className = _ref.className, fitOnFrame = _ref.fitOnFrame, rounded = _ref.rounded;
    var style = {};
    if (height) style.height = height + "px";
    if (width) style.width = width + "px";
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        className: $cf65bf8d4d365af4$var$classnames({
            "h-100": fitOnFrame,
            "text-center ": center
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        className: $cf65bf8d4d365af4$var$classnames($cf65bf8d4d365af4$var$defineProperty({
            "h-100": fitOnFrame,
            "shimmer shimmer-thumbnail": true,
            "border-rounded": rounded
        }, className, className)),
        style: style
    }));
};
$cf65bf8d4d365af4$export$973ab931129fa7e9.propTypes = {
    height: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).number,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).number,
    center: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).string,
    fitOnFrame: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool,
    rounded: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool
};
$cf65bf8d4d365af4$export$973ab931129fa7e9.defaultProps = {
    canter: false,
    fitOnFrame: false,
    rounded: false,
    height: 250
};
var $cf65bf8d4d365af4$var$css$1 = ".shimmer-avatar {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  margin-bottom: 20px;\n  display: inline-block; }\n\n.shimmer-thumbnail {\n  min-width: 80px;\n  width: 100%;\n  height: 200px;\n  margin-bottom: 20px;\n  display: inline-block; }\n";
$cf65bf8d4d365af4$var$styleInject($cf65bf8d4d365af4$var$css$1);
var $cf65bf8d4d365af4$var$css$2 = ".shimmer-title {\n  margin-bottom: 20px; }\n  .shimmer-title--secondary {\n    margin-bottom: 20px; }\n    .shimmer-title--secondary .shimmer-title-line {\n      height: 16px; }\n  .shimmer-title-line {\n    width: 100%;\n    height: 24px;\n    border-radius: 20px; }\n    .shimmer-title-line:first-child {\n      width: 100% !important; }\n    .shimmer-title-line:last-child {\n      width: 40%; }\n";
$cf65bf8d4d365af4$var$styleInject($cf65bf8d4d365af4$var$css$2);
var $cf65bf8d4d365af4$export$62bbbc04d7c5e7c6 = function ShimmerTitle(_ref) {
    var _classNames;
    var line = _ref.line, gap = _ref.gap, variant = _ref.variant, className = _ref.className;
    var renderLines = function renderLines() {
        var title_lines = [];
        for(var index = 0; index < line; index++)title_lines.push((0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
            className: "shimmer shimmer-title-line",
            key: index
        }));
        return title_lines;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        className: $cf65bf8d4d365af4$var$classnames((_classNames = {
            grid: true,
            "shimmer-title": variant === "primary",
            "shimmer-title--secondary": variant === "secondary"
        }, $cf65bf8d4d365af4$var$defineProperty(_classNames, "grid-gap-" + gap, gap), $cf65bf8d4d365af4$var$defineProperty(_classNames, className, className), _classNames))
    }, renderLines());
};
$cf65bf8d4d365af4$export$62bbbc04d7c5e7c6.propTypes = {
    line: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).number,
    gap: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).oneOf([
        10,
        15,
        20,
        30
    ]),
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).oneOf([
        "primary",
        "secondary"
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).string
};
$cf65bf8d4d365af4$export$62bbbc04d7c5e7c6.defaultProps = {
    line: 2,
    gap: 10,
    variant: "primary"
};
var $cf65bf8d4d365af4$var$css$3 = ".shimmer-card {\n  border-radius: 8px;\n  box-shadow: 0 0px 10px rgba(0, 0, 0, 0.1);\n  background-color: #ffffff;\n  width: 100%; }\n  .shimmer-card:not(:first-child) {\n    margin-top: 30px; }\n  .shimmer-card--content-center {\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center; }\n    .shimmer-card--content-center * {\n      width: 100%;\n      margin: auto; }\n";
$cf65bf8d4d365af4$var$styleInject($cf65bf8d4d365af4$var$css$3);
var $cf65bf8d4d365af4$export$f71f704701cc7071 = function ShimmerCard(_ref) {
    var _classNames;
    var children = _ref.children, className = _ref.className, paddingSize = _ref.paddingSize;
    if (!children) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        className: $cf65bf8d4d365af4$var$classnames((_classNames = {
            "shimmer-card": true
        }, $cf65bf8d4d365af4$var$defineProperty(_classNames, "p-" + paddingSize, paddingSize), $cf65bf8d4d365af4$var$defineProperty(_classNames, className, className), _classNames))
    }, children);
};
$cf65bf8d4d365af4$export$f71f704701cc7071.propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).array
    ]).isRequired,
    paddingSize: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).oneOf([
        false,
        20,
        30
    ])
};
$cf65bf8d4d365af4$export$f71f704701cc7071.defaultProps = {
    paddingSize: false
};
var $cf65bf8d4d365af4$export$8c9c634ed03dd9d = function ShimmerSimpleGallery(_ref) {
    var _classNames, _classNames2;
    var row = _ref.row, col = _ref.col, gap = _ref.gap, className = _ref.className, fitOnFrame = _ref.fitOnFrame, imageType = _ref.imageType, imageHeight = _ref.imageHeight, caption = _ref.caption, card = _ref.card;
    var renderPhotos = function renderPhotos() {
        var photos = [];
        var items = row * col;
        for(var index = 0; index < items; index++)photos.push((0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
            key: index
        }, imageType === "thumbnail" && (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$973ab931129fa7e9, {
            key: index,
            fitOnFrame: fitOnFrame,
            height: imageHeight,
            className: $cf65bf8d4d365af4$var$classnames({
                "m-0": true
            })
        }), imageType === "circular" && (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$697f501f4c22166d, {
            size: imageHeight,
            center: true
        }), caption && (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$62bbbc04d7c5e7c6, {
            variant: "secondary",
            className: $cf65bf8d4d365af4$var$classnames({
                "mt-15": imageType === "thumbnail",
                "w-50 ml-auto mr-auto circular-image-caption": imageType === "circular"
            })
        })));
        return photos;
    };
    if (!card) return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        className: $cf65bf8d4d365af4$var$classnames((_classNames = {
            grid: true
        }, $cf65bf8d4d365af4$var$defineProperty(_classNames, "grid-gap-" + gap, true), $cf65bf8d4d365af4$var$defineProperty(_classNames, "grid-column-" + col, true), $cf65bf8d4d365af4$var$defineProperty(_classNames, className, className), _classNames))
    }, renderPhotos());
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f71f704701cc7071, {
        paddingSize: 20
    }, (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        className: $cf65bf8d4d365af4$var$classnames((_classNames2 = {
            grid: true
        }, $cf65bf8d4d365af4$var$defineProperty(_classNames2, "grid-gap-" + gap, true), $cf65bf8d4d365af4$var$defineProperty(_classNames2, "grid-column-" + col, true), $cf65bf8d4d365af4$var$defineProperty(_classNames2, className, className), _classNames2))
    }, renderPhotos()));
};
$cf65bf8d4d365af4$export$8c9c634ed03dd9d.propTypes = {
    row: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).number,
    col: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).oneOf([
        2,
        3,
        4
    ]),
    gap: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).oneOf([
        20,
        30
    ]),
    fitOnFrame: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool,
    imageType: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).oneOf([
        "thumbnail",
        "circular"
    ]),
    imageHeight: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).number,
    caption: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool,
    card: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool
};
$cf65bf8d4d365af4$export$8c9c634ed03dd9d.defaultProps = {
    row: 3,
    col: 3,
    gap: 20,
    fitOnFrame: false,
    imageType: "thumbnail",
    caption: false,
    card: false
};
var $cf65bf8d4d365af4$var$css$4 = ".shimmer-gallery-puzzle {\n  height: 540px; }\n\n.circular-image-caption .shimmer-title-line {\n  margin: auto; }\n";
$cf65bf8d4d365af4$var$styleInject($cf65bf8d4d365af4$var$css$4);
var $cf65bf8d4d365af4$export$c09226fd0b9248fd = function ShimmerFeaturedGallery(_ref) {
    var row = _ref.row, col = _ref.col, gap = _ref.gap, card = _ref.card, frameHeight = _ref.frameHeight;
    var style = {};
    if (frameHeight) style.height = frameHeight + "px";
    var renderContent = function renderContent() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
            className: "shimmer-row shimmer-gallery-puzzle",
            style: style
        }, (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
            className: "shimmer-col flex-1"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$973ab931129fa7e9, {
            className: "h-100",
            fitOnFrame: true
        })), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
            className: "shimmer-col flex-1"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$8c9c634ed03dd9d, {
            row: row,
            col: col,
            gap: gap,
            className: "h-100",
            fitOnFrame: true
        })));
    };
    if (!card) return renderContent();
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f71f704701cc7071, {
        paddingSize: 20
    }, renderContent());
};
$cf65bf8d4d365af4$export$c09226fd0b9248fd.propTypes = {
    row: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).number,
    col: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).oneOf([
        2,
        3,
        4
    ]),
    gap: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).oneOf([
        20,
        30
    ]),
    card: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool,
    frameHeight: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).number
};
$cf65bf8d4d365af4$export$c09226fd0b9248fd.defaultProps = {
    card: false,
    row: 2,
    col: 2,
    gap: 20,
    frameHeight: 600
};
var $cf65bf8d4d365af4$export$b1d53d64a35cfa03 = function ShimmerTableCol() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        className: "shimmer shimmer-table-col"
    });
};
var $cf65bf8d4d365af4$export$1f21ce2ff8f10a8e = function ShimmerTableRow(_ref) {
    var col = _ref.col, header = _ref.header;
    var renderColumns = function renderColumns() {
        var columns = [];
        for(var index = 0; index < col; index++)columns.push((0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$b1d53d64a35cfa03, {
            key: index
        }));
        return columns;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        className: $cf65bf8d4d365af4$var$classnames({
            "shimmer-table-row": true,
            "shimmer-table-row--header": header
        })
    }, renderColumns());
};
$cf65bf8d4d365af4$export$1f21ce2ff8f10a8e.propTypes = {
    col: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).number.isRequired,
    header: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool
};
$cf65bf8d4d365af4$export$1f21ce2ff8f10a8e.defaultProps = {
    col: 5,
    header: false
};
var $cf65bf8d4d365af4$var$css$5 = ".shimmer-table-row {\n  box-shadow: 0 0px 10px rgba(0, 0, 0, 0.1);\n  display: flex;\n  padding: 25px 0;\n  background-color: #ffffff;\n  border-radius: 5px;\n  margin-bottom: 20px; }\n  .shimmer-table-row--header {\n    background-color: transparent;\n    box-shadow: none;\n    margin: 0; }\n  .shimmer-table-row > .shimmer {\n    margin: 0 30px; }\n\n.shimmer-table-col {\n  width: 100%;\n  height: 10px;\n  border-radius: 10px; }\n";
$cf65bf8d4d365af4$var$styleInject($cf65bf8d4d365af4$var$css$5);
var $cf65bf8d4d365af4$export$49f46bfa35d9f4ed = function ShimmerTable(_ref) {
    var row = _ref.row, col = _ref.col;
    var renderRows = function renderRows() {
        var rows = [];
        for(var index = 0; index < row; index++)rows.push((0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$1f21ce2ff8f10a8e, {
            col: col,
            key: index
        }));
        return rows;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$1f21ce2ff8f10a8e, {
        col: col,
        header: true
    }), renderRows());
};
$cf65bf8d4d365af4$export$49f46bfa35d9f4ed.propTypes = {
    row: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).number,
    col: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).number
};
$cf65bf8d4d365af4$export$49f46bfa35d9f4ed.defaultProps = {
    row: 5,
    col: 5
};
var $cf65bf8d4d365af4$var$css$6 = ".shimmer-badge {\n  width: 80px;\n  height: 24px;\n  border-radius: 20px;\n  margin-bottom: 20px; }\n";
$cf65bf8d4d365af4$var$styleInject($cf65bf8d4d365af4$var$css$6);
var $cf65bf8d4d365af4$export$72eb2c1f271ac333 = function ShimmerBadge(_ref) {
    var width = _ref.width;
    var style = {};
    if (width) style.width = width + "px";
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        className: "shimmer shimmer-badge",
        style: style
    });
};
$cf65bf8d4d365af4$export$72eb2c1f271ac333.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).number
};
var $cf65bf8d4d365af4$var$css$7 = ".shimmer-text {\n  margin-bottom: 30px; }\n  .shimmer-text-line {\n    width: 100%;\n    height: 8px;\n    border-radius: 10px; }\n    .shimmer-text-line:first-child {\n      width: 100% !important; }\n    .shimmer-text-line:last-child {\n      width: 40%; }\n";
$cf65bf8d4d365af4$var$styleInject($cf65bf8d4d365af4$var$css$7);
var $cf65bf8d4d365af4$export$f35c7d979dec8662 = function ShimmerText(_ref) {
    var _classNames;
    var line = _ref.line, gap = _ref.gap, className = _ref.className;
    var renderLines = function renderLines() {
        var text_lines = [];
        for(var index = 0; index < line; index++)text_lines.push((0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
            className: "shimmer shimmer-text-line",
            key: index
        }));
        return text_lines;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        className: $cf65bf8d4d365af4$var$classnames((_classNames = {
            "grid shimmer-text": true
        }, $cf65bf8d4d365af4$var$defineProperty(_classNames, "grid-gap-" + gap, gap), $cf65bf8d4d365af4$var$defineProperty(_classNames, className, className), _classNames))
    }, renderLines());
};
$cf65bf8d4d365af4$export$f35c7d979dec8662.propTypes = {
    line: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).number,
    gap: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).oneOf([
        10,
        15,
        20,
        30
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).string
};
$cf65bf8d4d365af4$export$f35c7d979dec8662.defaultProps = {
    line: 5,
    gap: 15
};
var $cf65bf8d4d365af4$var$css$8 = ".shimmer-separator {\n  height: 1px;\n  background-color: #dddddd;\n  margin: 40px 0; }\n";
$cf65bf8d4d365af4$var$styleInject($cf65bf8d4d365af4$var$css$8);
var $cf65bf8d4d365af4$export$f2de27eb84c8765a = function ShimmerSeparator() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        className: "shimmer-separator"
    });
};
var $cf65bf8d4d365af4$export$7f84737e62455c69 = function ShimmerSocialPost(_ref) {
    var type = _ref.type, title = _ref.title;
    var renderContents = function renderContents() {
        if (type === "image") return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$973ab931129fa7e9, {
            height: 300,
            className: "m-02"
        });
        else if (type === "text") return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f35c7d979dec8662, {
            line: 13,
            className: "p-15"
        });
        else return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f35c7d979dec8662, {
            line: 3,
            className: "p-15"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$973ab931129fa7e9, {
            height: 300,
            className: "m-02"
        }));
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f71f704701cc7071, null, (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        className: "p-15"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        className: "flex"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$697f501f4c22166d, null), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        className: "flex-1 p-15"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$62bbbc04d7c5e7c6, {
        variant: "secondary",
        className: "w-40"
    }))), title && (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$62bbbc04d7c5e7c6, {
        line: 1,
        className: "w-40 m-0"
    })), renderContents(), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        className: "p-15 flex flex-content-between"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$62bbbc04d7c5e7c6, {
        line: 1,
        className: "w-10",
        variant: "secondary"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$62bbbc04d7c5e7c6, {
        line: 1,
        className: "w-10",
        variant: "secondary"
    })));
};
$cf65bf8d4d365af4$export$7f84737e62455c69.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).oneOf([
        "text",
        "image",
        "both"
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool
};
$cf65bf8d4d365af4$export$7f84737e62455c69.defaultProps = {
    type: "image",
    title: false
};
var $cf65bf8d4d365af4$export$40380b9af9f6d929 = function ShimmerCategoryItem(_ref) {
    var hasImage = _ref.hasImage, imageType = _ref.imageType, imageWidth = _ref.imageWidth, imageHeight = _ref.imageHeight, title = _ref.title, text = _ref.text, cta = _ref.cta, contentCenter = _ref.contentCenter;
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", null, !hasImage ? (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$62bbbc04d7c5e7c6, {
        variant: "secondary",
        line: 1,
        className: "mb-15 w-80"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        className: "w-40"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f35c7d979dec8662, {
        line: 3,
        gap: 10
    }))) : (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        className: $cf65bf8d4d365af4$var$classnames({
            flex: true,
            "flex-vertical-center": contentCenter
        })
    }, imageType === "thumbnail" && (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$973ab931129fa7e9, {
        width: imageWidth,
        height: imageHeight
    }), imageType === "circular" && (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$697f501f4c22166d, {
        size: imageWidth
    }), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        className: "flex-1 p-15"
    }, title && (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$62bbbc04d7c5e7c6, {
        variant: "secondary"
    }), text && (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f35c7d979dec8662, {
        line: 3,
        gap: 10,
        className: "mb-20"
    }), cta && (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$399c7d54452eb442, {
        size: "sm"
    }))));
};
$cf65bf8d4d365af4$export$40380b9af9f6d929.propTypes = {
    hasImage: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool.isRequired,
    imageType: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).oneOf([
        "circular",
        "thumbnail"
    ]),
    imageWidth: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).number,
    imageHeight: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).number,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool,
    cta: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool,
    contentCenter: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool
};
$cf65bf8d4d365af4$export$40380b9af9f6d929.defaultProps = {
    hasImage: false,
    imageType: "thumbnail",
    title: false,
    text: false,
    contentCenter: false
};
var $cf65bf8d4d365af4$export$ec67eaf539d05493 = function ShimmerCategoryList(_ref) {
    var items = _ref.items, categoryStyle = _ref.categoryStyle, title = _ref.title;
    var categories = {
        STYLE_ONE: (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$40380b9af9f6d929, null),
        STYLE_TWO: (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$40380b9af9f6d929, {
            hasImage: true,
            imageType: "thumbnail",
            imageWidth: 100,
            imageHeight: 100,
            title: true
        }),
        STYLE_THREE: (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$40380b9af9f6d929, {
            hasImage: true,
            imageType: "circular",
            imageWidth: 100,
            imageHeight: 100,
            title: true
        }),
        STYLE_FOUR: (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$40380b9af9f6d929, {
            hasImage: true,
            imageType: "thumbnail",
            imageWidth: 100,
            imageHeight: 100,
            text: true
        }),
        STYLE_FIVE: (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$40380b9af9f6d929, {
            hasImage: true,
            imageType: "circular",
            imageWidth: 100,
            imageHeight: 100,
            text: true
        }),
        STYLE_SIX: (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$40380b9af9f6d929, {
            hasImage: true,
            imageType: "thumbnail",
            imageWidth: 100,
            imageHeight: 100,
            text: true,
            cta: true
        }),
        STYLE_SEVEN: (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$40380b9af9f6d929, {
            hasImage: true,
            imageType: "circular",
            imageWidth: 100,
            imageHeight: 100,
            text: true,
            cta: true
        })
    };
    var renderItems = function renderItems() {
        var list = [];
        for(var index = 0; index < items; index++)list.push((0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
            key: index
        }, categories[categoryStyle]));
        return list;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f71f704701cc7071, {
        paddingSize: 20
    }, title && (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$62bbbc04d7c5e7c6, {
        line: 1,
        className: "w-60"
    }), renderItems());
};
$cf65bf8d4d365af4$export$ec67eaf539d05493.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool,
    items: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).number,
    categoryStyle: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).oneOf([
        "STYLE_ONE",
        "STYLE_TWO",
        "STYLE_THREE",
        "STYLE_FOUR",
        "STYLE_FIVE",
        "STYLE_SIX",
        "STYLE_SEVEN"
    ])
};
$cf65bf8d4d365af4$export$ec67eaf539d05493.defaultProps = {
    title: false,
    items: 5,
    categoryStyle: "STYLE_ONE"
};
var $cf65bf8d4d365af4$export$655909292232fedc = function ShimmerPostDetails(_ref) {
    var variant = _ref.variant, cta = _ref.cta, card = _ref.card;
    var variants = {
        SIMPLE: (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$62bbbc04d7c5e7c6, {
            line: 1,
            className: "w-40"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$62bbbc04d7c5e7c6, {
            line: 1,
            variant: "secondary",
            className: "w-20 mb-40"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
            className: "w-40 mb-40"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f35c7d979dec8662, {
            line: 1,
            className: "mb-15 w-20"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f35c7d979dec8662, {
            line: 1,
            className: "mb-15 w-40"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f35c7d979dec8662, {
            line: 1,
            className: "mb-30 w-60"
        })), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$62bbbc04d7c5e7c6, {
            line: 1,
            variant: "secondary",
            className: "w-30"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f35c7d979dec8662, {
            className: "mb-40"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$62bbbc04d7c5e7c6, {
            line: 1,
            variant: "secondary",
            className: "w-30"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f35c7d979dec8662, {
            className: "mb-40"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$62bbbc04d7c5e7c6, {
            line: 1,
            variant: "secondary",
            className: "w-30"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f35c7d979dec8662, {
            className: "mb-40"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$62bbbc04d7c5e7c6, {
            line: 1,
            variant: "secondary",
            className: "w-30"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f35c7d979dec8662, {
            className: "mb-40"
        }), cta && (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$399c7d54452eb442, null)),
        EDITOR: (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$62bbbc04d7c5e7c6, {
            line: 1,
            className: "w-40"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$973ab931129fa7e9, {
            height: 400
        }), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f35c7d979dec8662, null), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f35c7d979dec8662, null), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
            className: "shimmer-row"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
            className: "shimmer-col"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f35c7d979dec8662, {
            line: 13
        })), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
            className: "shimmer-col"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$973ab931129fa7e9, {
            height: 300
        }))), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f35c7d979dec8662, null), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f35c7d979dec8662, null), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f35c7d979dec8662, null))
    };
    if (!card) return variants[variant];
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f71f704701cc7071, {
        paddingSize: 30
    }, variants[variant]);
};
$cf65bf8d4d365af4$export$655909292232fedc.propTypes = {
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).oneOf([
        "SIMPLE",
        "EDITOR"
    ]),
    cta: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool,
    card: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool
};
$cf65bf8d4d365af4$export$655909292232fedc.defaultProps = {
    variant: "SIMPLE",
    cta: false,
    card: false
};
var $cf65bf8d4d365af4$export$6f1e2cdcdce53633 = function ShimmerPostItem(_ref) {
    var cta = _ref.cta, title = _ref.title, text = _ref.text, imageType = _ref.imageType, imageWidth = _ref.imageWidth, imageHeight = _ref.imageHeight;
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f71f704701cc7071, null, imageType === "thumbnail" && (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$973ab931129fa7e9, {
        height: imageHeight,
        width: imageWidth,
        className: imageWidth && imageWidth !== "w-100" ? "m-30 mb-0" : "mb-0"
    }), imageType === "circular" && (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$697f501f4c22166d, {
        size: imageWidth,
        className: "m-30 mb-0"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        className: "p-30"
    }, title && (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$62bbbc04d7c5e7c6, {
        variant: "secondary"
    }), text && (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f35c7d979dec8662, {
        line: 3,
        gap: 10
    }), cta && (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$399c7d54452eb442, {
        size: "sm"
    })));
};
$cf65bf8d4d365af4$export$6f1e2cdcdce53633.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool,
    cta: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool,
    imageType: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).oneOf([
        "circular",
        "thumbnail"
    ]),
    imageHeight: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).number,
    imageWidth: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).number
};
$cf65bf8d4d365af4$export$6f1e2cdcdce53633.defaultProps = {
    title: false,
    text: false,
    cta: false,
    imageType: "thumbnail"
};
var $cf65bf8d4d365af4$export$b952781d999a9dfd = function ShimmerPostList(_ref) {
    var _classNames;
    var row = _ref.row, col = _ref.col, gap = _ref.gap, className = _ref.className, postStyle = _ref.postStyle;
    var posts = {
        STYLE_ONE: (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$6f1e2cdcdce53633, {
            title: true,
            text: true,
            cta: true
        }),
        STYLE_TWO: (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$6f1e2cdcdce53633, {
            title: true,
            cta: true
        }),
        STYLE_THREE: (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$6f1e2cdcdce53633, {
            title: true
        }),
        STYLE_FOUR: (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$6f1e2cdcdce53633, {
            text: true,
            cta: true
        }),
        STYLE_FIVE: (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$6f1e2cdcdce53633, {
            text: true
        }),
        STYLE_SIX: (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$6f1e2cdcdce53633, {
            title: true,
            text: true,
            cta: true,
            imageType: "thumbnail",
            imageWidth: 80,
            imageHeight: 80,
            contentCenter: true
        }),
        STYLE_SEVEN: (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$6f1e2cdcdce53633, {
            text: true,
            cta: true,
            imageType: "thumbnail",
            imageWidth: 80,
            imageHeight: 80,
            contentCenter: true
        }),
        STYLE_EIGHT: (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$6f1e2cdcdce53633, {
            title: true,
            cta: true,
            imageType: "thumbnail",
            imageWidth: 80,
            imageHeight: 80,
            contentCenter: true
        })
    };
    var renderPosts = function renderPosts() {
        var list = [];
        var items = row * col;
        for(var index = 0; index < items; index++)list.push((0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
            key: index
        }, posts[postStyle]));
        return list;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        className: $cf65bf8d4d365af4$var$classnames((_classNames = {
            grid: true
        }, $cf65bf8d4d365af4$var$defineProperty(_classNames, "grid-gap-" + gap, true), $cf65bf8d4d365af4$var$defineProperty(_classNames, "grid-column-" + col, true), $cf65bf8d4d365af4$var$defineProperty(_classNames, className, className), _classNames))
    }, renderPosts());
};
$cf65bf8d4d365af4$export$b952781d999a9dfd.propTypes = {
    row: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).number,
    col: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).oneOf([
        2,
        3,
        4
    ]),
    gap: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).oneOf([
        20,
        30
    ]),
    postStyle: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).oneOf([
        "STYLE_ONE",
        "STYLE_TWO",
        "STYLE_THREE",
        "STYLE_FOUR",
        "STYLE_FIVE",
        "STYLE_SIX",
        "STYLE_SEVEN",
        "STYLE_EIGHT"
    ])
};
$cf65bf8d4d365af4$export$b952781d999a9dfd.defaultProps = {
    row: 3,
    col: 3,
    gap: 20,
    postStyle: "STYLE_ONE"
};
var $cf65bf8d4d365af4$export$e057a94f8fc7d641 = function ShimmerContentBlock(_ref) {
    var card = _ref.card, title = _ref.title, text = _ref.text, cta = _ref.cta, thumbnailWidth = _ref.thumbnailWidth, thumbnailHeight = _ref.thumbnailHeight, reverse = _ref.reverse;
    var renderContent = function renderContent() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
            className: $cf65bf8d4d365af4$var$classnames({
                flex: true,
                "flex-reverse": reverse
            })
        }, (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
            className: $cf65bf8d4d365af4$var$classnames({
                flex: true,
                "w-50": !thumbnailWidth
            })
        }, (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$973ab931129fa7e9, {
            width: thumbnailWidth,
            height: thumbnailHeight,
            className: "h-100 m-0"
        })), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
            className: " flex-1 p-30"
        }, title && (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$62bbbc04d7c5e7c6, {
            className: "w-40",
            line: 1
        }), text && (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f35c7d979dec8662, null), cta && (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$399c7d54452eb442, null)));
    };
    if (!card) return renderContent();
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f71f704701cc7071, null, renderContent());
};
$cf65bf8d4d365af4$export$e057a94f8fc7d641.propTypes = {
    card: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool,
    cta: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool,
    thumbnailWidth: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).number,
    thumbnailHeight: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).number,
    reverse: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool
};
$cf65bf8d4d365af4$export$e057a94f8fc7d641.defaultProps = {
    card: true,
    title: false,
    text: false,
    cta: false,
    reverse: false
};
var $cf65bf8d4d365af4$export$c9c934c1772d984e = function ShimmerSectionHeader(_ref) {
    var title = _ref.title, subTitle = _ref.subTitle, center = _ref.center;
    if (!title && !subTitle) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        className: $cf65bf8d4d365af4$var$classnames({
            "w-60 mb-40": true,
            "ml-auto mr-auto": center
        })
    }, title && (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$62bbbc04d7c5e7c6, {
        className: $cf65bf8d4d365af4$var$classnames({
            "w-40": true,
            "ml-auto mr-auto": center
        }),
        line: 1
    }), subTitle && (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement("div", {
        className: $cf65bf8d4d365af4$var$classnames({
            "flex-horizontal-center": center
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f35c7d979dec8662, {
        line: 1,
        className: "mb-15 w-80"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f35c7d979dec8662, {
        line: 1,
        className: "mb-15 w-70"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).createElement($cf65bf8d4d365af4$export$f35c7d979dec8662, {
        line: 1,
        className: "mb-15 w-60"
    })));
};
$cf65bf8d4d365af4$export$c9c934c1772d984e.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool,
    subTitle: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool,
    center: (0, (/*@__PURE__*/$parcel$interopDefault($ea26611a4ff88c75$exports))).bool
};
$cf65bf8d4d365af4$export$c9c934c1772d984e.defaultProps = {
    title: true,
    subTitle: true,
    center: false
};
var $cf65bf8d4d365af4$var$css$9 = ".shimmer {\n  background: linear-gradient(to right, #f6f6f6 8%, #f0f0f0 18%, #f6f6f6 33%);\n  background-size: 1000px 100%;\n  animation: shimmer 2.2s linear infinite forwards; }\n\n@-webkit-keyframes shimmer {\n  0% {\n    background-position: -100% 0; }\n  100% {\n    background-position: 100% 0; } }\n\n@keyframes shimmer {\n  0% {\n    background-position: -1000px 0; }\n  100% {\n    background-position: 1000px 0; } }\n\n/*\n=====\nPadding Styles\n=====\n*/\n.p-30 {\n  padding: 30px; }\n\n.p-20 {\n  padding: 20px; }\n\n.p-15 {\n  padding: 15px; }\n\n/*\n=====\nMargin Styles\n=====\n*/\n.m-0 {\n  margin: 0; }\n\n.m-auto {\n  margin: auto; }\n\n.ml-auto {\n  margin-left: auto; }\n\n.mr-auto {\n  margin-right: auto; }\n\n.m-15 {\n  margin: 15px; }\n\n.m-30 {\n  margin: 30px; }\n\n.mb-0 {\n  margin-bottom: 0px; }\n\n.mb-10 {\n  margin-bottom: 10px; }\n\n.mb-15 {\n  margin-bottom: 15px; }\n\n.mb-20 {\n  margin-bottom: 20px; }\n\n.mt-15 {\n  margin-top: 15px; }\n\n.mb-30 {\n  margin-bottom: 30px; }\n\n.mb-40 {\n  margin-bottom: 40px; }\n\n/*\n=======\nContent Size Styles\n=======\n*/\n.w-10 {\n  width: 10%; }\n\n.w-20 {\n  width: 20%; }\n\n.w-30 {\n  width: 30%; }\n\n.w-40 {\n  width: 40%; }\n\n.w-50 {\n  width: 50%; }\n\n.w-60 {\n  width: 60%; }\n\n.w-70 {\n  width: 70%; }\n\n.w-80 {\n  width: 80%; }\n\n/*\n========\nFlex Styles\n========\n*/\n.flex {\n  display: flex; }\n\n.flex-direction-column {\n  flex-direction: column; }\n\n.flex-horizontal-center {\n  display: flex;\n  flex-direction: column;\n  align-items: center; }\n\n.flex-vertical-center {\n  align-items: center; }\n\n.flex-content-between {\n  justify-content: space-between; }\n\n.flex-reverse {\n  flex-direction: row-reverse; }\n\n.flex-1 {\n  flex-grow: 1; }\n\n/*\n=======\nGrid Styles\n=======\n*/\n.grid {\n  display: grid; }\n\n.grid-gap-10 {\n  gap: 10px; }\n\n.grid-gap-15 {\n  gap: 15px; }\n\n.grid-gap-20 {\n  gap: 20px; }\n\n.grid-gap-30 {\n  gap: 30px; }\n\n.grid-column-2 {\n  grid-template-columns: auto auto; }\n\n.grid-column-3 {\n  grid-template-columns: auto auto auto; }\n\n.grid-column-4 {\n  grid-template-columns: auto auto auto auto; }\n\n.text-center {\n  text-align: center; }\n\n.border-rounded {\n  border-radius: 4px; }\n\n.h-100 {\n  height: 100% !important; }\n\n.shimmer-hr {\n  border-color: #f6f6f6; }\n\n.shimmer-row {\n  display: flex;\n  margin: 0 -15px; }\n  .shimmer-row .shimmer-col,\n  .shimmer-row [class*=\"shimmer-col-\"] {\n    padding-left: 15px;\n    padding-right: 15px;\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%; }\n";
$cf65bf8d4d365af4$var$styleInject($cf65bf8d4d365af4$var$css$9);


const $4ad91f0b3377f485$var$Shimmer = ()=>{
    return /*#__PURE__*/ (0, $R1mjg.jsx)((0, $cf65bf8d4d365af4$export$b952781d999a9dfd), {
        postStyle: "STYLE_FOUR",
        col: 3,
        row: 2,
        gap: 30
    });
};
var $4ad91f0b3377f485$export$2e2bcd8739ae039 = $4ad91f0b3377f485$var$Shimmer;




const $4910cfde57c76095$var$Body = ()=>{
    const [listOfRes, setListOfRes] = (0, $i7uhG.useState)([]);
    const [searchText, setsearchText] = (0, $i7uhG.useState)("");
    const [filteredlistOfRes, setfilteredListOfRes] = (0, $i7uhG.useState)([]);
    const Restaurantcartrecomm = (0, $6110d401c0c7fa44$export$cbace1feb04360aa)((0, $6110d401c0c7fa44$export$2e2bcd8739ae039));
    (0, $i7uhG.useEffect)(()=>{
        fetchData();
    }, []);
    const fetchData = async ()=>{
        const data = await fetch("https://corsproxy.io/https://www.swiggy.com/dapi/restaurants/list/v5?lat=20.2959847&lng=85.8246101&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING");
        const json = await data.json();
        setListOfRes(json?.data?.cards[4]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
        // this is also valid setfilteredListOfRes(json?.data?.cards[4]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
        //setfilteredListOfRES(listofres);gives wrong answer sometimes bcz this exexutes sometimes setlistofres so we got empty res
        setfilteredListOfRes(json?.data?.cards[4]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
    };
    /*if (listOfRes.length == 0) {

    return < Shimmer/>
  }*/ //------------------------------------------online/offline status ----------------------------------------------------------
    const status = (0, $c9030a919f491fd7$export$2e2bcd8739ae039)();
    if (status == false) return /*#__PURE__*/ (0, $R1mjg.jsx)("h1", {
        children: "opps!you seem to be offline"
    });
    //--------------------------------------------but if online below codes ------------------------------------------------
    return listOfRes.length == 0 ? /*#__PURE__*/ (0, $R1mjg.jsx)((0, $4ad91f0b3377f485$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $R1mjg.jsxs)("div", {
        className: "body",
        children: [
            /*#__PURE__*/ (0, $R1mjg.jsxs)("div", {
                className: "filter",
                children: [
                    /*#__PURE__*/ (0, $R1mjg.jsxs)("div", {
                        className: "search",
                        children: [
                            /*#__PURE__*/ (0, $R1mjg.jsx)("input", {
                                type: "text",
                                className: "w-full max-w-md px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-300 focus:border-transparent transition duration-200",
                                value: searchText,
                                onChange: (e)=>{
                                    setsearchText(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0, $R1mjg.jsx)("button", {
                                className: " mt-3 px-4 py-2 bg-orange-400 text-white rounded-lg shadow-md hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200",
                                onClick: ()=>{
                                    const filteredlist = listOfRes.filter((res)=>res.info.name.toLowerCase().includes(searchText.toLowerCase()));
                                    setfilteredListOfRes(filteredlist);
                                },
                                children: "search"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $R1mjg.jsx)("button", {
                        className: "mt-10 mb-3 h-[3rem] w-[20rem] text-[15px] bg-sky-300 border-10 text-[#070404] rounded-[10px] px-1 py-0.5 cursor-pointer border-none hover:shadow-[0_4px_8px_rgba(252,4,4,0.1),0_6px_20px_rgba(225,3,3,0.19)] transition-shadow duration-300",
                        onClick: ()=>{
                            const filteredlist = listOfRes.filter((res)=>res.info.avgRating > 4.5);
                            console.log(filteredlist);
                            //earlier this filteredlist updated in listofres but now in filteredlist as it will be rendered
                            setfilteredListOfRes(filteredlist);
                        },
                        children: "top reated restaurant"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $R1mjg.jsx)("div", {
                className: "res-container",
                children: //---------------  earlier we were doing using listofres
                //  ------listofres.map((restaurant) => (
                //<Restuarantcart key={restaurant.info.id} resdata={restaurant} />
                //but now we are maintaining a copy of this to keep all restaurant for available to compare and use using filtered state
                //----------------------------------------------------------------------------------------------------------------------
                filteredlistOfRes.map((restaurant)=>(console.log(filteredlistOfRes), /*#__PURE__*/ (0, $R1mjg.jsx)((0, $b9ce296f3422b46b$export$a6c7ac8248d6e38a), {
                        to: "/restaurant/" + restaurant.info.id,
                        children: restaurant.info.avgRating > 4.3 ? /*#__PURE__*/ (0, $R1mjg.jsx)(Restaurantcartrecomm, {
                            resdata: restaurant
                        }) : /*#__PURE__*/ (0, $R1mjg.jsx)((0, $6110d401c0c7fa44$export$2e2bcd8739ae039), {
                            resdata: restaurant
                        }, restaurant.info.id)
                    }, restaurant.info.id)))
            })
        ]
    });
};
var $4910cfde57c76095$export$2e2bcd8739ae039 = $4910cfde57c76095$var$Body;




var $R1mjg = parcelRequire("R1mjg");

var $R1mjg = parcelRequire("R1mjg");
const $3b84791aaeff1123$var$Userf = ()=>{
    return /*#__PURE__*/ (0, $R1mjg.jsxs)("div", {
        className: "user-card",
        children: [
            /*#__PURE__*/ (0, $R1mjg.jsx)("h2", {
                children: "name:saqlain"
            }),
            /*#__PURE__*/ (0, $R1mjg.jsx)("h3", {
                children: "location:bbsr"
            }),
            /*#__PURE__*/ (0, $R1mjg.jsx)("h4", {
                children: "contact:-mdsaq07"
            })
        ]
    });
};
var $3b84791aaeff1123$export$2e2bcd8739ae039 = $3b84791aaeff1123$var$Userf;



var $R1mjg = parcelRequire("R1mjg");

var $i7uhG = parcelRequire("i7uhG");
class $f77f2defa390316a$var$Userc extends (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).Component {
    render() {
        return /*#__PURE__*/ (0, $R1mjg.jsxs)("div", {
            className: "user-card",
            children: [
                /*#__PURE__*/ (0, $R1mjg.jsx)("h2", {
                    children: "name:saqlain"
                }),
                /*#__PURE__*/ (0, $R1mjg.jsx)("h3", {
                    children: "location:bbsr"
                }),
                /*#__PURE__*/ (0, $R1mjg.jsx)("h4", {
                    children: "contact:-mdsaq07"
                })
            ]
        });
    }
}
var $f77f2defa390316a$export$2e2bcd8739ae039 //rest about class based component is written in the copy and some under the services.js
 = $f77f2defa390316a$var$Userc;


const $cc46b92cca05229e$var$About = ()=>{
    return /*#__PURE__*/ (0, $R1mjg.jsxs)("div", {
        className: "about-container",
        children: [
            /*#__PURE__*/ (0, $R1mjg.jsx)("h1", {
                children: "About Our Food App"
            }),
            /*#__PURE__*/ (0, $R1mjg.jsx)("p", {
                children: "Welcome to [Your App Name]! We are passionate about connecting food lovers with delicious meals and culinary experiences. Our mission is to make ordering food easy, convenient, and enjoyable for everyone."
            }),
            /*#__PURE__*/ (0, $R1mjg.jsx)((0, $3b84791aaeff1123$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $R1mjg.jsx)((0, $f77f2defa390316a$export$2e2bcd8739ae039), {})
        ]
    });
};
var $cc46b92cca05229e$export$2e2bcd8739ae039 = $cc46b92cca05229e$var$About;



var $R1mjg = parcelRequire("R1mjg");

var $i7uhG = parcelRequire("i7uhG");
const $5efd4f57743cca9e$var$Contact = ()=>{
    const [formData, setFormData] = (0, $i7uhG.useState)({
        name: '',
        email: '',
        message: ''
    });
    const handleChange = (e)=>{
        setFormData((prev)=>({
                ...prev,
                [e.target.name]: e.target.value
            }));
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        // You can integrate with an API or email service here
        console.log('Form submitted:', formData);
        alert("Thanks for reaching out! We\u2019ll get back to you soon.");
        setFormData({
            name: '',
            email: '',
            message: ''
        });
    };
    return /*#__PURE__*/ (0, $R1mjg.jsxs)("div", {
        className: "contact-container",
        children: [
            /*#__PURE__*/ (0, $R1mjg.jsx)("h2", {
                children: "Contact Us"
            }),
            /*#__PURE__*/ (0, $R1mjg.jsxs)("div", {
                className: "contact-content",
                children: [
                    /*#__PURE__*/ (0, $R1mjg.jsxs)("form", {
                        className: "contact-form",
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0, $R1mjg.jsx)("input", {
                                type: "text",
                                name: "name",
                                placeholder: "Your Name",
                                value: formData.name,
                                onChange: handleChange,
                                required: true
                            }),
                            /*#__PURE__*/ (0, $R1mjg.jsx)("input", {
                                type: "email",
                                name: "email",
                                placeholder: "Your Email",
                                value: formData.email,
                                onChange: handleChange,
                                required: true
                            }),
                            /*#__PURE__*/ (0, $R1mjg.jsx)("textarea", {
                                name: "message",
                                placeholder: "Your Message",
                                rows: "5",
                                value: formData.message,
                                onChange: handleChange,
                                required: true
                            }),
                            /*#__PURE__*/ (0, $R1mjg.jsx)("button", {
                                type: "submit",
                                children: "Send Message"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $R1mjg.jsxs)("div", {
                        className: "contact-info",
                        children: [
                            /*#__PURE__*/ (0, $R1mjg.jsx)("h3", {
                                children: "\uD83D\uDCCD Our Location"
                            }),
                            /*#__PURE__*/ (0, $R1mjg.jsx)("p", {
                                children: "123 Foodie Street, Bhubaneswar, Odisha"
                            }),
                            /*#__PURE__*/ (0, $R1mjg.jsx)("h3", {
                                children: "\uD83D\uDCDE Call Us"
                            }),
                            /*#__PURE__*/ (0, $R1mjg.jsx)("p", {
                                children: "+91 98765 43210"
                            }),
                            /*#__PURE__*/ (0, $R1mjg.jsx)("h3", {
                                children: "\uD83D\uDCE7 Email"
                            }),
                            /*#__PURE__*/ (0, $R1mjg.jsx)("p", {
                                children: "support@foodexpress.com"
                            }),
                            /*#__PURE__*/ (0, $R1mjg.jsx)("h3", {
                                children: "\uD83D\uDDFA\uFE0F Find Us"
                            }),
                            /*#__PURE__*/ (0, $R1mjg.jsx)("div", {
                                className: "map-placeholder",
                                children: /*#__PURE__*/ (0, $R1mjg.jsx)("iframe", {
                                    title: "map",
                                    src: "https://maps.google.com/maps?q=Bhubaneswar&t=&z=13&ie=UTF8&iwloc=&output=embed",
                                    width: "100%",
                                    height: "200",
                                    frameBorder: "0",
                                    allowFullScreen: true
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $5efd4f57743cca9e$export$2e2bcd8739ae039 = $5efd4f57743cca9e$var$Contact;



var $R1mjg = parcelRequire("R1mjg");

const $4d4e665efd9a9d0d$var$Error = ()=>{
    const err = (0, $03719940145a991f$export$ed527bf60f6e05f2)();
    console.log(err);
    return /*#__PURE__*/ (0, $R1mjg.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $R1mjg.jsx)("h1", {
                children: "oops!"
            }),
            /*#__PURE__*/ (0, $R1mjg.jsxs)("h3", {
                children: [
                    err.status,
                    " : ",
                    err.statusText
                ]
            })
        ]
    });
};
var $4d4e665efd9a9d0d$export$2e2bcd8739ae039 = $4d4e665efd9a9d0d$var$Error;



var $R1mjg = parcelRequire("R1mjg");

var $i7uhG = parcelRequire("i7uhG");




var $R1mjg = parcelRequire("R1mjg");

var $i7uhG = parcelRequire("i7uhG");

var $R1mjg = parcelRequire("R1mjg");


// src/utils/formatProdErrorMessage.ts
function $b40d0dadbbab45f1$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $b40d0dadbbab45f1$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $b40d0dadbbab45f1$var$symbol_observable_default = $b40d0dadbbab45f1$var$$$observable;
// src/utils/actionTypes.ts
var $b40d0dadbbab45f1$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $b40d0dadbbab45f1$var$ActionTypes = {
    INIT: `@@redux/INIT${$b40d0dadbbab45f1$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$b40d0dadbbab45f1$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$b40d0dadbbab45f1$var$randomString()}`
};
var $b40d0dadbbab45f1$export$4219e499db7ca678 = $b40d0dadbbab45f1$var$ActionTypes;
// src/utils/isPlainObject.ts
function $b40d0dadbbab45f1$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $b40d0dadbbab45f1$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($b40d0dadbbab45f1$var$isDate(val)) return "date";
    if ($b40d0dadbbab45f1$var$isError(val)) return "error";
    const constructorName = $b40d0dadbbab45f1$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $b40d0dadbbab45f1$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $b40d0dadbbab45f1$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $b40d0dadbbab45f1$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $b40d0dadbbab45f1$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $b40d0dadbbab45f1$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($b40d0dadbbab45f1$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($b40d0dadbbab45f1$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($b40d0dadbbab45f1$var$formatProdErrorMessage(1));
        return enhancer($b40d0dadbbab45f1$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($b40d0dadbbab45f1$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($b40d0dadbbab45f1$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($b40d0dadbbab45f1$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($b40d0dadbbab45f1$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$b40d0dadbbab45f1$export$53b83ca8eaab0383(action)) throw new Error($b40d0dadbbab45f1$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($b40d0dadbbab45f1$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($b40d0dadbbab45f1$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($b40d0dadbbab45f1$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($b40d0dadbbab45f1$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $b40d0dadbbab45f1$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($b40d0dadbbab45f1$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$b40d0dadbbab45f1$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $b40d0dadbbab45f1$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$b40d0dadbbab45f1$var$symbol_observable_default]: observable
    };
    return store;
}
function $b40d0dadbbab45f1$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $b40d0dadbbab45f1$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $b40d0dadbbab45f1$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $b40d0dadbbab45f1$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $b40d0dadbbab45f1$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$b40d0dadbbab45f1$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$b40d0dadbbab45f1$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $b40d0dadbbab45f1$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $b40d0dadbbab45f1$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $b40d0dadbbab45f1$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($b40d0dadbbab45f1$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $b40d0dadbbab45f1$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($b40d0dadbbab45f1$var$formatProdErrorMessage(13));
    });
}
function $b40d0dadbbab45f1$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $b40d0dadbbab45f1$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($b40d0dadbbab45f1$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $b40d0dadbbab45f1$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $b40d0dadbbab45f1$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $b40d0dadbbab45f1$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($b40d0dadbbab45f1$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $b40d0dadbbab45f1$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $b40d0dadbbab45f1$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $b40d0dadbbab45f1$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($b40d0dadbbab45f1$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $b40d0dadbbab45f1$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $b40d0dadbbab45f1$export$b956e38827fca970(action) {
    return $b40d0dadbbab45f1$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $d9169d6545ae6690$var$__defProp = Object.defineProperty;
var $d9169d6545ae6690$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d9169d6545ae6690$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d9169d6545ae6690$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d9169d6545ae6690$var$__defNormalProp = (obj, key, value)=>key in obj ? $d9169d6545ae6690$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d9169d6545ae6690$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d9169d6545ae6690$var$__hasOwnProp.call(b, prop)) $d9169d6545ae6690$var$__defNormalProp(a, prop, b[prop]);
    if ($d9169d6545ae6690$var$__getOwnPropSymbols) {
        for (var prop of $d9169d6545ae6690$var$__getOwnPropSymbols(b))if ($d9169d6545ae6690$var$__propIsEnum.call(b, prop)) $d9169d6545ae6690$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $d9169d6545ae6690$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $d9169d6545ae6690$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $d9169d6545ae6690$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $d9169d6545ae6690$var$errors = [];
function $d9169d6545ae6690$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $d9169d6545ae6690$var$getPrototypeOf = Object.getPrototypeOf;
function $d9169d6545ae6690$export$541ac630993a4c84(value) {
    return !!value && !!value[$d9169d6545ae6690$var$DRAFT_STATE];
}
function $d9169d6545ae6690$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $d9169d6545ae6690$var$isPlainObject(value) || Array.isArray(value) || !!value[$d9169d6545ae6690$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$d9169d6545ae6690$export$6ee2082928bcb0ee]) || $d9169d6545ae6690$var$isMap(value) || $d9169d6545ae6690$var$isSet(value);
}
var $d9169d6545ae6690$var$objectCtorString = Object.prototype.constructor.toString();
function $d9169d6545ae6690$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $d9169d6545ae6690$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $d9169d6545ae6690$var$objectCtorString;
}
function $d9169d6545ae6690$export$22e8af3f75a010e3(value) {
    if (!$d9169d6545ae6690$export$541ac630993a4c84(value)) $d9169d6545ae6690$var$die(15, value);
    return value[$d9169d6545ae6690$var$DRAFT_STATE].base_;
}
function $d9169d6545ae6690$var$each(obj, iter) {
    if ($d9169d6545ae6690$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $d9169d6545ae6690$var$getArchtype(thing) {
    const state = thing[$d9169d6545ae6690$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $d9169d6545ae6690$var$isMap(thing) ? 2 /* Map */  : $d9169d6545ae6690$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $d9169d6545ae6690$var$has(thing, prop) {
    return $d9169d6545ae6690$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $d9169d6545ae6690$var$get(thing, prop) {
    return $d9169d6545ae6690$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $d9169d6545ae6690$var$set(thing, propOrOldValue, value) {
    const t = $d9169d6545ae6690$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $d9169d6545ae6690$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $d9169d6545ae6690$var$isMap(target) {
    return target instanceof Map;
}
function $d9169d6545ae6690$var$isSet(target) {
    return target instanceof Set;
}
function $d9169d6545ae6690$var$latest(state) {
    return state.copy_ || state.base_;
}
function $d9169d6545ae6690$var$shallowCopy(base, strict) {
    if ($d9169d6545ae6690$var$isMap(base)) return new Map(base);
    if ($d9169d6545ae6690$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $d9169d6545ae6690$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$d9169d6545ae6690$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($d9169d6545ae6690$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $d9169d6545ae6690$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $d9169d6545ae6690$var$__spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $d9169d6545ae6690$export$792f3d81ea979f55(obj, deep = false) {
    if ($d9169d6545ae6690$var$isFrozen(obj) || $d9169d6545ae6690$export$541ac630993a4c84(obj) || !$d9169d6545ae6690$export$16e3aed3edb85946(obj)) return obj;
    if ($d9169d6545ae6690$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $d9169d6545ae6690$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$d9169d6545ae6690$export$792f3d81ea979f55(value, true));
    return obj;
}
function $d9169d6545ae6690$var$dontMutateFrozenCollections() {
    $d9169d6545ae6690$var$die(2);
}
function $d9169d6545ae6690$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $d9169d6545ae6690$var$plugins = {};
function $d9169d6545ae6690$var$getPlugin(pluginKey) {
    const plugin = $d9169d6545ae6690$var$plugins[pluginKey];
    if (!plugin) $d9169d6545ae6690$var$die(0, pluginKey);
    return plugin;
}
function $d9169d6545ae6690$var$loadPlugin(pluginKey, implementation) {
    if (!$d9169d6545ae6690$var$plugins[pluginKey]) $d9169d6545ae6690$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $d9169d6545ae6690$var$currentScope;
function $d9169d6545ae6690$var$getCurrentScope() {
    return $d9169d6545ae6690$var$currentScope;
}
function $d9169d6545ae6690$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $d9169d6545ae6690$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $d9169d6545ae6690$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $d9169d6545ae6690$var$revokeScope(scope) {
    $d9169d6545ae6690$var$leaveScope(scope);
    scope.drafts_.forEach($d9169d6545ae6690$var$revokeDraft);
    scope.drafts_ = null;
}
function $d9169d6545ae6690$var$leaveScope(scope) {
    if (scope === $d9169d6545ae6690$var$currentScope) $d9169d6545ae6690$var$currentScope = scope.parent_;
}
function $d9169d6545ae6690$var$enterScope(immer2) {
    return $d9169d6545ae6690$var$currentScope = $d9169d6545ae6690$var$createScope($d9169d6545ae6690$var$currentScope, immer2);
}
function $d9169d6545ae6690$var$revokeDraft(draft) {
    const state = draft[$d9169d6545ae6690$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $d9169d6545ae6690$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$d9169d6545ae6690$var$DRAFT_STATE].modified_) {
            $d9169d6545ae6690$var$revokeScope(scope);
            $d9169d6545ae6690$var$die(4);
        }
        if ($d9169d6545ae6690$export$16e3aed3edb85946(result)) {
            result = $d9169d6545ae6690$var$finalize(scope, result);
            if (!scope.parent_) $d9169d6545ae6690$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $d9169d6545ae6690$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$d9169d6545ae6690$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $d9169d6545ae6690$var$finalize(scope, baseDraft, []);
    $d9169d6545ae6690$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $d9169d6545ae6690$export$45b790e32b2810ee ? result : void 0;
}
function $d9169d6545ae6690$var$finalize(rootScope, value, path) {
    if ($d9169d6545ae6690$var$isFrozen(value)) return value;
    const state = value[$d9169d6545ae6690$var$DRAFT_STATE];
    if (!state) {
        $d9169d6545ae6690$var$each(value, (key, childValue)=>$d9169d6545ae6690$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $d9169d6545ae6690$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $d9169d6545ae6690$var$each(resultEach, (key, childValue)=>$d9169d6545ae6690$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $d9169d6545ae6690$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $d9169d6545ae6690$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $d9169d6545ae6690$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($d9169d6545ae6690$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$d9169d6545ae6690$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $d9169d6545ae6690$var$finalize(rootScope, childValue, path);
        $d9169d6545ae6690$var$set(targetObject, prop, res);
        if ($d9169d6545ae6690$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($d9169d6545ae6690$export$16e3aed3edb85946(childValue) && !$d9169d6545ae6690$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $d9169d6545ae6690$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $d9169d6545ae6690$var$maybeFreeze(rootScope, childValue);
    }
}
function $d9169d6545ae6690$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $d9169d6545ae6690$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $d9169d6545ae6690$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $d9169d6545ae6690$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $d9169d6545ae6690$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $d9169d6545ae6690$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $d9169d6545ae6690$var$objectTraps = {
    get (state, prop) {
        if (prop === $d9169d6545ae6690$var$DRAFT_STATE) return state;
        const source = $d9169d6545ae6690$var$latest(state);
        if (!$d9169d6545ae6690$var$has(source, prop)) return $d9169d6545ae6690$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$d9169d6545ae6690$export$16e3aed3edb85946(value)) return value;
        if (value === $d9169d6545ae6690$var$peek(state.base_, prop)) {
            $d9169d6545ae6690$var$prepareCopy(state);
            return state.copy_[prop] = $d9169d6545ae6690$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $d9169d6545ae6690$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($d9169d6545ae6690$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $d9169d6545ae6690$var$getDescriptorFromProto($d9169d6545ae6690$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $d9169d6545ae6690$var$peek($d9169d6545ae6690$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$d9169d6545ae6690$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($d9169d6545ae6690$var$is(value, current2) && (value !== void 0 || $d9169d6545ae6690$var$has(state.base_, prop))) return true;
            $d9169d6545ae6690$var$prepareCopy(state);
            $d9169d6545ae6690$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($d9169d6545ae6690$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $d9169d6545ae6690$var$prepareCopy(state);
            $d9169d6545ae6690$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $d9169d6545ae6690$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $d9169d6545ae6690$var$die(11);
    },
    getPrototypeOf (state) {
        return $d9169d6545ae6690$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $d9169d6545ae6690$var$die(12);
    }
};
var $d9169d6545ae6690$var$arrayTraps = {};
$d9169d6545ae6690$var$each($d9169d6545ae6690$var$objectTraps, (key, fn)=>{
    $d9169d6545ae6690$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$d9169d6545ae6690$var$arrayTraps.deleteProperty = function(state, prop) {
    return $d9169d6545ae6690$var$arrayTraps.set.call(this, state, prop, void 0);
};
$d9169d6545ae6690$var$arrayTraps.set = function(state, prop, value) {
    return $d9169d6545ae6690$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $d9169d6545ae6690$var$peek(draft, prop) {
    const state = draft[$d9169d6545ae6690$var$DRAFT_STATE];
    const source = state ? $d9169d6545ae6690$var$latest(state) : draft;
    return source[prop];
}
function $d9169d6545ae6690$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $d9169d6545ae6690$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $d9169d6545ae6690$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $d9169d6545ae6690$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $d9169d6545ae6690$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $d9169d6545ae6690$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $d9169d6545ae6690$var$markChanged(state.parent_);
    }
}
function $d9169d6545ae6690$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $d9169d6545ae6690$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $d9169d6545ae6690$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $d9169d6545ae6690$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $d9169d6545ae6690$var$die(7);
            let result;
            if ($d9169d6545ae6690$export$16e3aed3edb85946(base)) {
                const scope = $d9169d6545ae6690$var$enterScope(this);
                const proxy = $d9169d6545ae6690$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $d9169d6545ae6690$var$revokeScope(scope);
                    else $d9169d6545ae6690$var$leaveScope(scope);
                }
                $d9169d6545ae6690$var$usePatchesInScope(scope, patchListener);
                return $d9169d6545ae6690$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $d9169d6545ae6690$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $d9169d6545ae6690$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $d9169d6545ae6690$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $d9169d6545ae6690$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$d9169d6545ae6690$export$16e3aed3edb85946(base)) $d9169d6545ae6690$var$die(8);
        if ($d9169d6545ae6690$export$541ac630993a4c84(base)) base = $d9169d6545ae6690$export$97aac956da55dae9(base);
        const scope = $d9169d6545ae6690$var$enterScope(this);
        const proxy = $d9169d6545ae6690$var$createProxy(base, void 0);
        proxy[$d9169d6545ae6690$var$DRAFT_STATE].isManual_ = true;
        $d9169d6545ae6690$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$d9169d6545ae6690$var$DRAFT_STATE];
        if (!state || !state.isManual_) $d9169d6545ae6690$var$die(9);
        const { scope_: scope } = state;
        $d9169d6545ae6690$var$usePatchesInScope(scope, patchListener);
        return $d9169d6545ae6690$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $d9169d6545ae6690$var$getPlugin("Patches").applyPatches_;
        if ($d9169d6545ae6690$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $d9169d6545ae6690$var$createProxy(value, parent) {
    const draft = $d9169d6545ae6690$var$isMap(value) ? $d9169d6545ae6690$var$getPlugin("MapSet").proxyMap_(value, parent) : $d9169d6545ae6690$var$isSet(value) ? $d9169d6545ae6690$var$getPlugin("MapSet").proxySet_(value, parent) : $d9169d6545ae6690$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $d9169d6545ae6690$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $d9169d6545ae6690$export$97aac956da55dae9(value) {
    if (!$d9169d6545ae6690$export$541ac630993a4c84(value)) $d9169d6545ae6690$var$die(10, value);
    return $d9169d6545ae6690$var$currentImpl(value);
}
function $d9169d6545ae6690$var$currentImpl(value) {
    if (!$d9169d6545ae6690$export$16e3aed3edb85946(value) || $d9169d6545ae6690$var$isFrozen(value)) return value;
    const state = value[$d9169d6545ae6690$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $d9169d6545ae6690$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $d9169d6545ae6690$var$shallowCopy(value, true);
    $d9169d6545ae6690$var$each(copy, (key, childValue)=>{
        $d9169d6545ae6690$var$set(copy, key, $d9169d6545ae6690$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $d9169d6545ae6690$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $d9169d6545ae6690$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $d9169d6545ae6690$var$get(base_, key);
            const value = $d9169d6545ae6690$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $d9169d6545ae6690$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $d9169d6545ae6690$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $d9169d6545ae6690$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $d9169d6545ae6690$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $d9169d6545ae6690$var$die(errorOffset + 3);
                base = $d9169d6545ae6690$var$get(base, p);
                if (typeof base !== "object") $d9169d6545ae6690$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $d9169d6545ae6690$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $d9169d6545ae6690$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $d9169d6545ae6690$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$d9169d6545ae6690$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($d9169d6545ae6690$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($d9169d6545ae6690$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($d9169d6545ae6690$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($d9169d6545ae6690$var$has(obj, $d9169d6545ae6690$export$6ee2082928bcb0ee)) cloned[$d9169d6545ae6690$export$6ee2082928bcb0ee] = obj[$d9169d6545ae6690$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($d9169d6545ae6690$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $d9169d6545ae6690$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $d9169d6545ae6690$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$d9169d6545ae6690$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $d9169d6545ae6690$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $d9169d6545ae6690$var$latest(this[$d9169d6545ae6690$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $d9169d6545ae6690$var$latest(this[$d9169d6545ae6690$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$d9169d6545ae6690$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$d9169d6545ae6690$var$latest(state).has(key) || $d9169d6545ae6690$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $d9169d6545ae6690$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$d9169d6545ae6690$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $d9169d6545ae6690$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$d9169d6545ae6690$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($d9169d6545ae6690$var$latest(state).size) {
                prepareMapCopy(state);
                $d9169d6545ae6690$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $d9169d6545ae6690$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$d9169d6545ae6690$var$DRAFT_STATE];
            $d9169d6545ae6690$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$d9169d6545ae6690$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $d9169d6545ae6690$var$latest(state).get(key);
            if (state.finalized_ || !$d9169d6545ae6690$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $d9169d6545ae6690$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $d9169d6545ae6690$var$latest(this[$d9169d6545ae6690$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($d9169d6545ae6690$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$d9169d6545ae6690$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $d9169d6545ae6690$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $d9169d6545ae6690$var$latest(this[$d9169d6545ae6690$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$d9169d6545ae6690$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$d9169d6545ae6690$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $d9169d6545ae6690$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$d9169d6545ae6690$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $d9169d6545ae6690$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$d9169d6545ae6690$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($d9169d6545ae6690$var$latest(state).size) {
                prepareSetCopy(state);
                $d9169d6545ae6690$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$d9169d6545ae6690$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$d9169d6545ae6690$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($d9169d6545ae6690$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($d9169d6545ae6690$export$16e3aed3edb85946(value)) {
                    const draft = $d9169d6545ae6690$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $d9169d6545ae6690$var$die(3, JSON.stringify($d9169d6545ae6690$var$latest(state)));
    }
    $d9169d6545ae6690$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $d9169d6545ae6690$var$immer = new $d9169d6545ae6690$export$aaadc6ff0f822719();
var $d9169d6545ae6690$export$b46cabe22e78bc00 = $d9169d6545ae6690$var$immer.produce;
var $d9169d6545ae6690$export$4da66d41c9492c78 = $d9169d6545ae6690$var$immer.produceWithPatches.bind($d9169d6545ae6690$var$immer);
var $d9169d6545ae6690$export$573f26f60825c493 = $d9169d6545ae6690$var$immer.setAutoFreeze.bind($d9169d6545ae6690$var$immer);
var $d9169d6545ae6690$export$333ce65961cbe047 = $d9169d6545ae6690$var$immer.setUseStrictShallowCopy.bind($d9169d6545ae6690$var$immer);
var $d9169d6545ae6690$export$a8b8e03e6bbe5473 = $d9169d6545ae6690$var$immer.applyPatches.bind($d9169d6545ae6690$var$immer);
var $d9169d6545ae6690$export$3c3214997190395f = $d9169d6545ae6690$var$immer.createDraft.bind($d9169d6545ae6690$var$immer);
var $d9169d6545ae6690$export$c60f5e69c521b528 = $d9169d6545ae6690$var$immer.finishDraft.bind($d9169d6545ae6690$var$immer);
function $d9169d6545ae6690$export$c05b21e3257751e5(value) {
    return value;
}
function $d9169d6545ae6690$export$20f911b3f8cf0b74(value) {
    return value;
}


var $395cdbc00ac0518b$var$__defProp = Object.defineProperty;
var $395cdbc00ac0518b$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $395cdbc00ac0518b$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $395cdbc00ac0518b$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $395cdbc00ac0518b$var$__defNormalProp = (obj, key, value)=>key in obj ? $395cdbc00ac0518b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $395cdbc00ac0518b$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($395cdbc00ac0518b$var$__hasOwnProp.call(b, prop)) $395cdbc00ac0518b$var$__defNormalProp(a, prop, b[prop]);
    if ($395cdbc00ac0518b$var$__getOwnPropSymbols) {
        for (var prop of $395cdbc00ac0518b$var$__getOwnPropSymbols(b))if ($395cdbc00ac0518b$var$__propIsEnum.call(b, prop)) $395cdbc00ac0518b$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $395cdbc00ac0518b$var$__publicField = (obj, key, value)=>{
    $395cdbc00ac0518b$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $395cdbc00ac0518b$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $395cdbc00ac0518b$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $395cdbc00ac0518b$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $395cdbc00ac0518b$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($395cdbc00ac0518b$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $395cdbc00ac0518b$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $395cdbc00ac0518b$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $395cdbc00ac0518b$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $395cdbc00ac0518b$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $395cdbc00ac0518b$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $395cdbc00ac0518b$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $395cdbc00ac0518b$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $395cdbc00ac0518b$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $395cdbc00ac0518b$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $395cdbc00ac0518b$var$__spreadValues($395cdbc00ac0518b$var$__spreadValues({}, $395cdbc00ac0518b$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $395cdbc00ac0518b$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $395cdbc00ac0518b$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $395cdbc00ac0518b$var$$REVISION = 0;
var $395cdbc00ac0518b$var$CURRENT_TRACKER = null;
var $395cdbc00ac0518b$var$Cell = class {
    constructor(initialValue, isEqual = $395cdbc00ac0518b$var$tripleEq){
        $395cdbc00ac0518b$var$__publicField(this, "revision", $395cdbc00ac0518b$var$$REVISION);
        $395cdbc00ac0518b$var$__publicField(this, "_value");
        $395cdbc00ac0518b$var$__publicField(this, "_lastValue");
        $395cdbc00ac0518b$var$__publicField(this, "_isEqual", $395cdbc00ac0518b$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $395cdbc00ac0518b$var$CURRENT_TRACKER == null || $395cdbc00ac0518b$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$395cdbc00ac0518b$var$$REVISION;
    }
};
function $395cdbc00ac0518b$var$tripleEq(a, b) {
    return a === b;
}
var $395cdbc00ac0518b$var$TrackingCache = class {
    constructor(fn){
        $395cdbc00ac0518b$var$__publicField(this, "_cachedValue");
        $395cdbc00ac0518b$var$__publicField(this, "_cachedRevision", -1);
        $395cdbc00ac0518b$var$__publicField(this, "_deps", []);
        $395cdbc00ac0518b$var$__publicField(this, "hits", 0);
        $395cdbc00ac0518b$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $395cdbc00ac0518b$var$CURRENT_TRACKER;
            $395cdbc00ac0518b$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $395cdbc00ac0518b$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $395cdbc00ac0518b$var$CURRENT_TRACKER == null || $395cdbc00ac0518b$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $395cdbc00ac0518b$var$getValue(cell) {
    if (!(cell instanceof $395cdbc00ac0518b$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $395cdbc00ac0518b$var$setValue(storage, value) {
    if (!(storage instanceof $395cdbc00ac0518b$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $395cdbc00ac0518b$var$createCell(initialValue, isEqual = $395cdbc00ac0518b$var$tripleEq) {
    return new $395cdbc00ac0518b$var$Cell(initialValue, isEqual);
}
function $395cdbc00ac0518b$var$createCache(fn) {
    $395cdbc00ac0518b$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $395cdbc00ac0518b$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $395cdbc00ac0518b$var$neverEq = (a, b)=>false;
function $395cdbc00ac0518b$var$createTag() {
    return $395cdbc00ac0518b$var$createCell(null, $395cdbc00ac0518b$var$neverEq);
}
function $395cdbc00ac0518b$var$dirtyTag(tag, value) {
    $395cdbc00ac0518b$var$setValue(tag, value);
}
var $395cdbc00ac0518b$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $395cdbc00ac0518b$var$createTag();
    $395cdbc00ac0518b$var$getValue(tag);
};
var $395cdbc00ac0518b$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $395cdbc00ac0518b$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $395cdbc00ac0518b$var$REDUX_PROXY_LABEL = Symbol();
var $395cdbc00ac0518b$var$nextId = 0;
var $395cdbc00ac0518b$var$proto = Object.getPrototypeOf({});
var $395cdbc00ac0518b$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $395cdbc00ac0518b$var$__publicField(this, "proxy", new Proxy(this, $395cdbc00ac0518b$var$objectProxyHandler));
        $395cdbc00ac0518b$var$__publicField(this, "tag", $395cdbc00ac0518b$var$createTag());
        $395cdbc00ac0518b$var$__publicField(this, "tags", {});
        $395cdbc00ac0518b$var$__publicField(this, "children", {});
        $395cdbc00ac0518b$var$__publicField(this, "collectionTag", null);
        $395cdbc00ac0518b$var$__publicField(this, "id", $395cdbc00ac0518b$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $395cdbc00ac0518b$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $395cdbc00ac0518b$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $395cdbc00ac0518b$var$createNode(childValue);
                if (childNode.tag) $395cdbc00ac0518b$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $395cdbc00ac0518b$var$createTag();
                    tag.value = childValue;
                }
                $395cdbc00ac0518b$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $395cdbc00ac0518b$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $395cdbc00ac0518b$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $395cdbc00ac0518b$var$__publicField(this, "proxy", new Proxy([
            this
        ], $395cdbc00ac0518b$var$arrayProxyHandler));
        $395cdbc00ac0518b$var$__publicField(this, "tag", $395cdbc00ac0518b$var$createTag());
        $395cdbc00ac0518b$var$__publicField(this, "tags", {});
        $395cdbc00ac0518b$var$__publicField(this, "children", {});
        $395cdbc00ac0518b$var$__publicField(this, "collectionTag", null);
        $395cdbc00ac0518b$var$__publicField(this, "id", $395cdbc00ac0518b$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $395cdbc00ac0518b$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $395cdbc00ac0518b$var$consumeCollection(node);
        return $395cdbc00ac0518b$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $395cdbc00ac0518b$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $395cdbc00ac0518b$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $395cdbc00ac0518b$var$objectProxyHandler.has(node, prop);
    }
};
function $395cdbc00ac0518b$var$createNode(value) {
    if (Array.isArray(value)) return new $395cdbc00ac0518b$var$ArrayTreeNode(value);
    return new $395cdbc00ac0518b$var$ObjectTreeNode(value);
}
function $395cdbc00ac0518b$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $395cdbc00ac0518b$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $395cdbc00ac0518b$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $395cdbc00ac0518b$var$dirtyCollection(node);
            $395cdbc00ac0518b$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $395cdbc00ac0518b$var$updateNode(childNode, newChildValue);
        else {
            $395cdbc00ac0518b$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $395cdbc00ac0518b$var$deleteNode(node) {
    if (node.tag) $395cdbc00ac0518b$var$dirtyTag(node.tag, null);
    $395cdbc00ac0518b$var$dirtyCollection(node);
    for(const key in node.tags)$395cdbc00ac0518b$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$395cdbc00ac0518b$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $395cdbc00ac0518b$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $395cdbc00ac0518b$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $395cdbc00ac0518b$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $395cdbc00ac0518b$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $395cdbc00ac0518b$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $395cdbc00ac0518b$export$3f025202a230c6dd = (a, b)=>a === b;
function $395cdbc00ac0518b$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $395cdbc00ac0518b$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $395cdbc00ac0518b$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $395cdbc00ac0518b$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $395cdbc00ac0518b$var$createSingletonCache(comparator) : $395cdbc00ac0518b$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $395cdbc00ac0518b$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $395cdbc00ac0518b$export$c8f9cf88d9fdee55(func) {
    const node = $395cdbc00ac0518b$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $395cdbc00ac0518b$var$createCacheKeyComparator($395cdbc00ac0518b$export$3f025202a230c6dd);
    const cache = $395cdbc00ac0518b$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $395cdbc00ac0518b$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $395cdbc00ac0518b$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $395cdbc00ac0518b$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $395cdbc00ac0518b$var$StrongRef;
var $395cdbc00ac0518b$var$UNTERMINATED = 0;
var $395cdbc00ac0518b$var$TERMINATED = 1;
function $395cdbc00ac0518b$var$createCacheNode() {
    return {
        s: $395cdbc00ac0518b$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $395cdbc00ac0518b$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $395cdbc00ac0518b$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $395cdbc00ac0518b$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $395cdbc00ac0518b$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $395cdbc00ac0518b$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $395cdbc00ac0518b$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $395cdbc00ac0518b$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $395cdbc00ac0518b$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $395cdbc00ac0518b$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $395cdbc00ac0518b$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $395cdbc00ac0518b$var$__spreadValues($395cdbc00ac0518b$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $395cdbc00ac0518b$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $395cdbc00ac0518b$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $395cdbc00ac0518b$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $395cdbc00ac0518b$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $395cdbc00ac0518b$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $395cdbc00ac0518b$export$595d22ed68ca2841 = /* @__PURE__ */ $395cdbc00ac0518b$export$5943f4447f6ef248($395cdbc00ac0518b$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $395cdbc00ac0518b$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $395cdbc00ac0518b$export$595d22ed68ca2841)=>{
    $395cdbc00ac0518b$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$395cdbc00ac0518b$export$75979cfcd91bf38f
});


// src/index.ts
function $648272315463e815$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $648272315463e815$export$dd164f5517779f15 = $648272315463e815$var$createThunkMiddleware();
var $648272315463e815$export$16d06542a1949d9e = $648272315463e815$var$createThunkMiddleware;


var $1579f3bfe4607d2e$var$__defProp = Object.defineProperty;
var $1579f3bfe4607d2e$var$__defProps = Object.defineProperties;
var $1579f3bfe4607d2e$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $1579f3bfe4607d2e$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $1579f3bfe4607d2e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $1579f3bfe4607d2e$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $1579f3bfe4607d2e$var$__defNormalProp = (obj, key, value)=>key in obj ? $1579f3bfe4607d2e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $1579f3bfe4607d2e$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($1579f3bfe4607d2e$var$__hasOwnProp.call(b, prop)) $1579f3bfe4607d2e$var$__defNormalProp(a, prop, b[prop]);
    if ($1579f3bfe4607d2e$var$__getOwnPropSymbols) {
        for (var prop of $1579f3bfe4607d2e$var$__getOwnPropSymbols(b))if ($1579f3bfe4607d2e$var$__propIsEnum.call(b, prop)) $1579f3bfe4607d2e$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $1579f3bfe4607d2e$var$__spreadProps = (a, b)=>$1579f3bfe4607d2e$var$__defProps(a, $1579f3bfe4607d2e$var$__getOwnPropDescs(b));
var $1579f3bfe4607d2e$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($1579f3bfe4607d2e$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $1579f3bfe4607d2e$var$__getOwnPropSymbols) {
        for (var prop of $1579f3bfe4607d2e$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $1579f3bfe4607d2e$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $1579f3bfe4607d2e$var$__publicField = (obj, key, value)=>$1579f3bfe4607d2e$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $1579f3bfe4607d2e$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $395cdbc00ac0518b$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $d9169d6545ae6690$export$541ac630993a4c84)(value) ? (0, $d9169d6545ae6690$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $1579f3bfe4607d2e$export$a5d3c27355e35910 = /* @__PURE__ */ $1579f3bfe4607d2e$export$aab6de9e3dbb1473((0, $395cdbc00ac0518b$export$8402dc26d96f6902));
var $1579f3bfe4607d2e$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $b40d0dadbbab45f1$export$f672e0b6f7222cd7;
    return (0, $b40d0dadbbab45f1$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $1579f3bfe4607d2e$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $1579f3bfe4607d2e$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $1579f3bfe4607d2e$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($1579f3bfe4607d2e$export$378fa86b259c0280(0));
            return $1579f3bfe4607d2e$var$__spreadValues($1579f3bfe4607d2e$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $b40d0dadbbab45f1$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $1579f3bfe4607d2e$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $1579f3bfe4607d2e$var$hasMatchFunction(action);
}
function $1579f3bfe4607d2e$export$ebd532f9034651f3(action) {
    return (0, $b40d0dadbbab45f1$export$b956e38827fca970)(action) && Object.keys(action).every($1579f3bfe4607d2e$var$isValidKey);
}
function $1579f3bfe4607d2e$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $1579f3bfe4607d2e$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $1579f3bfe4607d2e$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $1579f3bfe4607d2e$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $1579f3bfe4607d2e$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $1579f3bfe4607d2e$var$freezeDraftable(val) {
    return (0, $d9169d6545ae6690$export$16e3aed3edb85946)(val) ? (0, $d9169d6545ae6690$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $1579f3bfe4607d2e$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $1579f3bfe4607d2e$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $1579f3bfe4607d2e$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $1579f3bfe4607d2e$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $1579f3bfe4607d2e$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $1579f3bfe4607d2e$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $1579f3bfe4607d2e$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $1579f3bfe4607d2e$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $1579f3bfe4607d2e$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $1579f3bfe4607d2e$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $1579f3bfe4607d2e$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $b40d0dadbbab45f1$export$53b83ca8eaab0383)(val);
}
function $1579f3bfe4607d2e$export$ada5dca0b571bc7(value, path = "", isSerializable = $1579f3bfe4607d2e$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $1579f3bfe4607d2e$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $1579f3bfe4607d2e$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $1579f3bfe4607d2e$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$1579f3bfe4607d2e$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $1579f3bfe4607d2e$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $1579f3bfe4607d2e$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $1579f3bfe4607d2e$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $1579f3bfe4607d2e$export$1908877435b1d5e9();
        if (thunk) {
            if ($1579f3bfe4607d2e$var$isBoolean(thunk)) middlewareArray.push((0, $648272315463e815$export$dd164f5517779f15));
            else middlewareArray.push((0, $648272315463e815$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $1579f3bfe4607d2e$export$8fb31c0f05df007b = "RTK_autoBatch";
var $1579f3bfe4607d2e$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$1579f3bfe4607d2e$export$8fb31c0f05df007b]: true
            }
        });
var $1579f3bfe4607d2e$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $1579f3bfe4607d2e$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $1579f3bfe4607d2e$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $1579f3bfe4607d2e$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$1579f3bfe4607d2e$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $1579f3bfe4607d2e$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $1579f3bfe4607d2e$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($1579f3bfe4607d2e$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $1579f3bfe4607d2e$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $1579f3bfe4607d2e$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $b40d0dadbbab45f1$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $b40d0dadbbab45f1$export$66e4520cdb265d18)(reducer);
    else throw new Error($1579f3bfe4607d2e$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, $b40d0dadbbab45f1$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $1579f3bfe4607d2e$var$composeWithDevTools($1579f3bfe4607d2e$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $b40d0dadbbab45f1$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $1579f3bfe4607d2e$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $b40d0dadbbab45f1$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $1579f3bfe4607d2e$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($1579f3bfe4607d2e$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($1579f3bfe4607d2e$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $1579f3bfe4607d2e$var$isStateFunction(x) {
    return typeof x === "function";
}
function $1579f3bfe4607d2e$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $1579f3bfe4607d2e$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($1579f3bfe4607d2e$var$isStateFunction(initialState)) getInitialState = ()=>$1579f3bfe4607d2e$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $1579f3bfe4607d2e$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $d9169d6545ae6690$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $d9169d6545ae6690$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $d9169d6545ae6690$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $1579f3bfe4607d2e$var$matches = (matcher, action)=>{
    if ($1579f3bfe4607d2e$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $1579f3bfe4607d2e$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$1579f3bfe4607d2e$var$matches(matcher, action));
    };
}
function $1579f3bfe4607d2e$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$1579f3bfe4607d2e$var$matches(matcher, action));
    };
}
function $1579f3bfe4607d2e$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $1579f3bfe4607d2e$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $1579f3bfe4607d2e$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$1579f3bfe4607d2e$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$1579f3bfe4607d2e$var$isAsyncThunkArray(asyncThunks)) return $1579f3bfe4607d2e$export$872dec21e9a69476()(asyncThunks[0]);
    return $1579f3bfe4607d2e$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $1579f3bfe4607d2e$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$1579f3bfe4607d2e$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$1579f3bfe4607d2e$var$isAsyncThunkArray(asyncThunks)) return $1579f3bfe4607d2e$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $1579f3bfe4607d2e$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $1579f3bfe4607d2e$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $1579f3bfe4607d2e$export$9dd1fb32974da385($1579f3bfe4607d2e$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$1579f3bfe4607d2e$var$isAsyncThunkArray(asyncThunks)) return $1579f3bfe4607d2e$export$fcc3388fb56de601()(asyncThunks[0]);
    return $1579f3bfe4607d2e$export$9dd1fb32974da385($1579f3bfe4607d2e$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $1579f3bfe4607d2e$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$1579f3bfe4607d2e$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$1579f3bfe4607d2e$var$isAsyncThunkArray(asyncThunks)) return $1579f3bfe4607d2e$export$1da80a6ef1307441()(asyncThunks[0]);
    return $1579f3bfe4607d2e$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $1579f3bfe4607d2e$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$1579f3bfe4607d2e$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$1579f3bfe4607d2e$var$isAsyncThunkArray(asyncThunks)) return $1579f3bfe4607d2e$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $1579f3bfe4607d2e$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $1579f3bfe4607d2e$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $1579f3bfe4607d2e$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $1579f3bfe4607d2e$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $1579f3bfe4607d2e$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $1579f3bfe4607d2e$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $1579f3bfe4607d2e$var$__publicField(this, "_type");
    }
};
var $1579f3bfe4607d2e$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $1579f3bfe4607d2e$var$__publicField(this, "_type");
    }
};
var $1579f3bfe4607d2e$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $1579f3bfe4607d2e$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $1579f3bfe4607d2e$var$externalAbortMessage = "External signal was aborted";
var $1579f3bfe4607d2e$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $1579f3bfe4607d2e$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $1579f3bfe4607d2e$var$__spreadProps($1579f3bfe4607d2e$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $1579f3bfe4607d2e$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $1579f3bfe4607d2e$var$__spreadProps($1579f3bfe4607d2e$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $1579f3bfe4607d2e$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $1579f3bfe4607d2e$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $1579f3bfe4607d2e$var$__spreadProps($1579f3bfe4607d2e$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $1579f3bfe4607d2e$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($1579f3bfe4607d2e$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($1579f3bfe4607d2e$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($1579f3bfe4607d2e$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $1579f3bfe4607d2e$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $1579f3bfe4607d2e$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $1579f3bfe4607d2e$var$RejectWithValue) throw result;
                                if (result instanceof $1579f3bfe4607d2e$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $1579f3bfe4607d2e$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($1579f3bfe4607d2e$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $1579f3bfe4607d2e$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $1579f3bfe4607d2e$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $1579f3bfe4607d2e$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $1579f3bfe4607d2e$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $1579f3bfe4607d2e$export$343355ed40c51c46 = {
    [$1579f3bfe4607d2e$var$asyncThunkSymbol]: $1579f3bfe4607d2e$export$6abd22dc03e5063f
};
var $1579f3bfe4607d2e$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($1579f3bfe4607d2e$export$23a094319a4b586 || {});
function $1579f3bfe4607d2e$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $1579f3bfe4607d2e$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$1579f3bfe4607d2e$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($1579f3bfe4607d2e$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($1579f3bfe4607d2e$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($1579f3bfe4607d2e$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($1579f3bfe4607d2e$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $1579f3bfe4607d2e$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($1579f3bfe4607d2e$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $1579f3bfe4607d2e$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $1579f3bfe4607d2e$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $1579f3bfe4607d2e$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $1579f3bfe4607d2e$var$__spreadValues($1579f3bfe4607d2e$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $1579f3bfe4607d2e$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $1579f3bfe4607d2e$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $1579f3bfe4607d2e$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $1579f3bfe4607d2e$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $1579f3bfe4607d2e$var$wrapSelector(selector, selectState, ()=>$1579f3bfe4607d2e$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $1579f3bfe4607d2e$var$__spreadProps($1579f3bfe4607d2e$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $1579f3bfe4607d2e$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $1579f3bfe4607d2e$var$__spreadValues($1579f3bfe4607d2e$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $1579f3bfe4607d2e$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $1579f3bfe4607d2e$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $1579f3bfe4607d2e$export$affdea4146de9cf5();
function $1579f3bfe4607d2e$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $1579f3bfe4607d2e$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $1579f3bfe4607d2e$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$1579f3bfe4607d2e$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($1579f3bfe4607d2e$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $1579f3bfe4607d2e$export$309c7a02b0b0bc62(type, prepareCallback) : $1579f3bfe4607d2e$export$309c7a02b0b0bc62(type));
}
function $1579f3bfe4607d2e$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $1579f3bfe4607d2e$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $1579f3bfe4607d2e$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($1579f3bfe4607d2e$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $1579f3bfe4607d2e$var$noop,
        pending: pending || $1579f3bfe4607d2e$var$noop,
        rejected: rejected || $1579f3bfe4607d2e$var$noop,
        settled: settled || $1579f3bfe4607d2e$var$noop
    });
}
function $1579f3bfe4607d2e$var$noop() {}
// src/entities/entity_state.ts
function $1579f3bfe4607d2e$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $1579f3bfe4607d2e$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($1579f3bfe4607d2e$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $1579f3bfe4607d2e$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $1579f3bfe4607d2e$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $1579f3bfe4607d2e$var$isDraftTyped = (0, $d9169d6545ae6690$export$541ac630993a4c84);
function $1579f3bfe4607d2e$var$createSingleArgumentStateOperator(mutator) {
    const operator = $1579f3bfe4607d2e$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $1579f3bfe4607d2e$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $1579f3bfe4607d2e$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($1579f3bfe4607d2e$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $d9169d6545ae6690$export$b46cabe22e78bc00)(state, runMutator);
    };
}
function $1579f3bfe4607d2e$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $1579f3bfe4607d2e$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $1579f3bfe4607d2e$var$getCurrent(value) {
    return (0, $d9169d6545ae6690$export$541ac630993a4c84)(value) ? (0, $d9169d6545ae6690$export$97aac956da55dae9)(value) : value;
}
function $1579f3bfe4607d2e$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $1579f3bfe4607d2e$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $1579f3bfe4607d2e$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $1579f3bfe4607d2e$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $1579f3bfe4607d2e$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $1579f3bfe4607d2e$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $1579f3bfe4607d2e$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $1579f3bfe4607d2e$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $1579f3bfe4607d2e$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $1579f3bfe4607d2e$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $1579f3bfe4607d2e$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $1579f3bfe4607d2e$var$__spreadValues($1579f3bfe4607d2e$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$1579f3bfe4607d2e$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $1579f3bfe4607d2e$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $1579f3bfe4607d2e$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $1579f3bfe4607d2e$var$createStateOperator(addOneMutably),
        addMany: $1579f3bfe4607d2e$var$createStateOperator(addManyMutably),
        setOne: $1579f3bfe4607d2e$var$createStateOperator(setOneMutably),
        setMany: $1579f3bfe4607d2e$var$createStateOperator(setManyMutably),
        setAll: $1579f3bfe4607d2e$var$createStateOperator(setAllMutably),
        updateOne: $1579f3bfe4607d2e$var$createStateOperator(updateOneMutably),
        updateMany: $1579f3bfe4607d2e$var$createStateOperator(updateManyMutably),
        upsertOne: $1579f3bfe4607d2e$var$createStateOperator(upsertOneMutably),
        upsertMany: $1579f3bfe4607d2e$var$createStateOperator(upsertManyMutably),
        removeOne: $1579f3bfe4607d2e$var$createStateOperator(removeOneMutably),
        removeMany: $1579f3bfe4607d2e$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $1579f3bfe4607d2e$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $1579f3bfe4607d2e$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $1579f3bfe4607d2e$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $1579f3bfe4607d2e$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $1579f3bfe4607d2e$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $1579f3bfe4607d2e$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $1579f3bfe4607d2e$var$getCurrent(state.ids));
        const models = newEntities.filter((model)=>!existingKeys.has($1579f3bfe4607d2e$var$selectIdValue(model, selectId)));
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $1579f3bfe4607d2e$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities)delete state.entities[selectId(item)];
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $1579f3bfe4607d2e$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $1579f3bfe4607d2e$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $1579f3bfe4607d2e$var$getCurrent(state.entities);
        const currentIds = $1579f3bfe4607d2e$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $1579f3bfe4607d2e$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $1579f3bfe4607d2e$var$createStateOperator(addOneMutably),
        updateOne: $1579f3bfe4607d2e$var$createStateOperator(updateOneMutably),
        upsertOne: $1579f3bfe4607d2e$var$createStateOperator(upsertOneMutably),
        setOne: $1579f3bfe4607d2e$var$createStateOperator(setOneMutably),
        setMany: $1579f3bfe4607d2e$var$createStateOperator(setManyMutably),
        setAll: $1579f3bfe4607d2e$var$createStateOperator(setAllMutably),
        addMany: $1579f3bfe4607d2e$var$createStateOperator(addManyMutably),
        updateMany: $1579f3bfe4607d2e$var$createStateOperator(updateManyMutably),
        upsertMany: $1579f3bfe4607d2e$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $1579f3bfe4607d2e$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $1579f3bfe4607d2e$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $1579f3bfe4607d2e$var$createSortedStateAdapter(selectId, sortComparer) : $1579f3bfe4607d2e$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $1579f3bfe4607d2e$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $1579f3bfe4607d2e$var$createSelectorsFactory();
    return $1579f3bfe4607d2e$var$__spreadValues($1579f3bfe4607d2e$var$__spreadValues($1579f3bfe4607d2e$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $1579f3bfe4607d2e$var$task = "task";
var $1579f3bfe4607d2e$var$listener = "listener";
var $1579f3bfe4607d2e$var$completed = "completed";
var $1579f3bfe4607d2e$var$cancelled = "cancelled";
var $1579f3bfe4607d2e$var$taskCancelled = `task-${$1579f3bfe4607d2e$var$cancelled}`;
var $1579f3bfe4607d2e$var$taskCompleted = `task-${$1579f3bfe4607d2e$var$completed}`;
var $1579f3bfe4607d2e$var$listenerCancelled = `${$1579f3bfe4607d2e$var$listener}-${$1579f3bfe4607d2e$var$cancelled}`;
var $1579f3bfe4607d2e$var$listenerCompleted = `${$1579f3bfe4607d2e$var$listener}-${$1579f3bfe4607d2e$var$completed}`;
var $1579f3bfe4607d2e$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $1579f3bfe4607d2e$var$__publicField(this, "name", "TaskAbortError");
        $1579f3bfe4607d2e$var$__publicField(this, "message");
        this.message = `${$1579f3bfe4607d2e$var$task} ${$1579f3bfe4607d2e$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $1579f3bfe4607d2e$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($1579f3bfe4607d2e$export$378fa86b259c0280(32));
};
var $1579f3bfe4607d2e$var$noop2 = ()=>{};
var $1579f3bfe4607d2e$var$catchRejection = (promise, onError = $1579f3bfe4607d2e$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $1579f3bfe4607d2e$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $1579f3bfe4607d2e$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $1579f3bfe4607d2e$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $1579f3bfe4607d2e$export$cb1bdac908fed7f(reason);
    }
};
function $1579f3bfe4607d2e$var$raceWithSignal(signal, promise) {
    let cleanup = $1579f3bfe4607d2e$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $1579f3bfe4607d2e$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $1579f3bfe4607d2e$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $1579f3bfe4607d2e$var$noop2;
    });
}
var $1579f3bfe4607d2e$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $1579f3bfe4607d2e$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $1579f3bfe4607d2e$var$createPause = (signal)=>{
    return (promise)=>{
        return $1579f3bfe4607d2e$var$catchRejection($1579f3bfe4607d2e$var$raceWithSignal(signal, promise).then((output)=>{
            $1579f3bfe4607d2e$var$validateActive(signal);
            return output;
        }));
    };
};
var $1579f3bfe4607d2e$var$createDelay = (signal)=>{
    const pause = $1579f3bfe4607d2e$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $1579f3bfe4607d2e$var$assign } = Object;
var $1579f3bfe4607d2e$var$INTERNAL_NIL_TOKEN = {};
var $1579f3bfe4607d2e$var$alm = "listenerMiddleware";
var $1579f3bfe4607d2e$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$1579f3bfe4607d2e$var$addAbortSignalListener(parentAbortSignal, ()=>$1579f3bfe4607d2e$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $1579f3bfe4607d2e$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $1579f3bfe4607d2e$var$runTask(async ()=>{
            $1579f3bfe4607d2e$var$validateActive(parentAbortSignal);
            $1579f3bfe4607d2e$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $1579f3bfe4607d2e$var$createPause(childAbortController.signal),
                delay: $1579f3bfe4607d2e$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $1579f3bfe4607d2e$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$1579f3bfe4607d2e$var$abortControllerWithReason(childAbortController, $1579f3bfe4607d2e$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($1579f3bfe4607d2e$var$noop2));
        return {
            result: $1579f3bfe4607d2e$var$createPause(parentAbortSignal)(result),
            cancel () {
                $1579f3bfe4607d2e$var$abortControllerWithReason(childAbortController, $1579f3bfe4607d2e$var$taskCancelled);
            }
        };
    };
};
var $1579f3bfe4607d2e$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $1579f3bfe4607d2e$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $1579f3bfe4607d2e$var$raceWithSignal(signal, Promise.race(promises));
            $1579f3bfe4607d2e$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$1579f3bfe4607d2e$var$catchRejection(take(predicate, timeout));
};
var $1579f3bfe4607d2e$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $1579f3bfe4607d2e$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($1579f3bfe4607d2e$export$378fa86b259c0280(21));
    $1579f3bfe4607d2e$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $1579f3bfe4607d2e$var$createListenerEntry = /* @__PURE__ */ $1579f3bfe4607d2e$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $1579f3bfe4607d2e$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $1579f3bfe4607d2e$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($1579f3bfe4607d2e$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$1579f3bfe4607d2e$var$createListenerEntry
});
var $1579f3bfe4607d2e$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $1579f3bfe4607d2e$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $1579f3bfe4607d2e$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $1579f3bfe4607d2e$var$abortControllerWithReason(controller, $1579f3bfe4607d2e$var$listenerCancelled);
    });
};
var $1579f3bfe4607d2e$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($1579f3bfe4607d2e$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $1579f3bfe4607d2e$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $1579f3bfe4607d2e$export$f03a6b845d3fb58b = /* @__PURE__ */ $1579f3bfe4607d2e$var$assign(/* @__PURE__ */ $1579f3bfe4607d2e$export$309c7a02b0b0bc62(`${$1579f3bfe4607d2e$var$alm}/add`), {
    withTypes: ()=>$1579f3bfe4607d2e$export$f03a6b845d3fb58b
});
var $1579f3bfe4607d2e$export$b1b8022855fb2b71 = /* @__PURE__ */ $1579f3bfe4607d2e$export$309c7a02b0b0bc62(`${$1579f3bfe4607d2e$var$alm}/removeAll`);
var $1579f3bfe4607d2e$export$b03e9483f936dccb = /* @__PURE__ */ $1579f3bfe4607d2e$var$assign(/* @__PURE__ */ $1579f3bfe4607d2e$export$309c7a02b0b0bc62(`${$1579f3bfe4607d2e$var$alm}/remove`), {
    withTypes: ()=>$1579f3bfe4607d2e$export$b03e9483f936dccb
});
var $1579f3bfe4607d2e$var$defaultErrorHandler = (...args)=>{
    console.error(`${$1579f3bfe4607d2e$var$alm}/error`, ...args);
};
var $1579f3bfe4607d2e$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $1579f3bfe4607d2e$var$defaultErrorHandler } = middlewareOptions;
    $1579f3bfe4607d2e$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $1579f3bfe4607d2e$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = $1579f3bfe4607d2e$var$findListenerEntry(listenerMap, options)) != null ? _a : $1579f3bfe4607d2e$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $1579f3bfe4607d2e$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $1579f3bfe4607d2e$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $1579f3bfe4607d2e$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $1579f3bfe4607d2e$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $1579f3bfe4607d2e$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $1579f3bfe4607d2e$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $1579f3bfe4607d2e$var$createDelay(internalTaskController.signal),
                pause: $1579f3bfe4607d2e$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $1579f3bfe4607d2e$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $1579f3bfe4607d2e$var$abortControllerWithReason(controller, $1579f3bfe4607d2e$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $1579f3bfe4607d2e$var$abortControllerWithReason(internalTaskController, $1579f3bfe4607d2e$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $1579f3bfe4607d2e$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $1579f3bfe4607d2e$export$cb1bdac908fed7f)) $1579f3bfe4607d2e$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $1579f3bfe4607d2e$var$abortControllerWithReason(internalTaskController, $1579f3bfe4607d2e$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $1579f3bfe4607d2e$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $b40d0dadbbab45f1$export$b956e38827fca970)(action)) return next(action);
                if ($1579f3bfe4607d2e$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($1579f3bfe4607d2e$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($1579f3bfe4607d2e$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $1579f3bfe4607d2e$var$INTERNAL_NIL_TOKEN) throw new Error($1579f3bfe4607d2e$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $1579f3bfe4607d2e$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $1579f3bfe4607d2e$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $1579f3bfe4607d2e$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $1579f3bfe4607d2e$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $1579f3bfe4607d2e$export$4bb1606a79445586 = ()=>{
    const instanceId = $1579f3bfe4607d2e$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($1579f3bfe4607d2e$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $1579f3bfe4607d2e$var$getOrInsertComputed(middlewareMap, middleware2, $1579f3bfe4607d2e$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$1579f3bfe4607d2e$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $b40d0dadbbab45f1$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $1579f3bfe4607d2e$export$9dd1fb32974da385(withMiddleware, $1579f3bfe4607d2e$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $1579f3bfe4607d2e$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $1579f3bfe4607d2e$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$1579f3bfe4607d2e$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $1579f3bfe4607d2e$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $1579f3bfe4607d2e$var$isStateProxy = (value)=>!!value && !!value[$1579f3bfe4607d2e$var$ORIGINAL_STATE];
var $1579f3bfe4607d2e$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $1579f3bfe4607d2e$var$createStateProxy = (state, reducerMap, initialStateCache)=>$1579f3bfe4607d2e$var$getOrInsertComputed($1579f3bfe4607d2e$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $1579f3bfe4607d2e$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $1579f3bfe4607d2e$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($1579f3bfe4607d2e$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $1579f3bfe4607d2e$var$original = (state)=>{
    if (!$1579f3bfe4607d2e$var$isStateProxy(state)) throw new Error($1579f3bfe4607d2e$export$378fa86b259c0280(25));
    return state[$1579f3bfe4607d2e$var$ORIGINAL_STATE];
};
var $1579f3bfe4607d2e$var$emptyObject = {};
var $1579f3bfe4607d2e$var$noopReducer = (state = $1579f3bfe4607d2e$var$emptyObject)=>state;
function $1579f3bfe4607d2e$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($1579f3bfe4607d2e$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $b40d0dadbbab45f1$export$66e4520cdb265d18)(reducerMap) : $1579f3bfe4607d2e$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($1579f3bfe4607d2e$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $1579f3bfe4607d2e$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $1579f3bfe4607d2e$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


const $9ce242a4d294957c$var$cartSlice = (0, $1579f3bfe4607d2e$export$4d8d9bd83c24ae8b)({
    name: "cart",
    initialState: {
        items: []
    },
    reducers: {
        addItem: (state, action)=>{
            state.items.push(action.payload);
        },
        removeItem: (state)=>{
            state.items.pop();
        },
        clearcart: (state)=>{
            state.items.length = 0;
        }
    }
});
const { addItem: $9ce242a4d294957c$export$fb9705de59d96855, removeItem: $9ce242a4d294957c$export$fe2d9b4e03920b4c, clearcart: $9ce242a4d294957c$export$d9e7d4472e335dc6 } = $9ce242a4d294957c$var$cartSlice.actions;
var $9ce242a4d294957c$export$2e2bcd8739ae039 = $9ce242a4d294957c$var$cartSlice.reducer;


const $53c0039fd50620c5$var$ItemList = ({ data1: data1 })=>{
    const dispatch = (0, $8a2e0dcbd07620ad$export$8ad76b76a4c905f8)();
    const handleclick = (item)=>{
        dispatch((0, $9ce242a4d294957c$export$fb9705de59d96855)(item));
        console.log(item);
    };
    return /*#__PURE__*/ (0, $R1mjg.jsx)("div", {
        children: data1?.map((item)=>/*#__PURE__*/ (0, $R1mjg.jsxs)("div", {
                className: "p-2 m-2 border-gray-200 border-b-2 text-left  ",
                children: [
                    /*#__PURE__*/ (0, $R1mjg.jsxs)("div", {
                        className: "py-2",
                        children: [
                            /*#__PURE__*/ (0, $R1mjg.jsxs)("div", {
                                className: "relative inline-block",
                                children: [
                                    /*#__PURE__*/ (0, $R1mjg.jsx)("img", {
                                        src: (0, $71f2a50233d21256$export$ee7e7ea446877ea7) + item.card.info.imageId,
                                        className: "w-50"
                                    }),
                                    /*#__PURE__*/ (0, $R1mjg.jsx)("button", {
                                        className: "absolute top-2 right-2 bg-black text-white text-sm px-5 py-3 rounded-lg shadow hover:bg-orange-600 transition",
                                        onClick: ()=>handleclick(item),
                                        children: "Add+"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $R1mjg.jsx)("span", {
                                children: item.card.info.name
                            }),
                            /*#__PURE__*/ (0, $R1mjg.jsxs)("span", {
                                children: [
                                    " ",
                                    " ",
                                    "-\u20B9 ",
                                    " ",
                                    item.card.info.price ? item.card.info.price / 100 : item.card.info.defaultPrice / 100
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $R1mjg.jsx)("p", {
                        className: "text-slate-950 text-xl",
                        children: item.card.info.description
                    })
                ]
            }, item.card.info.id))
    });
};
var $53c0039fd50620c5$export$2e2bcd8739ae039 = $53c0039fd50620c5$var$ItemList;


const $f9f10226464cd078$var$RestautrantCatgory = ({ data: data })=>{
    //this has two parts 1.header having category name and derop down logo and body
    const [showItems, setShowItems] = (0, $i7uhG.useState)(false);
    const handleClick = ()=>{
        setShowItems(!showItems);
    };
    return /*#__PURE__*/ (0, $R1mjg.jsx)("div", {
        children: /*#__PURE__*/ (0, $R1mjg.jsxs)("div", {
            className: "w-6/12 mx-auto my-4 bg-gray-50 p-6 shadow-lg cursor-pointer",
            children: [
                /*#__PURE__*/ (0, $R1mjg.jsxs)("div", {
                    className: "flex justify-between",
                    onClick: handleClick,
                    children: [
                        /*#__PURE__*/ (0, $R1mjg.jsxs)("span", {
                            className: "font-bold text-2xl",
                            children: [
                                data.title,
                                "(",
                                data.itemCards.length,
                                ")"
                            ]
                        }),
                        /*#__PURE__*/ (0, $R1mjg.jsx)("span", {
                            children: "\u2B07\uFE0F"
                        })
                    ]
                }),
                showItems && /*#__PURE__*/ (0, $R1mjg.jsx)((0, $53c0039fd50620c5$export$2e2bcd8739ae039), {
                    data1: data.itemCards
                })
            ]
        })
    });
};
var $f9f10226464cd078$export$2e2bcd8739ae039 = $f9f10226464cd078$var$RestautrantCatgory;


//later we will be using custom hooks for fetching and stroing res menu data in resinfo
const $5c7fa6be91a2cbaa$var$Restautrantmenu = ()=>{
    //-----------------------------------------res bmenu data fetched can be in custom hook ------------------------------
    const [resInfo, setresInfo] = (0, $i7uhG.useState)(null);
    const params = (0, $03719940145a991f$export$99eaa27ddbbb95ef)();
    console.log(params);
    const { resid: resid } = (0, $03719940145a991f$export$99eaa27ddbbb95ef)();
    (0, $i7uhG.useEffect)(()=>{
        fetchdata();
    }, []);
    const fetchdata = async ()=>{
        const data = await fetch((0, $71f2a50233d21256$export$5efc1bdaf069455a) + resid);
        const json = await data.json();
        console.log(json);
        setresInfo(json.data);
        console.log(resInfo); //always shows null as it does not wait till the api data fetch as no wait used
    //-------------------------------------------- upto this ----------------------------------------
    };
    if (resInfo == null) return /*#__PURE__*/ (0, $R1mjg.jsx)((0, $4ad91f0b3377f485$export$2e2bcd8739ae039), {});
    //in resinfo not null i.e api data got
    const { name: name, cuisines: cuisines, costForTwoMessage: costForTwoMessage } = resInfo?.cards[2]?.card?.card?.info;
    const { itemCards: itemCards } = resInfo?.cards[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards[2]?.card?.card;
    const categories = resInfo?.cards[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards.filter((c)=>{
        return c.card?.["card"]?.["@type"] === "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory"; // cant ue.@type as it is not a valid js
    //["@type"] so used to get that index value and a fat arrow method need to return to store in category else null
    }) //now cateogries has  restaurant categories we will use it to make accordian for kfc 12 out of 22(extra carts) and for other vary
    ;
    //-----------------------  most imp common mistakes to avoid-------------------------------------------------------------------
    /*
1.---- no need to write return as  within () it explicitly return
const categories = resInfo?.cards[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards.filter((c) => (
    c.card?.["card"]?.["@type"] ==="type.googleapis.com/swiggy.presentation.food.v2.ItemCategory";// cant ue.@type as it is not a valid js
    //["@type"] so used to get that index value and a fat arrow method need to return to store in category else null
))//now cateogries has  restaurant categories we will use it to make accordian for kfc 12 out of 22(extra carts) and for other vary
  console.log(categories);

2.------------- since we are not using () instead  using {} we need to return explicitly else error
const categories = resInfo?.cards[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards.filter((c) => {
   return c.card?.["card"]?.["@type"] ==="type.googleapis.com/swiggy.presentation.food.v2.ItemCategory";// cant ue.@type as it is not a valid js
    //["@type"] so used to get that index value and a fat arrow method need to return to store in category else null
  })//now cateogries has  restaurant categories we will use it to make accordian for kfc 12 out of 22(extra carts) and for other vary
  console.log(categories);


 */ return /*#__PURE__*/ (0, $R1mjg.jsxs)("div", {
        className: "text-center",
        children: [
            /*#__PURE__*/ (0, $R1mjg.jsx)("h1", {
                className: "font-bold my-6 text-2xl",
                children: name
            }),
            /*#__PURE__*/ (0, $R1mjg.jsxs)("div", {
                className: "font-bold text-xl",
                children: [
                    cuisines.join(" , "),
                    " -- ",
                    costForTwoMessage,
                    categories.map((category, index)=>/*#__PURE__*/ (0, $R1mjg.jsx)((0, $f9f10226464cd078$export$2e2bcd8739ae039), {
                            data: category?.card?.card
                        }, index))
                ]
            })
        ]
    });
};
var $5c7fa6be91a2cbaa$export$2e2bcd8739ae039 = $5c7fa6be91a2cbaa$var$Restautrantmenu;



var $R1mjg = parcelRequire("R1mjg");



const $c9feb0858f6ad8ad$var$Cart = ()=>{
    const cartitems = (0, $8a2e0dcbd07620ad$export$2105062e25df4afe)((store)=>store.cart.items);
    const dispatch = (0, $8a2e0dcbd07620ad$export$8ad76b76a4c905f8)();
    const handleclick = ()=>{
        dispatch((0, $9ce242a4d294957c$export$d9e7d4472e335dc6)());
    };
    return /*#__PURE__*/ (0, $R1mjg.jsxs)("div", {
        className: "text-center m-4 p-4",
        children: [
            /*#__PURE__*/ (0, $R1mjg.jsx)("h1", {
                className: "text-2xl font-bold",
                children: "cart"
            }),
            /*#__PURE__*/ (0, $R1mjg.jsxs)("div", {
                className: "w-6/12 m-auto",
                children: [
                    /*#__PURE__*/ (0, $R1mjg.jsx)("button", {
                        className: "p-2 m-2 bg-black text-white rounded-lg",
                        onClick: handleclick,
                        children: "clear cart"
                    }),
                    cartitems.length == 0 && /*#__PURE__*/ (0, $R1mjg.jsx)("h1", {
                        children: "carrt is empty add some fooders"
                    }),
                    /*#__PURE__*/ (0, $R1mjg.jsx)((0, $53c0039fd50620c5$export$2e2bcd8739ae039), {
                        data1: cartitems
                    })
                ]
            })
        ]
    });
};
var $c9feb0858f6ad8ad$export$2e2bcd8739ae039 = $c9feb0858f6ad8ad$var$Cart;



var $R1mjg = parcelRequire("R1mjg");

var $i7uhG = parcelRequire("i7uhG");
class $bc3e16a65e0caf42$var$Services extends (0, (/*@__PURE__*/$parcel$interopDefault($i7uhG))).Component {
    constructor(props){
        super(props);
        this.state = {
            //----------------------or give its value null userinfo:"null"nif null show shimmer ui  since we are
            // not using  the shimmer need hard coded name ,follower and url value to use it when render 1st time without api data----------------------
            userInfo: {
                name: "dummy",
                follower: "default",
                avatar_url: "null"
            }
        };
    }
    async componentDidMount() {
        const data = await fetch("https://api.github.com/users/mohammedsaqlain73");
        const json = await data.json();
        this.setState({
            userInfo: json
        });
        console.log(json);
    }
    render() {
        const { name: name, followers: followers, avatar_url: avatar_url, type: type } = this.state.userInfo;
        return /*#__PURE__*/ (0, $R1mjg.jsxs)("div", {
            className: "user-card",
            children: [
                /*#__PURE__*/ (0, $R1mjg.jsxs)("h2", {
                    children: [
                        "name:",
                        name
                    ]
                }),
                /*#__PURE__*/ (0, $R1mjg.jsxs)("h3", {
                    children: [
                        "follower:",
                        followers
                    ]
                }),
                /*#__PURE__*/ (0, $R1mjg.jsx)("img", {
                    src: avatar_url
                }),
                /*#__PURE__*/ (0, $R1mjg.jsxs)("h4", {
                    children: [
                        "type:",
                        type
                    ]
                })
            ]
        });
    }
}
var $bc3e16a65e0caf42$export$2e2bcd8739ae039 = $bc3e16a65e0caf42$var$Services;





const $ed8ed14d165fe551$var$appstore = (0, $1579f3bfe4607d2e$export$7d8a5b498da695ac)({
    reducer: {
        cart: (0, $9ce242a4d294957c$export$2e2bcd8739ae039)
    }
});
var $ed8ed14d165fe551$export$2e2bcd8739ae039 = $ed8ed14d165fe551$var$appstore;



const $a9969324acd420d5$var$Grocery = /*#__PURE__*/ (0, $i7uhG.lazy)(()=>(parcelRequire("7JPzv")));
/* ---------------------------------- APP LAYOUT ----------------------------------------------------------
-HEADER
  -LOGO
  -NAV ITEMS
-BODY
 -SEARCH BOX AND SEARCH LOGO
 -RESTUARANT CONTAINER
    -CART
-FOOTER
 -COPY RIGHT
 -LINKS
 -ADDRESS
 -CONTACT

*/ //------------------------------------------------------------------------------------------------------------------
//--------------------------------------------------restaurant infos-----------------------------------------------
//-----------------------------------------------------------------------------------------------------------------
const $a9969324acd420d5$var$Applayout = ()=>{
    return /*#__PURE__*/ (0, $R1mjg.jsx)("div", {
        className: "app",
        children: /*#__PURE__*/ (0, $R1mjg.jsxs)((0, $8a2e0dcbd07620ad$export$2881499e37b75b9a), {
            store: (0, $ed8ed14d165fe551$export$2e2bcd8739ae039),
            children: [
                /*#__PURE__*/ (0, $R1mjg.jsx)((0, $ec8fedabc841ae67$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $R1mjg.jsx)((0, $03719940145a991f$export$910ae8079b2c2852), {})
            ]
        })
    });
};
/* normal without header every time
const approutes = createBrowserRouter([
  {
    path: "/",
    element: <Applayout />,
    errorElement:<Error/>
  },
    {
    path: "/about",
    element: <About/>,
      },
       {
        path: "/content",
        element: <Contact/>,
      },




])
*/ const $a9969324acd420d5$var$approutes = (0, $b9ce296f3422b46b$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $R1mjg.jsx)($a9969324acd420d5$var$Applayout, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $R1mjg.jsx)((0, $4910cfde57c76095$export$2e2bcd8739ae039), {})
            },
            {
                path: "/about",
                element: /*#__PURE__*/ (0, $R1mjg.jsx)((0, $cc46b92cca05229e$export$2e2bcd8739ae039), {})
            },
            {
                path: "/contact",
                element: /*#__PURE__*/ (0, $R1mjg.jsx)((0, $5efd4f57743cca9e$export$2e2bcd8739ae039), {})
            },
            {
                path: "/services",
                element: /*#__PURE__*/ (0, $R1mjg.jsx)((0, $bc3e16a65e0caf42$export$2e2bcd8739ae039), {})
            },
            {
                path: "/grocery",
                element: /*#__PURE__*/ (0, $R1mjg.jsx)((0, $i7uhG.Suspense), {
                    fallback: /*#__PURE__*/ (0, $R1mjg.jsx)("h1", {
                        children: "loading.........."
                    }),
                    children: /*#__PURE__*/ (0, $R1mjg.jsx)($a9969324acd420d5$var$Grocery, {})
                })
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $R1mjg.jsx)((0, $c9feb0858f6ad8ad$export$2e2bcd8739ae039), {})
            },
            {
                path: "/restaurant/:resid",
                element: /*#__PURE__*/ (0, $R1mjg.jsx)((0, $5c7fa6be91a2cbaa$export$2e2bcd8739ae039), {})
            }
        ],
        errorElement: /*#__PURE__*/ (0, $R1mjg.jsx)((0, $4d4e665efd9a9d0d$export$2e2bcd8739ae039), {})
    }
]);
//---------------------------------------------reference and render section----------------------------------------
const $a9969324acd420d5$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($4088519dc6b9941f$exports))).createRoot(document.getElementById("root"));
$a9969324acd420d5$var$root.render(/*#__PURE__*/ (0, $R1mjg.jsx)((0, $b9ce296f3422b46b$export$323e4fc2fa4753fb), {
    router: $a9969324acd420d5$var$approutes
})); //root.render(<RouterProvider router={approutes} />);


//# sourceMappingURL=MY_REACT.3bf23d46.js.map
